/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 646:
/***/ ((__unused_webpack_module, exports) => {

				"use strict";
				var __webpack_unused_export__;

				__webpack_unused_export__ = ({ value: true });
				function all() {
					return window
						.getComputedStyle(document.documentElement, ':before')
						.getPropertyValue('content')
						.replace(/"/g, '')
						.split(',');
				}
				__webpack_unused_export__ = all;
				function current() {
					return window
						.getComputedStyle(document.documentElement, ':after')
						.getPropertyValue('content')
						.replace(/"/g, '');
				}
				__webpack_unused_export__ = current;
				var callbacks = [];
				var breakpoints = all();
				var breakpointData = {
					previous: current(),
					current: current(),
				};
				function min(breakpoint) {
					var current = breakpointData.current;
					var comparison = breakpoints.indexOf(current) - breakpoints.indexOf(breakpoint);
					return comparison >= 0;
				}
				exports.VV = min;
				function max(breakpoint) {
					var current = breakpointData.current;
					var comparison = breakpoints.indexOf(current) - breakpoints.indexOf(breakpoint);
					return comparison <= 0;
				}
				__webpack_unused_export__ = max;
				function range(breakpointStart, breakpointEnd) {
					var current = breakpointData.current;
					var indexCurrent = breakpoints.indexOf(current);
					var indexStart = breakpoints.indexOf(breakpointStart);
					var indexEnd = breakpoints.indexOf(breakpointEnd);
					return indexStart <= indexCurrent && indexCurrent <= indexEnd;
				}
				__webpack_unused_export__ = range;
				function is() {
					var breakpoints = [];
					for (var _i = 0; _i < arguments.length; _i++) {
						breakpoints[_i] = arguments[_i];
					}
					var current = breakpointData.current;
					return breakpoints.some(function (breakpoint) { return breakpoint === current; });
				}
				__webpack_unused_export__ = is;
				function onChange(callback) {
					if (callbacks.indexOf(callback) === -1) {
						callbacks.push(callback);
					}
				}
				exports.z2 = onChange;
				function offChange(callback) {
					var index = callbacks.indexOf(callback);
					if (index !== -1) {
						callbacks.splice(index, 1);
					}
				}
				__webpack_unused_export__ = offChange;
				var styleSheetList = document.styleSheets;
				var mediaLists = Object.keys(styleSheetList).reduce(function (accumulator, key) {
					var stylesheet = styleSheetList[key];
					if (!stylesheet.href || stylesheet.href.indexOf('theme') === -1) {
						return accumulator;
					}
					try {
						var cssRules = stylesheet.cssRules;
						for (var i = 0; i < cssRules.length; i++) {
							var cssRule = stylesheet.cssRules[i];
							if (!(cssRule instanceof CSSMediaRule)) {
								continue;
							}
							for (var j = 0; j < cssRules.length; j++) {
								var cssMediaCssRule = cssRule.cssRules[j];
								if (!(cssMediaCssRule instanceof CSSStyleRule)) {
									continue;
								}
								if (cssMediaCssRule.selectorText && cssMediaCssRule.selectorText.indexOf('html::after') !== -1) {
									accumulator.push(cssRule.media);
								}
							}
						}
					}
					catch (_a) {
						return accumulator;
					}
					return accumulator;
				}, []);
				if (mediaLists.length > 0) {
					mediaLists.forEach(function (mediaList) {
						var mql = window.matchMedia(mediaList.mediaText);
						mql.addListener(function () {
							var currentBreakpoint = current();
							if (breakpointData.current !== currentBreakpoint) {
								breakpointData.previous = breakpointData.current;
								breakpointData.current = currentBreakpoint;
								callbacks.forEach(function (callback) { return callback(breakpointData); });
							}
						});
					});
				}
				else {
					window.addEventListener('resize', function () {
						var currentBreakpoint = current();
						if (breakpointData.current !== currentBreakpoint) {
							breakpointData.previous = breakpointData.current;
							breakpointData.current = currentBreakpoint;
							callbacks.forEach(function (callback) { return callback(breakpointData); });
						}
					});
				}


				/***/
}),

/***/ 766:
/***/ ((__unused_webpack_module, exports) => {

				"use strict";
				var __webpack_unused_export__;

				__webpack_unused_export__ = true;
				var EventHandler = /** @class */ (function () {
					function EventHandler() {
						this.events = [];
					}
					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener)
							return null;
						this.events.push({ el: el, event: event, listener: listener });
						el.addEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						if (!el || !event || !listener)
							return null;
						this.events = this.events.filter(function (e) {
							return el !== e.el
								|| event !== e.event || listener !== e.listener;
						});
						el.removeEventListener(event, listener);
						return { el: el, event: event, listener: listener };
					};
					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el, event = _a.event, listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};
					return EventHandler;
				}());
				exports.Z = EventHandler;


				/***/
}),

/***/ 729:
/***/ ((module) => {

				"use strict";



				var selectors = [
					'iframe[src*="player.vimeo.com"]',
					'iframe[src*="youtube.com"]',
					'iframe[src*="youtube-nocookie.com"]',
					'iframe[src*="kickstarter.com"][src*="video.html"]',
					'object'
				]

				var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}'

				module.exports = function (parentSelector, opts) {
					parentSelector = parentSelector || 'body'
					opts = opts || {}

					if (isObject(parentSelector)) {
						opts = parentSelector
						parentSelector = 'body'
					}

					opts.ignore = opts.ignore || ''
					opts.players = opts.players || ''

					var containers = queryAll(parentSelector)
					if (!hasLength(containers)) return

					if (!document.getElementById('fit-vids-style')) {
						var head = document.head || document.getElementsByTagName('head')[0]
						head.appendChild(styles())
					}

					var custom = toSelectorArray(opts.players) || []
					var ignored = toSelectorArray(opts.ignore) || []
					var selector = selectors
						.filter(notIgnored(ignored))
						.concat(custom)
						.join()

					if (!hasLength(selector)) return

					containers.forEach(function (container) {
						var videos = queryAll(container, selector)
						videos.forEach(function (video) {
							wrap(video)
						})
					})
				}

				function queryAll(el, selector) {
					if (typeof el === 'string') {
						selector = el
						el = document
					}
					return Array.prototype.slice.call(el.querySelectorAll(selector))
				}

				function toSelectorArray(input) {
					if (typeof input === 'string') {
						return input.split(',').map(trim).filter(hasLength)
					} else if (isArray(input)) {
						return flatten(input.map(toSelectorArray).filter(hasLength))
					}
					return input || []
				}

				function wrap(el) {
					if (/fluid-width-video-wrapper/.test(el.parentNode.className)) return

					var widthAttr = parseInt(el.getAttribute('width'), 10)
					var heightAttr = parseInt(el.getAttribute('height'), 10)

					var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth
					var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight
					var aspect = height / width

					el.removeAttribute('width')
					el.removeAttribute('height')

					var wrapper = document.createElement('div')
					el.parentNode.insertBefore(wrapper, el)
					wrapper.className = 'fluid-width-video-wrapper'
					wrapper.style.paddingTop = (aspect * 100) + '%'
					wrapper.appendChild(el)
				}

				function styles() {
					var div = document.createElement('div')
					div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>'
					return div.childNodes[1]
				}

				function notIgnored(ignored) {
					if (ignored.length < 1) {
						return function () {
							return true
						}
					}
					return function (selector) {
						return ignored.indexOf(selector) === -1
					}
				}

				function hasLength(input) {
					return input.length > 0
				}

				function trim(str) {
					return str.replace(/^\s+|\s+$/g, '')
				}

				function flatten(input) {
					return [].concat.apply([], input)
				}

				function isObject(input) {
					return Object.prototype.toString.call(input) === '[object Object]'
				}

				function isArray(input) {
					return Object.prototype.toString.call(input) === '[object Array]'
				}


				/***/
}),

/***/ 337:
/***/ (() => {

				/**
				 * Copyright 2016 Google Inc. All Rights Reserved.
				 *
				 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
				 *
				 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
				 *
				 */

				(function (window, document) {
					'use strict';


					// Exits early if all IntersectionObserver and IntersectionObserverEntry
					// features are natively supported.
					if ('IntersectionObserver' in window &&
						'IntersectionObserverEntry' in window &&
						'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

						// Minimal polyfill for Edge 15's lack of `isIntersecting`
						// See: https://github.com/w3c/IntersectionObserver/issues/211
						if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
							Object.defineProperty(window.IntersectionObserverEntry.prototype,
								'isIntersecting', {
								get: function () {
									return this.intersectionRatio > 0;
								}
							});
						}
						return;
					}


					/**
					 * An IntersectionObserver registry. This registry exists to hold a strong
					 * reference to IntersectionObserver instances currently observing a target
					 * element. Without this registry, instances without another reference may be
					 * garbage collected.
					 */
					var registry = [];


					/**
					 * Creates the global IntersectionObserverEntry constructor.
					 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
					 * @param {Object} entry A dictionary of instance properties.
					 * @constructor
					 */
					function IntersectionObserverEntry(entry) {
						this.time = entry.time;
						this.target = entry.target;
						this.rootBounds = entry.rootBounds;
						this.boundingClientRect = entry.boundingClientRect;
						this.intersectionRect = entry.intersectionRect || getEmptyRect();
						this.isIntersecting = !!entry.intersectionRect;

						// Calculates the intersection ratio.
						var targetRect = this.boundingClientRect;
						var targetArea = targetRect.width * targetRect.height;
						var intersectionRect = this.intersectionRect;
						var intersectionArea = intersectionRect.width * intersectionRect.height;

						// Sets intersection ratio.
						if (targetArea) {
							// Round the intersection ratio to avoid floating point math issues:
							// https://github.com/w3c/IntersectionObserver/issues/324
							this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
						} else {
							// If area is zero and is intersecting, sets to 1, otherwise to 0
							this.intersectionRatio = this.isIntersecting ? 1 : 0;
						}
					}


					/**
					 * Creates the global IntersectionObserver constructor.
					 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
					 * @param {Function} callback The function to be invoked after intersection
					 *     changes have queued. The function is not invoked if the queue has
					 *     been emptied by calling the `takeRecords` method.
					 * @param {Object=} opt_options Optional configuration options.
					 * @constructor
					 */
					function IntersectionObserver(callback, opt_options) {

						var options = opt_options || {};

						if (typeof callback != 'function') {
							throw new Error('callback must be a function');
						}

						if (options.root && options.root.nodeType != 1) {
							throw new Error('root must be an Element');
						}

						// Binds and throttles `this._checkForIntersections`.
						this._checkForIntersections = throttle(
							this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

						// Private properties.
						this._callback = callback;
						this._observationTargets = [];
						this._queuedEntries = [];
						this._rootMarginValues = this._parseRootMargin(options.rootMargin);

						// Public properties.
						this.thresholds = this._initThresholds(options.threshold);
						this.root = options.root || null;
						this.rootMargin = this._rootMarginValues.map(function (margin) {
							return margin.value + margin.unit;
						}).join(' ');
					}


					/**
					 * The minimum interval within which the document will be checked for
					 * intersection changes.
					 */
					IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


					/**
					 * The frequency in which the polyfill polls for intersection changes.
					 * this can be updated on a per instance basis and must be set prior to
					 * calling `observe` on the first target.
					 */
					IntersectionObserver.prototype.POLL_INTERVAL = null;

					/**
					 * Use a mutation observer on the root element
					 * to detect intersection changes.
					 */
					IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


					/**
					 * Starts observing a target element for intersection changes based on
					 * the thresholds values.
					 * @param {Element} target The DOM element to observe.
					 */
					IntersectionObserver.prototype.observe = function (target) {
						var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
							return item.element == target;
						});

						if (isTargetAlreadyObserved) {
							return;
						}

						if (!(target && target.nodeType == 1)) {
							throw new Error('target must be an Element');
						}

						this._registerInstance();
						this._observationTargets.push({ element: target, entry: null });
						this._monitorIntersections();
						this._checkForIntersections();
					};


					/**
					 * Stops observing a target element for intersection changes.
					 * @param {Element} target The DOM element to observe.
					 */
					IntersectionObserver.prototype.unobserve = function (target) {
						this._observationTargets =
							this._observationTargets.filter(function (item) {

								return item.element != target;
							});
						if (!this._observationTargets.length) {
							this._unmonitorIntersections();
							this._unregisterInstance();
						}
					};


					/**
					 * Stops observing all target elements for intersection changes.
					 */
					IntersectionObserver.prototype.disconnect = function () {
						this._observationTargets = [];
						this._unmonitorIntersections();
						this._unregisterInstance();
					};


					/**
					 * Returns any queue entries that have not yet been reported to the
					 * callback and clears the queue. This can be used in conjunction with the
					 * callback to obtain the absolute most up-to-date intersection information.
					 * @return {Array} The currently queued entries.
					 */
					IntersectionObserver.prototype.takeRecords = function () {
						var records = this._queuedEntries.slice();
						this._queuedEntries = [];
						return records;
					};


					/**
					 * Accepts the threshold value from the user configuration object and
					 * returns a sorted array of unique threshold values. If a value is not
					 * between 0 and 1 and error is thrown.
					 * @private
					 * @param {Array|number=} opt_threshold An optional threshold value or
					 *     a list of threshold values, defaulting to [0].
					 * @return {Array} A sorted list of unique and valid threshold values.
					 */
					IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
						var threshold = opt_threshold || [0];
						if (!Array.isArray(threshold)) threshold = [threshold];

						return threshold.sort().filter(function (t, i, a) {
							if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
								throw new Error('threshold must be a number between 0 and 1 inclusively');
							}
							return t !== a[i - 1];
						});
					};


					/**
					 * Accepts the rootMargin value from the user configuration object
					 * and returns an array of the four margin values as an object containing
					 * the value and unit properties. If any of the values are not properly
					 * formatted or use a unit other than px or %, and error is thrown.
					 * @private
					 * @param {string=} opt_rootMargin An optional rootMargin value,
					 *     defaulting to '0px'.
					 * @return {Array<Object>} An array of margin objects with the keys
					 *     value and unit.
					 */
					IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
						var marginString = opt_rootMargin || '0px';
						var margins = marginString.split(/\s+/).map(function (margin) {
							var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
							if (!parts) {
								throw new Error('rootMargin must be specified in pixels or percent');
							}
							return { value: parseFloat(parts[1]), unit: parts[2] };
						});

						// Handles shorthand.
						margins[1] = margins[1] || margins[0];
						margins[2] = margins[2] || margins[0];
						margins[3] = margins[3] || margins[1];

						return margins;
					};


					/**
					 * Starts polling for intersection changes if the polling is not already
					 * happening, and if the page's visibility state is visible.
					 * @private
					 */
					IntersectionObserver.prototype._monitorIntersections = function () {
						if (!this._monitoringIntersections) {
							this._monitoringIntersections = true;

							// If a poll interval is set, use polling instead of listening to
							// resize and scroll events or DOM mutations.
							if (this.POLL_INTERVAL) {
								this._monitoringInterval = setInterval(
									this._checkForIntersections, this.POLL_INTERVAL);
							}
							else {
								addEvent(window, 'resize', this._checkForIntersections, true);
								addEvent(document, 'scroll', this._checkForIntersections, true);

								if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
									this._domObserver = new MutationObserver(this._checkForIntersections);
									this._domObserver.observe(document, {
										attributes: true,
										childList: true,
										characterData: true,
										subtree: true
									});
								}
							}
						}
					};


					/**
					 * Stops polling for intersection changes.
					 * @private
					 */
					IntersectionObserver.prototype._unmonitorIntersections = function () {
						if (this._monitoringIntersections) {
							this._monitoringIntersections = false;

							clearInterval(this._monitoringInterval);
							this._monitoringInterval = null;

							removeEvent(window, 'resize', this._checkForIntersections, true);
							removeEvent(document, 'scroll', this._checkForIntersections, true);

							if (this._domObserver) {
								this._domObserver.disconnect();
								this._domObserver = null;
							}
						}
					};


					/**
					 * Scans each observation target for intersection changes and adds them
					 * to the internal entries queue. If new entries are found, it
					 * schedules the callback to be invoked.
					 * @private
					 */
					IntersectionObserver.prototype._checkForIntersections = function () {
						var rootIsInDom = this._rootIsInDom();
						var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

						this._observationTargets.forEach(function (item) {
							var target = item.element;
							var targetRect = getBoundingClientRect(target);
							var rootContainsTarget = this._rootContainsTarget(target);
							var oldEntry = item.entry;
							var intersectionRect = rootIsInDom && rootContainsTarget &&
								this._computeTargetAndRootIntersection(target, rootRect);

							var newEntry = item.entry = new IntersectionObserverEntry({
								time: now(),
								target: target,
								boundingClientRect: targetRect,
								rootBounds: rootRect,
								intersectionRect: intersectionRect
							});

							if (!oldEntry) {
								this._queuedEntries.push(newEntry);
							} else if (rootIsInDom && rootContainsTarget) {
								// If the new entry intersection ratio has crossed any of the
								// thresholds, add a new entry.
								if (this._hasCrossedThreshold(oldEntry, newEntry)) {
									this._queuedEntries.push(newEntry);
								}
							} else {
								// If the root is not in the DOM or target is not contained within
								// root but the previous entry for this target had an intersection,
								// add a new record indicating removal.
								if (oldEntry && oldEntry.isIntersecting) {
									this._queuedEntries.push(newEntry);
								}
							}
						}, this);

						if (this._queuedEntries.length) {
							this._callback(this.takeRecords(), this);
						}
					};


					/**
					 * Accepts a target and root rect computes the intersection between then
					 * following the algorithm in the spec.
					 * TODO(philipwalton): at this time clip-path is not considered.
					 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
					 * @param {Element} target The target DOM element
					 * @param {Object} rootRect The bounding rect of the root after being
					 *     expanded by the rootMargin value.
					 * @return {?Object} The final intersection rect object or undefined if no
					 *     intersection is found.
					 * @private
					 */
					IntersectionObserver.prototype._computeTargetAndRootIntersection =
						function (target, rootRect) {

							// If the element isn't displayed, an intersection can't happen.
							if (window.getComputedStyle(target).display == 'none') return;

							var targetRect = getBoundingClientRect(target);
							var intersectionRect = targetRect;
							var parent = getParentNode(target);
							var atRoot = false;

							while (!atRoot) {
								var parentRect = null;
								var parentComputedStyle = parent.nodeType == 1 ?
									window.getComputedStyle(parent) : {};

								// If the parent isn't displayed, an intersection can't happen.
								if (parentComputedStyle.display == 'none') return;

								if (parent == this.root || parent == document) {
									atRoot = true;
									parentRect = rootRect;
								} else {
									// If the element has a non-visible overflow, and it's not the <body>
									// or <html> element, update the intersection rect.
									// Note: <body> and <html> cannot be clipped to a rect that's not also
									// the document rect, so no need to compute a new intersection.
									if (parent != document.body &&
										parent != document.documentElement &&
										parentComputedStyle.overflow != 'visible') {
										parentRect = getBoundingClientRect(parent);
									}
								}

								// If either of the above conditionals set a new parentRect,
								// calculate new intersection data.
								if (parentRect) {
									intersectionRect = computeRectIntersection(parentRect, intersectionRect);

									if (!intersectionRect) break;
								}
								parent = getParentNode(parent);
							}
							return intersectionRect;
						};


					/**
					 * Returns the root rect after being expanded by the rootMargin value.
					 * @return {Object} The expanded root rect.
					 * @private
					 */
					IntersectionObserver.prototype._getRootRect = function () {
						var rootRect;
						if (this.root) {
							rootRect = getBoundingClientRect(this.root);
						} else {
							// Use <html>/<body> instead of window since scroll bars affect size.
							var html = document.documentElement;
							var body = document.body;
							rootRect = {
								top: 0,
								left: 0,
								right: html.clientWidth || body.clientWidth,
								width: html.clientWidth || body.clientWidth,
								bottom: html.clientHeight || body.clientHeight,
								height: html.clientHeight || body.clientHeight
							};
						}
						return this._expandRectByRootMargin(rootRect);
					};


					/**
					 * Accepts a rect and expands it by the rootMargin value.
					 * @param {Object} rect The rect object to expand.
					 * @return {Object} The expanded rect.
					 * @private
					 */
					IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
						var margins = this._rootMarginValues.map(function (margin, i) {
							return margin.unit == 'px' ? margin.value :
								margin.value * (i % 2 ? rect.width : rect.height) / 100;
						});
						var newRect = {
							top: rect.top - margins[0],
							right: rect.right + margins[1],
							bottom: rect.bottom + margins[2],
							left: rect.left - margins[3]
						};
						newRect.width = newRect.right - newRect.left;
						newRect.height = newRect.bottom - newRect.top;

						return newRect;
					};


					/**
					 * Accepts an old and new entry and returns true if at least one of the
					 * threshold values has been crossed.
					 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
					 *    particular target element or null if no previous entry exists.
					 * @param {IntersectionObserverEntry} newEntry The current entry for a
					 *    particular target element.
					 * @return {boolean} Returns true if a any threshold has been crossed.
					 * @private
					 */
					IntersectionObserver.prototype._hasCrossedThreshold =
						function (oldEntry, newEntry) {

							// To make comparing easier, an entry that has a ratio of 0
							// but does not actually intersect is given a value of -1
							var oldRatio = oldEntry && oldEntry.isIntersecting ?
								oldEntry.intersectionRatio || 0 : -1;
							var newRatio = newEntry.isIntersecting ?
								newEntry.intersectionRatio || 0 : -1;

							// Ignore unchanged ratios
							if (oldRatio === newRatio) return;

							for (var i = 0; i < this.thresholds.length; i++) {
								var threshold = this.thresholds[i];

								// Return true if an entry matches a threshold or if the new ratio
								// and the old ratio are on the opposite sides of a threshold.
								if (threshold == oldRatio || threshold == newRatio ||
									threshold < oldRatio !== threshold < newRatio) {
									return true;
								}
							}
						};


					/**
					 * Returns whether or not the root element is an element and is in the DOM.
					 * @return {boolean} True if the root element is an element and is in the DOM.
					 * @private
					 */
					IntersectionObserver.prototype._rootIsInDom = function () {
						return !this.root || containsDeep(document, this.root);
					};


					/**
					 * Returns whether or not the target element is a child of root.
					 * @param {Element} target The target element to check.
					 * @return {boolean} True if the target element is a child of root.
					 * @private
					 */
					IntersectionObserver.prototype._rootContainsTarget = function (target) {
						return containsDeep(this.root || document, target);
					};


					/**
					 * Adds the instance to the global IntersectionObserver registry if it isn't
					 * already present.
					 * @private
					 */
					IntersectionObserver.prototype._registerInstance = function () {
						if (registry.indexOf(this) < 0) {
							registry.push(this);
						}
					};


					/**
					 * Removes the instance from the global IntersectionObserver registry.
					 * @private
					 */
					IntersectionObserver.prototype._unregisterInstance = function () {
						var index = registry.indexOf(this);
						if (index != -1) registry.splice(index, 1);
					};


					/**
					 * Returns the result of the performance.now() method or null in browsers
					 * that don't support the API.
					 * @return {number} The elapsed time since the page was requested.
					 */
					function now() {
						return window.performance && performance.now && performance.now();
					}


					/**
					 * Throttles a function and delays its execution, so it's only called at most
					 * once within a given time period.
					 * @param {Function} fn The function to throttle.
					 * @param {number} timeout The amount of time that must pass before the
					 *     function can be called again.
					 * @return {Function} The throttled function.
					 */
					function throttle(fn, timeout) {
						var timer = null;
						return function () {
							if (!timer) {
								timer = setTimeout(function () {
									fn();
									timer = null;
								}, timeout);
							}
						};
					}


					/**
					 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
					 * @param {Node} node The DOM node to add the event handler to.
					 * @param {string} event The event name.
					 * @param {Function} fn The event handler to add.
					 * @param {boolean} opt_useCapture Optionally adds the even to the capture
					 *     phase. Note: this only works in modern browsers.
					 */
					function addEvent(node, event, fn, opt_useCapture) {
						if (typeof node.addEventListener == 'function') {
							node.addEventListener(event, fn, opt_useCapture || false);
						}
						else if (typeof node.attachEvent == 'function') {
							node.attachEvent('on' + event, fn);
						}
					}


					/**
					 * Removes a previously added event handler from a DOM node.
					 * @param {Node} node The DOM node to remove the event handler from.
					 * @param {string} event The event name.
					 * @param {Function} fn The event handler to remove.
					 * @param {boolean} opt_useCapture If the event handler was added with this
					 *     flag set to true, it should be set to true here in order to remove it.
					 */
					function removeEvent(node, event, fn, opt_useCapture) {
						if (typeof node.removeEventListener == 'function') {
							node.removeEventListener(event, fn, opt_useCapture || false);
						}
						else if (typeof node.detatchEvent == 'function') {
							node.detatchEvent('on' + event, fn);
						}
					}


					/**
					 * Returns the intersection between two rect objects.
					 * @param {Object} rect1 The first rect.
					 * @param {Object} rect2 The second rect.
					 * @return {?Object} The intersection rect or undefined if no intersection
					 *     is found.
					 */
					function computeRectIntersection(rect1, rect2) {
						var top = Math.max(rect1.top, rect2.top);
						var bottom = Math.min(rect1.bottom, rect2.bottom);
						var left = Math.max(rect1.left, rect2.left);
						var right = Math.min(rect1.right, rect2.right);
						var width = right - left;
						var height = bottom - top;

						return (width >= 0 && height >= 0) && {
							top: top,
							bottom: bottom,
							left: left,
							right: right,
							width: width,
							height: height
						};
					}


					/**
					 * Shims the native getBoundingClientRect for compatibility with older IE.
					 * @param {Element} el The element whose bounding rect to get.
					 * @return {Object} The (possibly shimmed) rect of the element.
					 */
					function getBoundingClientRect(el) {
						var rect;

						try {
							rect = el.getBoundingClientRect();
						} catch (err) {
							// Ignore Windows 7 IE11 "Unspecified error"
							// https://github.com/w3c/IntersectionObserver/pull/205
						}

						if (!rect) return getEmptyRect();

						// Older IE
						if (!(rect.width && rect.height)) {
							rect = {
								top: rect.top,
								right: rect.right,
								bottom: rect.bottom,
								left: rect.left,
								width: rect.right - rect.left,
								height: rect.bottom - rect.top
							};
						}
						return rect;
					}


					/**
					 * Returns an empty rect object. An empty rect is returned when an element
					 * is not in the DOM.
					 * @return {Object} The empty rect.
					 */
					function getEmptyRect() {
						return {
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							width: 0,
							height: 0
						};
					}

					/**
					 * Checks to see if a parent element contains a child element (including inside
					 * shadow DOM).
					 * @param {Node} parent The parent element.
					 * @param {Node} child The child element.
					 * @return {boolean} True if the parent node contains the child node.
					 */
					function containsDeep(parent, child) {
						var node = child;
						while (node) {
							if (node == parent) return true;

							node = getParentNode(node);
						}
						return false;
					}


					/**
					 * Gets the parent node of an element or its host element if the parent node
					 * is a shadow root.
					 * @param {Node} node The node whose parent to get.
					 * @return {Node|null} The parent node or null if no parent exists.
					 */
					function getParentNode(node) {
						var parent = node.parentNode;

						if (parent && parent.nodeType == 11 && parent.host) {
							// If the parent is a shadow root, return the host element.
							return parent.host;
						}
						return parent;
					}


					// Exposes the constructors globally.
					window.IntersectionObserver = IntersectionObserver;
					window.IntersectionObserverEntry = IntersectionObserverEntry;

				}(window, document));


				/***/
}),

/***/ 755:
/***/ (function (module, exports) {

				var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
				(function (global, factory) {

					"use strict";

					if (true && typeof module.exports === "object") {

						// For CommonJS and CommonJS-like environments where a proper `window`
						// is present, execute the factory and get jQuery.
						// For environments that do not have a `window` with a `document`
						// (such as Node.js), expose a factory as module.exports.
						// This accentuates the need for the creation of a real `window`.
						// e.g. var jQuery = require("jquery")(window);
						// See ticket #14549 for more info.
						module.exports = global.document ?
							factory(global, true) :
							function (w) {
								if (!w.document) {
									throw new Error("jQuery requires a window with a document");
								}
								return factory(w);
							};
					} else {
						factory(global);
					}

					// Pass this if window is not defined yet
				})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

					// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
					// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
					// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
					// enough that all such attempts are guarded in a try block.
					"use strict";

					var arr = [];

					var document = window.document;

					var getProto = Object.getPrototypeOf;

					var slice = arr.slice;

					var concat = arr.concat;

					var push = arr.push;

					var indexOf = arr.indexOf;

					var class2type = {};

					var toString = class2type.toString;

					var hasOwn = class2type.hasOwnProperty;

					var fnToString = hasOwn.toString;

					var ObjectFunctionString = fnToString.call(Object);

					var support = {};

					var isFunction = function isFunction(obj) {

						// Support: Chrome <=57, Firefox <=52
						// In some browsers, typeof returns "function" for HTML <object> elements
						// (i.e., `typeof document.createElement( "object" ) === "function"`).
						// We don't want to classify *any* DOM node as a function.
						return typeof obj === "function" && typeof obj.nodeType !== "number";
					};


					var isWindow = function isWindow(obj) {
						return obj != null && obj === obj.window;
					};




					var preservedScriptAttributes = {
						type: true,
						src: true,
						nonce: true,
						noModule: true
					};

					function DOMEval(code, node, doc) {
						doc = doc || document;

						var i, val,
							script = doc.createElement("script");

						script.text = code;
						if (node) {
							for (i in preservedScriptAttributes) {

								// Support: Firefox 64+, Edge 18+
								// Some browsers don't support the "nonce" property on scripts.
								// On the other hand, just using `getAttribute` is not enough as
								// the `nonce` attribute is reset to an empty string whenever it
								// becomes browsing-context connected.
								// See https://github.com/whatwg/html/issues/2369
								// See https://html.spec.whatwg.org/#nonce-attributes
								// The `node.getAttribute` check was added for the sake of
								// `jQuery.globalEval` so that it can fake a nonce-containing node
								// via an object.
								val = node[i] || node.getAttribute && node.getAttribute(i);
								if (val) {
									script.setAttribute(i, val);
								}
							}
						}
						doc.head.appendChild(script).parentNode.removeChild(script);
					}


					function toType(obj) {
						if (obj == null) {
							return obj + "";
						}

						// Support: Android <=2.3 only (functionish RegExp)
						return typeof obj === "object" || typeof obj === "function" ?
							class2type[toString.call(obj)] || "object" :
							typeof obj;
					}
					/* global Symbol */
					// Defining this global in .eslintrc.json would create a danger of using the global
					// unguarded in another place, it seems safer to define global only for this module



					var
						version = "3.4.1",

						// Define a local copy of jQuery
						jQuery = function (selector, context) {

							// The jQuery object is actually just the init constructor 'enhanced'
							// Need init if jQuery is called (just allow error to be thrown if not included)
							return new jQuery.fn.init(selector, context);
						},

						// Support: Android <=4.0 only
						// Make sure we trim BOM and NBSP
						rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

					jQuery.fn = jQuery.prototype = {

						// The current version of jQuery being used
						jquery: version,

						constructor: jQuery,

						// The default length of a jQuery object is 0
						length: 0,

						toArray: function () {
							return slice.call(this);
						},

						// Get the Nth element in the matched element set OR
						// Get the whole matched element set as a clean array
						get: function (num) {

							// Return all the elements in a clean array
							if (num == null) {
								return slice.call(this);
							}

							// Return just the one element from the set
							return num < 0 ? this[num + this.length] : this[num];
						},

						// Take an array of elements and push it onto the stack
						// (returning the new matched element set)
						pushStack: function (elems) {

							// Build a new jQuery matched element set
							var ret = jQuery.merge(this.constructor(), elems);

							// Add the old object onto the stack (as a reference)
							ret.prevObject = this;

							// Return the newly-formed element set
							return ret;
						},

						// Execute a callback for every element in the matched set.
						each: function (callback) {
							return jQuery.each(this, callback);
						},

						map: function (callback) {
							return this.pushStack(jQuery.map(this, function (elem, i) {
								return callback.call(elem, i, elem);
							}));
						},

						slice: function () {
							return this.pushStack(slice.apply(this, arguments));
						},

						first: function () {
							return this.eq(0);
						},

						last: function () {
							return this.eq(-1);
						},

						eq: function (i) {
							var len = this.length,
								j = +i + (i < 0 ? len : 0);
							return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
						},

						end: function () {
							return this.prevObject || this.constructor();
						},

						// For internal use only.
						// Behaves like an Array's method, not like a jQuery method.
						push: push,
						sort: arr.sort,
						splice: arr.splice
					};

					jQuery.extend = jQuery.fn.extend = function () {
						var options, name, src, copy, copyIsArray, clone,
							target = arguments[0] || {},
							i = 1,
							length = arguments.length,
							deep = false;

						// Handle a deep copy situation
						if (typeof target === "boolean") {
							deep = target;

							// Skip the boolean and the target
							target = arguments[i] || {};
							i++;
						}

						// Handle case when target is a string or something (possible in deep copy)
						if (typeof target !== "object" && !isFunction(target)) {
							target = {};
						}

						// Extend jQuery itself if only one argument is passed
						if (i === length) {
							target = this;
							i--;
						}

						for (; i < length; i++) {

							// Only deal with non-null/undefined values
							if ((options = arguments[i]) != null) {

								// Extend the base object
								for (name in options) {
									copy = options[name];

									// Prevent Object.prototype pollution
									// Prevent never-ending loop
									if (name === "__proto__" || target === copy) {
										continue;
									}

									// Recurse if we're merging plain objects or arrays
									if (deep && copy && (jQuery.isPlainObject(copy) ||
										(copyIsArray = Array.isArray(copy)))) {
										src = target[name];

										// Ensure proper type for the source value
										if (copyIsArray && !Array.isArray(src)) {
											clone = [];
										} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
											clone = {};
										} else {
											clone = src;
										}
										copyIsArray = false;

										// Never move original objects, clone them
										target[name] = jQuery.extend(deep, clone, copy);

										// Don't bring in undefined values
									} else if (copy !== undefined) {
										target[name] = copy;
									}
								}
							}
						}

						// Return the modified object
						return target;
					};

					jQuery.extend({

						// Unique for each copy of jQuery on the page
						expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

						// Assume jQuery is ready without the ready module
						isReady: true,

						error: function (msg) {
							throw new Error(msg);
						},

						noop: function () { },

						isPlainObject: function (obj) {
							var proto, Ctor;

							// Detect obvious negatives
							// Use toString instead of jQuery.type to catch host objects
							if (!obj || toString.call(obj) !== "[object Object]") {
								return false;
							}

							proto = getProto(obj);

							// Objects with no prototype (e.g., `Object.create( null )`) are plain
							if (!proto) {
								return true;
							}

							// Objects with prototype are plain iff they were constructed by a global Object function
							Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
							return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
						},

						isEmptyObject: function (obj) {
							var name;

							for (name in obj) {
								return false;
							}
							return true;
						},

						// Evaluates a script in a global context
						globalEval: function (code, options) {
							DOMEval(code, { nonce: options && options.nonce });
						},

						each: function (obj, callback) {
							var length, i = 0;

							if (isArrayLike(obj)) {
								length = obj.length;
								for (; i < length; i++) {
									if (callback.call(obj[i], i, obj[i]) === false) {
										break;
									}
								}
							} else {
								for (i in obj) {
									if (callback.call(obj[i], i, obj[i]) === false) {
										break;
									}
								}
							}

							return obj;
						},

						// Support: Android <=4.0 only
						trim: function (text) {
							return text == null ?
								"" :
								(text + "").replace(rtrim, "");
						},

						// results is for internal usage only
						makeArray: function (arr, results) {
							var ret = results || [];

							if (arr != null) {
								if (isArrayLike(Object(arr))) {
									jQuery.merge(ret,
										typeof arr === "string" ?
											[arr] : arr
									);
								} else {
									push.call(ret, arr);
								}
							}

							return ret;
						},

						inArray: function (elem, arr, i) {
							return arr == null ? -1 : indexOf.call(arr, elem, i);
						},

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						merge: function (first, second) {
							var len = +second.length,
								j = 0,
								i = first.length;

							for (; j < len; j++) {
								first[i++] = second[j];
							}

							first.length = i;

							return first;
						},

						grep: function (elems, callback, invert) {
							var callbackInverse,
								matches = [],
								i = 0,
								length = elems.length,
								callbackExpect = !invert;

							// Go through the array, only saving the items
							// that pass the validator function
							for (; i < length; i++) {
								callbackInverse = !callback(elems[i], i);
								if (callbackInverse !== callbackExpect) {
									matches.push(elems[i]);
								}
							}

							return matches;
						},

						// arg is for internal usage only
						map: function (elems, callback, arg) {
							var length, value,
								i = 0,
								ret = [];

							// Go through the array, translating each of the items to their new values
							if (isArrayLike(elems)) {
								length = elems.length;
								for (; i < length; i++) {
									value = callback(elems[i], i, arg);

									if (value != null) {
										ret.push(value);
									}
								}

								// Go through every key on the object,
							} else {
								for (i in elems) {
									value = callback(elems[i], i, arg);

									if (value != null) {
										ret.push(value);
									}
								}
							}

							// Flatten any nested arrays
							return concat.apply([], ret);
						},

						// A global GUID counter for objects
						guid: 1,

						// jQuery.support is not used in Core but other projects attach their
						// properties to it so it needs to exist.
						support: support
					});

					if (typeof Symbol === "function") {
						jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
					}

					// Populate the class2type map
					jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
						function (i, name) {
							class2type["[object " + name + "]"] = name.toLowerCase();
						});

					function isArrayLike(obj) {

						// Support: real iOS 8.2 only (not reproducible in simulator)
						// `in` check used to prevent JIT error (gh-2145)
						// hasOwn isn't used here due to false negatives
						// regarding Nodelist length in IE
						var length = !!obj && "length" in obj && obj.length,
							type = toType(obj);

						if (isFunction(obj) || isWindow(obj)) {
							return false;
						}

						return type === "array" || length === 0 ||
							typeof length === "number" && length > 0 && (length - 1) in obj;
					}
					var Sizzle =
						/*!
						 * Sizzle CSS Selector Engine v2.3.4
						 * https://sizzlejs.com/
						 *
						 * Copyright JS Foundation and other contributors
						 * Released under the MIT license
						 * https://js.foundation/
						 *
						 * Date: 2019-04-08
						 */
						(function (window) {

							var i,
								support,
								Expr,
								getText,
								isXML,
								tokenize,
								compile,
								select,
								outermostContext,
								sortInput,
								hasDuplicate,

								// Local document vars
								setDocument,
								document,
								docElem,
								documentIsHTML,
								rbuggyQSA,
								rbuggyMatches,
								matches,
								contains,

								// Instance-specific data
								expando = "sizzle" + 1 * new Date(),
								preferredDoc = window.document,
								dirruns = 0,
								done = 0,
								classCache = createCache(),
								tokenCache = createCache(),
								compilerCache = createCache(),
								nonnativeSelectorCache = createCache(),
								sortOrder = function (a, b) {
									if (a === b) {
										hasDuplicate = true;
									}
									return 0;
								},

								// Instance methods
								hasOwn = ({}).hasOwnProperty,
								arr = [],
								pop = arr.pop,
								push_native = arr.push,
								push = arr.push,
								slice = arr.slice,
								// Use a stripped-down indexOf as it's faster than native
								// https://jsperf.com/thor-indexof-vs-for/5
								indexOf = function (list, elem) {
									var i = 0,
										len = list.length;
									for (; i < len; i++) {
										if (list[i] === elem) {
											return i;
										}
									}
									return -1;
								},

								booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

								// Regular expressions

								// http://www.w3.org/TR/css3-selectors/#whitespace
								whitespace = "[\\x20\\t\\r\\n\\f]",

								// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
								identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

								// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
								attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
									// Operator (capture 2)
									"*([*^$|!~]?=)" + whitespace +
									// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
									"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
									"*\\]",

								pseudos = ":(" + identifier + ")(?:\\((" +
									// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
									// 1. quoted (capture 3; capture 4 or capture 5)
									"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
									// 2. simple (capture 6)
									"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
									// 3. anything else (capture 2)
									".*" +
									")\\)|)",

								// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
								rwhitespace = new RegExp(whitespace + "+", "g"),
								rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),

								rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
								rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
								rdescend = new RegExp(whitespace + "|>"),

								rpseudo = new RegExp(pseudos),
								ridentifier = new RegExp("^" + identifier + "$"),

								matchExpr = {
									"ID": new RegExp("^#(" + identifier + ")"),
									"CLASS": new RegExp("^\\.(" + identifier + ")"),
									"TAG": new RegExp("^(" + identifier + "|[*])"),
									"ATTR": new RegExp("^" + attributes),
									"PSEUDO": new RegExp("^" + pseudos),
									"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
										"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
										"*(\\d+)|))" + whitespace + "*\\)|)", "i"),
									"bool": new RegExp("^(?:" + booleans + ")$", "i"),
									// For use in libraries implementing .is()
									// We use this for POS matching in `select`
									"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
										whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
								},

								rhtml = /HTML$/i,
								rinputs = /^(?:input|select|textarea|button)$/i,
								rheader = /^h\d$/i,

								rnative = /^[^{]+\{\s*\[native \w/,

								// Easily-parseable/retrievable ID or TAG or CLASS selectors
								rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

								rsibling = /[+~]/,

								// CSS escapes
								// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
								runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
								funescape = function (_, escaped, escapedWhitespace) {
									var high = "0x" + escaped - 0x10000;
									// NaN means non-codepoint
									// Support: Firefox<24
									// Workaround erroneous numeric interpretation of +"0x"
									return high !== high || escapedWhitespace ?
										escaped :
										high < 0 ?
											// BMP codepoint
											String.fromCharCode(high + 0x10000) :
											// Supplemental Plane codepoint (surrogate pair)
											String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
								},

								// CSS string/identifier serialization
								// https://drafts.csswg.org/cssom/#common-serializing-idioms
								rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
								fcssescape = function (ch, asCodePoint) {
									if (asCodePoint) {

										// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
										if (ch === "\0") {
											return "\uFFFD";
										}

										// Control characters and (dependent upon position) numbers get escaped as code points
										return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
									}

									// Other potentially-special ASCII characters get backslash-escaped
									return "\\" + ch;
								},

								// Used for iframes
								// See setDocument()
								// Removing the function wrapper causes a "Permission Denied"
								// error in IE
								unloadHandler = function () {
									setDocument();
								},

								inDisabledFieldset = addCombinator(
									function (elem) {
										return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
									},
									{ dir: "parentNode", next: "legend" }
								);

							// Optimize for push.apply( _, NodeList )
							try {
								push.apply(
									(arr = slice.call(preferredDoc.childNodes)),
									preferredDoc.childNodes
								);
								// Support: Android<4.0
								// Detect silently failing push.apply
								arr[preferredDoc.childNodes.length].nodeType;
							} catch (e) {
								push = {
									apply: arr.length ?

										// Leverage slice if possible
										function (target, els) {
											push_native.apply(target, slice.call(els));
										} :

										// Support: IE<9
										// Otherwise append directly
										function (target, els) {
											var j = target.length,
												i = 0;
											// Can't trust NodeList.length
											while ((target[j++] = els[i++])) { }
											target.length = j - 1;
										}
								};
							}

							function Sizzle(selector, context, results, seed) {
								var m, i, elem, nid, match, groups, newSelector,
									newContext = context && context.ownerDocument,

									// nodeType defaults to 9, since context defaults to document
									nodeType = context ? context.nodeType : 9;

								results = results || [];

								// Return early from calls with invalid selector or context
								if (typeof selector !== "string" || !selector ||
									nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

									return results;
								}

								// Try to shortcut find operations (as opposed to filters) in HTML documents
								if (!seed) {

									if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
										setDocument(context);
									}
									context = context || document;

									if (documentIsHTML) {

										// If the selector is sufficiently simple, try using a "get*By*" DOM method
										// (excepting DocumentFragment context, where the methods don't exist)
										if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

											// ID selector
											if ((m = match[1])) {

												// Document context
												if (nodeType === 9) {
													if ((elem = context.getElementById(m))) {

														// Support: IE, Opera, Webkit
														// TODO: identify versions
														// getElementById can match elements by name instead of ID
														if (elem.id === m) {
															results.push(elem);
															return results;
														}
													} else {
														return results;
													}

													// Element context
												} else {

													// Support: IE, Opera, Webkit
													// TODO: identify versions
													// getElementById can match elements by name instead of ID
													if (newContext && (elem = newContext.getElementById(m)) &&
														contains(context, elem) &&
														elem.id === m) {

														results.push(elem);
														return results;
													}
												}

												// Type selector
											} else if (match[2]) {
												push.apply(results, context.getElementsByTagName(selector));
												return results;

												// Class selector
											} else if ((m = match[3]) && support.getElementsByClassName &&
												context.getElementsByClassName) {

												push.apply(results, context.getElementsByClassName(m));
												return results;
											}
										}

										// Take advantage of querySelectorAll
										if (support.qsa &&
											!nonnativeSelectorCache[selector + " "] &&
											(!rbuggyQSA || !rbuggyQSA.test(selector)) &&

											// Support: IE 8 only
											// Exclude object elements
											(nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {

											newSelector = selector;
											newContext = context;

											// qSA considers elements outside a scoping root when evaluating child or
											// descendant combinators, which is not what we want.
											// In such cases, we work around the behavior by prefixing every selector in the
											// list with an ID selector referencing the scope context.
											// Thanks to Andrew Dupont for this technique.
											if (nodeType === 1 && rdescend.test(selector)) {

												// Capture the context ID, setting it first if necessary
												if ((nid = context.getAttribute("id"))) {
													nid = nid.replace(rcssescape, fcssescape);
												} else {
													context.setAttribute("id", (nid = expando));
												}

												// Prefix every selector in the list
												groups = tokenize(selector);
												i = groups.length;
												while (i--) {
													groups[i] = "#" + nid + " " + toSelector(groups[i]);
												}
												newSelector = groups.join(",");

												// Expand context for sibling selectors
												newContext = rsibling.test(selector) && testContext(context.parentNode) ||
													context;
											}

											try {
												push.apply(results,
													newContext.querySelectorAll(newSelector)
												);
												return results;
											} catch (qsaError) {
												nonnativeSelectorCache(selector, true);
											} finally {
												if (nid === expando) {
													context.removeAttribute("id");
												}
											}
										}
									}
								}

								// All others
								return select(selector.replace(rtrim, "$1"), context, results, seed);
							}

							/**
							 * Create key-value caches of limited size
							 * @returns {function(string, object)} Returns the Object data after storing it on itself with
							 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
							 *	deleting the oldest entry
							 */
							function createCache() {
								var keys = [];

								function cache(key, value) {
									// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
									if (keys.push(key + " ") > Expr.cacheLength) {
										// Only keep the most recent entries
										delete cache[keys.shift()];
									}
									return (cache[key + " "] = value);
								}
								return cache;
							}

							/**
							 * Mark a function for special use by Sizzle
							 * @param {Function} fn The function to mark
							 */
							function markFunction(fn) {
								fn[expando] = true;
								return fn;
							}

							/**
							 * Support testing using an element
							 * @param {Function} fn Passed the created element and returns a boolean result
							 */
							function assert(fn) {
								var el = document.createElement("fieldset");

								try {
									return !!fn(el);
								} catch (e) {
									return false;
								} finally {
									// Remove from its parent by default
									if (el.parentNode) {
										el.parentNode.removeChild(el);
									}
									// release memory in IE
									el = null;
								}
							}

							/**
							 * Adds the same handler for all of the specified attrs
							 * @param {String} attrs Pipe-separated list of attributes
							 * @param {Function} handler The method that will be applied
							 */
							function addHandle(attrs, handler) {
								var arr = attrs.split("|"),
									i = arr.length;

								while (i--) {
									Expr.attrHandle[arr[i]] = handler;
								}
							}

							/**
							 * Checks document order of two siblings
							 * @param {Element} a
							 * @param {Element} b
							 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
							 */
							function siblingCheck(a, b) {
								var cur = b && a,
									diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
										a.sourceIndex - b.sourceIndex;

								// Use IE sourceIndex if available on both nodes
								if (diff) {
									return diff;
								}

								// Check if b follows a
								if (cur) {
									while ((cur = cur.nextSibling)) {
										if (cur === b) {
											return -1;
										}
									}
								}

								return a ? 1 : -1;
							}

							/**
							 * Returns a function to use in pseudos for input types
							 * @param {String} type
							 */
							function createInputPseudo(type) {
								return function (elem) {
									var name = elem.nodeName.toLowerCase();
									return name === "input" && elem.type === type;
								};
							}

							/**
							 * Returns a function to use in pseudos for buttons
							 * @param {String} type
							 */
							function createButtonPseudo(type) {
								return function (elem) {
									var name = elem.nodeName.toLowerCase();
									return (name === "input" || name === "button") && elem.type === type;
								};
							}

							/**
							 * Returns a function to use in pseudos for :enabled/:disabled
							 * @param {Boolean} disabled true for :disabled; false for :enabled
							 */
							function createDisabledPseudo(disabled) {

								// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
								return function (elem) {

									// Only certain elements can match :enabled or :disabled
									// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
									// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
									if ("form" in elem) {

										// Check for inherited disabledness on relevant non-disabled elements:
										// * listed form-associated elements in a disabled fieldset
										//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
										//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
										// * option elements in a disabled optgroup
										//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
										// All such elements have a "form" property.
										if (elem.parentNode && elem.disabled === false) {

											// Option elements defer to a parent optgroup if present
											if ("label" in elem) {
												if ("label" in elem.parentNode) {
													return elem.parentNode.disabled === disabled;
												} else {
													return elem.disabled === disabled;
												}
											}

											// Support: IE 6 - 11
											// Use the isDisabled shortcut property to check for disabled fieldset ancestors
											return elem.isDisabled === disabled ||

												// Where there is no isDisabled, check manually
												/* jshint -W018 */
												elem.isDisabled !== !disabled &&
												inDisabledFieldset(elem) === disabled;
										}

										return elem.disabled === disabled;

										// Try to winnow out elements that can't be disabled before trusting the disabled property.
										// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
										// even exist on them, let alone have a boolean value.
									} else if ("label" in elem) {
										return elem.disabled === disabled;
									}

									// Remaining elements are neither :enabled nor :disabled
									return false;
								};
							}

							/**
							 * Returns a function to use in pseudos for positionals
							 * @param {Function} fn
							 */
							function createPositionalPseudo(fn) {
								return markFunction(function (argument) {
									argument = +argument;
									return markFunction(function (seed, matches) {
										var j,
											matchIndexes = fn([], seed.length, argument),
											i = matchIndexes.length;

										// Match elements found at the specified indexes
										while (i--) {
											if (seed[(j = matchIndexes[i])]) {
												seed[j] = !(matches[j] = seed[j]);
											}
										}
									});
								});
							}

							/**
							 * Checks a node for validity as a Sizzle context
							 * @param {Element|Object=} context
							 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
							 */
							function testContext(context) {
								return context && typeof context.getElementsByTagName !== "undefined" && context;
							}

							// Expose support vars for convenience
							support = Sizzle.support = {};

							/**
							 * Detects XML nodes
							 * @param {Element|Object} elem An element or a document
							 * @returns {Boolean} True iff elem is a non-HTML XML node
							 */
							isXML = Sizzle.isXML = function (elem) {
								var namespace = elem.namespaceURI,
									docElem = (elem.ownerDocument || elem).documentElement;

								// Support: IE <=8
								// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
								// https://bugs.jquery.com/ticket/4833
								return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
							};

							/**
							 * Sets document-related variables once based on the current document
							 * @param {Element|Object} [doc] An element or document object to use to set the document
							 * @returns {Object} Returns the current document
							 */
							setDocument = Sizzle.setDocument = function (node) {
								var hasCompare, subWindow,
									doc = node ? node.ownerDocument || node : preferredDoc;

								// Return early if doc is invalid or already selected
								if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
									return document;
								}

								// Update global variables
								document = doc;
								docElem = document.documentElement;
								documentIsHTML = !isXML(document);

								// Support: IE 9-11, Edge
								// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
								if (preferredDoc !== document &&
									(subWindow = document.defaultView) && subWindow.top !== subWindow) {

									// Support: IE 11, Edge
									if (subWindow.addEventListener) {
										subWindow.addEventListener("unload", unloadHandler, false);

										// Support: IE 9 - 10 only
									} else if (subWindow.attachEvent) {
										subWindow.attachEvent("onunload", unloadHandler);
									}
								}

								/* Attributes
								---------------------------------------------------------------------- */

								// Support: IE<8
								// Verify that getAttribute really returns attributes and not properties
								// (excepting IE8 booleans)
								support.attributes = assert(function (el) {
									el.className = "i";
									return !el.getAttribute("className");
								});

								/* getElement(s)By*
								---------------------------------------------------------------------- */

								// Check if getElementsByTagName("*") returns only elements
								support.getElementsByTagName = assert(function (el) {
									el.appendChild(document.createComment(""));
									return !el.getElementsByTagName("*").length;
								});

								// Support: IE<9
								support.getElementsByClassName = rnative.test(document.getElementsByClassName);

								// Support: IE<10
								// Check if getElementById returns elements by name
								// The broken getElementById methods don't pick up programmatically-set names,
								// so use a roundabout getElementsByName test
								support.getById = assert(function (el) {
									docElem.appendChild(el).id = expando;
									return !document.getElementsByName || !document.getElementsByName(expando).length;
								});

								// ID filter and find
								if (support.getById) {
									Expr.filter["ID"] = function (id) {
										var attrId = id.replace(runescape, funescape);
										return function (elem) {
											return elem.getAttribute("id") === attrId;
										};
									};
									Expr.find["ID"] = function (id, context) {
										if (typeof context.getElementById !== "undefined" && documentIsHTML) {
											var elem = context.getElementById(id);
											return elem ? [elem] : [];
										}
									};
								} else {
									Expr.filter["ID"] = function (id) {
										var attrId = id.replace(runescape, funescape);
										return function (elem) {
											var node = typeof elem.getAttributeNode !== "undefined" &&
												elem.getAttributeNode("id");
											return node && node.value === attrId;
										};
									};

									// Support: IE 6 - 7 only
									// getElementById is not reliable as a find shortcut
									Expr.find["ID"] = function (id, context) {
										if (typeof context.getElementById !== "undefined" && documentIsHTML) {
											var node, i, elems,
												elem = context.getElementById(id);

											if (elem) {

												// Verify the id attribute
												node = elem.getAttributeNode("id");
												if (node && node.value === id) {
													return [elem];
												}

												// Fall back on getElementsByName
												elems = context.getElementsByName(id);
												i = 0;
												while ((elem = elems[i++])) {
													node = elem.getAttributeNode("id");
													if (node && node.value === id) {
														return [elem];
													}
												}
											}

											return [];
										}
									};
								}

								// Tag
								Expr.find["TAG"] = support.getElementsByTagName ?
									function (tag, context) {
										if (typeof context.getElementsByTagName !== "undefined") {
											return context.getElementsByTagName(tag);

											// DocumentFragment nodes don't have gEBTN
										} else if (support.qsa) {
											return context.querySelectorAll(tag);
										}
									} :

									function (tag, context) {
										var elem,
											tmp = [],
											i = 0,
											// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
											results = context.getElementsByTagName(tag);

										// Filter out possible comments
										if (tag === "*") {
											while ((elem = results[i++])) {
												if (elem.nodeType === 1) {
													tmp.push(elem);
												}
											}

											return tmp;
										}
										return results;
									};

								// Class
								Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
									if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
										return context.getElementsByClassName(className);
									}
								};

								/* QSA/matchesSelector
								---------------------------------------------------------------------- */

								// QSA and matchesSelector support

								// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
								rbuggyMatches = [];

								// qSa(:focus) reports false when true (Chrome 21)
								// We allow this because of a bug in IE8/9 that throws an error
								// whenever `document.activeElement` is accessed on an iframe
								// So, we allow :focus to pass through QSA all the time to avoid the IE error
								// See https://bugs.jquery.com/ticket/13378
								rbuggyQSA = [];

								if ((support.qsa = rnative.test(document.querySelectorAll))) {
									// Build QSA regex
									// Regex strategy adopted from Diego Perini
									assert(function (el) {
										// Select is set to empty string on purpose
										// This is to test IE's treatment of not explicitly
										// setting a boolean content attribute,
										// since its presence should be enough
										// https://bugs.jquery.com/ticket/12359
										docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" +
											"<select id='" + expando + "-\r\\' msallowcapture=''>" +
											"<option selected=''></option></select>";

										// Support: IE8, Opera 11-12.16
										// Nothing should be selected when empty strings follow ^= or $= or *=
										// The test attribute must be unknown in Opera but "safe" for WinRT
										// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
										if (el.querySelectorAll("[msallowcapture^='']").length) {
											rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
										}

										// Support: IE8
										// Boolean attributes and "value" are not treated correctly
										if (!el.querySelectorAll("[selected]").length) {
											rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
										}

										// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
										if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
											rbuggyQSA.push("~=");
										}

										// Webkit/Opera - :checked should return selected option elements
										// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
										// IE8 throws error here and will not see later tests
										if (!el.querySelectorAll(":checked").length) {
											rbuggyQSA.push(":checked");
										}

										// Support: Safari 8+, iOS 8+
										// https://bugs.webkit.org/show_bug.cgi?id=136851
										// In-page `selector#id sibling-combinator selector` fails
										if (!el.querySelectorAll("a#" + expando + "+*").length) {
											rbuggyQSA.push(".#.+[+~]");
										}
									});

									assert(function (el) {
										el.innerHTML = "<a href='' disabled='disabled'></a>" +
											"<select disabled='disabled'><option/></select>";

										// Support: Windows 8 Native Apps
										// The type and name attributes are restricted during .innerHTML assignment
										var input = document.createElement("input");
										input.setAttribute("type", "hidden");
										el.appendChild(input).setAttribute("name", "D");

										// Support: IE8
										// Enforce case-sensitivity of name attribute
										if (el.querySelectorAll("[name=d]").length) {
											rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
										}

										// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
										// IE8 throws error here and will not see later tests
										if (el.querySelectorAll(":enabled").length !== 2) {
											rbuggyQSA.push(":enabled", ":disabled");
										}

										// Support: IE9-11+
										// IE's :disabled selector does not pick up the children of disabled fieldsets
										docElem.appendChild(el).disabled = true;
										if (el.querySelectorAll(":disabled").length !== 2) {
											rbuggyQSA.push(":enabled", ":disabled");
										}

										// Opera 10-11 does not throw on post-comma invalid pseudos
										el.querySelectorAll("*,:x");
										rbuggyQSA.push(",.*:");
									});
								}

								if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
									docElem.webkitMatchesSelector ||
									docElem.mozMatchesSelector ||
									docElem.oMatchesSelector ||
									docElem.msMatchesSelector)))) {

									assert(function (el) {
										// Check to see if it's possible to do matchesSelector
										// on a disconnected node (IE 9)
										support.disconnectedMatch = matches.call(el, "*");

										// This should fail with an exception
										// Gecko does not error, returns false instead
										matches.call(el, "[s!='']:x");
										rbuggyMatches.push("!=", pseudos);
									});
								}

								rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
								rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

								/* Contains
								---------------------------------------------------------------------- */
								hasCompare = rnative.test(docElem.compareDocumentPosition);

								// Element contains another
								// Purposefully self-exclusive
								// As in, an element does not contain itself
								contains = hasCompare || rnative.test(docElem.contains) ?
									function (a, b) {
										var adown = a.nodeType === 9 ? a.documentElement : a,
											bup = b && b.parentNode;
										return a === bup || !!(bup && bup.nodeType === 1 && (
											adown.contains ?
												adown.contains(bup) :
												a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
										));
									} :
									function (a, b) {
										if (b) {
											while ((b = b.parentNode)) {
												if (b === a) {
													return true;
												}
											}
										}
										return false;
									};

								/* Sorting
								---------------------------------------------------------------------- */

								// Document order sorting
								sortOrder = hasCompare ?
									function (a, b) {

										// Flag for duplicate removal
										if (a === b) {
											hasDuplicate = true;
											return 0;
										}

										// Sort on method existence if only one input has compareDocumentPosition
										var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
										if (compare) {
											return compare;
										}

										// Calculate position if both inputs belong to the same document
										compare = (a.ownerDocument || a) === (b.ownerDocument || b) ?
											a.compareDocumentPosition(b) :

											// Otherwise we know they are disconnected
											1;

										// Disconnected nodes
										if (compare & 1 ||
											(!support.sortDetached && b.compareDocumentPosition(a) === compare)) {

											// Choose the first element that is related to our preferred document
											if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
												return -1;
											}
											if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
												return 1;
											}

											// Maintain original order
											return sortInput ?
												(indexOf(sortInput, a) - indexOf(sortInput, b)) :
												0;
										}

										return compare & 4 ? -1 : 1;
									} :
									function (a, b) {
										// Exit early if the nodes are identical
										if (a === b) {
											hasDuplicate = true;
											return 0;
										}

										var cur,
											i = 0,
											aup = a.parentNode,
											bup = b.parentNode,
											ap = [a],
											bp = [b];

										// Parentless nodes are either documents or disconnected
										if (!aup || !bup) {
											return a === document ? -1 :
												b === document ? 1 :
													aup ? -1 :
														bup ? 1 :
															sortInput ?
																(indexOf(sortInput, a) - indexOf(sortInput, b)) :
																0;

											// If the nodes are siblings, we can do a quick check
										} else if (aup === bup) {
											return siblingCheck(a, b);
										}

										// Otherwise we need full lists of their ancestors for comparison
										cur = a;
										while ((cur = cur.parentNode)) {
											ap.unshift(cur);
										}
										cur = b;
										while ((cur = cur.parentNode)) {
											bp.unshift(cur);
										}

										// Walk down the tree looking for a discrepancy
										while (ap[i] === bp[i]) {
											i++;
										}

										return i ?
											// Do a sibling check if the nodes have a common ancestor
											siblingCheck(ap[i], bp[i]) :

											// Otherwise nodes in our document sort first
											ap[i] === preferredDoc ? -1 :
												bp[i] === preferredDoc ? 1 :
													0;
									};

								return document;
							};

							Sizzle.matches = function (expr, elements) {
								return Sizzle(expr, null, null, elements);
							};

							Sizzle.matchesSelector = function (elem, expr) {
								// Set document vars if needed
								if ((elem.ownerDocument || elem) !== document) {
									setDocument(elem);
								}

								if (support.matchesSelector && documentIsHTML &&
									!nonnativeSelectorCache[expr + " "] &&
									(!rbuggyMatches || !rbuggyMatches.test(expr)) &&
									(!rbuggyQSA || !rbuggyQSA.test(expr))) {

									try {
										var ret = matches.call(elem, expr);

										// IE 9's matchesSelector returns false on disconnected nodes
										if (ret || support.disconnectedMatch ||
											// As well, disconnected nodes are said to be in a document
											// fragment in IE 9
											elem.document && elem.document.nodeType !== 11) {
											return ret;
										}
									} catch (e) {
										nonnativeSelectorCache(expr, true);
									}
								}

								return Sizzle(expr, document, null, [elem]).length > 0;
							};

							Sizzle.contains = function (context, elem) {
								// Set document vars if needed
								if ((context.ownerDocument || context) !== document) {
									setDocument(context);
								}
								return contains(context, elem);
							};

							Sizzle.attr = function (elem, name) {
								// Set document vars if needed
								if ((elem.ownerDocument || elem) !== document) {
									setDocument(elem);
								}

								var fn = Expr.attrHandle[name.toLowerCase()],
									// Don't get fooled by Object.prototype properties (jQuery #13807)
									val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ?
										fn(elem, name, !documentIsHTML) :
										undefined;

								return val !== undefined ?
									val :
									support.attributes || !documentIsHTML ?
										elem.getAttribute(name) :
										(val = elem.getAttributeNode(name)) && val.specified ?
											val.value :
											null;
							};

							Sizzle.escape = function (sel) {
								return (sel + "").replace(rcssescape, fcssescape);
							};

							Sizzle.error = function (msg) {
								throw new Error("Syntax error, unrecognized expression: " + msg);
							};

							/**
							 * Document sorting and removing duplicates
							 * @param {ArrayLike} results
							 */
							Sizzle.uniqueSort = function (results) {
								var elem,
									duplicates = [],
									j = 0,
									i = 0;

								// Unless we *know* we can detect duplicates, assume their presence
								hasDuplicate = !support.detectDuplicates;
								sortInput = !support.sortStable && results.slice(0);
								results.sort(sortOrder);

								if (hasDuplicate) {
									while ((elem = results[i++])) {
										if (elem === results[i]) {
											j = duplicates.push(i);
										}
									}
									while (j--) {
										results.splice(duplicates[j], 1);
									}
								}

								// Clear input after sorting to release objects
								// See https://github.com/jquery/sizzle/pull/225
								sortInput = null;

								return results;
							};

							/**
							 * Utility function for retrieving the text value of an array of DOM nodes
							 * @param {Array|Element} elem
							 */
							getText = Sizzle.getText = function (elem) {
								var node,
									ret = "",
									i = 0,
									nodeType = elem.nodeType;

								if (!nodeType) {
									// If no nodeType, this is expected to be an array
									while ((node = elem[i++])) {
										// Do not traverse comment nodes
										ret += getText(node);
									}
								} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
									// Use textContent for elements
									// innerText usage removed for consistency of new lines (jQuery #11153)
									if (typeof elem.textContent === "string") {
										return elem.textContent;
									} else {
										// Traverse its children
										for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
											ret += getText(elem);
										}
									}
								} else if (nodeType === 3 || nodeType === 4) {
									return elem.nodeValue;
								}
								// Do not include comment or processing instruction nodes

								return ret;
							};

							Expr = Sizzle.selectors = {

								// Can be adjusted by the user
								cacheLength: 50,

								createPseudo: markFunction,

								match: matchExpr,

								attrHandle: {},

								find: {},

								relative: {
									">": { dir: "parentNode", first: true },
									" ": { dir: "parentNode" },
									"+": { dir: "previousSibling", first: true },
									"~": { dir: "previousSibling" }
								},

								preFilter: {
									"ATTR": function (match) {
										match[1] = match[1].replace(runescape, funescape);

										// Move the given value to match[3] whether quoted or unquoted
										match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

										if (match[2] === "~=") {
											match[3] = " " + match[3] + " ";
										}

										return match.slice(0, 4);
									},

									"CHILD": function (match) {
										/* matches from matchExpr["CHILD"]
											1 type (only|nth|...)
											2 what (child|of-type)
											3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
											4 xn-component of xn+y argument ([+-]?\d*n|)
											5 sign of xn-component
											6 x of xn-component
											7 sign of y-component
											8 y of y-component
										*/
										match[1] = match[1].toLowerCase();

										if (match[1].slice(0, 3) === "nth") {
											// nth-* requires argument
											if (!match[3]) {
												Sizzle.error(match[0]);
											}

											// numeric x and y parameters for Expr.filter.CHILD
											// remember that false/true cast respectively to 0/1
											match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
											match[5] = +((match[7] + match[8]) || match[3] === "odd");

											// other types prohibit arguments
										} else if (match[3]) {
											Sizzle.error(match[0]);
										}

										return match;
									},

									"PSEUDO": function (match) {
										var excess,
											unquoted = !match[6] && match[2];

										if (matchExpr["CHILD"].test(match[0])) {
											return null;
										}

										// Accept quoted arguments as-is
										if (match[3]) {
											match[2] = match[4] || match[5] || "";

											// Strip excess characters from unquoted arguments
										} else if (unquoted && rpseudo.test(unquoted) &&
											// Get excess from tokenize (recursively)
											(excess = tokenize(unquoted, true)) &&
											// advance to the next closing parenthesis
											(excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

											// excess is a negative index
											match[0] = match[0].slice(0, excess);
											match[2] = unquoted.slice(0, excess);
										}

										// Return only captures needed by the pseudo filter method (type and argument)
										return match.slice(0, 3);
									}
								},

								filter: {

									"TAG": function (nodeNameSelector) {
										var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
										return nodeNameSelector === "*" ?
											function () { return true; } :
											function (elem) {
												return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
											};
									},

									"CLASS": function (className) {
										var pattern = classCache[className + " "];

										return pattern ||
											(pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) &&
											classCache(className, function (elem) {
												return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
											});
									},

									"ATTR": function (name, operator, check) {
										return function (elem) {
											var result = Sizzle.attr(elem, name);

											if (result == null) {
												return operator === "!=";
											}
											if (!operator) {
												return true;
											}

											result += "";

											return operator === "=" ? result === check :
												operator === "!=" ? result !== check :
													operator === "^=" ? check && result.indexOf(check) === 0 :
														operator === "*=" ? check && result.indexOf(check) > -1 :
															operator === "$=" ? check && result.slice(-check.length) === check :
																operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 :
																	operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" :
																		false;
										};
									},

									"CHILD": function (type, what, argument, first, last) {
										var simple = type.slice(0, 3) !== "nth",
											forward = type.slice(-4) !== "last",
											ofType = what === "of-type";

										return first === 1 && last === 0 ?

											// Shortcut for :nth-*(n)
											function (elem) {
												return !!elem.parentNode;
											} :

											function (elem, context, xml) {
												var cache, uniqueCache, outerCache, node, nodeIndex, start,
													dir = simple !== forward ? "nextSibling" : "previousSibling",
													parent = elem.parentNode,
													name = ofType && elem.nodeName.toLowerCase(),
													useCache = !xml && !ofType,
													diff = false;

												if (parent) {

													// :(first|last|only)-(child|of-type)
													if (simple) {
														while (dir) {
															node = elem;
															while ((node = node[dir])) {
																if (ofType ?
																	node.nodeName.toLowerCase() === name :
																	node.nodeType === 1) {

																	return false;
																}
															}
															// Reverse direction for :only-* (if we haven't yet done so)
															start = dir = type === "only" && !start && "nextSibling";
														}
														return true;
													}

													start = [forward ? parent.firstChild : parent.lastChild];

													// non-xml :nth-child(...) stores cache data on `parent`
													if (forward && useCache) {

														// Seek `elem` from a previously-cached index

														// ...in a gzip-friendly way
														node = parent;
														outerCache = node[expando] || (node[expando] = {});

														// Support: IE <9 only
														// Defend against cloned attroperties (jQuery gh-1709)
														uniqueCache = outerCache[node.uniqueID] ||
															(outerCache[node.uniqueID] = {});

														cache = uniqueCache[type] || [];
														nodeIndex = cache[0] === dirruns && cache[1];
														diff = nodeIndex && cache[2];
														node = nodeIndex && parent.childNodes[nodeIndex];

														while ((node = ++nodeIndex && node && node[dir] ||

															// Fallback to seeking `elem` from the start
															(diff = nodeIndex = 0) || start.pop())) {

															// When found, cache indexes on `parent` and break
															if (node.nodeType === 1 && ++diff && node === elem) {
																uniqueCache[type] = [dirruns, nodeIndex, diff];
																break;
															}
														}

													} else {
														// Use previously-cached element index if available
														if (useCache) {
															// ...in a gzip-friendly way
															node = elem;
															outerCache = node[expando] || (node[expando] = {});

															// Support: IE <9 only
															// Defend against cloned attroperties (jQuery gh-1709)
															uniqueCache = outerCache[node.uniqueID] ||
																(outerCache[node.uniqueID] = {});

															cache = uniqueCache[type] || [];
															nodeIndex = cache[0] === dirruns && cache[1];
															diff = nodeIndex;
														}

														// xml :nth-child(...)
														// or :nth-last-child(...) or :nth(-last)?-of-type(...)
														if (diff === false) {
															// Use the same loop as above to seek `elem` from the start
															while ((node = ++nodeIndex && node && node[dir] ||
																(diff = nodeIndex = 0) || start.pop())) {

																if ((ofType ?
																	node.nodeName.toLowerCase() === name :
																	node.nodeType === 1) &&
																	++diff) {

																	// Cache the index of each encountered element
																	if (useCache) {
																		outerCache = node[expando] || (node[expando] = {});

																		// Support: IE <9 only
																		// Defend against cloned attroperties (jQuery gh-1709)
																		uniqueCache = outerCache[node.uniqueID] ||
																			(outerCache[node.uniqueID] = {});

																		uniqueCache[type] = [dirruns, diff];
																	}

																	if (node === elem) {
																		break;
																	}
																}
															}
														}
													}

													// Incorporate the offset, then check against cycle size
													diff -= last;
													return diff === first || (diff % first === 0 && diff / first >= 0);
												}
											};
									},

									"PSEUDO": function (pseudo, argument) {
										// pseudo-class names are case-insensitive
										// http://www.w3.org/TR/selectors/#pseudo-classes
										// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
										// Remember that setFilters inherits from pseudos
										var args,
											fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
												Sizzle.error("unsupported pseudo: " + pseudo);

										// The user may use createPseudo to indicate that
										// arguments are needed to create the filter function
										// just as Sizzle does
										if (fn[expando]) {
											return fn(argument);
										}

										// But maintain support for old signatures
										if (fn.length > 1) {
											args = [pseudo, pseudo, "", argument];
											return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ?
												markFunction(function (seed, matches) {
													var idx,
														matched = fn(seed, argument),
														i = matched.length;
													while (i--) {
														idx = indexOf(seed, matched[i]);
														seed[idx] = !(matches[idx] = matched[i]);
													}
												}) :
												function (elem) {
													return fn(elem, 0, args);
												};
										}

										return fn;
									}
								},

								pseudos: {
									// Potentially complex pseudos
									"not": markFunction(function (selector) {
										// Trim the selector passed to compile
										// to avoid treating leading and trailing
										// spaces as combinators
										var input = [],
											results = [],
											matcher = compile(selector.replace(rtrim, "$1"));

										return matcher[expando] ?
											markFunction(function (seed, matches, context, xml) {
												var elem,
													unmatched = matcher(seed, null, xml, []),
													i = seed.length;

												// Match elements unmatched by `matcher`
												while (i--) {
													if ((elem = unmatched[i])) {
														seed[i] = !(matches[i] = elem);
													}
												}
											}) :
											function (elem, context, xml) {
												input[0] = elem;
												matcher(input, null, xml, results);
												// Don't keep the element (issue #299)
												input[0] = null;
												return !results.pop();
											};
									}),

									"has": markFunction(function (selector) {
										return function (elem) {
											return Sizzle(selector, elem).length > 0;
										};
									}),

									"contains": markFunction(function (text) {
										text = text.replace(runescape, funescape);
										return function (elem) {
											return (elem.textContent || getText(elem)).indexOf(text) > -1;
										};
									}),

									// "Whether an element is represented by a :lang() selector
									// is based solely on the element's language value
									// being equal to the identifier C,
									// or beginning with the identifier C immediately followed by "-".
									// The matching of C against the element's language value is performed case-insensitively.
									// The identifier C does not have to be a valid language name."
									// http://www.w3.org/TR/selectors/#lang-pseudo
									"lang": markFunction(function (lang) {
										// lang value must be a valid identifier
										if (!ridentifier.test(lang || "")) {
											Sizzle.error("unsupported lang: " + lang);
										}
										lang = lang.replace(runescape, funescape).toLowerCase();
										return function (elem) {
											var elemLang;
											do {
												if ((elemLang = documentIsHTML ?
													elem.lang :
													elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {

													elemLang = elemLang.toLowerCase();
													return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
												}
											} while ((elem = elem.parentNode) && elem.nodeType === 1);
											return false;
										};
									}),

									// Miscellaneous
									"target": function (elem) {
										var hash = window.location && window.location.hash;
										return hash && hash.slice(1) === elem.id;
									},

									"root": function (elem) {
										return elem === docElem;
									},

									"focus": function (elem) {
										return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
									},

									// Boolean properties
									"enabled": createDisabledPseudo(false),
									"disabled": createDisabledPseudo(true),

									"checked": function (elem) {
										// In CSS3, :checked should return both checked and selected elements
										// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
										var nodeName = elem.nodeName.toLowerCase();
										return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
									},

									"selected": function (elem) {
										// Accessing this property makes selected-by-default
										// options in Safari work properly
										if (elem.parentNode) {
											elem.parentNode.selectedIndex;
										}

										return elem.selected === true;
									},

									// Contents
									"empty": function (elem) {
										// http://www.w3.org/TR/selectors/#empty-pseudo
										// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
										//   but not by others (comment: 8; processing instruction: 7; etc.)
										// nodeType < 6 works because attributes (2) do not appear as children
										for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
											if (elem.nodeType < 6) {
												return false;
											}
										}
										return true;
									},

									"parent": function (elem) {
										return !Expr.pseudos["empty"](elem);
									},

									// Element/input types
									"header": function (elem) {
										return rheader.test(elem.nodeName);
									},

									"input": function (elem) {
										return rinputs.test(elem.nodeName);
									},

									"button": function (elem) {
										var name = elem.nodeName.toLowerCase();
										return name === "input" && elem.type === "button" || name === "button";
									},

									"text": function (elem) {
										var attr;
										return elem.nodeName.toLowerCase() === "input" &&
											elem.type === "text" &&

											// Support: IE<8
											// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
											((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
									},

									// Position-in-collection
									"first": createPositionalPseudo(function () {
										return [0];
									}),

									"last": createPositionalPseudo(function (matchIndexes, length) {
										return [length - 1];
									}),

									"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
										return [argument < 0 ? argument + length : argument];
									}),

									"even": createPositionalPseudo(function (matchIndexes, length) {
										var i = 0;
										for (; i < length; i += 2) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									"odd": createPositionalPseudo(function (matchIndexes, length) {
										var i = 1;
										for (; i < length; i += 2) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
										var i = argument < 0 ?
											argument + length :
											argument > length ?
												length :
												argument;
										for (; --i >= 0;) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									}),

									"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
										var i = argument < 0 ? argument + length : argument;
										for (; ++i < length;) {
											matchIndexes.push(i);
										}
										return matchIndexes;
									})
								}
							};

							Expr.pseudos["nth"] = Expr.pseudos["eq"];

							// Add button/input type pseudos
							for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
								Expr.pseudos[i] = createInputPseudo(i);
							}
							for (i in { submit: true, reset: true }) {
								Expr.pseudos[i] = createButtonPseudo(i);
							}

							// Easy API for creating new setFilters
							function setFilters() { }
							setFilters.prototype = Expr.filters = Expr.pseudos;
							Expr.setFilters = new setFilters();

							tokenize = Sizzle.tokenize = function (selector, parseOnly) {
								var matched, match, tokens, type,
									soFar, groups, preFilters,
									cached = tokenCache[selector + " "];

								if (cached) {
									return parseOnly ? 0 : cached.slice(0);
								}

								soFar = selector;
								groups = [];
								preFilters = Expr.preFilter;

								while (soFar) {

									// Comma and first run
									if (!matched || (match = rcomma.exec(soFar))) {
										if (match) {
											// Don't consume trailing commas as valid
											soFar = soFar.slice(match[0].length) || soFar;
										}
										groups.push((tokens = []));
									}

									matched = false;

									// Combinators
									if ((match = rcombinators.exec(soFar))) {
										matched = match.shift();
										tokens.push({
											value: matched,
											// Cast descendant combinators to space
											type: match[0].replace(rtrim, " ")
										});
										soFar = soFar.slice(matched.length);
									}

									// Filters
									for (type in Expr.filter) {
										if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
											(match = preFilters[type](match)))) {
											matched = match.shift();
											tokens.push({
												value: matched,
												type: type,
												matches: match
											});
											soFar = soFar.slice(matched.length);
										}
									}

									if (!matched) {
										break;
									}
								}

								// Return the length of the invalid excess
								// if we're just parsing
								// Otherwise, throw an error or return tokens
								return parseOnly ?
									soFar.length :
									soFar ?
										Sizzle.error(selector) :
										// Cache the tokens
										tokenCache(selector, groups).slice(0);
							};

							function toSelector(tokens) {
								var i = 0,
									len = tokens.length,
									selector = "";
								for (; i < len; i++) {
									selector += tokens[i].value;
								}
								return selector;
							}

							function addCombinator(matcher, combinator, base) {
								var dir = combinator.dir,
									skip = combinator.next,
									key = skip || dir,
									checkNonElements = base && key === "parentNode",
									doneName = done++;

								return combinator.first ?
									// Check against closest ancestor/preceding element
									function (elem, context, xml) {
										while ((elem = elem[dir])) {
											if (elem.nodeType === 1 || checkNonElements) {
												return matcher(elem, context, xml);
											}
										}
										return false;
									} :

									// Check against all ancestor/preceding elements
									function (elem, context, xml) {
										var oldCache, uniqueCache, outerCache,
											newCache = [dirruns, doneName];

										// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
										if (xml) {
											while ((elem = elem[dir])) {
												if (elem.nodeType === 1 || checkNonElements) {
													if (matcher(elem, context, xml)) {
														return true;
													}
												}
											}
										} else {
											while ((elem = elem[dir])) {
												if (elem.nodeType === 1 || checkNonElements) {
													outerCache = elem[expando] || (elem[expando] = {});

													// Support: IE <9 only
													// Defend against cloned attroperties (jQuery gh-1709)
													uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

													if (skip && skip === elem.nodeName.toLowerCase()) {
														elem = elem[dir] || elem;
													} else if ((oldCache = uniqueCache[key]) &&
														oldCache[0] === dirruns && oldCache[1] === doneName) {

														// Assign to newCache so results back-propagate to previous elements
														return (newCache[2] = oldCache[2]);
													} else {
														// Reuse newcache so results back-propagate to previous elements
														uniqueCache[key] = newCache;

														// A match means we're done; a fail means we have to keep checking
														if ((newCache[2] = matcher(elem, context, xml))) {
															return true;
														}
													}
												}
											}
										}
										return false;
									};
							}

							function elementMatcher(matchers) {
								return matchers.length > 1 ?
									function (elem, context, xml) {
										var i = matchers.length;
										while (i--) {
											if (!matchers[i](elem, context, xml)) {
												return false;
											}
										}
										return true;
									} :
									matchers[0];
							}

							function multipleContexts(selector, contexts, results) {
								var i = 0,
									len = contexts.length;
								for (; i < len; i++) {
									Sizzle(selector, contexts[i], results);
								}
								return results;
							}

							function condense(unmatched, map, filter, context, xml) {
								var elem,
									newUnmatched = [],
									i = 0,
									len = unmatched.length,
									mapped = map != null;

								for (; i < len; i++) {
									if ((elem = unmatched[i])) {
										if (!filter || filter(elem, context, xml)) {
											newUnmatched.push(elem);
											if (mapped) {
												map.push(i);
											}
										}
									}
								}

								return newUnmatched;
							}

							function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
								if (postFilter && !postFilter[expando]) {
									postFilter = setMatcher(postFilter);
								}
								if (postFinder && !postFinder[expando]) {
									postFinder = setMatcher(postFinder, postSelector);
								}
								return markFunction(function (seed, results, context, xml) {
									var temp, i, elem,
										preMap = [],
										postMap = [],
										preexisting = results.length,

										// Get initial elements from seed or context
										elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),

										// Prefilter to get matcher input, preserving a map for seed-results synchronization
										matcherIn = preFilter && (seed || !selector) ?
											condense(elems, preMap, preFilter, context, xml) :
											elems,

										matcherOut = matcher ?
											// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
											postFinder || (seed ? preFilter : preexisting || postFilter) ?

												// ...intermediate processing is necessary
												[] :

												// ...otherwise use results directly
												results :
											matcherIn;

									// Find primary matches
									if (matcher) {
										matcher(matcherIn, matcherOut, context, xml);
									}

									// Apply postFilter
									if (postFilter) {
										temp = condense(matcherOut, postMap);
										postFilter(temp, [], context, xml);

										// Un-match failing elements by moving them back to matcherIn
										i = temp.length;
										while (i--) {
											if ((elem = temp[i])) {
												matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
											}
										}
									}

									if (seed) {
										if (postFinder || preFilter) {
											if (postFinder) {
												// Get the final matcherOut by condensing this intermediate into postFinder contexts
												temp = [];
												i = matcherOut.length;
												while (i--) {
													if ((elem = matcherOut[i])) {
														// Restore matcherIn since elem is not yet a final match
														temp.push((matcherIn[i] = elem));
													}
												}
												postFinder(null, (matcherOut = []), temp, xml);
											}

											// Move matched elements from seed to results to keep them synchronized
											i = matcherOut.length;
											while (i--) {
												if ((elem = matcherOut[i]) &&
													(temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

													seed[temp] = !(results[temp] = elem);
												}
											}
										}

										// Add elements to results, through postFinder if defined
									} else {
										matcherOut = condense(
											matcherOut === results ?
												matcherOut.splice(preexisting, matcherOut.length) :
												matcherOut
										);
										if (postFinder) {
											postFinder(null, results, matcherOut, xml);
										} else {
											push.apply(results, matcherOut);
										}
									}
								});
							}

							function matcherFromTokens(tokens) {
								var checkContext, matcher, j,
									len = tokens.length,
									leadingRelative = Expr.relative[tokens[0].type],
									implicitRelative = leadingRelative || Expr.relative[" "],
									i = leadingRelative ? 1 : 0,

									// The foundational matcher ensures that elements are reachable from top-level context(s)
									matchContext = addCombinator(function (elem) {
										return elem === checkContext;
									}, implicitRelative, true),
									matchAnyContext = addCombinator(function (elem) {
										return indexOf(checkContext, elem) > -1;
									}, implicitRelative, true),
									matchers = [function (elem, context, xml) {
										var ret = (!leadingRelative && (xml || context !== outermostContext)) || (
											(checkContext = context).nodeType ?
												matchContext(elem, context, xml) :
												matchAnyContext(elem, context, xml));
										// Avoid hanging onto element (issue #299)
										checkContext = null;
										return ret;
									}];

								for (; i < len; i++) {
									if ((matcher = Expr.relative[tokens[i].type])) {
										matchers = [addCombinator(elementMatcher(matchers), matcher)];
									} else {
										matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

										// Return special upon seeing a positional matcher
										if (matcher[expando]) {
											// Find the next relative operator (if any) for proper handling
											j = ++i;
											for (; j < len; j++) {
												if (Expr.relative[tokens[j].type]) {
													break;
												}
											}
											return setMatcher(
												i > 1 && elementMatcher(matchers),
												i > 1 && toSelector(
													// If the preceding token was a descendant combinator, insert an implicit any-element `*`
													tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })
												).replace(rtrim, "$1"),
												matcher,
												i < j && matcherFromTokens(tokens.slice(i, j)),
												j < len && matcherFromTokens((tokens = tokens.slice(j))),
												j < len && toSelector(tokens)
											);
										}
										matchers.push(matcher);
									}
								}

								return elementMatcher(matchers);
							}

							function matcherFromGroupMatchers(elementMatchers, setMatchers) {
								var bySet = setMatchers.length > 0,
									byElement = elementMatchers.length > 0,
									superMatcher = function (seed, context, xml, results, outermost) {
										var elem, j, matcher,
											matchedCount = 0,
											i = "0",
											unmatched = seed && [],
											setMatched = [],
											contextBackup = outermostContext,
											// We must always have either seed elements or outermost context
											elems = seed || byElement && Expr.find["TAG"]("*", outermost),
											// Use integer dirruns iff this is the outermost matcher
											dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
											len = elems.length;

										if (outermost) {
											outermostContext = context === document || context || outermost;
										}

										// Add elements passing elementMatchers directly to results
										// Support: IE<9, Safari
										// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
										for (; i !== len && (elem = elems[i]) != null; i++) {
											if (byElement && elem) {
												j = 0;
												if (!context && elem.ownerDocument !== document) {
													setDocument(elem);
													xml = !documentIsHTML;
												}
												while ((matcher = elementMatchers[j++])) {
													if (matcher(elem, context || document, xml)) {
														results.push(elem);
														break;
													}
												}
												if (outermost) {
													dirruns = dirrunsUnique;
												}
											}

											// Track unmatched elements for set filters
											if (bySet) {
												// They will have gone through all possible matchers
												if ((elem = !matcher && elem)) {
													matchedCount--;
												}

												// Lengthen the array for every element, matched or not
												if (seed) {
													unmatched.push(elem);
												}
											}
										}

										// `i` is now the count of elements visited above, and adding it to `matchedCount`
										// makes the latter nonnegative.
										matchedCount += i;

										// Apply set filters to unmatched elements
										// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
										// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
										// no element matchers and no seed.
										// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
										// case, which will result in a "00" `matchedCount` that differs from `i` but is also
										// numerically zero.
										if (bySet && i !== matchedCount) {
											j = 0;
											while ((matcher = setMatchers[j++])) {
												matcher(unmatched, setMatched, context, xml);
											}

											if (seed) {
												// Reintegrate element matches to eliminate the need for sorting
												if (matchedCount > 0) {
													while (i--) {
														if (!(unmatched[i] || setMatched[i])) {
															setMatched[i] = pop.call(results);
														}
													}
												}

												// Discard index placeholder values to get only actual matches
												setMatched = condense(setMatched);
											}

											// Add matches to results
											push.apply(results, setMatched);

											// Seedless set matches succeeding multiple successful matchers stipulate sorting
											if (outermost && !seed && setMatched.length > 0 &&
												(matchedCount + setMatchers.length) > 1) {

												Sizzle.uniqueSort(results);
											}
										}

										// Override manipulation of globals by nested matchers
										if (outermost) {
											dirruns = dirrunsUnique;
											outermostContext = contextBackup;
										}

										return unmatched;
									};

								return bySet ?
									markFunction(superMatcher) :
									superMatcher;
							}

							compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
								var i,
									setMatchers = [],
									elementMatchers = [],
									cached = compilerCache[selector + " "];

								if (!cached) {
									// Generate a function of recursive functions that can be used to check each element
									if (!match) {
										match = tokenize(selector);
									}
									i = match.length;
									while (i--) {
										cached = matcherFromTokens(match[i]);
										if (cached[expando]) {
											setMatchers.push(cached);
										} else {
											elementMatchers.push(cached);
										}
									}

									// Cache the compiled function
									cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

									// Save selector and tokenization
									cached.selector = selector;
								}
								return cached;
							};

							/**
							 * A low-level selection function that works with Sizzle's compiled
							 *  selector functions
							 * @param {String|Function} selector A selector or a pre-compiled
							 *  selector function built with Sizzle.compile
							 * @param {Element} context
							 * @param {Array} [results]
							 * @param {Array} [seed] A set of elements to match against
							 */
							select = Sizzle.select = function (selector, context, results, seed) {
								var i, tokens, token, type, find,
									compiled = typeof selector === "function" && selector,
									match = !seed && tokenize((selector = compiled.selector || selector));

								results = results || [];

								// Try to minimize operations if there is only one selector in the list and no seed
								// (the latter of which guarantees us context)
								if (match.length === 1) {

									// Reduce context if the leading compound selector is an ID
									tokens = match[0] = match[0].slice(0);
									if (tokens.length > 2 && (token = tokens[0]).type === "ID" &&
										context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

										context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
										if (!context) {
											return results;

											// Precompiled matchers will still verify ancestry, so step up a level
										} else if (compiled) {
											context = context.parentNode;
										}

										selector = selector.slice(tokens.shift().value.length);
									}

									// Fetch a seed set for right-to-left matching
									i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
									while (i--) {
										token = tokens[i];

										// Abort if we hit a combinator
										if (Expr.relative[(type = token.type)]) {
											break;
										}
										if ((find = Expr.find[type])) {
											// Search, expanding context for leading sibling combinators
											if ((seed = find(
												token.matches[0].replace(runescape, funescape),
												rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
											))) {

												// If seed is empty or no tokens remain, we can return early
												tokens.splice(i, 1);
												selector = seed.length && toSelector(tokens);
												if (!selector) {
													push.apply(results, seed);
													return results;
												}

												break;
											}
										}
									}
								}

								// Compile and execute a filtering function if one is not provided
								// Provide `match` to avoid retokenization if we modified the selector above
								(compiled || compile(selector, match))(
									seed,
									context,
									!documentIsHTML,
									results,
									!context || rsibling.test(selector) && testContext(context.parentNode) || context
								);
								return results;
							};

							// One-time assignments

							// Sort stability
							support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

							// Support: Chrome 14-35+
							// Always assume duplicates if they aren't passed to the comparison function
							support.detectDuplicates = !!hasDuplicate;

							// Initialize against the default document
							setDocument();

							// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
							// Detached nodes confoundingly follow *each other*
							support.sortDetached = assert(function (el) {
								// Should return 1, but returns 4 (following)
								return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
							});

							// Support: IE<8
							// Prevent attribute/property "interpolation"
							// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
							if (!assert(function (el) {
								el.innerHTML = "<a href='#'></a>";
								return el.firstChild.getAttribute("href") === "#";
							})) {
								addHandle("type|href|height|width", function (elem, name, isXML) {
									if (!isXML) {
										return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
									}
								});
							}

							// Support: IE<9
							// Use defaultValue in place of getAttribute("value")
							if (!support.attributes || !assert(function (el) {
								el.innerHTML = "<input/>";
								el.firstChild.setAttribute("value", "");
								return el.firstChild.getAttribute("value") === "";
							})) {
								addHandle("value", function (elem, name, isXML) {
									if (!isXML && elem.nodeName.toLowerCase() === "input") {
										return elem.defaultValue;
									}
								});
							}

							// Support: IE<9
							// Use getAttributeNode to fetch booleans when getAttribute lies
							if (!assert(function (el) {
								return el.getAttribute("disabled") == null;
							})) {
								addHandle(booleans, function (elem, name, isXML) {
									var val;
									if (!isXML) {
										return elem[name] === true ? name.toLowerCase() :
											(val = elem.getAttributeNode(name)) && val.specified ?
												val.value :
												null;
									}
								});
							}

							return Sizzle;

						})(window);



					jQuery.find = Sizzle;
					jQuery.expr = Sizzle.selectors;

					// Deprecated
					jQuery.expr[":"] = jQuery.expr.pseudos;
					jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
					jQuery.text = Sizzle.getText;
					jQuery.isXMLDoc = Sizzle.isXML;
					jQuery.contains = Sizzle.contains;
					jQuery.escapeSelector = Sizzle.escape;




					var dir = function (elem, dir, until) {
						var matched = [],
							truncate = until !== undefined;

						while ((elem = elem[dir]) && elem.nodeType !== 9) {
							if (elem.nodeType === 1) {
								if (truncate && jQuery(elem).is(until)) {
									break;
								}
								matched.push(elem);
							}
						}
						return matched;
					};


					var siblings = function (n, elem) {
						var matched = [];

						for (; n; n = n.nextSibling) {
							if (n.nodeType === 1 && n !== elem) {
								matched.push(n);
							}
						}

						return matched;
					};


					var rneedsContext = jQuery.expr.match.needsContext;



					function nodeName(elem, name) {

						return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

					};
					var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);



					// Implement the identical functionality for filter and not
					function winnow(elements, qualifier, not) {
						if (isFunction(qualifier)) {
							return jQuery.grep(elements, function (elem, i) {
								return !!qualifier.call(elem, i, elem) !== not;
							});
						}

						// Single element
						if (qualifier.nodeType) {
							return jQuery.grep(elements, function (elem) {
								return (elem === qualifier) !== not;
							});
						}

						// Arraylike of elements (jQuery, arguments, Array)
						if (typeof qualifier !== "string") {
							return jQuery.grep(elements, function (elem) {
								return (indexOf.call(qualifier, elem) > -1) !== not;
							});
						}

						// Filtered directly for both simple and complex selectors
						return jQuery.filter(qualifier, elements, not);
					}

					jQuery.filter = function (expr, elems, not) {
						var elem = elems[0];

						if (not) {
							expr = ":not(" + expr + ")";
						}

						if (elems.length === 1 && elem.nodeType === 1) {
							return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
						}

						return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
							return elem.nodeType === 1;
						}));
					};

					jQuery.fn.extend({
						find: function (selector) {
							var i, ret,
								len = this.length,
								self = this;

							if (typeof selector !== "string") {
								return this.pushStack(jQuery(selector).filter(function () {
									for (i = 0; i < len; i++) {
										if (jQuery.contains(self[i], this)) {
											return true;
										}
									}
								}));
							}

							ret = this.pushStack([]);

							for (i = 0; i < len; i++) {
								jQuery.find(selector, self[i], ret);
							}

							return len > 1 ? jQuery.uniqueSort(ret) : ret;
						},
						filter: function (selector) {
							return this.pushStack(winnow(this, selector || [], false));
						},
						not: function (selector) {
							return this.pushStack(winnow(this, selector || [], true));
						},
						is: function (selector) {
							return !!winnow(
								this,

								// If this is a positional/relative selector, check membership in the returned set
								// so $("p:first").is("p:last") won't return true for a doc with two "p".
								typeof selector === "string" && rneedsContext.test(selector) ?
									jQuery(selector) :
									selector || [],
								false
							).length;
						}
					});


					// Initialize a jQuery object


					// A central reference to the root jQuery(document)
					var rootjQuery,

						// A simple way to check for HTML strings
						// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
						// Strict HTML recognition (#11290: must start with <)
						// Shortcut simple #id case for speed
						rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

						init = jQuery.fn.init = function (selector, context, root) {
							var match, elem;

							// HANDLE: $(""), $(null), $(undefined), $(false)
							if (!selector) {
								return this;
							}

							// Method init() accepts an alternate rootjQuery
							// so migrate can support jQuery.sub (gh-2101)
							root = root || rootjQuery;

							// Handle HTML strings
							if (typeof selector === "string") {
								if (selector[0] === "<" &&
									selector[selector.length - 1] === ">" &&
									selector.length >= 3) {

									// Assume that strings that start and end with <> are HTML and skip the regex check
									match = [null, selector, null];

								} else {
									match = rquickExpr.exec(selector);
								}

								// Match html or make sure no context is specified for #id
								if (match && (match[1] || !context)) {

									// HANDLE: $(html) -> $(array)
									if (match[1]) {
										context = context instanceof jQuery ? context[0] : context;

										// Option to run scripts is true for back-compat
										// Intentionally let the error be thrown if parseHTML is not present
										jQuery.merge(this, jQuery.parseHTML(
											match[1],
											context && context.nodeType ? context.ownerDocument || context : document,
											true
										));

										// HANDLE: $(html, props)
										if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
											for (match in context) {

												// Properties of context are called as methods if possible
												if (isFunction(this[match])) {
													this[match](context[match]);

													// ...and otherwise set as attributes
												} else {
													this.attr(match, context[match]);
												}
											}
										}

										return this;

										// HANDLE: $(#id)
									} else {
										elem = document.getElementById(match[2]);

										if (elem) {

											// Inject the element directly into the jQuery object
											this[0] = elem;
											this.length = 1;
										}
										return this;
									}

									// HANDLE: $(expr, $(...))
								} else if (!context || context.jquery) {
									return (context || root).find(selector);

									// HANDLE: $(expr, context)
									// (which is just equivalent to: $(context).find(expr)
								} else {
									return this.constructor(context).find(selector);
								}

								// HANDLE: $(DOMElement)
							} else if (selector.nodeType) {
								this[0] = selector;
								this.length = 1;
								return this;

								// HANDLE: $(function)
								// Shortcut for document ready
							} else if (isFunction(selector)) {
								return root.ready !== undefined ?
									root.ready(selector) :

									// Execute immediately if ready is not present
									selector(jQuery);
							}

							return jQuery.makeArray(selector, this);
						};

					// Give the init function the jQuery prototype for later instantiation
					init.prototype = jQuery.fn;

					// Initialize central reference
					rootjQuery = jQuery(document);


					var rparentsprev = /^(?:parents|prev(?:Until|All))/,

						// Methods guaranteed to produce a unique set when starting from a unique set
						guaranteedUnique = {
							children: true,
							contents: true,
							next: true,
							prev: true
						};

					jQuery.fn.extend({
						has: function (target) {
							var targets = jQuery(target, this),
								l = targets.length;

							return this.filter(function () {
								var i = 0;
								for (; i < l; i++) {
									if (jQuery.contains(this, targets[i])) {
										return true;
									}
								}
							});
						},

						closest: function (selectors, context) {
							var cur,
								i = 0,
								l = this.length,
								matched = [],
								targets = typeof selectors !== "string" && jQuery(selectors);

							// Positional selectors never match, since there's no _selection_ context
							if (!rneedsContext.test(selectors)) {
								for (; i < l; i++) {
									for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

										// Always skip document fragments
										if (cur.nodeType < 11 && (targets ?
											targets.index(cur) > -1 :

											// Don't pass non-elements to Sizzle
											cur.nodeType === 1 &&
											jQuery.find.matchesSelector(cur, selectors))) {

											matched.push(cur);
											break;
										}
									}
								}
							}

							return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
						},

						// Determine the position of an element within the set
						index: function (elem) {

							// No argument, return index in parent
							if (!elem) {
								return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
							}

							// Index in selector
							if (typeof elem === "string") {
								return indexOf.call(jQuery(elem), this[0]);
							}

							// Locate the position of the desired element
							return indexOf.call(this,

								// If it receives a jQuery object, the first element is used
								elem.jquery ? elem[0] : elem
							);
						},

						add: function (selector, context) {
							return this.pushStack(
								jQuery.uniqueSort(
									jQuery.merge(this.get(), jQuery(selector, context))
								)
							);
						},

						addBack: function (selector) {
							return this.add(selector == null ?
								this.prevObject : this.prevObject.filter(selector)
							);
						}
					});

					function sibling(cur, dir) {
						while ((cur = cur[dir]) && cur.nodeType !== 1) { }
						return cur;
					}

					jQuery.each({
						parent: function (elem) {
							var parent = elem.parentNode;
							return parent && parent.nodeType !== 11 ? parent : null;
						},
						parents: function (elem) {
							return dir(elem, "parentNode");
						},
						parentsUntil: function (elem, i, until) {
							return dir(elem, "parentNode", until);
						},
						next: function (elem) {
							return sibling(elem, "nextSibling");
						},
						prev: function (elem) {
							return sibling(elem, "previousSibling");
						},
						nextAll: function (elem) {
							return dir(elem, "nextSibling");
						},
						prevAll: function (elem) {
							return dir(elem, "previousSibling");
						},
						nextUntil: function (elem, i, until) {
							return dir(elem, "nextSibling", until);
						},
						prevUntil: function (elem, i, until) {
							return dir(elem, "previousSibling", until);
						},
						siblings: function (elem) {
							return siblings((elem.parentNode || {}).firstChild, elem);
						},
						children: function (elem) {
							return siblings(elem.firstChild);
						},
						contents: function (elem) {
							if (typeof elem.contentDocument !== "undefined") {
								return elem.contentDocument;
							}

							// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
							// Treat the template element as a regular one in browsers that
							// don't support it.
							if (nodeName(elem, "template")) {
								elem = elem.content || elem;
							}

							return jQuery.merge([], elem.childNodes);
						}
					}, function (name, fn) {
						jQuery.fn[name] = function (until, selector) {
							var matched = jQuery.map(this, fn, until);

							if (name.slice(-5) !== "Until") {
								selector = until;
							}

							if (selector && typeof selector === "string") {
								matched = jQuery.filter(selector, matched);
							}

							if (this.length > 1) {

								// Remove duplicates
								if (!guaranteedUnique[name]) {
									jQuery.uniqueSort(matched);
								}

								// Reverse order for parents* and prev-derivatives
								if (rparentsprev.test(name)) {
									matched.reverse();
								}
							}

							return this.pushStack(matched);
						};
					});
					var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);



					// Convert String-formatted options into Object-formatted ones
					function createOptions(options) {
						var object = {};
						jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
							object[flag] = true;
						});
						return object;
					}

					/*
					 * Create a callback list using the following parameters:
					 *
					 *	options: an optional list of space-separated options that will change how
					 *			the callback list behaves or a more traditional option object
					 *
					 * By default a callback list will act like an event callback list and can be
					 * "fired" multiple times.
					 *
					 * Possible options:
					 *
					 *	once:			will ensure the callback list can only be fired once (like a Deferred)
					 *
					 *	memory:			will keep track of previous values and will call any callback added
					 *					after the list has been fired right away with the latest "memorized"
					 *					values (like a Deferred)
					 *
					 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
					 *
					 *	stopOnFalse:	interrupt callings when a callback returns false
					 *
					 */
					jQuery.Callbacks = function (options) {

						// Convert options from String-formatted to Object-formatted if needed
						// (we check in cache first)
						options = typeof options === "string" ?
							createOptions(options) :
							jQuery.extend({}, options);

						var // Flag to know if list is currently firing
							firing,

							// Last fire value for non-forgettable lists
							memory,

							// Flag to know if list was already fired
							fired,

							// Flag to prevent firing
							locked,

							// Actual callback list
							list = [],

							// Queue of execution data for repeatable lists
							queue = [],

							// Index of currently firing callback (modified by add/remove as needed)
							firingIndex = -1,

							// Fire callbacks
							fire = function () {

								// Enforce single-firing
								locked = locked || options.once;

								// Execute callbacks for all pending executions,
								// respecting firingIndex overrides and runtime changes
								fired = firing = true;
								for (; queue.length; firingIndex = -1) {
									memory = queue.shift();
									while (++firingIndex < list.length) {

										// Run callback and check for early termination
										if (list[firingIndex].apply(memory[0], memory[1]) === false &&
											options.stopOnFalse) {

											// Jump to end and forget the data so .add doesn't re-fire
											firingIndex = list.length;
											memory = false;
										}
									}
								}

								// Forget the data if we're done with it
								if (!options.memory) {
									memory = false;
								}

								firing = false;

								// Clean up if we're done firing for good
								if (locked) {

									// Keep an empty list if we have data for future add calls
									if (memory) {
										list = [];

										// Otherwise, this object is spent
									} else {
										list = "";
									}
								}
							},

							// Actual Callbacks object
							self = {

								// Add a callback or a collection of callbacks to the list
								add: function () {
									if (list) {

										// If we have memory from a past run, we should fire after adding
										if (memory && !firing) {
											firingIndex = list.length - 1;
											queue.push(memory);
										}

										(function add(args) {
											jQuery.each(args, function (_, arg) {
												if (isFunction(arg)) {
													if (!options.unique || !self.has(arg)) {
														list.push(arg);
													}
												} else if (arg && arg.length && toType(arg) !== "string") {

													// Inspect recursively
													add(arg);
												}
											});
										})(arguments);

										if (memory && !firing) {
											fire();
										}
									}
									return this;
								},

								// Remove a callback from the list
								remove: function () {
									jQuery.each(arguments, function (_, arg) {
										var index;
										while ((index = jQuery.inArray(arg, list, index)) > -1) {
											list.splice(index, 1);

											// Handle firing indexes
											if (index <= firingIndex) {
												firingIndex--;
											}
										}
									});
									return this;
								},

								// Check if a given callback is in the list.
								// If no argument is given, return whether or not list has callbacks attached.
								has: function (fn) {
									return fn ?
										jQuery.inArray(fn, list) > -1 :
										list.length > 0;
								},

								// Remove all callbacks from the list
								empty: function () {
									if (list) {
										list = [];
									}
									return this;
								},

								// Disable .fire and .add
								// Abort any current/pending executions
								// Clear all callbacks and values
								disable: function () {
									locked = queue = [];
									list = memory = "";
									return this;
								},
								disabled: function () {
									return !list;
								},

								// Disable .fire
								// Also disable .add unless we have memory (since it would have no effect)
								// Abort any pending executions
								lock: function () {
									locked = queue = [];
									if (!memory && !firing) {
										list = memory = "";
									}
									return this;
								},
								locked: function () {
									return !!locked;
								},

								// Call all callbacks with the given context and arguments
								fireWith: function (context, args) {
									if (!locked) {
										args = args || [];
										args = [context, args.slice ? args.slice() : args];
										queue.push(args);
										if (!firing) {
											fire();
										}
									}
									return this;
								},

								// Call all the callbacks with the given arguments
								fire: function () {
									self.fireWith(this, arguments);
									return this;
								},

								// To know if the callbacks have already been called at least once
								fired: function () {
									return !!fired;
								}
							};

						return self;
					};


					function Identity(v) {
						return v;
					}
					function Thrower(ex) {
						throw ex;
					}

					function adoptValue(value, resolve, reject, noValue) {
						var method;

						try {

							// Check for promise aspect first to privilege synchronous behavior
							if (value && isFunction((method = value.promise))) {
								method.call(value).done(resolve).fail(reject);

								// Other thenables
							} else if (value && isFunction((method = value.then))) {
								method.call(value, resolve, reject);

								// Other non-thenables
							} else {

								// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
								// * false: [ value ].slice( 0 ) => resolve( value )
								// * true: [ value ].slice( 1 ) => resolve()
								resolve.apply(undefined, [value].slice(noValue));
							}

							// For Promises/A+, convert exceptions into rejections
							// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
							// Deferred#then to conditionally suppress rejection.
						} catch (value) {

							// Support: Android 4.0 only
							// Strict mode functions invoked without .call/.apply get global-object context
							reject.apply(undefined, [value]);
						}
					}

					jQuery.extend({

						Deferred: function (func) {
							var tuples = [

								// action, add listener, callbacks,
								// ... .then handlers, argument index, [final state]
								["notify", "progress", jQuery.Callbacks("memory"),
									jQuery.Callbacks("memory"), 2],
								["resolve", "done", jQuery.Callbacks("once memory"),
									jQuery.Callbacks("once memory"), 0, "resolved"],
								["reject", "fail", jQuery.Callbacks("once memory"),
									jQuery.Callbacks("once memory"), 1, "rejected"]
							],
								state = "pending",
								promise = {
									state: function () {
										return state;
									},
									always: function () {
										deferred.done(arguments).fail(arguments);
										return this;
									},
									"catch": function (fn) {
										return promise.then(null, fn);
									},

									// Keep pipe for back-compat
									pipe: function ( /* fnDone, fnFail, fnProgress */) {
										var fns = arguments;

										return jQuery.Deferred(function (newDefer) {
											jQuery.each(tuples, function (i, tuple) {

												// Map tuples (progress, done, fail) to arguments (done, fail, progress)
												var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

												// deferred.progress(function() { bind to newDefer or newDefer.notify })
												// deferred.done(function() { bind to newDefer or newDefer.resolve })
												// deferred.fail(function() { bind to newDefer or newDefer.reject })
												deferred[tuple[1]](function () {
													var returned = fn && fn.apply(this, arguments);
													if (returned && isFunction(returned.promise)) {
														returned.promise()
															.progress(newDefer.notify)
															.done(newDefer.resolve)
															.fail(newDefer.reject);
													} else {
														newDefer[tuple[0] + "With"](
															this,
															fn ? [returned] : arguments
														);
													}
												});
											});
											fns = null;
										}).promise();
									},
									then: function (onFulfilled, onRejected, onProgress) {
										var maxDepth = 0;
										function resolve(depth, deferred, handler, special) {
											return function () {
												var that = this,
													args = arguments,
													mightThrow = function () {
														var returned, then;

														// Support: Promises/A+ section 2.3.3.3.3
														// https://promisesaplus.com/#point-59
														// Ignore double-resolution attempts
														if (depth < maxDepth) {
															return;
														}

														returned = handler.apply(that, args);

														// Support: Promises/A+ section 2.3.1
														// https://promisesaplus.com/#point-48
														if (returned === deferred.promise()) {
															throw new TypeError("Thenable self-resolution");
														}

														// Support: Promises/A+ sections 2.3.3.1, 3.5
														// https://promisesaplus.com/#point-54
														// https://promisesaplus.com/#point-75
														// Retrieve `then` only once
														then = returned &&

															// Support: Promises/A+ section 2.3.4
															// https://promisesaplus.com/#point-64
															// Only check objects and functions for thenability
															(typeof returned === "object" ||
																typeof returned === "function") &&
															returned.then;

														// Handle a returned thenable
														if (isFunction(then)) {

															// Special processors (notify) just wait for resolution
															if (special) {
																then.call(
																	returned,
																	resolve(maxDepth, deferred, Identity, special),
																	resolve(maxDepth, deferred, Thrower, special)
																);

																// Normal processors (resolve) also hook into progress
															} else {

																// ...and disregard older resolution values
																maxDepth++;

																then.call(
																	returned,
																	resolve(maxDepth, deferred, Identity, special),
																	resolve(maxDepth, deferred, Thrower, special),
																	resolve(maxDepth, deferred, Identity,
																		deferred.notifyWith)
																);
															}

															// Handle all other returned values
														} else {

															// Only substitute handlers pass on context
															// and multiple values (non-spec behavior)
															if (handler !== Identity) {
																that = undefined;
																args = [returned];
															}

															// Process the value(s)
															// Default process is resolve
															(special || deferred.resolveWith)(that, args);
														}
													},

													// Only normal processors (resolve) catch and reject exceptions
													process = special ?
														mightThrow :
														function () {
															try {
																mightThrow();
															} catch (e) {

																if (jQuery.Deferred.exceptionHook) {
																	jQuery.Deferred.exceptionHook(e,
																		process.stackTrace);
																}

																// Support: Promises/A+ section 2.3.3.3.4.1
																// https://promisesaplus.com/#point-61
																// Ignore post-resolution exceptions
																if (depth + 1 >= maxDepth) {

																	// Only substitute handlers pass on context
																	// and multiple values (non-spec behavior)
																	if (handler !== Thrower) {
																		that = undefined;
																		args = [e];
																	}

																	deferred.rejectWith(that, args);
																}
															}
														};

												// Support: Promises/A+ section 2.3.3.3.1
												// https://promisesaplus.com/#point-57
												// Re-resolve promises immediately to dodge false rejection from
												// subsequent errors
												if (depth) {
													process();
												} else {

													// Call an optional hook to record the stack, in case of exception
													// since it's otherwise lost when execution goes async
													if (jQuery.Deferred.getStackHook) {
														process.stackTrace = jQuery.Deferred.getStackHook();
													}
													window.setTimeout(process);
												}
											};
										}

										return jQuery.Deferred(function (newDefer) {

											// progress_handlers.add( ... )
											tuples[0][3].add(
												resolve(
													0,
													newDefer,
													isFunction(onProgress) ?
														onProgress :
														Identity,
													newDefer.notifyWith
												)
											);

											// fulfilled_handlers.add( ... )
											tuples[1][3].add(
												resolve(
													0,
													newDefer,
													isFunction(onFulfilled) ?
														onFulfilled :
														Identity
												)
											);

											// rejected_handlers.add( ... )
											tuples[2][3].add(
												resolve(
													0,
													newDefer,
													isFunction(onRejected) ?
														onRejected :
														Thrower
												)
											);
										}).promise();
									},

									// Get a promise for this deferred
									// If obj is provided, the promise aspect is added to the object
									promise: function (obj) {
										return obj != null ? jQuery.extend(obj, promise) : promise;
									}
								},
								deferred = {};

							// Add list-specific methods
							jQuery.each(tuples, function (i, tuple) {
								var list = tuple[2],
									stateString = tuple[5];

								// promise.progress = list.add
								// promise.done = list.add
								// promise.fail = list.add
								promise[tuple[1]] = list.add;

								// Handle state
								if (stateString) {
									list.add(
										function () {

											// state = "resolved" (i.e., fulfilled)
											// state = "rejected"
											state = stateString;
										},

										// rejected_callbacks.disable
										// fulfilled_callbacks.disable
										tuples[3 - i][2].disable,

										// rejected_handlers.disable
										// fulfilled_handlers.disable
										tuples[3 - i][3].disable,

										// progress_callbacks.lock
										tuples[0][2].lock,

										// progress_handlers.lock
										tuples[0][3].lock
									);
								}

								// progress_handlers.fire
								// fulfilled_handlers.fire
								// rejected_handlers.fire
								list.add(tuple[3].fire);

								// deferred.notify = function() { deferred.notifyWith(...) }
								// deferred.resolve = function() { deferred.resolveWith(...) }
								// deferred.reject = function() { deferred.rejectWith(...) }
								deferred[tuple[0]] = function () {
									deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
									return this;
								};

								// deferred.notifyWith = list.fireWith
								// deferred.resolveWith = list.fireWith
								// deferred.rejectWith = list.fireWith
								deferred[tuple[0] + "With"] = list.fireWith;
							});

							// Make the deferred a promise
							promise.promise(deferred);

							// Call given func if any
							if (func) {
								func.call(deferred, deferred);
							}

							// All done!
							return deferred;
						},

						// Deferred helper
						when: function (singleValue) {
							var

								// count of uncompleted subordinates
								remaining = arguments.length,

								// count of unprocessed arguments
								i = remaining,

								// subordinate fulfillment data
								resolveContexts = Array(i),
								resolveValues = slice.call(arguments),

								// the master Deferred
								master = jQuery.Deferred(),

								// subordinate callback factory
								updateFunc = function (i) {
									return function (value) {
										resolveContexts[i] = this;
										resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
										if (!(--remaining)) {
											master.resolveWith(resolveContexts, resolveValues);
										}
									};
								};

							// Single- and empty arguments are adopted like Promise.resolve
							if (remaining <= 1) {
								adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject,
									!remaining);

								// Use .then() to unwrap secondary thenables (cf. gh-3000)
								if (master.state() === "pending" ||
									isFunction(resolveValues[i] && resolveValues[i].then)) {

									return master.then();
								}
							}

							// Multiple arguments are aggregated like Promise.all array elements
							while (i--) {
								adoptValue(resolveValues[i], updateFunc(i), master.reject);
							}

							return master.promise();
						}
					});


					// These usually indicate a programmer mistake during development,
					// warn about them ASAP rather than swallowing them by default.
					var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

					jQuery.Deferred.exceptionHook = function (error, stack) {

						// Support: IE 8 - 9 only
						// Console exists when dev tools are open, which can happen at any time
						if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
							window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
						}
					};




					jQuery.readyException = function (error) {
						window.setTimeout(function () {
							throw error;
						});
					};




					// The deferred used on DOM ready
					var readyList = jQuery.Deferred();

					jQuery.fn.ready = function (fn) {

						readyList
							.then(fn)

							// Wrap jQuery.readyException in a function so that the lookup
							// happens at the time of error handling instead of callback
							// registration.
							.catch(function (error) {
								jQuery.readyException(error);
							});

						return this;
					};

					jQuery.extend({

						// Is the DOM ready to be used? Set to true once it occurs.
						isReady: false,

						// A counter to track how many items to wait for before
						// the ready event fires. See #6781
						readyWait: 1,

						// Handle when the DOM is ready
						ready: function (wait) {

							// Abort if there are pending holds or we're already ready
							if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
								return;
							}

							// Remember that the DOM is ready
							jQuery.isReady = true;

							// If a normal DOM Ready event fired, decrement, and wait if need be
							if (wait !== true && --jQuery.readyWait > 0) {
								return;
							}

							// If there are functions bound, to execute
							readyList.resolveWith(document, [jQuery]);
						}
					});

					jQuery.ready.then = readyList.then;

					// The ready event handler and self cleanup method
					function completed() {
						document.removeEventListener("DOMContentLoaded", completed);
						window.removeEventListener("load", completed);
						jQuery.ready();
					}

					// Catch cases where $(document).ready() is called
					// after the browser event has already occurred.
					// Support: IE <=9 - 10 only
					// Older IE sometimes signals "interactive" too soon
					if (document.readyState === "complete" ||
						(document.readyState !== "loading" && !document.documentElement.doScroll)) {

						// Handle it asynchronously to allow scripts the opportunity to delay ready
						window.setTimeout(jQuery.ready);

					} else {

						// Use the handy event callback
						document.addEventListener("DOMContentLoaded", completed);

						// A fallback to window.onload, that will always work
						window.addEventListener("load", completed);
					}




					// Multifunctional method to get and set values of a collection
					// The value/s can optionally be executed if it's a function
					var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
						var i = 0,
							len = elems.length,
							bulk = key == null;

						// Sets many values
						if (toType(key) === "object") {
							chainable = true;
							for (i in key) {
								access(elems, fn, i, key[i], true, emptyGet, raw);
							}

							// Sets one value
						} else if (value !== undefined) {
							chainable = true;

							if (!isFunction(value)) {
								raw = true;
							}

							if (bulk) {

								// Bulk operations run against the entire set
								if (raw) {
									fn.call(elems, value);
									fn = null;

									// ...except when executing function values
								} else {
									bulk = fn;
									fn = function (elem, key, value) {
										return bulk.call(jQuery(elem), value);
									};
								}
							}

							if (fn) {
								for (; i < len; i++) {
									fn(
										elems[i], key, raw ?
										value :
										value.call(elems[i], i, fn(elems[i], key))
									);
								}
							}
						}

						if (chainable) {
							return elems;
						}

						// Gets
						if (bulk) {
							return fn.call(elems);
						}

						return len ? fn(elems[0], key) : emptyGet;
					};


					// Matches dashed string for camelizing
					var rmsPrefix = /^-ms-/,
						rdashAlpha = /-([a-z])/g;

					// Used by camelCase as callback to replace()
					function fcamelCase(all, letter) {
						return letter.toUpperCase();
					}

					// Convert dashed to camelCase; used by the css and data modules
					// Support: IE <=9 - 11, Edge 12 - 15
					// Microsoft forgot to hump their vendor prefix (#9572)
					function camelCase(string) {
						return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
					}
					var acceptData = function (owner) {

						// Accepts only:
						//  - Node
						//    - Node.ELEMENT_NODE
						//    - Node.DOCUMENT_NODE
						//  - Object
						//    - Any
						return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
					};




					function Data() {
						this.expando = jQuery.expando + Data.uid++;
					}

					Data.uid = 1;

					Data.prototype = {

						cache: function (owner) {

							// Check if the owner object already has a cache
							var value = owner[this.expando];

							// If not, create one
							if (!value) {
								value = {};

								// We can accept data for non-element nodes in modern browsers,
								// but we should not, see #8335.
								// Always return an empty object.
								if (acceptData(owner)) {

									// If it is a node unlikely to be stringify-ed or looped over
									// use plain assignment
									if (owner.nodeType) {
										owner[this.expando] = value;

										// Otherwise secure it in a non-enumerable property
										// configurable must be true to allow the property to be
										// deleted when data is removed
									} else {
										Object.defineProperty(owner, this.expando, {
											value: value,
											configurable: true
										});
									}
								}
							}

							return value;
						},
						set: function (owner, data, value) {
							var prop,
								cache = this.cache(owner);

							// Handle: [ owner, key, value ] args
							// Always use camelCase key (gh-2257)
							if (typeof data === "string") {
								cache[camelCase(data)] = value;

								// Handle: [ owner, { properties } ] args
							} else {

								// Copy the properties one-by-one to the cache object
								for (prop in data) {
									cache[camelCase(prop)] = data[prop];
								}
							}
							return cache;
						},
						get: function (owner, key) {
							return key === undefined ?
								this.cache(owner) :

								// Always use camelCase key (gh-2257)
								owner[this.expando] && owner[this.expando][camelCase(key)];
						},
						access: function (owner, key, value) {

							// In cases where either:
							//
							//   1. No key was specified
							//   2. A string key was specified, but no value provided
							//
							// Take the "read" path and allow the get method to determine
							// which value to return, respectively either:
							//
							//   1. The entire cache object
							//   2. The data stored at the key
							//
							if (key === undefined ||
								((key && typeof key === "string") && value === undefined)) {

								return this.get(owner, key);
							}

							// When the key is not a string, or both a key and value
							// are specified, set or extend (existing objects) with either:
							//
							//   1. An object of properties
							//   2. A key and value
							//
							this.set(owner, key, value);

							// Since the "set" path can have two possible entry points
							// return the expected data based on which path was taken[*]
							return value !== undefined ? value : key;
						},
						remove: function (owner, key) {
							var i,
								cache = owner[this.expando];

							if (cache === undefined) {
								return;
							}

							if (key !== undefined) {

								// Support array or space separated string of keys
								if (Array.isArray(key)) {

									// If key is an array of keys...
									// We always set camelCase keys, so remove that.
									key = key.map(camelCase);
								} else {
									key = camelCase(key);

									// If a key with the spaces exists, use it.
									// Otherwise, create an array by matching non-whitespace
									key = key in cache ?
										[key] :
										(key.match(rnothtmlwhite) || []);
								}

								i = key.length;

								while (i--) {
									delete cache[key[i]];
								}
							}

							// Remove the expando if there's no more data
							if (key === undefined || jQuery.isEmptyObject(cache)) {

								// Support: Chrome <=35 - 45
								// Webkit & Blink performance suffers when deleting properties
								// from DOM nodes, so set to undefined instead
								// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
								if (owner.nodeType) {
									owner[this.expando] = undefined;
								} else {
									delete owner[this.expando];
								}
							}
						},
						hasData: function (owner) {
							var cache = owner[this.expando];
							return cache !== undefined && !jQuery.isEmptyObject(cache);
						}
					};
					var dataPriv = new Data();

					var dataUser = new Data();



					//	Implementation Summary
					//
					//	1. Enforce API surface and semantic compatibility with 1.9.x branch
					//	2. Improve the module's maintainability by reducing the storage
					//		paths to a single mechanism.
					//	3. Use the same single mechanism to support "private" and "user" data.
					//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
					//	5. Avoid exposing implementation details on user objects (eg. expando properties)
					//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

					var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
						rmultiDash = /[A-Z]/g;

					function getData(data) {
						if (data === "true") {
							return true;
						}

						if (data === "false") {
							return false;
						}

						if (data === "null") {
							return null;
						}

						// Only convert to a number if it doesn't change the string
						if (data === +data + "") {
							return +data;
						}

						if (rbrace.test(data)) {
							return JSON.parse(data);
						}

						return data;
					}

					function dataAttr(elem, key, data) {
						var name;

						// If nothing was found internally, try to fetch any
						// data from the HTML5 data-* attribute
						if (data === undefined && elem.nodeType === 1) {
							name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
							data = elem.getAttribute(name);

							if (typeof data === "string") {
								try {
									data = getData(data);
								} catch (e) { }

								// Make sure we set the data so it isn't changed later
								dataUser.set(elem, key, data);
							} else {
								data = undefined;
							}
						}
						return data;
					}

					jQuery.extend({
						hasData: function (elem) {
							return dataUser.hasData(elem) || dataPriv.hasData(elem);
						},

						data: function (elem, name, data) {
							return dataUser.access(elem, name, data);
						},

						removeData: function (elem, name) {
							dataUser.remove(elem, name);
						},

						// TODO: Now that all calls to _data and _removeData have been replaced
						// with direct calls to dataPriv methods, these can be deprecated.
						_data: function (elem, name, data) {
							return dataPriv.access(elem, name, data);
						},

						_removeData: function (elem, name) {
							dataPriv.remove(elem, name);
						}
					});

					jQuery.fn.extend({
						data: function (key, value) {
							var i, name, data,
								elem = this[0],
								attrs = elem && elem.attributes;

							// Gets all values
							if (key === undefined) {
								if (this.length) {
									data = dataUser.get(elem);

									if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
										i = attrs.length;
										while (i--) {

											// Support: IE 11 only
											// The attrs elements can be null (#14894)
											if (attrs[i]) {
												name = attrs[i].name;
												if (name.indexOf("data-") === 0) {
													name = camelCase(name.slice(5));
													dataAttr(elem, name, data[name]);
												}
											}
										}
										dataPriv.set(elem, "hasDataAttrs", true);
									}
								}

								return data;
							}

							// Sets multiple values
							if (typeof key === "object") {
								return this.each(function () {
									dataUser.set(this, key);
								});
							}

							return access(this, function (value) {
								var data;

								// The calling jQuery object (element matches) is not empty
								// (and therefore has an element appears at this[ 0 ]) and the
								// `value` parameter was not undefined. An empty jQuery object
								// will result in `undefined` for elem = this[ 0 ] which will
								// throw an exception if an attempt to read a data cache is made.
								if (elem && value === undefined) {

									// Attempt to get data from the cache
									// The key will always be camelCased in Data
									data = dataUser.get(elem, key);
									if (data !== undefined) {
										return data;
									}

									// Attempt to "discover" the data in
									// HTML5 custom data-* attrs
									data = dataAttr(elem, key);
									if (data !== undefined) {
										return data;
									}

									// We tried really hard, but the data doesn't exist.
									return;
								}

								// Set the data...
								this.each(function () {

									// We always store the camelCased key
									dataUser.set(this, key, value);
								});
							}, null, value, arguments.length > 1, null, true);
						},

						removeData: function (key) {
							return this.each(function () {
								dataUser.remove(this, key);
							});
						}
					});


					jQuery.extend({
						queue: function (elem, type, data) {
							var queue;

							if (elem) {
								type = (type || "fx") + "queue";
								queue = dataPriv.get(elem, type);

								// Speed up dequeue by getting out quickly if this is just a lookup
								if (data) {
									if (!queue || Array.isArray(data)) {
										queue = dataPriv.access(elem, type, jQuery.makeArray(data));
									} else {
										queue.push(data);
									}
								}
								return queue || [];
							}
						},

						dequeue: function (elem, type) {
							type = type || "fx";

							var queue = jQuery.queue(elem, type),
								startLength = queue.length,
								fn = queue.shift(),
								hooks = jQuery._queueHooks(elem, type),
								next = function () {
									jQuery.dequeue(elem, type);
								};

							// If the fx queue is dequeued, always remove the progress sentinel
							if (fn === "inprogress") {
								fn = queue.shift();
								startLength--;
							}

							if (fn) {

								// Add a progress sentinel to prevent the fx queue from being
								// automatically dequeued
								if (type === "fx") {
									queue.unshift("inprogress");
								}

								// Clear up the last queue stop function
								delete hooks.stop;
								fn.call(elem, next, hooks);
							}

							if (!startLength && hooks) {
								hooks.empty.fire();
							}
						},

						// Not public - generate a queueHooks object, or return the current one
						_queueHooks: function (elem, type) {
							var key = type + "queueHooks";
							return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
								empty: jQuery.Callbacks("once memory").add(function () {
									dataPriv.remove(elem, [type + "queue", key]);
								})
							});
						}
					});

					jQuery.fn.extend({
						queue: function (type, data) {
							var setter = 2;

							if (typeof type !== "string") {
								data = type;
								type = "fx";
								setter--;
							}

							if (arguments.length < setter) {
								return jQuery.queue(this[0], type);
							}

							return data === undefined ?
								this :
								this.each(function () {
									var queue = jQuery.queue(this, type, data);

									// Ensure a hooks for this queue
									jQuery._queueHooks(this, type);

									if (type === "fx" && queue[0] !== "inprogress") {
										jQuery.dequeue(this, type);
									}
								});
						},
						dequeue: function (type) {
							return this.each(function () {
								jQuery.dequeue(this, type);
							});
						},
						clearQueue: function (type) {
							return this.queue(type || "fx", []);
						},

						// Get a promise resolved when queues of a certain type
						// are emptied (fx is the type by default)
						promise: function (type, obj) {
							var tmp,
								count = 1,
								defer = jQuery.Deferred(),
								elements = this,
								i = this.length,
								resolve = function () {
									if (!(--count)) {
										defer.resolveWith(elements, [elements]);
									}
								};

							if (typeof type !== "string") {
								obj = type;
								type = undefined;
							}
							type = type || "fx";

							while (i--) {
								tmp = dataPriv.get(elements[i], type + "queueHooks");
								if (tmp && tmp.empty) {
									count++;
									tmp.empty.add(resolve);
								}
							}
							resolve();
							return defer.promise(obj);
						}
					});
					var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

					var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");


					var cssExpand = ["Top", "Right", "Bottom", "Left"];

					var documentElement = document.documentElement;



					var isAttached = function (elem) {
						return jQuery.contains(elem.ownerDocument, elem);
					},
						composed = { composed: true };

					// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
					// Check attachment across shadow DOM boundaries when possible (gh-3504)
					// Support: iOS 10.0-10.2 only
					// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
					// leading to errors. We need to check for `getRootNode`.
					if (documentElement.getRootNode) {
						isAttached = function (elem) {
							return jQuery.contains(elem.ownerDocument, elem) ||
								elem.getRootNode(composed) === elem.ownerDocument;
						};
					}
					var isHiddenWithinTree = function (elem, el) {

						// isHiddenWithinTree might be called from jQuery#filter function;
						// in that case, element will be second argument
						elem = el || elem;

						// Inline style trumps all
						return elem.style.display === "none" ||
							elem.style.display === "" &&

							// Otherwise, check computed style
							// Support: Firefox <=43 - 45
							// Disconnected elements can have computed display: none, so first confirm that elem is
							// in the document.
							isAttached(elem) &&

							jQuery.css(elem, "display") === "none";
					};

					var swap = function (elem, options, callback, args) {
						var ret, name,
							old = {};

						// Remember the old values, and insert the new ones
						for (name in options) {
							old[name] = elem.style[name];
							elem.style[name] = options[name];
						}

						ret = callback.apply(elem, args || []);

						// Revert the old values
						for (name in options) {
							elem.style[name] = old[name];
						}

						return ret;
					};




					function adjustCSS(elem, prop, valueParts, tween) {
						var adjusted, scale,
							maxIterations = 20,
							currentValue = tween ?
								function () {
									return tween.cur();
								} :
								function () {
									return jQuery.css(elem, prop, "");
								},
							initial = currentValue(),
							unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),

							// Starting value computation is required for potential unit mismatches
							initialInUnit = elem.nodeType &&
								(jQuery.cssNumber[prop] || unit !== "px" && +initial) &&
								rcssNum.exec(jQuery.css(elem, prop));

						if (initialInUnit && initialInUnit[3] !== unit) {

							// Support: Firefox <=54
							// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
							initial = initial / 2;

							// Trust units reported by jQuery.css
							unit = unit || initialInUnit[3];

							// Iteratively approximate from a nonzero starting point
							initialInUnit = +initial || 1;

							while (maxIterations--) {

								// Evaluate and update our best guess (doubling guesses that zero out).
								// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
								jQuery.style(elem, prop, initialInUnit + unit);
								if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
									maxIterations = 0;
								}
								initialInUnit = initialInUnit / scale;

							}

							initialInUnit = initialInUnit * 2;
							jQuery.style(elem, prop, initialInUnit + unit);

							// Make sure we update the tween properties later on
							valueParts = valueParts || [];
						}

						if (valueParts) {
							initialInUnit = +initialInUnit || +initial || 0;

							// Apply relative offset (+=/-=) if specified
							adjusted = valueParts[1] ?
								initialInUnit + (valueParts[1] + 1) * valueParts[2] :
								+valueParts[2];
							if (tween) {
								tween.unit = unit;
								tween.start = initialInUnit;
								tween.end = adjusted;
							}
						}
						return adjusted;
					}


					var defaultDisplayMap = {};

					function getDefaultDisplay(elem) {
						var temp,
							doc = elem.ownerDocument,
							nodeName = elem.nodeName,
							display = defaultDisplayMap[nodeName];

						if (display) {
							return display;
						}

						temp = doc.body.appendChild(doc.createElement(nodeName));
						display = jQuery.css(temp, "display");

						temp.parentNode.removeChild(temp);

						if (display === "none") {
							display = "block";
						}
						defaultDisplayMap[nodeName] = display;

						return display;
					}

					function showHide(elements, show) {
						var display, elem,
							values = [],
							index = 0,
							length = elements.length;

						// Determine new display value for elements that need to change
						for (; index < length; index++) {
							elem = elements[index];
							if (!elem.style) {
								continue;
							}

							display = elem.style.display;
							if (show) {

								// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
								// check is required in this first loop unless we have a nonempty display value (either
								// inline or about-to-be-restored)
								if (display === "none") {
									values[index] = dataPriv.get(elem, "display") || null;
									if (!values[index]) {
										elem.style.display = "";
									}
								}
								if (elem.style.display === "" && isHiddenWithinTree(elem)) {
									values[index] = getDefaultDisplay(elem);
								}
							} else {
								if (display !== "none") {
									values[index] = "none";

									// Remember what we're overwriting
									dataPriv.set(elem, "display", display);
								}
							}
						}

						// Set the display of the elements in a second loop to avoid constant reflow
						for (index = 0; index < length; index++) {
							if (values[index] != null) {
								elements[index].style.display = values[index];
							}
						}

						return elements;
					}

					jQuery.fn.extend({
						show: function () {
							return showHide(this, true);
						},
						hide: function () {
							return showHide(this);
						},
						toggle: function (state) {
							if (typeof state === "boolean") {
								return state ? this.show() : this.hide();
							}

							return this.each(function () {
								if (isHiddenWithinTree(this)) {
									jQuery(this).show();
								} else {
									jQuery(this).hide();
								}
							});
						}
					});
					var rcheckableType = (/^(?:checkbox|radio)$/i);

					var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]*)/i);

					var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);



					// We have to close these tags to support XHTML (#13200)
					var wrapMap = {

						// Support: IE <=9 only
						option: [1, "<select multiple='multiple'>", "</select>"],

						// XHTML parsers do not magically insert elements in the
						// same way that tag soup parsers do. So we cannot shorten
						// this by omitting <tbody> or other required elements.
						thead: [1, "<table>", "</table>"],
						col: [2, "<table><colgroup>", "</colgroup></table>"],
						tr: [2, "<table><tbody>", "</tbody></table>"],
						td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

						_default: [0, "", ""]
					};

					// Support: IE <=9 only
					wrapMap.optgroup = wrapMap.option;

					wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
					wrapMap.th = wrapMap.td;


					function getAll(context, tag) {

						// Support: IE <=9 - 11 only
						// Use typeof to avoid zero-argument method invocation on host objects (#15151)
						var ret;

						if (typeof context.getElementsByTagName !== "undefined") {
							ret = context.getElementsByTagName(tag || "*");

						} else if (typeof context.querySelectorAll !== "undefined") {
							ret = context.querySelectorAll(tag || "*");

						} else {
							ret = [];
						}

						if (tag === undefined || tag && nodeName(context, tag)) {
							return jQuery.merge([context], ret);
						}

						return ret;
					}


					// Mark scripts as having already been evaluated
					function setGlobalEval(elems, refElements) {
						var i = 0,
							l = elems.length;

						for (; i < l; i++) {
							dataPriv.set(
								elems[i],
								"globalEval",
								!refElements || dataPriv.get(refElements[i], "globalEval")
							);
						}
					}


					var rhtml = /<|&#?\w+;/;

					function buildFragment(elems, context, scripts, selection, ignored) {
						var elem, tmp, tag, wrap, attached, j,
							fragment = context.createDocumentFragment(),
							nodes = [],
							i = 0,
							l = elems.length;

						for (; i < l; i++) {
							elem = elems[i];

							if (elem || elem === 0) {

								// Add nodes directly
								if (toType(elem) === "object") {

									// Support: Android <=4.0 only, PhantomJS 1 only
									// push.apply(_, arraylike) throws on ancient WebKit
									jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

									// Convert non-html into a text node
								} else if (!rhtml.test(elem)) {
									nodes.push(context.createTextNode(elem));

									// Convert html into DOM nodes
								} else {
									tmp = tmp || fragment.appendChild(context.createElement("div"));

									// Deserialize a standard representation
									tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
									wrap = wrapMap[tag] || wrapMap._default;
									tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

									// Descend through wrappers to the right content
									j = wrap[0];
									while (j--) {
										tmp = tmp.lastChild;
									}

									// Support: Android <=4.0 only, PhantomJS 1 only
									// push.apply(_, arraylike) throws on ancient WebKit
									jQuery.merge(nodes, tmp.childNodes);

									// Remember the top-level container
									tmp = fragment.firstChild;

									// Ensure the created nodes are orphaned (#12392)
									tmp.textContent = "";
								}
							}
						}

						// Remove wrapper from fragment
						fragment.textContent = "";

						i = 0;
						while ((elem = nodes[i++])) {

							// Skip elements already in the context collection (trac-4087)
							if (selection && jQuery.inArray(elem, selection) > -1) {
								if (ignored) {
									ignored.push(elem);
								}
								continue;
							}

							attached = isAttached(elem);

							// Append to fragment
							tmp = getAll(fragment.appendChild(elem), "script");

							// Preserve script evaluation history
							if (attached) {
								setGlobalEval(tmp);
							}

							// Capture executables
							if (scripts) {
								j = 0;
								while ((elem = tmp[j++])) {
									if (rscriptType.test(elem.type || "")) {
										scripts.push(elem);
									}
								}
							}
						}

						return fragment;
					}


					(function () {
						var fragment = document.createDocumentFragment(),
							div = fragment.appendChild(document.createElement("div")),
							input = document.createElement("input");

						// Support: Android 4.0 - 4.3 only
						// Check state lost if the name is set (#11217)
						// Support: Windows Web Apps (WWA)
						// `name` and `type` must use .setAttribute for WWA (#14901)
						input.setAttribute("type", "radio");
						input.setAttribute("checked", "checked");
						input.setAttribute("name", "t");

						div.appendChild(input);

						// Support: Android <=4.1 only
						// Older WebKit doesn't clone checked state correctly in fragments
						support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

						// Support: IE <=11 only
						// Make sure textarea (and checkbox) defaultValue is properly cloned
						div.innerHTML = "<textarea>x</textarea>";
						support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
					})();


					var
						rkeyEvent = /^key/,
						rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
						rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

					function returnTrue() {
						return true;
					}

					function returnFalse() {
						return false;
					}

					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous, except when they are no-op.
					// So expect focus to be synchronous when the element is already active,
					// and blur to be synchronous when the element is not already active.
					// (focus and blur are always synchronous in other supported browsers,
					// this just defines when we can count on it).
					function expectSync(elem, type) {
						return (elem === safeActiveElement()) === (type === "focus");
					}

					// Support: IE <=9 only
					// Accessing document.activeElement can throw unexpectedly
					// https://bugs.jquery.com/ticket/13393
					function safeActiveElement() {
						try {
							return document.activeElement;
						} catch (err) { }
					}

					function on(elem, types, selector, data, fn, one) {
						var origFn, type;

						// Types can be a map of types/handlers
						if (typeof types === "object") {

							// ( types-Object, selector, data )
							if (typeof selector !== "string") {

								// ( types-Object, data )
								data = data || selector;
								selector = undefined;
							}
							for (type in types) {
								on(elem, type, selector, data, types[type], one);
							}
							return elem;
						}

						if (data == null && fn == null) {

							// ( types, fn )
							fn = selector;
							data = selector = undefined;
						} else if (fn == null) {
							if (typeof selector === "string") {

								// ( types, selector, fn )
								fn = data;
								data = undefined;
							} else {

								// ( types, data, fn )
								fn = data;
								data = selector;
								selector = undefined;
							}
						}
						if (fn === false) {
							fn = returnFalse;
						} else if (!fn) {
							return elem;
						}

						if (one === 1) {
							origFn = fn;
							fn = function (event) {

								// Can use an empty set, since event contains the info
								jQuery().off(event);
								return origFn.apply(this, arguments);
							};

							// Use same guid so caller can remove using origFn
							fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
						}
						return elem.each(function () {
							jQuery.event.add(this, types, fn, data, selector);
						});
					}

					/*
					 * Helper functions for managing events -- not part of the public interface.
					 * Props to Dean Edwards' addEvent library for many of the ideas.
					 */
					jQuery.event = {

						global: {},

						add: function (elem, types, handler, data, selector) {

							var handleObjIn, eventHandle, tmp,
								events, t, handleObj,
								special, handlers, type, namespaces, origType,
								elemData = dataPriv.get(elem);

							// Don't attach events to noData or text/comment nodes (but allow plain objects)
							if (!elemData) {
								return;
							}

							// Caller can pass in an object of custom data in lieu of the handler
							if (handler.handler) {
								handleObjIn = handler;
								handler = handleObjIn.handler;
								selector = handleObjIn.selector;
							}

							// Ensure that invalid selectors throw exceptions at attach time
							// Evaluate against documentElement in case elem is a non-element node (e.g., document)
							if (selector) {
								jQuery.find.matchesSelector(documentElement, selector);
							}

							// Make sure that the handler has a unique ID, used to find/remove it later
							if (!handler.guid) {
								handler.guid = jQuery.guid++;
							}

							// Init the element's event structure and main handler, if this is the first
							if (!(events = elemData.events)) {
								events = elemData.events = {};
							}
							if (!(eventHandle = elemData.handle)) {
								eventHandle = elemData.handle = function (e) {

									// Discard the second event of a jQuery.event.trigger() and
									// when an event is called after a page has unloaded
									return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
										jQuery.event.dispatch.apply(elem, arguments) : undefined;
								};
							}

							// Handle multiple events separated by a space
							types = (types || "").match(rnothtmlwhite) || [""];
							t = types.length;
							while (t--) {
								tmp = rtypenamespace.exec(types[t]) || [];
								type = origType = tmp[1];
								namespaces = (tmp[2] || "").split(".").sort();

								// There *must* be a type, no attaching namespace-only handlers
								if (!type) {
									continue;
								}

								// If event changes its type, use the special event handlers for the changed type
								special = jQuery.event.special[type] || {};

								// If selector defined, determine special event api type, otherwise given type
								type = (selector ? special.delegateType : special.bindType) || type;

								// Update special based on newly reset type
								special = jQuery.event.special[type] || {};

								// handleObj is passed to all event handlers
								handleObj = jQuery.extend({
									type: type,
									origType: origType,
									data: data,
									handler: handler,
									guid: handler.guid,
									selector: selector,
									needsContext: selector && jQuery.expr.match.needsContext.test(selector),
									namespace: namespaces.join(".")
								}, handleObjIn);

								// Init the event handler queue if we're the first
								if (!(handlers = events[type])) {
									handlers = events[type] = [];
									handlers.delegateCount = 0;

									// Only use addEventListener if the special events handler returns false
									if (!special.setup ||
										special.setup.call(elem, data, namespaces, eventHandle) === false) {

										if (elem.addEventListener) {
											elem.addEventListener(type, eventHandle);
										}
									}
								}

								if (special.add) {
									special.add.call(elem, handleObj);

									if (!handleObj.handler.guid) {
										handleObj.handler.guid = handler.guid;
									}
								}

								// Add to the element's handler list, delegates in front
								if (selector) {
									handlers.splice(handlers.delegateCount++, 0, handleObj);
								} else {
									handlers.push(handleObj);
								}

								// Keep track of which events have ever been used, for event optimization
								jQuery.event.global[type] = true;
							}

						},

						// Detach an event or set of events from an element
						remove: function (elem, types, handler, selector, mappedTypes) {

							var j, origCount, tmp,
								events, t, handleObj,
								special, handlers, type, namespaces, origType,
								elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

							if (!elemData || !(events = elemData.events)) {
								return;
							}

							// Once for each type.namespace in types; type may be omitted
							types = (types || "").match(rnothtmlwhite) || [""];
							t = types.length;
							while (t--) {
								tmp = rtypenamespace.exec(types[t]) || [];
								type = origType = tmp[1];
								namespaces = (tmp[2] || "").split(".").sort();

								// Unbind all events (on this namespace, if provided) for the element
								if (!type) {
									for (type in events) {
										jQuery.event.remove(elem, type + types[t], handler, selector, true);
									}
									continue;
								}

								special = jQuery.event.special[type] || {};
								type = (selector ? special.delegateType : special.bindType) || type;
								handlers = events[type] || [];
								tmp = tmp[2] &&
									new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

								// Remove matching events
								origCount = j = handlers.length;
								while (j--) {
									handleObj = handlers[j];

									if ((mappedTypes || origType === handleObj.origType) &&
										(!handler || handler.guid === handleObj.guid) &&
										(!tmp || tmp.test(handleObj.namespace)) &&
										(!selector || selector === handleObj.selector ||
											selector === "**" && handleObj.selector)) {
										handlers.splice(j, 1);

										if (handleObj.selector) {
											handlers.delegateCount--;
										}
										if (special.remove) {
											special.remove.call(elem, handleObj);
										}
									}
								}

								// Remove generic event handler if we removed something and no more handlers exist
								// (avoids potential for endless recursion during removal of special event handlers)
								if (origCount && !handlers.length) {
									if (!special.teardown ||
										special.teardown.call(elem, namespaces, elemData.handle) === false) {

										jQuery.removeEvent(elem, type, elemData.handle);
									}

									delete events[type];
								}
							}

							// Remove data and the expando if it's no longer used
							if (jQuery.isEmptyObject(events)) {
								dataPriv.remove(elem, "handle events");
							}
						},

						dispatch: function (nativeEvent) {

							// Make a writable jQuery.Event from the native event object
							var event = jQuery.event.fix(nativeEvent);

							var i, j, ret, matched, handleObj, handlerQueue,
								args = new Array(arguments.length),
								handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
								special = jQuery.event.special[event.type] || {};

							// Use the fix-ed jQuery.Event rather than the (read-only) native event
							args[0] = event;

							for (i = 1; i < arguments.length; i++) {
								args[i] = arguments[i];
							}

							event.delegateTarget = this;

							// Call the preDispatch hook for the mapped type, and let it bail if desired
							if (special.preDispatch && special.preDispatch.call(this, event) === false) {
								return;
							}

							// Determine handlers
							handlerQueue = jQuery.event.handlers.call(this, event, handlers);

							// Run delegates first; they may want to stop propagation beneath us
							i = 0;
							while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
								event.currentTarget = matched.elem;

								j = 0;
								while ((handleObj = matched.handlers[j++]) &&
									!event.isImmediatePropagationStopped()) {

									// If the event is namespaced, then each handler is only invoked if it is
									// specially universal or its namespaces are a superset of the event's.
									if (!event.rnamespace || handleObj.namespace === false ||
										event.rnamespace.test(handleObj.namespace)) {

										event.handleObj = handleObj;
										event.data = handleObj.data;

										ret = ((jQuery.event.special[handleObj.origType] || {}).handle ||
											handleObj.handler).apply(matched.elem, args);

										if (ret !== undefined) {
											if ((event.result = ret) === false) {
												event.preventDefault();
												event.stopPropagation();
											}
										}
									}
								}
							}

							// Call the postDispatch hook for the mapped type
							if (special.postDispatch) {
								special.postDispatch.call(this, event);
							}

							return event.result;
						},

						handlers: function (event, handlers) {
							var i, handleObj, sel, matchedHandlers, matchedSelectors,
								handlerQueue = [],
								delegateCount = handlers.delegateCount,
								cur = event.target;

							// Find delegate handlers
							if (delegateCount &&

								// Support: IE <=9
								// Black-hole SVG <use> instance trees (trac-13180)
								cur.nodeType &&

								// Support: Firefox <=42
								// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
								// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
								// Support: IE 11 only
								// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
								!(event.type === "click" && event.button >= 1)) {

								for (; cur !== this; cur = cur.parentNode || this) {

									// Don't check non-elements (#13208)
									// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
									if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
										matchedHandlers = [];
										matchedSelectors = {};
										for (i = 0; i < delegateCount; i++) {
											handleObj = handlers[i];

											// Don't conflict with Object.prototype properties (#13203)
											sel = handleObj.selector + " ";

											if (matchedSelectors[sel] === undefined) {
												matchedSelectors[sel] = handleObj.needsContext ?
													jQuery(sel, this).index(cur) > -1 :
													jQuery.find(sel, this, null, [cur]).length;
											}
											if (matchedSelectors[sel]) {
												matchedHandlers.push(handleObj);
											}
										}
										if (matchedHandlers.length) {
											handlerQueue.push({ elem: cur, handlers: matchedHandlers });
										}
									}
								}
							}

							// Add the remaining (directly-bound) handlers
							cur = this;
							if (delegateCount < handlers.length) {
								handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
							}

							return handlerQueue;
						},

						addProp: function (name, hook) {
							Object.defineProperty(jQuery.Event.prototype, name, {
								enumerable: true,
								configurable: true,

								get: isFunction(hook) ?
									function () {
										if (this.originalEvent) {
											return hook(this.originalEvent);
										}
									} :
									function () {
										if (this.originalEvent) {
											return this.originalEvent[name];
										}
									},

								set: function (value) {
									Object.defineProperty(this, name, {
										enumerable: true,
										configurable: true,
										writable: true,
										value: value
									});
								}
							});
						},

						fix: function (originalEvent) {
							return originalEvent[jQuery.expando] ?
								originalEvent :
								new jQuery.Event(originalEvent);
						},

						special: {
							load: {

								// Prevent triggered image.load events from bubbling to window.load
								noBubble: true
							},
							click: {

								// Utilize native event to ensure correct state for checkable inputs
								setup: function (data) {

									// For mutual compressibility with _default, replace `this` access with a local var.
									// `|| data` is dead code meant only to preserve the variable through minification.
									var el = this || data;

									// Claim the first handler
									if (rcheckableType.test(el.type) &&
										el.click && nodeName(el, "input")) {

										// dataPriv.set( el, "click", ... )
										leverageNative(el, "click", returnTrue);
									}

									// Return false to allow normal processing in the caller
									return false;
								},
								trigger: function (data) {

									// For mutual compressibility with _default, replace `this` access with a local var.
									// `|| data` is dead code meant only to preserve the variable through minification.
									var el = this || data;

									// Force setup before triggering a click
									if (rcheckableType.test(el.type) &&
										el.click && nodeName(el, "input")) {

										leverageNative(el, "click");
									}

									// Return non-false to allow normal event-path propagation
									return true;
								},

								// For cross-browser consistency, suppress native .click() on links
								// Also prevent it if we're currently inside a leveraged native-event stack
								_default: function (event) {
									var target = event.target;
									return rcheckableType.test(target.type) &&
										target.click && nodeName(target, "input") &&
										dataPriv.get(target, "click") ||
										nodeName(target, "a");
								}
							},

							beforeunload: {
								postDispatch: function (event) {

									// Support: Firefox 20+
									// Firefox doesn't alert if the returnValue field is not set.
									if (event.result !== undefined && event.originalEvent) {
										event.originalEvent.returnValue = event.result;
									}
								}
							}
						}
					};

					// Ensure the presence of an event listener that handles manually-triggered
					// synthetic events by interrupting progress until reinvoked in response to
					// *native* events that it fires directly, ensuring that state changes have
					// already occurred before other listeners are invoked.
					function leverageNative(el, type, expectSync) {

						// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
						if (!expectSync) {
							if (dataPriv.get(el, type) === undefined) {
								jQuery.event.add(el, type, returnTrue);
							}
							return;
						}

						// Register the controller as a special universal handler for all event namespaces
						dataPriv.set(el, type, false);
						jQuery.event.add(el, type, {
							namespace: false,
							handler: function (event) {
								var notAsync, result,
									saved = dataPriv.get(this, type);

								if ((event.isTrigger & 1) && this[type]) {

									// Interrupt processing of the outer synthetic .trigger()ed event
									// Saved data should be false in such cases, but might be a leftover capture object
									// from an async native handler (gh-4350)
									if (!saved.length) {

										// Store arguments for use when handling the inner native event
										// There will always be at least one argument (an event object), so this array
										// will not be confused with a leftover capture object.
										saved = slice.call(arguments);
										dataPriv.set(this, type, saved);

										// Trigger the native event and capture its result
										// Support: IE <=9 - 11+
										// focus() and blur() are asynchronous
										notAsync = expectSync(this, type);
										this[type]();
										result = dataPriv.get(this, type);
										if (saved !== result || notAsync) {
											dataPriv.set(this, type, false);
										} else {
											result = {};
										}
										if (saved !== result) {

											// Cancel the outer synthetic event
											event.stopImmediatePropagation();
											event.preventDefault();
											return result.value;
										}

										// If this is an inner synthetic event for an event with a bubbling surrogate
										// (focus or blur), assume that the surrogate already propagated from triggering the
										// native event and prevent that from happening again here.
										// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
										// bubbling surrogate propagates *after* the non-bubbling base), but that seems
										// less bad than duplication.
									} else if ((jQuery.event.special[type] || {}).delegateType) {
										event.stopPropagation();
									}

									// If this is a native event triggered above, everything is now in order
									// Fire an inner synthetic event with the original arguments
								} else if (saved.length) {

									// ...and capture the result
									dataPriv.set(this, type, {
										value: jQuery.event.trigger(

											// Support: IE <=9 - 11+
											// Extend with the prototype to reset the above stopImmediatePropagation()
											jQuery.extend(saved[0], jQuery.Event.prototype),
											saved.slice(1),
											this
										)
									});

									// Abort handling of the native event
									event.stopImmediatePropagation();
								}
							}
						});
					}

					jQuery.removeEvent = function (elem, type, handle) {

						// This "if" is needed for plain objects
						if (elem.removeEventListener) {
							elem.removeEventListener(type, handle);
						}
					};

					jQuery.Event = function (src, props) {

						// Allow instantiation without the 'new' keyword
						if (!(this instanceof jQuery.Event)) {
							return new jQuery.Event(src, props);
						}

						// Event object
						if (src && src.type) {
							this.originalEvent = src;
							this.type = src.type;

							// Events bubbling up the document may have been marked as prevented
							// by a handler lower down the tree; reflect the correct value.
							this.isDefaultPrevented = src.defaultPrevented ||
								src.defaultPrevented === undefined &&

								// Support: Android <=2.3 only
								src.returnValue === false ?
								returnTrue :
								returnFalse;

							// Create target properties
							// Support: Safari <=6 - 7 only
							// Target should not be a text node (#504, #13143)
							this.target = (src.target && src.target.nodeType === 3) ?
								src.target.parentNode :
								src.target;

							this.currentTarget = src.currentTarget;
							this.relatedTarget = src.relatedTarget;

							// Event type
						} else {
							this.type = src;
						}

						// Put explicitly provided properties onto the event object
						if (props) {
							jQuery.extend(this, props);
						}

						// Create a timestamp if incoming event doesn't have one
						this.timeStamp = src && src.timeStamp || Date.now();

						// Mark it as fixed
						this[jQuery.expando] = true;
					};

					// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
					// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
					jQuery.Event.prototype = {
						constructor: jQuery.Event,
						isDefaultPrevented: returnFalse,
						isPropagationStopped: returnFalse,
						isImmediatePropagationStopped: returnFalse,
						isSimulated: false,

						preventDefault: function () {
							var e = this.originalEvent;

							this.isDefaultPrevented = returnTrue;

							if (e && !this.isSimulated) {
								e.preventDefault();
							}
						},
						stopPropagation: function () {
							var e = this.originalEvent;

							this.isPropagationStopped = returnTrue;

							if (e && !this.isSimulated) {
								e.stopPropagation();
							}
						},
						stopImmediatePropagation: function () {
							var e = this.originalEvent;

							this.isImmediatePropagationStopped = returnTrue;

							if (e && !this.isSimulated) {
								e.stopImmediatePropagation();
							}

							this.stopPropagation();
						}
					};

					// Includes all common event props including KeyEvent and MouseEvent specific props
					jQuery.each({
						altKey: true,
						bubbles: true,
						cancelable: true,
						changedTouches: true,
						ctrlKey: true,
						detail: true,
						eventPhase: true,
						metaKey: true,
						pageX: true,
						pageY: true,
						shiftKey: true,
						view: true,
						"char": true,
						code: true,
						charCode: true,
						key: true,
						keyCode: true,
						button: true,
						buttons: true,
						clientX: true,
						clientY: true,
						offsetX: true,
						offsetY: true,
						pointerId: true,
						pointerType: true,
						screenX: true,
						screenY: true,
						targetTouches: true,
						toElement: true,
						touches: true,

						which: function (event) {
							var button = event.button;

							// Add which for key events
							if (event.which == null && rkeyEvent.test(event.type)) {
								return event.charCode != null ? event.charCode : event.keyCode;
							}

							// Add which for click: 1 === left; 2 === middle; 3 === right
							if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
								if (button & 1) {
									return 1;
								}

								if (button & 2) {
									return 3;
								}

								if (button & 4) {
									return 2;
								}

								return 0;
							}

							return event.which;
						}
					}, jQuery.event.addProp);

					jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {
						jQuery.event.special[type] = {

							// Utilize native event if possible so blur/focus sequence is correct
							setup: function () {

								// Claim the first handler
								// dataPriv.set( this, "focus", ... )
								// dataPriv.set( this, "blur", ... )
								leverageNative(this, type, expectSync);

								// Return false to allow normal processing in the caller
								return false;
							},
							trigger: function () {

								// Force setup before trigger
								leverageNative(this, type);

								// Return non-false to allow normal event-path propagation
								return true;
							},

							delegateType: delegateType
						};
					});

					// Create mouseenter/leave events using mouseover/out and event-time checks
					// so that event delegation works in jQuery.
					// Do the same for pointerenter/pointerleave and pointerover/pointerout
					//
					// Support: Safari 7 only
					// Safari sends mouseenter too often; see:
					// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
					// for the description of the bug (it existed in older Chrome versions as well).
					jQuery.each({
						mouseenter: "mouseover",
						mouseleave: "mouseout",
						pointerenter: "pointerover",
						pointerleave: "pointerout"
					}, function (orig, fix) {
						jQuery.event.special[orig] = {
							delegateType: fix,
							bindType: fix,

							handle: function (event) {
								var ret,
									target = this,
									related = event.relatedTarget,
									handleObj = event.handleObj;

								// For mouseenter/leave call the handler if related is outside the target.
								// NB: No relatedTarget if the mouse left/entered the browser window
								if (!related || (related !== target && !jQuery.contains(target, related))) {
									event.type = handleObj.origType;
									ret = handleObj.handler.apply(this, arguments);
									event.type = fix;
								}
								return ret;
							}
						};
					});

					jQuery.fn.extend({

						on: function (types, selector, data, fn) {
							return on(this, types, selector, data, fn);
						},
						one: function (types, selector, data, fn) {
							return on(this, types, selector, data, fn, 1);
						},
						off: function (types, selector, fn) {
							var handleObj, type;
							if (types && types.preventDefault && types.handleObj) {

								// ( event )  dispatched jQuery.Event
								handleObj = types.handleObj;
								jQuery(types.delegateTarget).off(
									handleObj.namespace ?
										handleObj.origType + "." + handleObj.namespace :
										handleObj.origType,
									handleObj.selector,
									handleObj.handler
								);
								return this;
							}
							if (typeof types === "object") {

								// ( types-object [, selector] )
								for (type in types) {
									this.off(type, selector, types[type]);
								}
								return this;
							}
							if (selector === false || typeof selector === "function") {

								// ( types [, fn] )
								fn = selector;
								selector = undefined;
							}
							if (fn === false) {
								fn = returnFalse;
							}
							return this.each(function () {
								jQuery.event.remove(this, types, fn, selector);
							});
						}
					});


					var

						/* eslint-disable max-len */

						// See https://github.com/eslint/eslint/issues/3229
						rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

						/* eslint-enable */

						// Support: IE <=10 - 11, Edge 12 - 13 only
						// In IE/Edge using regex groups here causes severe slowdowns.
						// See https://connect.microsoft.com/IE/feedback/details/1736512/
						rnoInnerhtml = /<script|<style|<link/i,

						// checked="checked" or checked
						rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
						rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

					// Prefer a tbody over its parent table for containing new rows
					function manipulationTarget(elem, content) {
						if (nodeName(elem, "table") &&
							nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

							return jQuery(elem).children("tbody")[0] || elem;
						}

						return elem;
					}

					// Replace/restore the type attribute of script elements for safe DOM manipulation
					function disableScript(elem) {
						elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
						return elem;
					}
					function restoreScript(elem) {
						if ((elem.type || "").slice(0, 5) === "true/") {
							elem.type = elem.type.slice(5);
						} else {
							elem.removeAttribute("type");
						}

						return elem;
					}

					function cloneCopyEvent(src, dest) {
						var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

						if (dest.nodeType !== 1) {
							return;
						}

						// 1. Copy private data: events, handlers, etc.
						if (dataPriv.hasData(src)) {
							pdataOld = dataPriv.access(src);
							pdataCur = dataPriv.set(dest, pdataOld);
							events = pdataOld.events;

							if (events) {
								delete pdataCur.handle;
								pdataCur.events = {};

								for (type in events) {
									for (i = 0, l = events[type].length; i < l; i++) {
										jQuery.event.add(dest, type, events[type][i]);
									}
								}
							}
						}

						// 2. Copy user data
						if (dataUser.hasData(src)) {
							udataOld = dataUser.access(src);
							udataCur = jQuery.extend({}, udataOld);

							dataUser.set(dest, udataCur);
						}
					}

					// Fix IE bugs, see support tests
					function fixInput(src, dest) {
						var nodeName = dest.nodeName.toLowerCase();

						// Fails to persist the checked state of a cloned checkbox or radio button.
						if (nodeName === "input" && rcheckableType.test(src.type)) {
							dest.checked = src.checked;

							// Fails to return the selected option to the default selected state when cloning options
						} else if (nodeName === "input" || nodeName === "textarea") {
							dest.defaultValue = src.defaultValue;
						}
					}

					function domManip(collection, args, callback, ignored) {

						// Flatten any nested arrays
						args = concat.apply([], args);

						var fragment, first, scripts, hasScripts, node, doc,
							i = 0,
							l = collection.length,
							iNoClone = l - 1,
							value = args[0],
							valueIsFunction = isFunction(value);

						// We can't cloneNode fragments that contain checked, in WebKit
						if (valueIsFunction ||
							(l > 1 && typeof value === "string" &&
								!support.checkClone && rchecked.test(value))) {
							return collection.each(function (index) {
								var self = collection.eq(index);
								if (valueIsFunction) {
									args[0] = value.call(this, index, self.html());
								}
								domManip(self, args, callback, ignored);
							});
						}

						if (l) {
							fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
							first = fragment.firstChild;

							if (fragment.childNodes.length === 1) {
								fragment = first;
							}

							// Require either new content or an interest in ignored elements to invoke the callback
							if (first || ignored) {
								scripts = jQuery.map(getAll(fragment, "script"), disableScript);
								hasScripts = scripts.length;

								// Use the original fragment for the last item
								// instead of the first because it can end up
								// being emptied incorrectly in certain situations (#8070).
								for (; i < l; i++) {
									node = fragment;

									if (i !== iNoClone) {
										node = jQuery.clone(node, true, true);

										// Keep references to cloned scripts for later restoration
										if (hasScripts) {

											// Support: Android <=4.0 only, PhantomJS 1 only
											// push.apply(_, arraylike) throws on ancient WebKit
											jQuery.merge(scripts, getAll(node, "script"));
										}
									}

									callback.call(collection[i], node, i);
								}

								if (hasScripts) {
									doc = scripts[scripts.length - 1].ownerDocument;

									// Reenable scripts
									jQuery.map(scripts, restoreScript);

									// Evaluate executable scripts on first document insertion
									for (i = 0; i < hasScripts; i++) {
										node = scripts[i];
										if (rscriptType.test(node.type || "") &&
											!dataPriv.access(node, "globalEval") &&
											jQuery.contains(doc, node)) {

											if (node.src && (node.type || "").toLowerCase() !== "module") {

												// Optional AJAX dependency, but won't run scripts if not present
												if (jQuery._evalUrl && !node.noModule) {
													jQuery._evalUrl(node.src, {
														nonce: node.nonce || node.getAttribute("nonce")
													});
												}
											} else {
												DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
											}
										}
									}
								}
							}
						}

						return collection;
					}

					function remove(elem, selector, keepData) {
						var node,
							nodes = selector ? jQuery.filter(selector, elem) : elem,
							i = 0;

						for (; (node = nodes[i]) != null; i++) {
							if (!keepData && node.nodeType === 1) {
								jQuery.cleanData(getAll(node));
							}

							if (node.parentNode) {
								if (keepData && isAttached(node)) {
									setGlobalEval(getAll(node, "script"));
								}
								node.parentNode.removeChild(node);
							}
						}

						return elem;
					}

					jQuery.extend({
						htmlPrefilter: function (html) {
							return html.replace(rxhtmlTag, "<$1></$2>");
						},

						clone: function (elem, dataAndEvents, deepDataAndEvents) {
							var i, l, srcElements, destElements,
								clone = elem.cloneNode(true),
								inPage = isAttached(elem);

							// Fix IE cloning issues
							if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) &&
								!jQuery.isXMLDoc(elem)) {

								// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
								destElements = getAll(clone);
								srcElements = getAll(elem);

								for (i = 0, l = srcElements.length; i < l; i++) {
									fixInput(srcElements[i], destElements[i]);
								}
							}

							// Copy the events from the original to the clone
							if (dataAndEvents) {
								if (deepDataAndEvents) {
									srcElements = srcElements || getAll(elem);
									destElements = destElements || getAll(clone);

									for (i = 0, l = srcElements.length; i < l; i++) {
										cloneCopyEvent(srcElements[i], destElements[i]);
									}
								} else {
									cloneCopyEvent(elem, clone);
								}
							}

							// Preserve script evaluation history
							destElements = getAll(clone, "script");
							if (destElements.length > 0) {
								setGlobalEval(destElements, !inPage && getAll(elem, "script"));
							}

							// Return the cloned set
							return clone;
						},

						cleanData: function (elems) {
							var data, elem, type,
								special = jQuery.event.special,
								i = 0;

							for (; (elem = elems[i]) !== undefined; i++) {
								if (acceptData(elem)) {
									if ((data = elem[dataPriv.expando])) {
										if (data.events) {
											for (type in data.events) {
												if (special[type]) {
													jQuery.event.remove(elem, type);

													// This is a shortcut to avoid jQuery.event.remove's overhead
												} else {
													jQuery.removeEvent(elem, type, data.handle);
												}
											}
										}

										// Support: Chrome <=35 - 45+
										// Assign undefined instead of using delete, see Data#remove
										elem[dataPriv.expando] = undefined;
									}
									if (elem[dataUser.expando]) {

										// Support: Chrome <=35 - 45+
										// Assign undefined instead of using delete, see Data#remove
										elem[dataUser.expando] = undefined;
									}
								}
							}
						}
					});

					jQuery.fn.extend({
						detach: function (selector) {
							return remove(this, selector, true);
						},

						remove: function (selector) {
							return remove(this, selector);
						},

						text: function (value) {
							return access(this, function (value) {
								return value === undefined ?
									jQuery.text(this) :
									this.empty().each(function () {
										if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
											this.textContent = value;
										}
									});
							}, null, value, arguments.length);
						},

						append: function () {
							return domManip(this, arguments, function (elem) {
								if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
									var target = manipulationTarget(this, elem);
									target.appendChild(elem);
								}
							});
						},

						prepend: function () {
							return domManip(this, arguments, function (elem) {
								if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
									var target = manipulationTarget(this, elem);
									target.insertBefore(elem, target.firstChild);
								}
							});
						},

						before: function () {
							return domManip(this, arguments, function (elem) {
								if (this.parentNode) {
									this.parentNode.insertBefore(elem, this);
								}
							});
						},

						after: function () {
							return domManip(this, arguments, function (elem) {
								if (this.parentNode) {
									this.parentNode.insertBefore(elem, this.nextSibling);
								}
							});
						},

						empty: function () {
							var elem,
								i = 0;

							for (; (elem = this[i]) != null; i++) {
								if (elem.nodeType === 1) {

									// Prevent memory leaks
									jQuery.cleanData(getAll(elem, false));

									// Remove any remaining nodes
									elem.textContent = "";
								}
							}

							return this;
						},

						clone: function (dataAndEvents, deepDataAndEvents) {
							dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
							deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

							return this.map(function () {
								return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
							});
						},

						html: function (value) {
							return access(this, function (value) {
								var elem = this[0] || {},
									i = 0,
									l = this.length;

								if (value === undefined && elem.nodeType === 1) {
									return elem.innerHTML;
								}

								// See if we can take a shortcut and just use innerHTML
								if (typeof value === "string" && !rnoInnerhtml.test(value) &&
									!wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

									value = jQuery.htmlPrefilter(value);

									try {
										for (; i < l; i++) {
											elem = this[i] || {};

											// Remove element nodes and prevent memory leaks
											if (elem.nodeType === 1) {
												jQuery.cleanData(getAll(elem, false));
												elem.innerHTML = value;
											}
										}

										elem = 0;

										// If using innerHTML throws an exception, use the fallback method
									} catch (e) { }
								}

								if (elem) {
									this.empty().append(value);
								}
							}, null, value, arguments.length);
						},

						replaceWith: function () {
							var ignored = [];

							// Make the changes, replacing each non-ignored context element with the new content
							return domManip(this, arguments, function (elem) {
								var parent = this.parentNode;

								if (jQuery.inArray(this, ignored) < 0) {
									jQuery.cleanData(getAll(this));
									if (parent) {
										parent.replaceChild(elem, this);
									}
								}

								// Force callback invocation
							}, ignored);
						}
					});

					jQuery.each({
						appendTo: "append",
						prependTo: "prepend",
						insertBefore: "before",
						insertAfter: "after",
						replaceAll: "replaceWith"
					}, function (name, original) {
						jQuery.fn[name] = function (selector) {
							var elems,
								ret = [],
								insert = jQuery(selector),
								last = insert.length - 1,
								i = 0;

							for (; i <= last; i++) {
								elems = i === last ? this : this.clone(true);
								jQuery(insert[i])[original](elems);

								// Support: Android <=4.0 only, PhantomJS 1 only
								// .get() because push.apply(_, arraylike) throws on ancient WebKit
								push.apply(ret, elems.get());
							}

							return this.pushStack(ret);
						};
					});
					var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

					var getStyles = function (elem) {

						// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
						// IE throws on elements created in popups
						// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
						var view = elem.ownerDocument.defaultView;

						if (!view || !view.opener) {
							view = window;
						}

						return view.getComputedStyle(elem);
					};

					var rboxStyle = new RegExp(cssExpand.join("|"), "i");



					(function () {

						// Executing both pixelPosition & boxSizingReliable tests require only one layout
						// so they're executed at the same time to save the second computation.
						function computeStyleTests() {

							// This is a singleton, we need to execute it only once
							if (!div) {
								return;
							}

							container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
								"margin-top:1px;padding:0;border:0";
							div.style.cssText =
								"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
								"margin:auto;border:1px;padding:1px;" +
								"width:60%;top:1%";
							documentElement.appendChild(container).appendChild(div);

							var divStyle = window.getComputedStyle(div);
							pixelPositionVal = divStyle.top !== "1%";

							// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
							reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

							// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
							// Some styles come back with percentage values, even though they shouldn't
							div.style.right = "60%";
							pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

							// Support: IE 9 - 11 only
							// Detect misreporting of content dimensions for box-sizing:border-box elements
							boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

							// Support: IE 9 only
							// Detect overflow:scroll screwiness (gh-3699)
							// Support: Chrome <=64
							// Don't get tricked when zoom affects offsetWidth (gh-4029)
							div.style.position = "absolute";
							scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

							documentElement.removeChild(container);

							// Nullify the div so it wouldn't be stored in the memory and
							// it will also be a sign that checks already performed
							div = null;
						}

						function roundPixelMeasures(measure) {
							return Math.round(parseFloat(measure));
						}

						var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
							reliableMarginLeftVal,
							container = document.createElement("div"),
							div = document.createElement("div");

						// Finish early in limited (non-browser) environments
						if (!div.style) {
							return;
						}

						// Support: IE <=9 - 11 only
						// Style of cloned element affects source element cloned (#8908)
						div.style.backgroundClip = "content-box";
						div.cloneNode(true).style.backgroundClip = "";
						support.clearCloneStyle = div.style.backgroundClip === "content-box";

						jQuery.extend(support, {
							boxSizingReliable: function () {
								computeStyleTests();
								return boxSizingReliableVal;
							},
							pixelBoxStyles: function () {
								computeStyleTests();
								return pixelBoxStylesVal;
							},
							pixelPosition: function () {
								computeStyleTests();
								return pixelPositionVal;
							},
							reliableMarginLeft: function () {
								computeStyleTests();
								return reliableMarginLeftVal;
							},
							scrollboxSize: function () {
								computeStyleTests();
								return scrollboxSizeVal;
							}
						});
					})();


					function curCSS(elem, name, computed) {
						var width, minWidth, maxWidth, ret,

							// Support: Firefox 51+
							// Retrieving style before computed somehow
							// fixes an issue with getting wrong values
							// on detached elements
							style = elem.style;

						computed = computed || getStyles(elem);

						// getPropertyValue is needed for:
						//   .css('filter') (IE 9 only, #12537)
						//   .css('--customProperty) (#3144)
						if (computed) {
							ret = computed.getPropertyValue(name) || computed[name];

							if (ret === "" && !isAttached(elem)) {
								ret = jQuery.style(elem, name);
							}

							// A tribute to the "awesome hack by Dean Edwards"
							// Android Browser returns percentage for some values,
							// but width seems to be reliably pixels.
							// This is against the CSSOM draft spec:
							// https://drafts.csswg.org/cssom/#resolved-values
							if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

								// Remember the original values
								width = style.width;
								minWidth = style.minWidth;
								maxWidth = style.maxWidth;

								// Put in the new values to get a computed value out
								style.minWidth = style.maxWidth = style.width = ret;
								ret = computed.width;

								// Revert the changed values
								style.width = width;
								style.minWidth = minWidth;
								style.maxWidth = maxWidth;
							}
						}

						return ret !== undefined ?

							// Support: IE <=9 - 11 only
							// IE returns zIndex value as an integer.
							ret + "" :
							ret;
					}


					function addGetHookIf(conditionFn, hookFn) {

						// Define the hook, we'll check on the first run if it's really needed.
						return {
							get: function () {
								if (conditionFn()) {

									// Hook not needed (or it's not possible to use it due
									// to missing dependency), remove it.
									delete this.get;
									return;
								}

								// Hook needed; redefine it so that the support test is not executed again.
								return (this.get = hookFn).apply(this, arguments);
							}
						};
					}


					var cssPrefixes = ["Webkit", "Moz", "ms"],
						emptyStyle = document.createElement("div").style,
						vendorProps = {};

					// Return a vendor-prefixed property or undefined
					function vendorPropName(name) {

						// Check for vendor prefixed names
						var capName = name[0].toUpperCase() + name.slice(1),
							i = cssPrefixes.length;

						while (i--) {
							name = cssPrefixes[i] + capName;
							if (name in emptyStyle) {
								return name;
							}
						}
					}

					// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
					function finalPropName(name) {
						var final = jQuery.cssProps[name] || vendorProps[name];

						if (final) {
							return final;
						}
						if (name in emptyStyle) {
							return name;
						}
						return vendorProps[name] = vendorPropName(name) || name;
					}


					var

						// Swappable if display is none or starts with table
						// except "table", "table-cell", or "table-caption"
						// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
						rdisplayswap = /^(none|table(?!-c[ea]).+)/,
						rcustomProp = /^--/,
						cssShow = { position: "absolute", visibility: "hidden", display: "block" },
						cssNormalTransform = {
							letterSpacing: "0",
							fontWeight: "400"
						};

					function setPositiveNumber(elem, value, subtract) {

						// Any relative (+/-) values have already been
						// normalized at this point
						var matches = rcssNum.exec(value);
						return matches ?

							// Guard against undefined "subtract", e.g., when used as in cssHooks
							Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") :
							value;
					}

					function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
						var i = dimension === "width" ? 1 : 0,
							extra = 0,
							delta = 0;

						// Adjustment may not be necessary
						if (box === (isBorderBox ? "border" : "content")) {
							return 0;
						}

						for (; i < 4; i += 2) {

							// Both box models exclude margin
							if (box === "margin") {
								delta += jQuery.css(elem, box + cssExpand[i], true, styles);
							}

							// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
							if (!isBorderBox) {

								// Add padding
								delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

								// For "border" or "margin", add border
								if (box !== "padding") {
									delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

									// But still keep track of it otherwise
								} else {
									extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
								}

								// If we get here with a border-box (content + padding + border), we're seeking "content" or
								// "padding" or "margin"
							} else {

								// For "content", subtract padding
								if (box === "content") {
									delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
								}

								// For "content" or "padding", subtract border
								if (box !== "margin") {
									delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
								}
							}
						}

						// Account for positive content-box scroll gutter when requested by providing computedVal
						if (!isBorderBox && computedVal >= 0) {

							// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
							// Assuming integer scroll gutter, subtract the rest and round down
							delta += Math.max(0, Math.ceil(
								elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
								computedVal -
								delta -
								extra -
								0.5

								// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
								// Use an explicit zero to avoid NaN (gh-3964)
							)) || 0;
						}

						return delta;
					}

					function getWidthOrHeight(elem, dimension, extra) {

						// Start with computed style
						var styles = getStyles(elem),

							// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
							// Fake content-box until we know it's needed to know the true value.
							boxSizingNeeded = !support.boxSizingReliable() || extra,
							isBorderBox = boxSizingNeeded &&
								jQuery.css(elem, "boxSizing", false, styles) === "border-box",
							valueIsBorderBox = isBorderBox,

							val = curCSS(elem, dimension, styles),
							offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

						// Support: Firefox <=54
						// Return a confounding non-pixel value or feign ignorance, as appropriate.
						if (rnumnonpx.test(val)) {
							if (!extra) {
								return val;
							}
							val = "auto";
						}


						// Fall back to offsetWidth/offsetHeight when value is "auto"
						// This happens for inline elements with no explicit setting (gh-3571)
						// Support: Android <=4.1 - 4.3 only
						// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
						// Support: IE 9-11 only
						// Also use offsetWidth/offsetHeight for when box sizing is unreliable
						// We use getClientRects() to check for hidden/disconnected.
						// In those cases, the computed value can be trusted to be border-box
						if ((!support.boxSizingReliable() && isBorderBox ||
							val === "auto" ||
							!parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&
							elem.getClientRects().length) {

							isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

							// Where available, offsetWidth/offsetHeight approximate border box dimensions.
							// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
							// retrieved value as a content box dimension.
							valueIsBorderBox = offsetProp in elem;
							if (valueIsBorderBox) {
								val = elem[offsetProp];
							}
						}

						// Normalize "" and auto
						val = parseFloat(val) || 0;

						// Adjust for the element's box model
						return (val +
							boxModelAdjustment(
								elem,
								dimension,
								extra || (isBorderBox ? "border" : "content"),
								valueIsBorderBox,
								styles,

								// Provide the current computed size to request scroll gutter calculation (gh-3589)
								val
							)
						) + "px";
					}

					jQuery.extend({

						// Add in style property hooks for overriding the default
						// behavior of getting and setting a style property
						cssHooks: {
							opacity: {
								get: function (elem, computed) {
									if (computed) {

										// We should always get a number back from opacity
										var ret = curCSS(elem, "opacity");
										return ret === "" ? "1" : ret;
									}
								}
							}
						},

						// Don't automatically add "px" to these possibly-unitless properties
						cssNumber: {
							"animationIterationCount": true,
							"columnCount": true,
							"fillOpacity": true,
							"flexGrow": true,
							"flexShrink": true,
							"fontWeight": true,
							"gridArea": true,
							"gridColumn": true,
							"gridColumnEnd": true,
							"gridColumnStart": true,
							"gridRow": true,
							"gridRowEnd": true,
							"gridRowStart": true,
							"lineHeight": true,
							"opacity": true,
							"order": true,
							"orphans": true,
							"widows": true,
							"zIndex": true,
							"zoom": true
						},

						// Add in properties whose names you wish to fix before
						// setting or getting the value
						cssProps: {},

						// Get and set the style property on a DOM Node
						style: function (elem, name, value, extra) {

							// Don't set styles on text and comment nodes
							if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
								return;
							}

							// Make sure that we're working with the right name
							var ret, type, hooks,
								origName = camelCase(name),
								isCustomProp = rcustomProp.test(name),
								style = elem.style;

							// Make sure that we're working with the right name. We don't
							// want to query the value if it is a CSS custom property
							// since they are user-defined.
							if (!isCustomProp) {
								name = finalPropName(origName);
							}

							// Gets hook for the prefixed version, then unprefixed version
							hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

							// Check if we're setting a value
							if (value !== undefined) {
								type = typeof value;

								// Convert "+=" or "-=" to relative numbers (#7345)
								if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
									value = adjustCSS(elem, name, ret);

									// Fixes bug #9237
									type = "number";
								}

								// Make sure that null and NaN values aren't set (#7116)
								if (value == null || value !== value) {
									return;
								}

								// If a number was passed in, add the unit (except for certain CSS properties)
								// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
								// "px" to a few hardcoded values.
								if (type === "number" && !isCustomProp) {
									value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
								}

								// background-* props affect original clone's values
								if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
									style[name] = "inherit";
								}

								// If a hook was provided, use that value, otherwise just set the specified value
								if (!hooks || !("set" in hooks) ||
									(value = hooks.set(elem, value, extra)) !== undefined) {

									if (isCustomProp) {
										style.setProperty(name, value);
									} else {
										style[name] = value;
									}
								}

							} else {

								// If a hook was provided get the non-computed value from there
								if (hooks && "get" in hooks &&
									(ret = hooks.get(elem, false, extra)) !== undefined) {

									return ret;
								}

								// Otherwise just get the value from the style object
								return style[name];
							}
						},

						css: function (elem, name, extra, styles) {
							var val, num, hooks,
								origName = camelCase(name),
								isCustomProp = rcustomProp.test(name);

							// Make sure that we're working with the right name. We don't
							// want to modify the value if it is a CSS custom property
							// since they are user-defined.
							if (!isCustomProp) {
								name = finalPropName(origName);
							}

							// Try prefixed name followed by the unprefixed name
							hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

							// If a hook was provided get the computed value from there
							if (hooks && "get" in hooks) {
								val = hooks.get(elem, true, extra);
							}

							// Otherwise, if a way to get the computed value exists, use that
							if (val === undefined) {
								val = curCSS(elem, name, styles);
							}

							// Convert "normal" to computed value
							if (val === "normal" && name in cssNormalTransform) {
								val = cssNormalTransform[name];
							}

							// Make numeric if forced or a qualifier was provided and val looks numeric
							if (extra === "" || extra) {
								num = parseFloat(val);
								return extra === true || isFinite(num) ? num || 0 : val;
							}

							return val;
						}
					});

					jQuery.each(["height", "width"], function (i, dimension) {
						jQuery.cssHooks[dimension] = {
							get: function (elem, computed, extra) {
								if (computed) {

									// Certain elements can have dimension info if we invisibly show them
									// but it must have a current display style that would benefit
									return rdisplayswap.test(jQuery.css(elem, "display")) &&

										// Support: Safari 8+
										// Table columns in Safari have non-zero offsetWidth & zero
										// getBoundingClientRect().width unless display is changed.
										// Support: IE <=11 only
										// Running getBoundingClientRect on a disconnected node
										// in IE throws an error.
										(!elem.getClientRects().length || !elem.getBoundingClientRect().width) ?
										swap(elem, cssShow, function () {
											return getWidthOrHeight(elem, dimension, extra);
										}) :
										getWidthOrHeight(elem, dimension, extra);
								}
							},

							set: function (elem, value, extra) {
								var matches,
									styles = getStyles(elem),

									// Only read styles.position if the test has a chance to fail
									// to avoid forcing a reflow.
									scrollboxSizeBuggy = !support.scrollboxSize() &&
										styles.position === "absolute",

									// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
									boxSizingNeeded = scrollboxSizeBuggy || extra,
									isBorderBox = boxSizingNeeded &&
										jQuery.css(elem, "boxSizing", false, styles) === "border-box",
									subtract = extra ?
										boxModelAdjustment(
											elem,
											dimension,
											extra,
											isBorderBox,
											styles
										) :
										0;

								// Account for unreliable border-box dimensions by comparing offset* to computed and
								// faking a content-box to get border and padding (gh-3699)
								if (isBorderBox && scrollboxSizeBuggy) {
									subtract -= Math.ceil(
										elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
										parseFloat(styles[dimension]) -
										boxModelAdjustment(elem, dimension, "border", false, styles) -
										0.5
									);
								}

								// Convert to pixels if value adjustment is needed
								if (subtract && (matches = rcssNum.exec(value)) &&
									(matches[3] || "px") !== "px") {

									elem.style[dimension] = value;
									value = jQuery.css(elem, dimension);
								}

								return setPositiveNumber(elem, value, subtract);
							}
						};
					});

					jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft,
						function (elem, computed) {
							if (computed) {
								return (parseFloat(curCSS(elem, "marginLeft")) ||
									elem.getBoundingClientRect().left -
									swap(elem, { marginLeft: 0 }, function () {
										return elem.getBoundingClientRect().left;
									})
								) + "px";
							}
						}
					);

					// These hooks are used by animate to expand properties
					jQuery.each({
						margin: "",
						padding: "",
						border: "Width"
					}, function (prefix, suffix) {
						jQuery.cssHooks[prefix + suffix] = {
							expand: function (value) {
								var i = 0,
									expanded = {},

									// Assumes a single number if not a string
									parts = typeof value === "string" ? value.split(" ") : [value];

								for (; i < 4; i++) {
									expanded[prefix + cssExpand[i] + suffix] =
										parts[i] || parts[i - 2] || parts[0];
								}

								return expanded;
							}
						};

						if (prefix !== "margin") {
							jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
						}
					});

					jQuery.fn.extend({
						css: function (name, value) {
							return access(this, function (elem, name, value) {
								var styles, len,
									map = {},
									i = 0;

								if (Array.isArray(name)) {
									styles = getStyles(elem);
									len = name.length;

									for (; i < len; i++) {
										map[name[i]] = jQuery.css(elem, name[i], false, styles);
									}

									return map;
								}

								return value !== undefined ?
									jQuery.style(elem, name, value) :
									jQuery.css(elem, name);
							}, name, value, arguments.length > 1);
						}
					});


					function Tween(elem, options, prop, end, easing) {
						return new Tween.prototype.init(elem, options, prop, end, easing);
					}
					jQuery.Tween = Tween;

					Tween.prototype = {
						constructor: Tween,
						init: function (elem, options, prop, end, easing, unit) {
							this.elem = elem;
							this.prop = prop;
							this.easing = easing || jQuery.easing._default;
							this.options = options;
							this.start = this.now = this.cur();
							this.end = end;
							this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
						},
						cur: function () {
							var hooks = Tween.propHooks[this.prop];

							return hooks && hooks.get ?
								hooks.get(this) :
								Tween.propHooks._default.get(this);
						},
						run: function (percent) {
							var eased,
								hooks = Tween.propHooks[this.prop];

							if (this.options.duration) {
								this.pos = eased = jQuery.easing[this.easing](
									percent, this.options.duration * percent, 0, 1, this.options.duration
								);
							} else {
								this.pos = eased = percent;
							}
							this.now = (this.end - this.start) * eased + this.start;

							if (this.options.step) {
								this.options.step.call(this.elem, this.now, this);
							}

							if (hooks && hooks.set) {
								hooks.set(this);
							} else {
								Tween.propHooks._default.set(this);
							}
							return this;
						}
					};

					Tween.prototype.init.prototype = Tween.prototype;

					Tween.propHooks = {
						_default: {
							get: function (tween) {
								var result;

								// Use a property on the element directly when it is not a DOM element,
								// or when there is no matching style property that exists.
								if (tween.elem.nodeType !== 1 ||
									tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
									return tween.elem[tween.prop];
								}

								// Passing an empty string as a 3rd parameter to .css will automatically
								// attempt a parseFloat and fallback to a string if the parse fails.
								// Simple values such as "10px" are parsed to Float;
								// complex values such as "rotate(1rad)" are returned as-is.
								result = jQuery.css(tween.elem, tween.prop, "");

								// Empty strings, null, undefined and "auto" are converted to 0.
								return !result || result === "auto" ? 0 : result;
							},
							set: function (tween) {

								// Use step hook for back compat.
								// Use cssHook if its there.
								// Use .style if available and use plain properties where available.
								if (jQuery.fx.step[tween.prop]) {
									jQuery.fx.step[tween.prop](tween);
								} else if (tween.elem.nodeType === 1 && (
									jQuery.cssHooks[tween.prop] ||
									tween.elem.style[finalPropName(tween.prop)] != null)) {
									jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
								} else {
									tween.elem[tween.prop] = tween.now;
								}
							}
						}
					};

					// Support: IE <=9 only
					// Panic based approach to setting things on disconnected nodes
					Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
						set: function (tween) {
							if (tween.elem.nodeType && tween.elem.parentNode) {
								tween.elem[tween.prop] = tween.now;
							}
						}
					};

					jQuery.easing = {
						linear: function (p) {
							return p;
						},
						swing: function (p) {
							return 0.5 - Math.cos(p * Math.PI) / 2;
						},
						_default: "swing"
					};

					jQuery.fx = Tween.prototype.init;

					// Back compat <1.8 extension point
					jQuery.fx.step = {};




					var
						fxNow, inProgress,
						rfxtypes = /^(?:toggle|show|hide)$/,
						rrun = /queueHooks$/;

					function schedule() {
						if (inProgress) {
							if (document.hidden === false && window.requestAnimationFrame) {
								window.requestAnimationFrame(schedule);
							} else {
								window.setTimeout(schedule, jQuery.fx.interval);
							}

							jQuery.fx.tick();
						}
					}

					// Animations created synchronously will run synchronously
					function createFxNow() {
						window.setTimeout(function () {
							fxNow = undefined;
						});
						return (fxNow = Date.now());
					}

					// Generate parameters to create a standard animation
					function genFx(type, includeWidth) {
						var which,
							i = 0,
							attrs = { height: type };

						// If we include width, step value is 1 to do all cssExpand values,
						// otherwise step value is 2 to skip over Left and Right
						includeWidth = includeWidth ? 1 : 0;
						for (; i < 4; i += 2 - includeWidth) {
							which = cssExpand[i];
							attrs["margin" + which] = attrs["padding" + which] = type;
						}

						if (includeWidth) {
							attrs.opacity = attrs.width = type;
						}

						return attrs;
					}

					function createTween(value, prop, animation) {
						var tween,
							collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
							index = 0,
							length = collection.length;
						for (; index < length; index++) {
							if ((tween = collection[index].call(animation, prop, value))) {

								// We're done with this property
								return tween;
							}
						}
					}

					function defaultPrefilter(elem, props, opts) {
						var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
							isBox = "width" in props || "height" in props,
							anim = this,
							orig = {},
							style = elem.style,
							hidden = elem.nodeType && isHiddenWithinTree(elem),
							dataShow = dataPriv.get(elem, "fxshow");

						// Queue-skipping animations hijack the fx hooks
						if (!opts.queue) {
							hooks = jQuery._queueHooks(elem, "fx");
							if (hooks.unqueued == null) {
								hooks.unqueued = 0;
								oldfire = hooks.empty.fire;
								hooks.empty.fire = function () {
									if (!hooks.unqueued) {
										oldfire();
									}
								};
							}
							hooks.unqueued++;

							anim.always(function () {

								// Ensure the complete handler is called before this completes
								anim.always(function () {
									hooks.unqueued--;
									if (!jQuery.queue(elem, "fx").length) {
										hooks.empty.fire();
									}
								});
							});
						}

						// Detect show/hide animations
						for (prop in props) {
							value = props[prop];
							if (rfxtypes.test(value)) {
								delete props[prop];
								toggle = toggle || value === "toggle";
								if (value === (hidden ? "hide" : "show")) {

									// Pretend to be hidden if this is a "show" and
									// there is still data from a stopped show/hide
									if (value === "show" && dataShow && dataShow[prop] !== undefined) {
										hidden = true;

										// Ignore all other no-op show/hide data
									} else {
										continue;
									}
								}
								orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
							}
						}

						// Bail out if this is a no-op like .hide().hide()
						propTween = !jQuery.isEmptyObject(props);
						if (!propTween && jQuery.isEmptyObject(orig)) {
							return;
						}

						// Restrict "overflow" and "display" styles during box animations
						if (isBox && elem.nodeType === 1) {

							// Support: IE <=9 - 11, Edge 12 - 15
							// Record all 3 overflow attributes because IE does not infer the shorthand
							// from identically-valued overflowX and overflowY and Edge just mirrors
							// the overflowX value there.
							opts.overflow = [style.overflow, style.overflowX, style.overflowY];

							// Identify a display type, preferring old show/hide data over the CSS cascade
							restoreDisplay = dataShow && dataShow.display;
							if (restoreDisplay == null) {
								restoreDisplay = dataPriv.get(elem, "display");
							}
							display = jQuery.css(elem, "display");
							if (display === "none") {
								if (restoreDisplay) {
									display = restoreDisplay;
								} else {

									// Get nonempty value(s) by temporarily forcing visibility
									showHide([elem], true);
									restoreDisplay = elem.style.display || restoreDisplay;
									display = jQuery.css(elem, "display");
									showHide([elem]);
								}
							}

							// Animate inline elements as inline-block
							if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
								if (jQuery.css(elem, "float") === "none") {

									// Restore the original display value at the end of pure show/hide animations
									if (!propTween) {
										anim.done(function () {
											style.display = restoreDisplay;
										});
										if (restoreDisplay == null) {
											display = style.display;
											restoreDisplay = display === "none" ? "" : display;
										}
									}
									style.display = "inline-block";
								}
							}
						}

						if (opts.overflow) {
							style.overflow = "hidden";
							anim.always(function () {
								style.overflow = opts.overflow[0];
								style.overflowX = opts.overflow[1];
								style.overflowY = opts.overflow[2];
							});
						}

						// Implement show/hide animations
						propTween = false;
						for (prop in orig) {

							// General show/hide setup for this element animation
							if (!propTween) {
								if (dataShow) {
									if ("hidden" in dataShow) {
										hidden = dataShow.hidden;
									}
								} else {
									dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
								}

								// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
								if (toggle) {
									dataShow.hidden = !hidden;
								}

								// Show elements before animating them
								if (hidden) {
									showHide([elem], true);
								}

								/* eslint-disable no-loop-func */

								anim.done(function () {

									/* eslint-enable no-loop-func */

									// The final step of a "hide" animation is actually hiding the element
									if (!hidden) {
										showHide([elem]);
									}
									dataPriv.remove(elem, "fxshow");
									for (prop in orig) {
										jQuery.style(elem, prop, orig[prop]);
									}
								});
							}

							// Per-property setup
							propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
							if (!(prop in dataShow)) {
								dataShow[prop] = propTween.start;
								if (hidden) {
									propTween.end = propTween.start;
									propTween.start = 0;
								}
							}
						}
					}

					function propFilter(props, specialEasing) {
						var index, name, easing, value, hooks;

						// camelCase, specialEasing and expand cssHook pass
						for (index in props) {
							name = camelCase(index);
							easing = specialEasing[name];
							value = props[index];
							if (Array.isArray(value)) {
								easing = value[1];
								value = props[index] = value[0];
							}

							if (index !== name) {
								props[name] = value;
								delete props[index];
							}

							hooks = jQuery.cssHooks[name];
							if (hooks && "expand" in hooks) {
								value = hooks.expand(value);
								delete props[name];

								// Not quite $.extend, this won't overwrite existing keys.
								// Reusing 'index' because we have the correct "name"
								for (index in value) {
									if (!(index in props)) {
										props[index] = value[index];
										specialEasing[index] = easing;
									}
								}
							} else {
								specialEasing[name] = easing;
							}
						}
					}

					function Animation(elem, properties, options) {
						var result,
							stopped,
							index = 0,
							length = Animation.prefilters.length,
							deferred = jQuery.Deferred().always(function () {

								// Don't match elem in the :animated selector
								delete tick.elem;
							}),
							tick = function () {
								if (stopped) {
									return false;
								}
								var currentTime = fxNow || createFxNow(),
									remaining = Math.max(0, animation.startTime + animation.duration - currentTime),

									// Support: Android 2.3 only
									// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
									temp = remaining / animation.duration || 0,
									percent = 1 - temp,
									index = 0,
									length = animation.tweens.length;

								for (; index < length; index++) {
									animation.tweens[index].run(percent);
								}

								deferred.notifyWith(elem, [animation, percent, remaining]);

								// If there's more to do, yield
								if (percent < 1 && length) {
									return remaining;
								}

								// If this was an empty animation, synthesize a final progress notification
								if (!length) {
									deferred.notifyWith(elem, [animation, 1, 0]);
								}

								// Resolve the animation and report its conclusion
								deferred.resolveWith(elem, [animation]);
								return false;
							},
							animation = deferred.promise({
								elem: elem,
								props: jQuery.extend({}, properties),
								opts: jQuery.extend(true, {
									specialEasing: {},
									easing: jQuery.easing._default
								}, options),
								originalProperties: properties,
								originalOptions: options,
								startTime: fxNow || createFxNow(),
								duration: options.duration,
								tweens: [],
								createTween: function (prop, end) {
									var tween = jQuery.Tween(elem, animation.opts, prop, end,
										animation.opts.specialEasing[prop] || animation.opts.easing);
									animation.tweens.push(tween);
									return tween;
								},
								stop: function (gotoEnd) {
									var index = 0,

										// If we are going to the end, we want to run all the tweens
										// otherwise we skip this part
										length = gotoEnd ? animation.tweens.length : 0;
									if (stopped) {
										return this;
									}
									stopped = true;
									for (; index < length; index++) {
										animation.tweens[index].run(1);
									}

									// Resolve when we played the last frame; otherwise, reject
									if (gotoEnd) {
										deferred.notifyWith(elem, [animation, 1, 0]);
										deferred.resolveWith(elem, [animation, gotoEnd]);
									} else {
										deferred.rejectWith(elem, [animation, gotoEnd]);
									}
									return this;
								}
							}),
							props = animation.props;

						propFilter(props, animation.opts.specialEasing);

						for (; index < length; index++) {
							result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
							if (result) {
								if (isFunction(result.stop)) {
									jQuery._queueHooks(animation.elem, animation.opts.queue).stop =
										result.stop.bind(result);
								}
								return result;
							}
						}

						jQuery.map(props, createTween, animation);

						if (isFunction(animation.opts.start)) {
							animation.opts.start.call(elem, animation);
						}

						// Attach callbacks from options
						animation
							.progress(animation.opts.progress)
							.done(animation.opts.done, animation.opts.complete)
							.fail(animation.opts.fail)
							.always(animation.opts.always);

						jQuery.fx.timer(
							jQuery.extend(tick, {
								elem: elem,
								anim: animation,
								queue: animation.opts.queue
							})
						);

						return animation;
					}

					jQuery.Animation = jQuery.extend(Animation, {

						tweeners: {
							"*": [function (prop, value) {
								var tween = this.createTween(prop, value);
								adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
								return tween;
							}]
						},

						tweener: function (props, callback) {
							if (isFunction(props)) {
								callback = props;
								props = ["*"];
							} else {
								props = props.match(rnothtmlwhite);
							}

							var prop,
								index = 0,
								length = props.length;

							for (; index < length; index++) {
								prop = props[index];
								Animation.tweeners[prop] = Animation.tweeners[prop] || [];
								Animation.tweeners[prop].unshift(callback);
							}
						},

						prefilters: [defaultPrefilter],

						prefilter: function (callback, prepend) {
							if (prepend) {
								Animation.prefilters.unshift(callback);
							} else {
								Animation.prefilters.push(callback);
							}
						}
					});

					jQuery.speed = function (speed, easing, fn) {
						var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
							complete: fn || !fn && easing ||
								isFunction(speed) && speed,
							duration: speed,
							easing: fn && easing || easing && !isFunction(easing) && easing
						};

						// Go to the end state if fx are off
						if (jQuery.fx.off) {
							opt.duration = 0;

						} else {
							if (typeof opt.duration !== "number") {
								if (opt.duration in jQuery.fx.speeds) {
									opt.duration = jQuery.fx.speeds[opt.duration];

								} else {
									opt.duration = jQuery.fx.speeds._default;
								}
							}
						}

						// Normalize opt.queue - true/undefined/null -> "fx"
						if (opt.queue == null || opt.queue === true) {
							opt.queue = "fx";
						}

						// Queueing
						opt.old = opt.complete;

						opt.complete = function () {
							if (isFunction(opt.old)) {
								opt.old.call(this);
							}

							if (opt.queue) {
								jQuery.dequeue(this, opt.queue);
							}
						};

						return opt;
					};

					jQuery.fn.extend({
						fadeTo: function (speed, to, easing, callback) {

							// Show any hidden elements after setting opacity to 0
							return this.filter(isHiddenWithinTree).css("opacity", 0).show()

								// Animate to the value specified
								.end().animate({ opacity: to }, speed, easing, callback);
						},
						animate: function (prop, speed, easing, callback) {
							var empty = jQuery.isEmptyObject(prop),
								optall = jQuery.speed(speed, easing, callback),
								doAnimation = function () {

									// Operate on a copy of prop so per-property easing won't be lost
									var anim = Animation(this, jQuery.extend({}, prop), optall);

									// Empty animations, or finishing resolves immediately
									if (empty || dataPriv.get(this, "finish")) {
										anim.stop(true);
									}
								};
							doAnimation.finish = doAnimation;

							return empty || optall.queue === false ?
								this.each(doAnimation) :
								this.queue(optall.queue, doAnimation);
						},
						stop: function (type, clearQueue, gotoEnd) {
							var stopQueue = function (hooks) {
								var stop = hooks.stop;
								delete hooks.stop;
								stop(gotoEnd);
							};

							if (typeof type !== "string") {
								gotoEnd = clearQueue;
								clearQueue = type;
								type = undefined;
							}
							if (clearQueue && type !== false) {
								this.queue(type || "fx", []);
							}

							return this.each(function () {
								var dequeue = true,
									index = type != null && type + "queueHooks",
									timers = jQuery.timers,
									data = dataPriv.get(this);

								if (index) {
									if (data[index] && data[index].stop) {
										stopQueue(data[index]);
									}
								} else {
									for (index in data) {
										if (data[index] && data[index].stop && rrun.test(index)) {
											stopQueue(data[index]);
										}
									}
								}

								for (index = timers.length; index--;) {
									if (timers[index].elem === this &&
										(type == null || timers[index].queue === type)) {

										timers[index].anim.stop(gotoEnd);
										dequeue = false;
										timers.splice(index, 1);
									}
								}

								// Start the next in the queue if the last step wasn't forced.
								// Timers currently will call their complete callbacks, which
								// will dequeue but only if they were gotoEnd.
								if (dequeue || !gotoEnd) {
									jQuery.dequeue(this, type);
								}
							});
						},
						finish: function (type) {
							if (type !== false) {
								type = type || "fx";
							}
							return this.each(function () {
								var index,
									data = dataPriv.get(this),
									queue = data[type + "queue"],
									hooks = data[type + "queueHooks"],
									timers = jQuery.timers,
									length = queue ? queue.length : 0;

								// Enable finishing flag on private data
								data.finish = true;

								// Empty the queue first
								jQuery.queue(this, type, []);

								if (hooks && hooks.stop) {
									hooks.stop.call(this, true);
								}

								// Look for any active animations, and finish them
								for (index = timers.length; index--;) {
									if (timers[index].elem === this && timers[index].queue === type) {
										timers[index].anim.stop(true);
										timers.splice(index, 1);
									}
								}

								// Look for any animations in the old queue and finish them
								for (index = 0; index < length; index++) {
									if (queue[index] && queue[index].finish) {
										queue[index].finish.call(this);
									}
								}

								// Turn off finishing flag
								delete data.finish;
							});
						}
					});

					jQuery.each(["toggle", "show", "hide"], function (i, name) {
						var cssFn = jQuery.fn[name];
						jQuery.fn[name] = function (speed, easing, callback) {
							return speed == null || typeof speed === "boolean" ?
								cssFn.apply(this, arguments) :
								this.animate(genFx(name, true), speed, easing, callback);
						};
					});

					// Generate shortcuts for custom animations
					jQuery.each({
						slideDown: genFx("show"),
						slideUp: genFx("hide"),
						slideToggle: genFx("toggle"),
						fadeIn: { opacity: "show" },
						fadeOut: { opacity: "hide" },
						fadeToggle: { opacity: "toggle" }
					}, function (name, props) {
						jQuery.fn[name] = function (speed, easing, callback) {
							return this.animate(props, speed, easing, callback);
						};
					});

					jQuery.timers = [];
					jQuery.fx.tick = function () {
						var timer,
							i = 0,
							timers = jQuery.timers;

						fxNow = Date.now();

						for (; i < timers.length; i++) {
							timer = timers[i];

							// Run the timer and safely remove it when done (allowing for external removal)
							if (!timer() && timers[i] === timer) {
								timers.splice(i--, 1);
							}
						}

						if (!timers.length) {
							jQuery.fx.stop();
						}
						fxNow = undefined;
					};

					jQuery.fx.timer = function (timer) {
						jQuery.timers.push(timer);
						jQuery.fx.start();
					};

					jQuery.fx.interval = 13;
					jQuery.fx.start = function () {
						if (inProgress) {
							return;
						}

						inProgress = true;
						schedule();
					};

					jQuery.fx.stop = function () {
						inProgress = null;
					};

					jQuery.fx.speeds = {
						slow: 600,
						fast: 200,

						// Default speed
						_default: 400
					};


					// Based off of the plugin by Clint Helfers, with permission.
					// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
					jQuery.fn.delay = function (time, type) {
						time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
						type = type || "fx";

						return this.queue(type, function (next, hooks) {
							var timeout = window.setTimeout(next, time);
							hooks.stop = function () {
								window.clearTimeout(timeout);
							};
						});
					};


					(function () {
						var input = document.createElement("input"),
							select = document.createElement("select"),
							opt = select.appendChild(document.createElement("option"));

						input.type = "checkbox";

						// Support: Android <=4.3 only
						// Default value for a checkbox should be "on"
						support.checkOn = input.value !== "";

						// Support: IE <=11 only
						// Must access selectedIndex to make default options select
						support.optSelected = opt.selected;

						// Support: IE <=11 only
						// An input loses its value after becoming a radio
						input = document.createElement("input");
						input.value = "t";
						input.type = "radio";
						support.radioValue = input.value === "t";
					})();


					var boolHook,
						attrHandle = jQuery.expr.attrHandle;

					jQuery.fn.extend({
						attr: function (name, value) {
							return access(this, jQuery.attr, name, value, arguments.length > 1);
						},

						removeAttr: function (name) {
							return this.each(function () {
								jQuery.removeAttr(this, name);
							});
						}
					});

					jQuery.extend({
						attr: function (elem, name, value) {
							var ret, hooks,
								nType = elem.nodeType;

							// Don't get/set attributes on text, comment and attribute nodes
							if (nType === 3 || nType === 8 || nType === 2) {
								return;
							}

							// Fallback to prop when attributes are not supported
							if (typeof elem.getAttribute === "undefined") {
								return jQuery.prop(elem, name, value);
							}

							// Attribute hooks are determined by the lowercase version
							// Grab necessary hook if one is defined
							if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
								hooks = jQuery.attrHooks[name.toLowerCase()] ||
									(jQuery.expr.match.bool.test(name) ? boolHook : undefined);
							}

							if (value !== undefined) {
								if (value === null) {
									jQuery.removeAttr(elem, name);
									return;
								}

								if (hooks && "set" in hooks &&
									(ret = hooks.set(elem, value, name)) !== undefined) {
									return ret;
								}

								elem.setAttribute(name, value + "");
								return value;
							}

							if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
								return ret;
							}

							ret = jQuery.find.attr(elem, name);

							// Non-existent attributes return null, we normalize to undefined
							return ret == null ? undefined : ret;
						},

						attrHooks: {
							type: {
								set: function (elem, value) {
									if (!support.radioValue && value === "radio" &&
										nodeName(elem, "input")) {
										var val = elem.value;
										elem.setAttribute("type", value);
										if (val) {
											elem.value = val;
										}
										return value;
									}
								}
							}
						},

						removeAttr: function (elem, value) {
							var name,
								i = 0,

								// Attribute names can contain non-HTML whitespace characters
								// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
								attrNames = value && value.match(rnothtmlwhite);

							if (attrNames && elem.nodeType === 1) {
								while ((name = attrNames[i++])) {
									elem.removeAttribute(name);
								}
							}
						}
					});

					// Hooks for boolean attributes
					boolHook = {
						set: function (elem, value, name) {
							if (value === false) {

								// Remove boolean attributes when set to false
								jQuery.removeAttr(elem, name);
							} else {
								elem.setAttribute(name, name);
							}
							return name;
						}
					};

					jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
						var getter = attrHandle[name] || jQuery.find.attr;

						attrHandle[name] = function (elem, name, isXML) {
							var ret, handle,
								lowercaseName = name.toLowerCase();

							if (!isXML) {

								// Avoid an infinite loop by temporarily removing this function from the getter
								handle = attrHandle[lowercaseName];
								attrHandle[lowercaseName] = ret;
								ret = getter(elem, name, isXML) != null ?
									lowercaseName :
									null;
								attrHandle[lowercaseName] = handle;
							}
							return ret;
						};
					});




					var rfocusable = /^(?:input|select|textarea|button)$/i,
						rclickable = /^(?:a|area)$/i;

					jQuery.fn.extend({
						prop: function (name, value) {
							return access(this, jQuery.prop, name, value, arguments.length > 1);
						},

						removeProp: function (name) {
							return this.each(function () {
								delete this[jQuery.propFix[name] || name];
							});
						}
					});

					jQuery.extend({
						prop: function (elem, name, value) {
							var ret, hooks,
								nType = elem.nodeType;

							// Don't get/set properties on text, comment and attribute nodes
							if (nType === 3 || nType === 8 || nType === 2) {
								return;
							}

							if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

								// Fix name and attach hooks
								name = jQuery.propFix[name] || name;
								hooks = jQuery.propHooks[name];
							}

							if (value !== undefined) {
								if (hooks && "set" in hooks &&
									(ret = hooks.set(elem, value, name)) !== undefined) {
									return ret;
								}

								return (elem[name] = value);
							}

							if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
								return ret;
							}

							return elem[name];
						},

						propHooks: {
							tabIndex: {
								get: function (elem) {

									// Support: IE <=9 - 11 only
									// elem.tabIndex doesn't always return the
									// correct value when it hasn't been explicitly set
									// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
									// Use proper attribute retrieval(#12072)
									var tabindex = jQuery.find.attr(elem, "tabindex");

									if (tabindex) {
										return parseInt(tabindex, 10);
									}

									if (
										rfocusable.test(elem.nodeName) ||
										rclickable.test(elem.nodeName) &&
										elem.href
									) {
										return 0;
									}

									return -1;
								}
							}
						},

						propFix: {
							"for": "htmlFor",
							"class": "className"
						}
					});

					// Support: IE <=11 only
					// Accessing the selectedIndex property
					// forces the browser to respect setting selected
					// on the option
					// The getter ensures a default option is selected
					// when in an optgroup
					// eslint rule "no-unused-expressions" is disabled for this code
					// since it considers such accessions noop
					if (!support.optSelected) {
						jQuery.propHooks.selected = {
							get: function (elem) {

								/* eslint no-unused-expressions: "off" */

								var parent = elem.parentNode;
								if (parent && parent.parentNode) {
									parent.parentNode.selectedIndex;
								}
								return null;
							},
							set: function (elem) {

								/* eslint no-unused-expressions: "off" */

								var parent = elem.parentNode;
								if (parent) {
									parent.selectedIndex;

									if (parent.parentNode) {
										parent.parentNode.selectedIndex;
									}
								}
							}
						};
					}

					jQuery.each([
						"tabIndex",
						"readOnly",
						"maxLength",
						"cellSpacing",
						"cellPadding",
						"rowSpan",
						"colSpan",
						"useMap",
						"frameBorder",
						"contentEditable"
					], function () {
						jQuery.propFix[this.toLowerCase()] = this;
					});




					// Strip and collapse whitespace according to HTML spec
					// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
					function stripAndCollapse(value) {
						var tokens = value.match(rnothtmlwhite) || [];
						return tokens.join(" ");
					}


					function getClass(elem) {
						return elem.getAttribute && elem.getAttribute("class") || "";
					}

					function classesToArray(value) {
						if (Array.isArray(value)) {
							return value;
						}
						if (typeof value === "string") {
							return value.match(rnothtmlwhite) || [];
						}
						return [];
					}

					jQuery.fn.extend({
						addClass: function (value) {
							var classes, elem, cur, curValue, clazz, j, finalValue,
								i = 0;

							if (isFunction(value)) {
								return this.each(function (j) {
									jQuery(this).addClass(value.call(this, j, getClass(this)));
								});
							}

							classes = classesToArray(value);

							if (classes.length) {
								while ((elem = this[i++])) {
									curValue = getClass(elem);
									cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

									if (cur) {
										j = 0;
										while ((clazz = classes[j++])) {
											if (cur.indexOf(" " + clazz + " ") < 0) {
												cur += clazz + " ";
											}
										}

										// Only assign if different to avoid unneeded rendering.
										finalValue = stripAndCollapse(cur);
										if (curValue !== finalValue) {
											elem.setAttribute("class", finalValue);
										}
									}
								}
							}

							return this;
						},

						removeClass: function (value) {
							var classes, elem, cur, curValue, clazz, j, finalValue,
								i = 0;

							if (isFunction(value)) {
								return this.each(function (j) {
									jQuery(this).removeClass(value.call(this, j, getClass(this)));
								});
							}

							if (!arguments.length) {
								return this.attr("class", "");
							}

							classes = classesToArray(value);

							if (classes.length) {
								while ((elem = this[i++])) {
									curValue = getClass(elem);

									// This expression is here for better compressibility (see addClass)
									cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

									if (cur) {
										j = 0;
										while ((clazz = classes[j++])) {

											// Remove *all* instances
											while (cur.indexOf(" " + clazz + " ") > -1) {
												cur = cur.replace(" " + clazz + " ", " ");
											}
										}

										// Only assign if different to avoid unneeded rendering.
										finalValue = stripAndCollapse(cur);
										if (curValue !== finalValue) {
											elem.setAttribute("class", finalValue);
										}
									}
								}
							}

							return this;
						},

						toggleClass: function (value, stateVal) {
							var type = typeof value,
								isValidValue = type === "string" || Array.isArray(value);

							if (typeof stateVal === "boolean" && isValidValue) {
								return stateVal ? this.addClass(value) : this.removeClass(value);
							}

							if (isFunction(value)) {
								return this.each(function (i) {
									jQuery(this).toggleClass(
										value.call(this, i, getClass(this), stateVal),
										stateVal
									);
								});
							}

							return this.each(function () {
								var className, i, self, classNames;

								if (isValidValue) {

									// Toggle individual class names
									i = 0;
									self = jQuery(this);
									classNames = classesToArray(value);

									while ((className = classNames[i++])) {

										// Check each className given, space separated list
										if (self.hasClass(className)) {
											self.removeClass(className);
										} else {
											self.addClass(className);
										}
									}

									// Toggle whole class name
								} else if (value === undefined || type === "boolean") {
									className = getClass(this);
									if (className) {

										// Store className if set
										dataPriv.set(this, "__className__", className);
									}

									// If the element has a class name or if we're passed `false`,
									// then remove the whole classname (if there was one, the above saved it).
									// Otherwise bring back whatever was previously saved (if anything),
									// falling back to the empty string if nothing was stored.
									if (this.setAttribute) {
										this.setAttribute("class",
											className || value === false ?
												"" :
												dataPriv.get(this, "__className__") || ""
										);
									}
								}
							});
						},

						hasClass: function (selector) {
							var className, elem,
								i = 0;

							className = " " + selector + " ";
							while ((elem = this[i++])) {
								if (elem.nodeType === 1 &&
									(" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
									return true;
								}
							}

							return false;
						}
					});




					var rreturn = /\r/g;

					jQuery.fn.extend({
						val: function (value) {
							var hooks, ret, valueIsFunction,
								elem = this[0];

							if (!arguments.length) {
								if (elem) {
									hooks = jQuery.valHooks[elem.type] ||
										jQuery.valHooks[elem.nodeName.toLowerCase()];

									if (hooks &&
										"get" in hooks &&
										(ret = hooks.get(elem, "value")) !== undefined
									) {
										return ret;
									}

									ret = elem.value;

									// Handle most common string cases
									if (typeof ret === "string") {
										return ret.replace(rreturn, "");
									}

									// Handle cases where value is null/undef or number
									return ret == null ? "" : ret;
								}

								return;
							}

							valueIsFunction = isFunction(value);

							return this.each(function (i) {
								var val;

								if (this.nodeType !== 1) {
									return;
								}

								if (valueIsFunction) {
									val = value.call(this, i, jQuery(this).val());
								} else {
									val = value;
								}

								// Treat null/undefined as ""; convert numbers to string
								if (val == null) {
									val = "";

								} else if (typeof val === "number") {
									val += "";

								} else if (Array.isArray(val)) {
									val = jQuery.map(val, function (value) {
										return value == null ? "" : value + "";
									});
								}

								hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

								// If set returns undefined, fall back to normal setting
								if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
									this.value = val;
								}
							});
						}
					});

					jQuery.extend({
						valHooks: {
							option: {
								get: function (elem) {

									var val = jQuery.find.attr(elem, "value");
									return val != null ?
										val :

										// Support: IE <=10 - 11 only
										// option.text throws exceptions (#14686, #14858)
										// Strip and collapse whitespace
										// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
										stripAndCollapse(jQuery.text(elem));
								}
							},
							select: {
								get: function (elem) {
									var value, option, i,
										options = elem.options,
										index = elem.selectedIndex,
										one = elem.type === "select-one",
										values = one ? null : [],
										max = one ? index + 1 : options.length;

									if (index < 0) {
										i = max;

									} else {
										i = one ? index : 0;
									}

									// Loop through all the selected options
									for (; i < max; i++) {
										option = options[i];

										// Support: IE <=9 only
										// IE8-9 doesn't update selected after form reset (#2551)
										if ((option.selected || i === index) &&

											// Don't return options that are disabled or in a disabled optgroup
											!option.disabled &&
											(!option.parentNode.disabled ||
												!nodeName(option.parentNode, "optgroup"))) {

											// Get the specific value for the option
											value = jQuery(option).val();

											// We don't need an array for one selects
											if (one) {
												return value;
											}

											// Multi-Selects return an array
											values.push(value);
										}
									}

									return values;
								},

								set: function (elem, value) {
									var optionSet, option,
										options = elem.options,
										values = jQuery.makeArray(value),
										i = options.length;

									while (i--) {
										option = options[i];

										/* eslint-disable no-cond-assign */

										if (option.selected =
											jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1
										) {
											optionSet = true;
										}

										/* eslint-enable no-cond-assign */
									}

									// Force browsers to behave consistently when non-matching value is set
									if (!optionSet) {
										elem.selectedIndex = -1;
									}
									return values;
								}
							}
						}
					});

					// Radios and checkboxes getter/setter
					jQuery.each(["radio", "checkbox"], function () {
						jQuery.valHooks[this] = {
							set: function (elem, value) {
								if (Array.isArray(value)) {
									return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
								}
							}
						};
						if (!support.checkOn) {
							jQuery.valHooks[this].get = function (elem) {
								return elem.getAttribute("value") === null ? "on" : elem.value;
							};
						}
					});




					// Return jQuery for attributes-only inclusion


					support.focusin = "onfocusin" in window;


					var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
						stopPropagationCallback = function (e) {
							e.stopPropagation();
						};

					jQuery.extend(jQuery.event, {

						trigger: function (event, data, elem, onlyHandlers) {

							var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
								eventPath = [elem || document],
								type = hasOwn.call(event, "type") ? event.type : event,
								namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

							cur = lastElement = tmp = elem = elem || document;

							// Don't do events on text and comment nodes
							if (elem.nodeType === 3 || elem.nodeType === 8) {
								return;
							}

							// focus/blur morphs to focusin/out; ensure we're not firing them right now
							if (rfocusMorph.test(type + jQuery.event.triggered)) {
								return;
							}

							if (type.indexOf(".") > -1) {

								// Namespaced trigger; create a regexp to match event type in handle()
								namespaces = type.split(".");
								type = namespaces.shift();
								namespaces.sort();
							}
							ontype = type.indexOf(":") < 0 && "on" + type;

							// Caller can pass in a jQuery.Event object, Object, or just an event type string
							event = event[jQuery.expando] ?
								event :
								new jQuery.Event(type, typeof event === "object" && event);

							// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
							event.isTrigger = onlyHandlers ? 2 : 3;
							event.namespace = namespaces.join(".");
							event.rnamespace = event.namespace ?
								new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") :
								null;

							// Clean up the event in case it is being reused
							event.result = undefined;
							if (!event.target) {
								event.target = elem;
							}

							// Clone any incoming data and prepend the event, creating the handler arg list
							data = data == null ?
								[event] :
								jQuery.makeArray(data, [event]);

							// Allow special events to draw outside the lines
							special = jQuery.event.special[type] || {};
							if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
								return;
							}

							// Determine event propagation path in advance, per W3C events spec (#9951)
							// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
							if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

								bubbleType = special.delegateType || type;
								if (!rfocusMorph.test(bubbleType + type)) {
									cur = cur.parentNode;
								}
								for (; cur; cur = cur.parentNode) {
									eventPath.push(cur);
									tmp = cur;
								}

								// Only add window if we got to document (e.g., not plain obj or detached DOM)
								if (tmp === (elem.ownerDocument || document)) {
									eventPath.push(tmp.defaultView || tmp.parentWindow || window);
								}
							}

							// Fire handlers on the event path
							i = 0;
							while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
								lastElement = cur;
								event.type = i > 1 ?
									bubbleType :
									special.bindType || type;

								// jQuery handler
								handle = (dataPriv.get(cur, "events") || {})[event.type] &&
									dataPriv.get(cur, "handle");
								if (handle) {
									handle.apply(cur, data);
								}

								// Native handler
								handle = ontype && cur[ontype];
								if (handle && handle.apply && acceptData(cur)) {
									event.result = handle.apply(cur, data);
									if (event.result === false) {
										event.preventDefault();
									}
								}
							}
							event.type = type;

							// If nobody prevented the default action, do it now
							if (!onlyHandlers && !event.isDefaultPrevented()) {

								if ((!special._default ||
									special._default.apply(eventPath.pop(), data) === false) &&
									acceptData(elem)) {

									// Call a native DOM method on the target with the same name as the event.
									// Don't do default actions on window, that's where global variables be (#6170)
									if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

										// Don't re-trigger an onFOO event when we call its FOO() method
										tmp = elem[ontype];

										if (tmp) {
											elem[ontype] = null;
										}

										// Prevent re-triggering of the same event, since we already bubbled it above
										jQuery.event.triggered = type;

										if (event.isPropagationStopped()) {
											lastElement.addEventListener(type, stopPropagationCallback);
										}

										elem[type]();

										if (event.isPropagationStopped()) {
											lastElement.removeEventListener(type, stopPropagationCallback);
										}

										jQuery.event.triggered = undefined;

										if (tmp) {
											elem[ontype] = tmp;
										}
									}
								}
							}

							return event.result;
						},

						// Piggyback on a donor event to simulate a different one
						// Used only for `focus(in | out)` events
						simulate: function (type, elem, event) {
							var e = jQuery.extend(
								new jQuery.Event(),
								event,
								{
									type: type,
									isSimulated: true
								}
							);

							jQuery.event.trigger(e, null, elem);
						}

					});

					jQuery.fn.extend({

						trigger: function (type, data) {
							return this.each(function () {
								jQuery.event.trigger(type, data, this);
							});
						},
						triggerHandler: function (type, data) {
							var elem = this[0];
							if (elem) {
								return jQuery.event.trigger(type, data, elem, true);
							}
						}
					});


					// Support: Firefox <=44
					// Firefox doesn't have focus(in | out) events
					// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
					//
					// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
					// focus(in | out) events fire after focus & blur events,
					// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
					// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
					if (!support.focusin) {
						jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

							// Attach a single capturing handler on the document while someone wants focusin/focusout
							var handler = function (event) {
								jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
							};

							jQuery.event.special[fix] = {
								setup: function () {
									var doc = this.ownerDocument || this,
										attaches = dataPriv.access(doc, fix);

									if (!attaches) {
										doc.addEventListener(orig, handler, true);
									}
									dataPriv.access(doc, fix, (attaches || 0) + 1);
								},
								teardown: function () {
									var doc = this.ownerDocument || this,
										attaches = dataPriv.access(doc, fix) - 1;

									if (!attaches) {
										doc.removeEventListener(orig, handler, true);
										dataPriv.remove(doc, fix);

									} else {
										dataPriv.access(doc, fix, attaches);
									}
								}
							};
						});
					}
					var location = window.location;

					var nonce = Date.now();

					var rquery = (/\?/);



					// Cross-browser xml parsing
					jQuery.parseXML = function (data) {
						var xml;
						if (!data || typeof data !== "string") {
							return null;
						}

						// Support: IE 9 - 11 only
						// IE throws on parseFromString with invalid input.
						try {
							xml = (new window.DOMParser()).parseFromString(data, "text/xml");
						} catch (e) {
							xml = undefined;
						}

						if (!xml || xml.getElementsByTagName("parsererror").length) {
							jQuery.error("Invalid XML: " + data);
						}
						return xml;
					};


					var
						rbracket = /\[\]$/,
						rCRLF = /\r?\n/g,
						rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
						rsubmittable = /^(?:input|select|textarea|keygen)/i;

					function buildParams(prefix, obj, traditional, add) {
						var name;

						if (Array.isArray(obj)) {

							// Serialize array item.
							jQuery.each(obj, function (i, v) {
								if (traditional || rbracket.test(prefix)) {

									// Treat each array item as a scalar.
									add(prefix, v);

								} else {

									// Item is non-scalar (array or object), encode its numeric index.
									buildParams(
										prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
										v,
										traditional,
										add
									);
								}
							});

						} else if (!traditional && toType(obj) === "object") {

							// Serialize object item.
							for (name in obj) {
								buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
							}

						} else {

							// Serialize scalar item.
							add(prefix, obj);
						}
					}

					// Serialize an array of form elements or a set of
					// key/values into a query string
					jQuery.param = function (a, traditional) {
						var prefix,
							s = [],
							add = function (key, valueOrFunction) {

								// If value is a function, invoke it and use its return value
								var value = isFunction(valueOrFunction) ?
									valueOrFunction() :
									valueOrFunction;

								s[s.length] = encodeURIComponent(key) + "=" +
									encodeURIComponent(value == null ? "" : value);
							};

						if (a == null) {
							return "";
						}

						// If an array was passed in, assume that it is an array of form elements.
						if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {

							// Serialize the form elements
							jQuery.each(a, function () {
								add(this.name, this.value);
							});

						} else {

							// If traditional, encode the "old" way (the way 1.3.2 or older
							// did it), otherwise encode params recursively.
							for (prefix in a) {
								buildParams(prefix, a[prefix], traditional, add);
							}
						}

						// Return the resulting serialization
						return s.join("&");
					};

					jQuery.fn.extend({
						serialize: function () {
							return jQuery.param(this.serializeArray());
						},
						serializeArray: function () {
							return this.map(function () {

								// Can add propHook for "elements" to filter or add form elements
								var elements = jQuery.prop(this, "elements");
								return elements ? jQuery.makeArray(elements) : this;
							})
								.filter(function () {
									var type = this.type;

									// Use .is( ":disabled" ) so that fieldset[disabled] works
									return this.name && !jQuery(this).is(":disabled") &&
										rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
										(this.checked || !rcheckableType.test(type));
								})
								.map(function (i, elem) {
									var val = jQuery(this).val();

									if (val == null) {
										return null;
									}

									if (Array.isArray(val)) {
										return jQuery.map(val, function (val) {
											return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
										});
									}

									return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
								}).get();
						}
					});


					var
						r20 = /%20/g,
						rhash = /#.*$/,
						rantiCache = /([?&])_=[^&]*/,
						rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

						// #7653, #8125, #8152: local protocol detection
						rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
						rnoContent = /^(?:GET|HEAD)$/,
						rprotocol = /^\/\//,

						/* Prefilters
						 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
						 * 2) These are called:
						 *    - BEFORE asking for a transport
						 *    - AFTER param serialization (s.data is a string if s.processData is true)
						 * 3) key is the dataType
						 * 4) the catchall symbol "*" can be used
						 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
						 */
						prefilters = {},

						/* Transports bindings
						 * 1) key is the dataType
						 * 2) the catchall symbol "*" can be used
						 * 3) selection will start with transport dataType and THEN go to "*" if needed
						 */
						transports = {},

						// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
						allTypes = "*/".concat("*"),

						// Anchor tag for parsing the document origin
						originAnchor = document.createElement("a");
					originAnchor.href = location.href;

					// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
					function addToPrefiltersOrTransports(structure) {

						// dataTypeExpression is optional and defaults to "*"
						return function (dataTypeExpression, func) {

							if (typeof dataTypeExpression !== "string") {
								func = dataTypeExpression;
								dataTypeExpression = "*";
							}

							var dataType,
								i = 0,
								dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

							if (isFunction(func)) {

								// For each dataType in the dataTypeExpression
								while ((dataType = dataTypes[i++])) {

									// Prepend if requested
									if (dataType[0] === "+") {
										dataType = dataType.slice(1) || "*";
										(structure[dataType] = structure[dataType] || []).unshift(func);

										// Otherwise append
									} else {
										(structure[dataType] = structure[dataType] || []).push(func);
									}
								}
							}
						};
					}

					// Base inspection function for prefilters and transports
					function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

						var inspected = {},
							seekingTransport = (structure === transports);

						function inspect(dataType) {
							var selected;
							inspected[dataType] = true;
							jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
								var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
								if (typeof dataTypeOrTransport === "string" &&
									!seekingTransport && !inspected[dataTypeOrTransport]) {

									options.dataTypes.unshift(dataTypeOrTransport);
									inspect(dataTypeOrTransport);
									return false;
								} else if (seekingTransport) {
									return !(selected = dataTypeOrTransport);
								}
							});
							return selected;
						}

						return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
					}

					// A special extend for ajax options
					// that takes "flat" options (not to be deep extended)
					// Fixes #9887
					function ajaxExtend(target, src) {
						var key, deep,
							flatOptions = jQuery.ajaxSettings.flatOptions || {};

						for (key in src) {
							if (src[key] !== undefined) {
								(flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key];
							}
						}
						if (deep) {
							jQuery.extend(true, target, deep);
						}

						return target;
					}

					/* Handles responses to an ajax request:
					 * - finds the right dataType (mediates between content-type and expected dataType)
					 * - returns the corresponding response
					 */
					function ajaxHandleResponses(s, jqXHR, responses) {

						var ct, type, finalDataType, firstDataType,
							contents = s.contents,
							dataTypes = s.dataTypes;

						// Remove auto dataType and get content-type in the process
						while (dataTypes[0] === "*") {
							dataTypes.shift();
							if (ct === undefined) {
								ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
							}
						}

						// Check if we're dealing with a known content-type
						if (ct) {
							for (type in contents) {
								if (contents[type] && contents[type].test(ct)) {
									dataTypes.unshift(type);
									break;
								}
							}
						}

						// Check to see if we have a response for the expected dataType
						if (dataTypes[0] in responses) {
							finalDataType = dataTypes[0];
						} else {

							// Try convertible dataTypes
							for (type in responses) {
								if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
									finalDataType = type;
									break;
								}
								if (!firstDataType) {
									firstDataType = type;
								}
							}

							// Or just use first one
							finalDataType = finalDataType || firstDataType;
						}

						// If we found a dataType
						// We add the dataType to the list if needed
						// and return the corresponding response
						if (finalDataType) {
							if (finalDataType !== dataTypes[0]) {
								dataTypes.unshift(finalDataType);
							}
							return responses[finalDataType];
						}
					}

					/* Chain conversions given the request and the original response
					 * Also sets the responseXXX fields on the jqXHR instance
					 */
					function ajaxConvert(s, response, jqXHR, isSuccess) {
						var conv2, current, conv, tmp, prev,
							converters = {},

							// Work with a copy of dataTypes in case we need to modify it for conversion
							dataTypes = s.dataTypes.slice();

						// Create converters map with lowercased keys
						if (dataTypes[1]) {
							for (conv in s.converters) {
								converters[conv.toLowerCase()] = s.converters[conv];
							}
						}

						current = dataTypes.shift();

						// Convert to each sequential dataType
						while (current) {

							if (s.responseFields[current]) {
								jqXHR[s.responseFields[current]] = response;
							}

							// Apply the dataFilter if provided
							if (!prev && isSuccess && s.dataFilter) {
								response = s.dataFilter(response, s.dataType);
							}

							prev = current;
							current = dataTypes.shift();

							if (current) {

								// There's only work to do if current dataType is non-auto
								if (current === "*") {

									current = prev;

									// Convert response if prev dataType is non-auto and differs from current
								} else if (prev !== "*" && prev !== current) {

									// Seek a direct converter
									conv = converters[prev + " " + current] || converters["* " + current];

									// If none found, seek a pair
									if (!conv) {
										for (conv2 in converters) {

											// If conv2 outputs current
											tmp = conv2.split(" ");
											if (tmp[1] === current) {

												// If prev can be converted to accepted input
												conv = converters[prev + " " + tmp[0]] ||
													converters["* " + tmp[0]];
												if (conv) {

													// Condense equivalence converters
													if (conv === true) {
														conv = converters[conv2];

														// Otherwise, insert the intermediate dataType
													} else if (converters[conv2] !== true) {
														current = tmp[0];
														dataTypes.unshift(tmp[1]);
													}
													break;
												}
											}
										}
									}

									// Apply converter (if not an equivalence)
									if (conv !== true) {

										// Unless errors are allowed to bubble, catch and return them
										if (conv && s.throws) {
											response = conv(response);
										} else {
											try {
												response = conv(response);
											} catch (e) {
												return {
													state: "parsererror",
													error: conv ? e : "No conversion from " + prev + " to " + current
												};
											}
										}
									}
								}
							}
						}

						return { state: "success", data: response };
					}

					jQuery.extend({

						// Counter for holding the number of active queries
						active: 0,

						// Last-Modified header cache for next request
						lastModified: {},
						etag: {},

						ajaxSettings: {
							url: location.href,
							type: "GET",
							isLocal: rlocalProtocol.test(location.protocol),
							global: true,
							processData: true,
							async: true,
							contentType: "application/x-www-form-urlencoded; charset=UTF-8",

							/*
							timeout: 0,
							data: null,
							dataType: null,
							username: null,
							password: null,
							cache: null,
							throws: false,
							traditional: false,
							headers: {},
							*/

							accepts: {
								"*": allTypes,
								text: "text/plain",
								html: "text/html",
								xml: "application/xml, text/xml",
								json: "application/json, text/javascript"
							},

							contents: {
								xml: /\bxml\b/,
								html: /\bhtml/,
								json: /\bjson\b/
							},

							responseFields: {
								xml: "responseXML",
								text: "responseText",
								json: "responseJSON"
							},

							// Data converters
							// Keys separate source (or catchall "*") and destination types with a single space
							converters: {

								// Convert anything to text
								"* text": String,

								// Text to html (true = no transformation)
								"text html": true,

								// Evaluate text as a json expression
								"text json": JSON.parse,

								// Parse text as xml
								"text xml": jQuery.parseXML
							},

							// For options that shouldn't be deep extended:
							// you can add your own custom options here if
							// and when you create one that shouldn't be
							// deep extended (see ajaxExtend)
							flatOptions: {
								url: true,
								context: true
							}
						},

						// Creates a full fledged settings object into target
						// with both ajaxSettings and settings fields.
						// If target is omitted, writes into ajaxSettings.
						ajaxSetup: function (target, settings) {
							return settings ?

								// Building a settings object
								ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

								// Extending ajaxSettings
								ajaxExtend(jQuery.ajaxSettings, target);
						},

						ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
						ajaxTransport: addToPrefiltersOrTransports(transports),

						// Main method
						ajax: function (url, options) {

							// If url is an object, simulate pre-1.5 signature
							if (typeof url === "object") {
								options = url;
								url = undefined;
							}

							// Force options to be an object
							options = options || {};

							var transport,

								// URL without anti-cache param
								cacheURL,

								// Response headers
								responseHeadersString,
								responseHeaders,

								// timeout handle
								timeoutTimer,

								// Url cleanup var
								urlAnchor,

								// Request state (becomes false upon send and true upon completion)
								completed,

								// To know if global events are to be dispatched
								fireGlobals,

								// Loop variable
								i,

								// uncached part of the url
								uncached,

								// Create the final options object
								s = jQuery.ajaxSetup({}, options),

								// Callbacks context
								callbackContext = s.context || s,

								// Context for global events is callbackContext if it is a DOM node or jQuery collection
								globalEventContext = s.context &&
									(callbackContext.nodeType || callbackContext.jquery) ?
									jQuery(callbackContext) :
									jQuery.event,

								// Deferreds
								deferred = jQuery.Deferred(),
								completeDeferred = jQuery.Callbacks("once memory"),

								// Status-dependent callbacks
								statusCode = s.statusCode || {},

								// Headers (they are sent all at once)
								requestHeaders = {},
								requestHeadersNames = {},

								// Default abort message
								strAbort = "canceled",

								// Fake xhr
								jqXHR = {
									readyState: 0,

									// Builds headers hashtable if needed
									getResponseHeader: function (key) {
										var match;
										if (completed) {
											if (!responseHeaders) {
												responseHeaders = {};
												while ((match = rheaders.exec(responseHeadersString))) {
													responseHeaders[match[1].toLowerCase() + " "] =
														(responseHeaders[match[1].toLowerCase() + " "] || [])
															.concat(match[2]);
												}
											}
											match = responseHeaders[key.toLowerCase() + " "];
										}
										return match == null ? null : match.join(", ");
									},

									// Raw string
									getAllResponseHeaders: function () {
										return completed ? responseHeadersString : null;
									},

									// Caches the header
									setRequestHeader: function (name, value) {
										if (completed == null) {
											name = requestHeadersNames[name.toLowerCase()] =
												requestHeadersNames[name.toLowerCase()] || name;
											requestHeaders[name] = value;
										}
										return this;
									},

									// Overrides response content-type header
									overrideMimeType: function (type) {
										if (completed == null) {
											s.mimeType = type;
										}
										return this;
									},

									// Status-dependent callbacks
									statusCode: function (map) {
										var code;
										if (map) {
											if (completed) {

												// Execute the appropriate callbacks
												jqXHR.always(map[jqXHR.status]);
											} else {

												// Lazy-add the new callbacks in a way that preserves old ones
												for (code in map) {
													statusCode[code] = [statusCode[code], map[code]];
												}
											}
										}
										return this;
									},

									// Cancel the request
									abort: function (statusText) {
										var finalText = statusText || strAbort;
										if (transport) {
											transport.abort(finalText);
										}
										done(0, finalText);
										return this;
									}
								};

							// Attach deferreds
							deferred.promise(jqXHR);

							// Add protocol if not provided (prefilters might expect it)
							// Handle falsy url in the settings object (#10093: consistency with old signature)
							// We also use the url parameter if available
							s.url = ((url || s.url || location.href) + "")
								.replace(rprotocol, location.protocol + "//");

							// Alias method option to type as per ticket #12004
							s.type = options.method || options.type || s.method || s.type;

							// Extract dataTypes list
							s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

							// A cross-domain request is in order when the origin doesn't match the current origin.
							if (s.crossDomain == null) {
								urlAnchor = document.createElement("a");

								// Support: IE <=8 - 11, Edge 12 - 15
								// IE throws exception on accessing the href property if url is malformed,
								// e.g. http://example.com:80x/
								try {
									urlAnchor.href = s.url;

									// Support: IE <=8 - 11 only
									// Anchor's host property isn't correctly set when s.url is relative
									urlAnchor.href = urlAnchor.href;
									s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
										urlAnchor.protocol + "//" + urlAnchor.host;
								} catch (e) {

									// If there is an error parsing the URL, assume it is crossDomain,
									// it can be rejected by the transport if it is invalid
									s.crossDomain = true;
								}
							}

							// Convert data if not already a string
							if (s.data && s.processData && typeof s.data !== "string") {
								s.data = jQuery.param(s.data, s.traditional);
							}

							// Apply prefilters
							inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

							// If request was aborted inside a prefilter, stop there
							if (completed) {
								return jqXHR;
							}

							// We can fire global events as of now if asked to
							// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
							fireGlobals = jQuery.event && s.global;

							// Watch for a new set of requests
							if (fireGlobals && jQuery.active++ === 0) {
								jQuery.event.trigger("ajaxStart");
							}

							// Uppercase the type
							s.type = s.type.toUpperCase();

							// Determine if request has content
							s.hasContent = !rnoContent.test(s.type);

							// Save the URL in case we're toying with the If-Modified-Since
							// and/or If-None-Match header later on
							// Remove hash to simplify url manipulation
							cacheURL = s.url.replace(rhash, "");

							// More options handling for requests with no content
							if (!s.hasContent) {

								// Remember the hash so we can put it back
								uncached = s.url.slice(cacheURL.length);

								// If data is available and should be processed, append data to url
								if (s.data && (s.processData || typeof s.data === "string")) {
									cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

									// #9682: remove data so that it's not used in an eventual retry
									delete s.data;
								}

								// Add or update anti-cache param if needed
								if (s.cache === false) {
									cacheURL = cacheURL.replace(rantiCache, "$1");
									uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + (nonce++) + uncached;
								}

								// Put hash and anti-cache on the URL that will be requested (gh-1732)
								s.url = cacheURL + uncached;

								// Change '%20' to '+' if this is encoded form body content (gh-2658)
							} else if (s.data && s.processData &&
								(s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
								s.data = s.data.replace(r20, "+");
							}

							// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
							if (s.ifModified) {
								if (jQuery.lastModified[cacheURL]) {
									jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
								}
								if (jQuery.etag[cacheURL]) {
									jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
								}
							}

							// Set the correct header, if data is being sent
							if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
								jqXHR.setRequestHeader("Content-Type", s.contentType);
							}

							// Set the Accepts header for the server, depending on the dataType
							jqXHR.setRequestHeader(
								"Accept",
								s.dataTypes[0] && s.accepts[s.dataTypes[0]] ?
									s.accepts[s.dataTypes[0]] +
									(s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") :
									s.accepts["*"]
							);

							// Check for headers option
							for (i in s.headers) {
								jqXHR.setRequestHeader(i, s.headers[i]);
							}

							// Allow custom headers/mimetypes and early abort
							if (s.beforeSend &&
								(s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

								// Abort if not done already and return
								return jqXHR.abort();
							}

							// Aborting is no longer a cancellation
							strAbort = "abort";

							// Install callbacks on deferreds
							completeDeferred.add(s.complete);
							jqXHR.done(s.success);
							jqXHR.fail(s.error);

							// Get transport
							transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

							// If no transport, we auto-abort
							if (!transport) {
								done(-1, "No Transport");
							} else {
								jqXHR.readyState = 1;

								// Send global event
								if (fireGlobals) {
									globalEventContext.trigger("ajaxSend", [jqXHR, s]);
								}

								// If request was aborted inside ajaxSend, stop there
								if (completed) {
									return jqXHR;
								}

								// Timeout
								if (s.async && s.timeout > 0) {
									timeoutTimer = window.setTimeout(function () {
										jqXHR.abort("timeout");
									}, s.timeout);
								}

								try {
									completed = false;
									transport.send(requestHeaders, done);
								} catch (e) {

									// Rethrow post-completion exceptions
									if (completed) {
										throw e;
									}

									// Propagate others as results
									done(-1, e);
								}
							}

							// Callback for when everything is done
							function done(status, nativeStatusText, responses, headers) {
								var isSuccess, success, error, response, modified,
									statusText = nativeStatusText;

								// Ignore repeat invocations
								if (completed) {
									return;
								}

								completed = true;

								// Clear timeout if it exists
								if (timeoutTimer) {
									window.clearTimeout(timeoutTimer);
								}

								// Dereference transport for early garbage collection
								// (no matter how long the jqXHR object will be used)
								transport = undefined;

								// Cache response headers
								responseHeadersString = headers || "";

								// Set readyState
								jqXHR.readyState = status > 0 ? 4 : 0;

								// Determine if successful
								isSuccess = status >= 200 && status < 300 || status === 304;

								// Get response data
								if (responses) {
									response = ajaxHandleResponses(s, jqXHR, responses);
								}

								// Convert no matter what (that way responseXXX fields are always set)
								response = ajaxConvert(s, response, jqXHR, isSuccess);

								// If successful, handle type chaining
								if (isSuccess) {

									// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
									if (s.ifModified) {
										modified = jqXHR.getResponseHeader("Last-Modified");
										if (modified) {
											jQuery.lastModified[cacheURL] = modified;
										}
										modified = jqXHR.getResponseHeader("etag");
										if (modified) {
											jQuery.etag[cacheURL] = modified;
										}
									}

									// if no content
									if (status === 204 || s.type === "HEAD") {
										statusText = "nocontent";

										// if not modified
									} else if (status === 304) {
										statusText = "notmodified";

										// If we have data, let's convert it
									} else {
										statusText = response.state;
										success = response.data;
										error = response.error;
										isSuccess = !error;
									}
								} else {

									// Extract error from statusText and normalize for non-aborts
									error = statusText;
									if (status || !statusText) {
										statusText = "error";
										if (status < 0) {
											status = 0;
										}
									}
								}

								// Set data for the fake xhr object
								jqXHR.status = status;
								jqXHR.statusText = (nativeStatusText || statusText) + "";

								// Success/Error
								if (isSuccess) {
									deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
								} else {
									deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
								}

								// Status-dependent callbacks
								jqXHR.statusCode(statusCode);
								statusCode = undefined;

								if (fireGlobals) {
									globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError",
										[jqXHR, s, isSuccess ? success : error]);
								}

								// Complete
								completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

								if (fireGlobals) {
									globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

									// Handle the global AJAX counter
									if (!(--jQuery.active)) {
										jQuery.event.trigger("ajaxStop");
									}
								}
							}

							return jqXHR;
						},

						getJSON: function (url, data, callback) {
							return jQuery.get(url, data, callback, "json");
						},

						getScript: function (url, callback) {
							return jQuery.get(url, undefined, callback, "script");
						}
					});

					jQuery.each(["get", "post"], function (i, method) {
						jQuery[method] = function (url, data, callback, type) {

							// Shift arguments if data argument was omitted
							if (isFunction(data)) {
								type = type || callback;
								callback = data;
								data = undefined;
							}

							// The url can be an options object (which then must have .url)
							return jQuery.ajax(jQuery.extend({
								url: url,
								type: method,
								dataType: type,
								data: data,
								success: callback
							}, jQuery.isPlainObject(url) && url));
						};
					});


					jQuery._evalUrl = function (url, options) {
						return jQuery.ajax({
							url: url,

							// Make this explicit, since user can override this through ajaxSetup (#11264)
							type: "GET",
							dataType: "script",
							cache: true,
							async: false,
							global: false,

							// Only evaluate the response if it is successful (gh-4126)
							// dataFilter is not invoked for failure responses, so using it instead
							// of the default converter is kludgy but it works.
							converters: {
								"text script": function () { }
							},
							dataFilter: function (response) {
								jQuery.globalEval(response, options);
							}
						});
					};


					jQuery.fn.extend({
						wrapAll: function (html) {
							var wrap;

							if (this[0]) {
								if (isFunction(html)) {
									html = html.call(this[0]);
								}

								// The elements to wrap the target around
								wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

								if (this[0].parentNode) {
									wrap.insertBefore(this[0]);
								}

								wrap.map(function () {
									var elem = this;

									while (elem.firstElementChild) {
										elem = elem.firstElementChild;
									}

									return elem;
								}).append(this);
							}

							return this;
						},

						wrapInner: function (html) {
							if (isFunction(html)) {
								return this.each(function (i) {
									jQuery(this).wrapInner(html.call(this, i));
								});
							}

							return this.each(function () {
								var self = jQuery(this),
									contents = self.contents();

								if (contents.length) {
									contents.wrapAll(html);

								} else {
									self.append(html);
								}
							});
						},

						wrap: function (html) {
							var htmlIsFunction = isFunction(html);

							return this.each(function (i) {
								jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
							});
						},

						unwrap: function (selector) {
							this.parent(selector).not("body").each(function () {
								jQuery(this).replaceWith(this.childNodes);
							});
							return this;
						}
					});


					jQuery.expr.pseudos.hidden = function (elem) {
						return !jQuery.expr.pseudos.visible(elem);
					};
					jQuery.expr.pseudos.visible = function (elem) {
						return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
					};




					jQuery.ajaxSettings.xhr = function () {
						try {
							return new window.XMLHttpRequest();
						} catch (e) { }
					};

					var xhrSuccessStatus = {

						// File protocol always yields status code 0, assume 200
						0: 200,

						// Support: IE <=9 only
						// #1450: sometimes IE returns 1223 when it should be 204
						1223: 204
					},
						xhrSupported = jQuery.ajaxSettings.xhr();

					support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
					support.ajax = xhrSupported = !!xhrSupported;

					jQuery.ajaxTransport(function (options) {
						var callback, errorCallback;

						// Cross domain only allowed if supported through XMLHttpRequest
						if (support.cors || xhrSupported && !options.crossDomain) {
							return {
								send: function (headers, complete) {
									var i,
										xhr = options.xhr();

									xhr.open(
										options.type,
										options.url,
										options.async,
										options.username,
										options.password
									);

									// Apply custom fields if provided
									if (options.xhrFields) {
										for (i in options.xhrFields) {
											xhr[i] = options.xhrFields[i];
										}
									}

									// Override mime type if needed
									if (options.mimeType && xhr.overrideMimeType) {
										xhr.overrideMimeType(options.mimeType);
									}

									// X-Requested-With header
									// For cross-domain requests, seeing as conditions for a preflight are
									// akin to a jigsaw puzzle, we simply never set it to be sure.
									// (it can always be set on a per-request basis or even using ajaxSetup)
									// For same-domain requests, won't change header if already provided.
									if (!options.crossDomain && !headers["X-Requested-With"]) {
										headers["X-Requested-With"] = "XMLHttpRequest";
									}

									// Set headers
									for (i in headers) {
										xhr.setRequestHeader(i, headers[i]);
									}

									// Callback
									callback = function (type) {
										return function () {
											if (callback) {
												callback = errorCallback = xhr.onload =
													xhr.onerror = xhr.onabort = xhr.ontimeout =
													xhr.onreadystatechange = null;

												if (type === "abort") {
													xhr.abort();
												} else if (type === "error") {

													// Support: IE <=9 only
													// On a manual native abort, IE9 throws
													// errors on any property access that is not readyState
													if (typeof xhr.status !== "number") {
														complete(0, "error");
													} else {
														complete(

															// File: protocol always yields status 0; see #8605, #14207
															xhr.status,
															xhr.statusText
														);
													}
												} else {
													complete(
														xhrSuccessStatus[xhr.status] || xhr.status,
														xhr.statusText,

														// Support: IE <=9 only
														// IE9 has no XHR2 but throws on binary (trac-11426)
														// For XHR2 non-text, let the caller handle it (gh-2498)
														(xhr.responseType || "text") !== "text" ||
															typeof xhr.responseText !== "string" ?
															{ binary: xhr.response } :
															{ text: xhr.responseText },
														xhr.getAllResponseHeaders()
													);
												}
											}
										};
									};

									// Listen to events
									xhr.onload = callback();
									errorCallback = xhr.onerror = xhr.ontimeout = callback("error");

									// Support: IE 9 only
									// Use onreadystatechange to replace onabort
									// to handle uncaught aborts
									if (xhr.onabort !== undefined) {
										xhr.onabort = errorCallback;
									} else {
										xhr.onreadystatechange = function () {

											// Check readyState before timeout as it changes
											if (xhr.readyState === 4) {

												// Allow onerror to be called first,
												// but that will not handle a native abort
												// Also, save errorCallback to a variable
												// as xhr.onerror cannot be accessed
												window.setTimeout(function () {
													if (callback) {
														errorCallback();
													}
												});
											}
										};
									}

									// Create the abort callback
									callback = callback("abort");

									try {

										// Do send the request (this may raise an exception)
										xhr.send(options.hasContent && options.data || null);
									} catch (e) {

										// #14683: Only rethrow if this hasn't been notified as an error yet
										if (callback) {
											throw e;
										}
									}
								},

								abort: function () {
									if (callback) {
										callback();
									}
								}
							};
						}
					});




					// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
					jQuery.ajaxPrefilter(function (s) {
						if (s.crossDomain) {
							s.contents.script = false;
						}
					});

					// Install script dataType
					jQuery.ajaxSetup({
						accepts: {
							script: "text/javascript, application/javascript, " +
								"application/ecmascript, application/x-ecmascript"
						},
						contents: {
							script: /\b(?:java|ecma)script\b/
						},
						converters: {
							"text script": function (text) {
								jQuery.globalEval(text);
								return text;
							}
						}
					});

					// Handle cache's special case and crossDomain
					jQuery.ajaxPrefilter("script", function (s) {
						if (s.cache === undefined) {
							s.cache = false;
						}
						if (s.crossDomain) {
							s.type = "GET";
						}
					});

					// Bind script tag hack transport
					jQuery.ajaxTransport("script", function (s) {

						// This transport only deals with cross domain or forced-by-attrs requests
						if (s.crossDomain || s.scriptAttrs) {
							var script, callback;
							return {
								send: function (_, complete) {
									script = jQuery("<script>")
										.attr(s.scriptAttrs || {})
										.prop({ charset: s.scriptCharset, src: s.url })
										.on("load error", callback = function (evt) {
											script.remove();
											callback = null;
											if (evt) {
												complete(evt.type === "error" ? 404 : 200, evt.type);
											}
										});

									// Use native DOM manipulation to avoid our domManip AJAX trickery
									document.head.appendChild(script[0]);
								},
								abort: function () {
									if (callback) {
										callback();
									}
								}
							};
						}
					});




					var oldCallbacks = [],
						rjsonp = /(=)\?(?=&|$)|\?\?/;

					// Default jsonp settings
					jQuery.ajaxSetup({
						jsonp: "callback",
						jsonpCallback: function () {
							var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce++));
							this[callback] = true;
							return callback;
						}
					});

					// Detect, normalize options and install callbacks for jsonp requests
					jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

						var callbackName, overwritten, responseContainer,
							jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ?
								"url" :
								typeof s.data === "string" &&
								(s.contentType || "")
									.indexOf("application/x-www-form-urlencoded") === 0 &&
								rjsonp.test(s.data) && "data"
							);

						// Handle iff the expected data type is "jsonp" or we have a parameter to set
						if (jsonProp || s.dataTypes[0] === "jsonp") {

							// Get callback name, remembering preexisting value associated with it
							callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ?
								s.jsonpCallback() :
								s.jsonpCallback;

							// Insert callback into url or form data
							if (jsonProp) {
								s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
							} else if (s.jsonp !== false) {
								s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
							}

							// Use data converter to retrieve json after script execution
							s.converters["script json"] = function () {
								if (!responseContainer) {
									jQuery.error(callbackName + " was not called");
								}
								return responseContainer[0];
							};

							// Force json dataType
							s.dataTypes[0] = "json";

							// Install callback
							overwritten = window[callbackName];
							window[callbackName] = function () {
								responseContainer = arguments;
							};

							// Clean-up function (fires after converters)
							jqXHR.always(function () {

								// If previous value didn't exist - remove it
								if (overwritten === undefined) {
									jQuery(window).removeProp(callbackName);

									// Otherwise restore preexisting value
								} else {
									window[callbackName] = overwritten;
								}

								// Save back as free
								if (s[callbackName]) {

									// Make sure that re-using the options doesn't screw things around
									s.jsonpCallback = originalSettings.jsonpCallback;

									// Save the callback name for future use
									oldCallbacks.push(callbackName);
								}

								// Call if it was a function and we have a response
								if (responseContainer && isFunction(overwritten)) {
									overwritten(responseContainer[0]);
								}

								responseContainer = overwritten = undefined;
							});

							// Delegate to script
							return "script";
						}
					});




					// Support: Safari 8 only
					// In Safari 8 documents created via document.implementation.createHTMLDocument
					// collapse sibling forms: the second one becomes a child of the first one.
					// Because of that, this security measure has to be disabled in Safari 8.
					// https://bugs.webkit.org/show_bug.cgi?id=137337
					support.createHTMLDocument = (function () {
						var body = document.implementation.createHTMLDocument("").body;
						body.innerHTML = "<form></form><form></form>";
						return body.childNodes.length === 2;
					})();


					// Argument "data" should be string of html
					// context (optional): If specified, the fragment will be created in this context,
					// defaults to document
					// keepScripts (optional): If true, will include scripts passed in the html string
					jQuery.parseHTML = function (data, context, keepScripts) {
						if (typeof data !== "string") {
							return [];
						}
						if (typeof context === "boolean") {
							keepScripts = context;
							context = false;
						}

						var base, parsed, scripts;

						if (!context) {

							// Stop scripts or inline event handlers from being executed immediately
							// by using document.implementation
							if (support.createHTMLDocument) {
								context = document.implementation.createHTMLDocument("");

								// Set the base href for the created document
								// so any parsed elements with URLs
								// are based on the document's URL (gh-2965)
								base = context.createElement("base");
								base.href = document.location.href;
								context.head.appendChild(base);
							} else {
								context = document;
							}
						}

						parsed = rsingleTag.exec(data);
						scripts = !keepScripts && [];

						// Single tag
						if (parsed) {
							return [context.createElement(parsed[1])];
						}

						parsed = buildFragment([data], context, scripts);

						if (scripts && scripts.length) {
							jQuery(scripts).remove();
						}

						return jQuery.merge([], parsed.childNodes);
					};


					/**
					 * Load a url into a page
					 */
					jQuery.fn.load = function (url, params, callback) {
						var selector, type, response,
							self = this,
							off = url.indexOf(" ");

						if (off > -1) {
							selector = stripAndCollapse(url.slice(off));
							url = url.slice(0, off);
						}

						// If it's a function
						if (isFunction(params)) {

							// We assume that it's the callback
							callback = params;
							params = undefined;

							// Otherwise, build a param string
						} else if (params && typeof params === "object") {
							type = "POST";
						}

						// If we have elements to modify, make the request
						if (self.length > 0) {
							jQuery.ajax({
								url: url,

								// If "type" variable is undefined, then "GET" method will be used.
								// Make value of this field explicit since
								// user can override it through ajaxSetup method
								type: type || "GET",
								dataType: "html",
								data: params
							}).done(function (responseText) {

								// Save response for use in complete callback
								response = arguments;

								self.html(selector ?

									// If a selector was specified, locate the right elements in a dummy div
									// Exclude scripts to avoid IE 'Permission Denied' errors
									jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

									// Otherwise use the full result
									responseText);

								// If the request succeeds, this function gets "data", "status", "jqXHR"
								// but they are ignored because response was set above.
								// If it fails, this function gets "jqXHR", "status", "error"
							}).always(callback && function (jqXHR, status) {
								self.each(function () {
									callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
								});
							});
						}

						return this;
					};




					// Attach a bunch of functions for handling common AJAX events
					jQuery.each([
						"ajaxStart",
						"ajaxStop",
						"ajaxComplete",
						"ajaxError",
						"ajaxSuccess",
						"ajaxSend"
					], function (i, type) {
						jQuery.fn[type] = function (fn) {
							return this.on(type, fn);
						};
					});




					jQuery.expr.pseudos.animated = function (elem) {
						return jQuery.grep(jQuery.timers, function (fn) {
							return elem === fn.elem;
						}).length;
					};




					jQuery.offset = {
						setOffset: function (elem, options, i) {
							var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
								position = jQuery.css(elem, "position"),
								curElem = jQuery(elem),
								props = {};

							// Set position first, in-case top/left are set even on static elem
							if (position === "static") {
								elem.style.position = "relative";
							}

							curOffset = curElem.offset();
							curCSSTop = jQuery.css(elem, "top");
							curCSSLeft = jQuery.css(elem, "left");
							calculatePosition = (position === "absolute" || position === "fixed") &&
								(curCSSTop + curCSSLeft).indexOf("auto") > -1;

							// Need to be able to calculate position if either
							// top or left is auto and position is either absolute or fixed
							if (calculatePosition) {
								curPosition = curElem.position();
								curTop = curPosition.top;
								curLeft = curPosition.left;

							} else {
								curTop = parseFloat(curCSSTop) || 0;
								curLeft = parseFloat(curCSSLeft) || 0;
							}

							if (isFunction(options)) {

								// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
								options = options.call(elem, i, jQuery.extend({}, curOffset));
							}

							if (options.top != null) {
								props.top = (options.top - curOffset.top) + curTop;
							}
							if (options.left != null) {
								props.left = (options.left - curOffset.left) + curLeft;
							}

							if ("using" in options) {
								options.using.call(elem, props);

							} else {
								curElem.css(props);
							}
						}
					};

					jQuery.fn.extend({

						// offset() relates an element's border box to the document origin
						offset: function (options) {

							// Preserve chaining for setter
							if (arguments.length) {
								return options === undefined ?
									this :
									this.each(function (i) {
										jQuery.offset.setOffset(this, options, i);
									});
							}

							var rect, win,
								elem = this[0];

							if (!elem) {
								return;
							}

							// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
							// Support: IE <=11 only
							// Running getBoundingClientRect on a
							// disconnected node in IE throws an error
							if (!elem.getClientRects().length) {
								return { top: 0, left: 0 };
							}

							// Get document-relative position by adding viewport scroll to viewport-relative gBCR
							rect = elem.getBoundingClientRect();
							win = elem.ownerDocument.defaultView;
							return {
								top: rect.top + win.pageYOffset,
								left: rect.left + win.pageXOffset
							};
						},

						// position() relates an element's margin box to its offset parent's padding box
						// This corresponds to the behavior of CSS absolute positioning
						position: function () {
							if (!this[0]) {
								return;
							}

							var offsetParent, offset, doc,
								elem = this[0],
								parentOffset = { top: 0, left: 0 };

							// position:fixed elements are offset from the viewport, which itself always has zero offset
							if (jQuery.css(elem, "position") === "fixed") {

								// Assume position:fixed implies availability of getBoundingClientRect
								offset = elem.getBoundingClientRect();

							} else {
								offset = this.offset();

								// Account for the *real* offset parent, which can be the document or its root element
								// when a statically positioned element is identified
								doc = elem.ownerDocument;
								offsetParent = elem.offsetParent || doc.documentElement;
								while (offsetParent &&
									(offsetParent === doc.body || offsetParent === doc.documentElement) &&
									jQuery.css(offsetParent, "position") === "static") {

									offsetParent = offsetParent.parentNode;
								}
								if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

									// Incorporate borders into its offset, since they are outside its content origin
									parentOffset = jQuery(offsetParent).offset();
									parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
									parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
								}
							}

							// Subtract parent offsets and element margins
							return {
								top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
								left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
							};
						},

						// This method will return documentElement in the following cases:
						// 1) For the element inside the iframe without offsetParent, this method will return
						//    documentElement of the parent window
						// 2) For the hidden or detached element
						// 3) For body or html element, i.e. in case of the html node - it will return itself
						//
						// but those exceptions were never presented as a real life use-cases
						// and might be considered as more preferable results.
						//
						// This logic, however, is not guaranteed and can change at any point in the future
						offsetParent: function () {
							return this.map(function () {
								var offsetParent = this.offsetParent;

								while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
									offsetParent = offsetParent.offsetParent;
								}

								return offsetParent || documentElement;
							});
						}
					});

					// Create scrollLeft and scrollTop methods
					jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
						var top = "pageYOffset" === prop;

						jQuery.fn[method] = function (val) {
							return access(this, function (elem, method, val) {

								// Coalesce documents and windows
								var win;
								if (isWindow(elem)) {
									win = elem;
								} else if (elem.nodeType === 9) {
									win = elem.defaultView;
								}

								if (val === undefined) {
									return win ? win[prop] : elem[method];
								}

								if (win) {
									win.scrollTo(
										!top ? val : win.pageXOffset,
										top ? val : win.pageYOffset
									);

								} else {
									elem[method] = val;
								}
							}, method, val, arguments.length);
						};
					});

					// Support: Safari <=7 - 9.1, Chrome <=37 - 49
					// Add the top/left cssHooks using jQuery.fn.position
					// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
					// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
					// getComputedStyle returns percent when specified for top/left/bottom/right;
					// rather than make the css module depend on the offset module, just check for it here
					jQuery.each(["top", "left"], function (i, prop) {
						jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition,
							function (elem, computed) {
								if (computed) {
									computed = curCSS(elem, prop);

									// If curCSS returns percentage, fallback to offset
									return rnumnonpx.test(computed) ?
										jQuery(elem).position()[prop] + "px" :
										computed;
								}
							}
						);
					});


					// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
					jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
						jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name },
							function (defaultExtra, funcName) {

								// Margin is only for outerHeight, outerWidth
								jQuery.fn[funcName] = function (margin, value) {
									var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
										extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

									return access(this, function (elem, type, value) {
										var doc;

										if (isWindow(elem)) {

											// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
											return funcName.indexOf("outer") === 0 ?
												elem["inner" + name] :
												elem.document.documentElement["client" + name];
										}

										// Get document width or height
										if (elem.nodeType === 9) {
											doc = elem.documentElement;

											// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
											// whichever is greatest
											return Math.max(
												elem.body["scroll" + name], doc["scroll" + name],
												elem.body["offset" + name], doc["offset" + name],
												doc["client" + name]
											);
										}

										return value === undefined ?

											// Get width or height on the element, requesting but not forcing parseFloat
											jQuery.css(elem, type, extra) :

											// Set width or height on the element
											jQuery.style(elem, type, value, extra);
									}, type, chainable ? margin : undefined, chainable);
								};
							});
					});


					jQuery.each(("blur focus focusin focusout resize scroll click dblclick " +
						"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
						"change select submit keydown keypress keyup contextmenu").split(" "),
						function (i, name) {

							// Handle event binding
							jQuery.fn[name] = function (data, fn) {
								return arguments.length > 0 ?
									this.on(name, null, data, fn) :
									this.trigger(name);
							};
						});

					jQuery.fn.extend({
						hover: function (fnOver, fnOut) {
							return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
						}
					});




					jQuery.fn.extend({

						bind: function (types, data, fn) {
							return this.on(types, null, data, fn);
						},
						unbind: function (types, fn) {
							return this.off(types, null, fn);
						},

						delegate: function (selector, types, data, fn) {
							return this.on(types, selector, data, fn);
						},
						undelegate: function (selector, types, fn) {

							// ( namespace ) or ( selector, types [, fn] )
							return arguments.length === 1 ?
								this.off(selector, "**") :
								this.off(types, selector || "**", fn);
						}
					});

					// Bind a function to a context, optionally partially applying any
					// arguments.
					// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
					// However, it is not slated for removal any time soon
					jQuery.proxy = function (fn, context) {
						var tmp, args, proxy;

						if (typeof context === "string") {
							tmp = fn[context];
							context = fn;
							fn = tmp;
						}

						// Quick check to determine if target is callable, in the spec
						// this throws a TypeError, but we will just return undefined.
						if (!isFunction(fn)) {
							return undefined;
						}

						// Simulated bind
						args = slice.call(arguments, 2);
						proxy = function () {
							return fn.apply(context || this, args.concat(slice.call(arguments)));
						};

						// Set the guid of unique handler to the same of original handler, so it can be removed
						proxy.guid = fn.guid = fn.guid || jQuery.guid++;

						return proxy;
					};

					jQuery.holdReady = function (hold) {
						if (hold) {
							jQuery.readyWait++;
						} else {
							jQuery.ready(true);
						}
					};
					jQuery.isArray = Array.isArray;
					jQuery.parseJSON = JSON.parse;
					jQuery.nodeName = nodeName;
					jQuery.isFunction = isFunction;
					jQuery.isWindow = isWindow;
					jQuery.camelCase = camelCase;
					jQuery.type = toType;

					jQuery.now = Date.now;

					jQuery.isNumeric = function (obj) {

						// As of jQuery 3.0, isNumeric is limited to
						// strings and numbers (primitives or objects)
						// that can be coerced to finite numbers (gh-2662)
						var type = jQuery.type(obj);
						return (type === "number" || type === "string") &&

							// parseFloat NaNs numeric-cast false positives ("")
							// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
							// subtraction forces infinities to NaN
							!isNaN(obj - parseFloat(obj));
					};




					// Register as a named AMD module, since jQuery can be concatenated with other
					// files that may use define, but not via a proper concatenation script that
					// understands anonymous AMD modules. A named AMD is safest and most robust
					// way to register. Lowercase jquery is used because AMD module names are
					// derived from file names, and jQuery is normally delivered in a lowercase
					// file name. Do this after creating the global so that if an AMD module wants
					// to call noConflict to hide this version of jQuery, it will work.

					// Note that for maximum portability, libraries that are not jQuery should
					// declare themselves as anonymous modules, and avoid setting a global if an
					// AMD loader is present. jQuery is a special case. For more information, see
					// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

					if (true) {
						!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
							return jQuery;
						}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
							__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
					}




					var

						// Map over jQuery in case of overwrite
						_jQuery = window.jQuery,

						// Map over the $ in case of overwrite
						_$ = window.$;

					jQuery.noConflict = function (deep) {
						if (window.$ === jQuery) {
							window.$ = _$;
						}

						if (deep && window.jQuery === jQuery) {
							window.jQuery = _jQuery;
						}

						return jQuery;
					};

					// Expose jQuery and $ identifiers, even in AMD
					// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
					// and CommonJS for browser emulators (#13566)
					if (!noGlobal) {
						window.jQuery = window.$ = jQuery;
					}




					return jQuery;
				});


				/***/
}),

/***/ 277:
/***/ ((module, exports, __webpack_require__) => {

				var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

				(function (name, definition) {
					if (true && module.exports) module.exports = definition()
					else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
						__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
							(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
							__WEBPACK_AMD_DEFINE_FACTORY__),
						__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
					else { }
				})('$script', function () {
					var doc = document
						, head = doc.getElementsByTagName('head')[0]
						, s = 'string'
						, f = false
						, push = 'push'
						, readyState = 'readyState'
						, onreadystatechange = 'onreadystatechange'
						, list = {}
						, ids = {}
						, delay = {}
						, scripts = {}
						, scriptpath
						, urlArgs

					function every(ar, fn) {
						for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
						return 1
					}
					function each(ar, fn) {
						every(ar, function (el) {
							fn(el)
							return 1
						})
					}

					function $script(paths, idOrDone, optDone) {
						paths = paths[push] ? paths : [paths]
						var idOrDoneIsDone = idOrDone && idOrDone.call
							, done = idOrDoneIsDone ? idOrDone : optDone
							, id = idOrDoneIsDone ? paths.join('') : idOrDone
							, queue = paths.length
						function loopFn(item) {
							return item.call ? item() : list[item]
						}
						function callback() {
							if (!--queue) {
								list[id] = 1
								done && done()
								for (var dset in delay) {
									every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
								}
							}
						}
						setTimeout(function () {
							each(paths, function loading(path, force) {
								if (path === null) return callback()

								if (!force && !/^https?:\/\//.test(path) && scriptpath) {
									path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
								}

								if (scripts[path]) {
									if (id) ids[id] = 1
									return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
								}

								scripts[path] = 1
								if (id) ids[id] = 1
								create(path, callback)
							})
						}, 0)
						return $script
					}

					function create(path, fn) {
						var el = doc.createElement('script'), loaded
						el.onload = el.onerror = el[onreadystatechange] = function () {
							if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
							el.onload = el[onreadystatechange] = null
							loaded = 1
							scripts[path] = 2
							fn()
						}
						el.async = 1
						el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
						head.insertBefore(el, head.lastChild)
					}

					$script.get = create

					$script.order = function (scripts, id, done) {
						(function callback(s) {
							s = scripts.shift()
							!scripts.length ? $script(s, id, done) : $script(s, callback)
						}())
					}

					$script.path = function (p) {
						scriptpath = p
					}
					$script.urlArgs = function (str) {
						urlArgs = str;
					}
					$script.ready = function (deps, ready, req) {
						deps = deps[push] ? deps : [deps]
						var missing = [];
						!each(deps, function (dep) {
							list[dep] || missing[push](dep);
						}) && every(deps, function (dep) { return list[dep] }) ?
							ready() : !function (key) {
								delay[key] = delay[key] || []
								delay[key][push](ready)
								req && req(missing)
							}(deps.join('|'))
						return $script
					}

					$script.done = function (idOrDone) {
						$script([null], idOrDone)
					}

					return $script
				});


				/***/
}),

/***/ 637:
/***/ ((module, exports) => {

				var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*********************************************************************
 * @license
*  #### Twitter Post Fetcher v17.1.0 ####
*  Coded by Jason Mayes 2015. A present to all the developers out there.
*  www.jasonmayes.com
*  Please keep this disclaimer with my code if you use it. Thanks. :-)
*  Got feedback or questions, ask here:
*  http://www.jasonmayes.com/projects/twitterApi/
*  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
*  Updates will be posted to this site.
*********************************************************************/
				!function (e, t) {
					true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
						__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
							(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
						__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0
				}(0, function () { var _ = "", y = 20, T = !0, k = [], C = !1, x = !0, E = !0, N = null, A = !0, I = !0, B = null, L = !0, M = !1, i = !1, R = !1, H = !0, a = "en", j = !0, q = !1, n = null; function P(e) { return e.replace(/<b[^>]*>(.*?)<\/b>/gi, function (e, t) { return t }).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, "") } function S(e) { for (var t = e.getElementsByTagName("a"), i = t.length - 1; 0 <= i; i--)t[i].setAttribute("target", "_blank") } function U(e, t) { for (var i = [], a = new RegExp("(^| )" + t + "( |$)"), n = e.getElementsByTagName("*"), s = 0, l = n.length; s < l; s++)a.test(n[s].className) && i.push(n[s]); return i } function F(e) { if (void 0 !== e && 0 <= e.innerHTML.indexOf("data-image")) { var t = e.innerHTML.split('data-image="')[1].split('"')[0]; return decodeURIComponent(t) + ".jpg" } } var O = { fetch: function (e) { if (void 0 === e.maxTweets && (e.maxTweets = 20), void 0 === e.enableLinks && (e.enableLinks = !0), void 0 === e.showUser && (e.showUser = !0), void 0 === e.showTime && (e.showTime = !0), void 0 === e.dateFunction && (e.dateFunction = "default"), void 0 === e.showRetweet && (e.showRetweet = !0), void 0 === e.customCallback && (e.customCallback = null), void 0 === e.showInteraction && (e.showInteraction = !0), void 0 === e.showImages && (e.showImages = !1), void 0 === e.showReplies && (e.showReplies = !1), void 0 === e.useEmoji && (e.useEmoji = !1), void 0 === e.linksInNewWindow && (e.linksInNewWindow = !0), void 0 === e.showPermalinks && (e.showPermalinks = !0), void 0 === e.dataOnly && (e.dataOnly = !1), C) k.push(e); else { C = !0, _ = e.domId, y = e.maxTweets, T = e.enableLinks, E = e.showUser, x = e.showTime, I = e.showRetweet, N = e.dateFunction, B = e.customCallback, L = e.showInteraction, M = e.showImages, i = e.showReplies, R = e.useEmoji, H = e.linksInNewWindow, j = e.showPermalinks, q = e.dataOnly; var t = document.getElementsByTagName("head")[0]; null !== n && t.removeChild(n), (n = document.createElement("script")).type = "text/javascript", void 0 !== e.list ? n.src = "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" + e.list.listSlug + "&screen_name=" + e.list.screenName + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : void 0 !== e.profile ? n.src = "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" + e.profile.screenName + "&with_replies=" + i + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : void 0 !== e.likes ? n.src = "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" + e.likes.screenName + "&suppress_response_codes=true&lang=" + (e.lang || a) + "&rnd=" + Math.random() : n.src = "https://cdn.syndication.twimg.com/widgets/timelines/" + e.id + "?&lang=" + (e.lang || a) + "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" + Math.random(), t.appendChild(n) } }, callback: function (e) { if (void 0 === e || void 0 === e.body) return C = !1, void (0 < k.length && (O.fetch(k[0]), k.splice(0, 1))); R || (e.body = e.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g, "")), M || (e.body = e.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g, "")), E || (e.body = e.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g, "")); var t = document.createElement("div"); function i(e) { var t = e.getElementsByTagName("img")[0]; return t && t.length && (t.src = t.getAttribute("data-src-2x")), e } t.innerHTML = e.body, void 0 === t.getElementsByClassName && (A = !1); var a = [], n = [], s = [], l = [], r = [], o = [], c = [], d = 0; if (A) for (var m = t.getElementsByClassName("timeline-Tweet"); d < m.length;)0 < m[d].getElementsByClassName("timeline-Tweet-retweetCredit").length ? r.push(!0) : r.push(!1), (!r[d] || r[d] && I) && (a.push(m[d].getElementsByClassName("timeline-Tweet-text")[0]), o.push(m[d].getAttribute("data-tweet-id")), E && n.push(i(m[d].getElementsByClassName("timeline-Tweet-author")[0])), s.push(m[d].getElementsByClassName("dt-updated")[0]), c.push(m[d].getElementsByClassName("timeline-Tweet-timestamp")[0]), void 0 !== m[d].getElementsByClassName("timeline-Tweet-media")[0] ? l.push(m[d].getElementsByClassName("timeline-Tweet-media")[0]) : l.push(void 0)), d++; else for (m = U(t, "timeline-Tweet"); d < m.length;)0 < U(m[d], "timeline-Tweet-retweetCredit").length ? r.push(!0) : r.push(!1), (!r[d] || r[d] && I) && (a.push(U(m[d], "timeline-Tweet-text")[0]), o.push(m[d].getAttribute("data-tweet-id")), E && n.push(i(U(m[d], "timeline-Tweet-author")[0])), s.push(U(m[d], "dt-updated")[0]), c.push(U(m[d], "timeline-Tweet-timestamp")[0]), void 0 !== U(m[d], "timeline-Tweet-media")[0] ? l.push(U(m[d], "timeline-Tweet-media")[0]) : l.push(void 0)), d++; a.length > y && (a.splice(y, a.length - y), n.splice(y, n.length - y), s.splice(y, s.length - y), r.splice(y, r.length - y), l.splice(y, l.length - y), c.splice(y, c.length - y)); var p = [], u = (d = a.length, 0); if (q) for (; u < d;)p.push({ tweet: a[u].innerHTML, author: n[u] ? n[u].innerHTML : "Unknown Author", author_data: { profile_url: n[u] ? n[u].querySelector('[data-scribe="element:user_link"]').href : null, profile_image: n[u] ? n[u].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-1x") : null, profile_image_2x: n[u] ? n[u].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-2x") : null, screen_name: n[u] ? n[u].querySelector('[data-scribe="element:screen_name"]').title : null, name: n[u] ? n[u].querySelector('[data-scribe="element:name"]').title : null }, time: s[u].textContent, timestamp: s[u].getAttribute("datetime").replace("+0000", "Z").replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"), image: F(l[u]), rt: r[u], tid: o[u], permalinkURL: void 0 === c[u] ? "" : c[u].href }), u++; else for (; u < d;) { if ("string" != typeof N) { var h = s[u].getAttribute("datetime"), g = new Date(s[u].getAttribute("datetime").replace(/-/g, "/").replace("T", " ").split("+")[0]), w = N(g, h); if (s[u].setAttribute("aria-label", w), a[u].textContent) if (A) s[u].textContent = w; else { var f = document.createElement("p"), v = document.createTextNode(w); f.appendChild(v), f.setAttribute("aria-label", w), s[u] = f } else s[u].textContent = w } var b = ""; T ? (H && (S(a[u]), E && S(n[u])), E && (b += '<div class="user">' + P(n[u].innerHTML) + "</div>"), b += '<p class="tweet">' + P(a[u].innerHTML) + "</p>", x && (b += j ? '<p class="timePosted"><a href="' + c[u] + '">' + s[u].getAttribute("aria-label") + "</a></p>" : '<p class="timePosted">' + s[u].getAttribute("aria-label") + "</p>")) : (a[u].textContent, E && (b += '<p class="user">' + n[u].textContent + "</p>"), b += '<p class="tweet">' + a[u].textContent + "</p>", x && (b += '<p class="timePosted">' + s[u].textContent + "</p>")), L && (b += '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' + o[u] + '" class="twitter_reply_icon"' + (H ? ' target="_blank">' : ">") + 'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' + o[u] + '" class="twitter_retweet_icon"' + (H ? ' target="_blank">' : ">") + 'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' + o[u] + '" class="twitter_fav_icon"' + (H ? ' target="_blank">' : ">") + "Favorite</a></p>"), M && void 0 !== l[u] && void 0 !== F(l[u]) && (b += '<div class="media"><img src="' + F(l[u]) + '" alt="Image from tweet" /></div>'), M ? p.push(b) : !M && a[u].textContent.length && p.push(b), u++ } !function (e) { if (null === B) { for (var t = e.length, i = 0, a = document.getElementById(_), n = "<ul>"; i < t;)n += "<li>" + e[i] + "</li>", i++; n += "</ul>", a.innerHTML = n } else B(e) }(p), C = !1, 0 < k.length && (O.fetch(k[0]), k.splice(0, 1)) } }; return window.__twttrf = O, window.twitterFetcher = O });

				/***/
})

		/******/
});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if (__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
			/******/
}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
			/******/
};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
		/******/
}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
			/******/
};
		/******/
})();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
					/******/
}
				/******/
}
			/******/
};
		/******/
})();
/******/
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function () {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
				/******/
} catch (e) {
/******/ 				if (typeof window === 'object') return window;
				/******/
}
			/******/
})();
		/******/
})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
		/******/
})();
	/******/
	/************************************************************************/
	(() => {
		"use strict";

		// UNUSED EXPORTS: default

		// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
		var jquery = __webpack_require__(755);
		var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
		// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
		var script = __webpack_require__(277);
		var script_default = /*#__PURE__*/__webpack_require__.n(script);
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-map/src/scripts/utils.js
		/*
		 * Function to convert any given latitude and longitude format to decimal degrees
		 */
		function getDecimalDegrees(
			firstComponent = 0,
			secondComponent = 0,
			thirdComponent = 0,
			fourthComponent = 0,
		) {
			const directions = {
				N: 1,
				E: 1,
				S: -1,
				W: -1,
			};
			let decimalDegrees = 0.0;
			const components = [firstComponent, secondComponent, thirdComponent, fourthComponent];

			for (let i = 0; i < components.length; i++) {
				const component = components[i];

				if (component) {
					if (Number.isNaN(parseFloat(component))) {
						decimalDegrees *= directions[component];
					} else {
						decimalDegrees += parseFloat(component) / (60 ** i);
					}
				}
			}

			return decimalDegrees;
		}

		/*
		 * By providing the ability to use a place name, or latitude and longitude coordinates
		 * we give merchants, and our demo stores the option to bypass the Geocoding API.
		 * The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
		 * to take a place name and convert it to latitude and longitude expressed in decimal degrees.
		 */
		function getLatitudeLongitude(address) {
			// Degrees, Minutes and Seconds: DDD° MM' SS.S"
			const latLongDegreesMinutesSeconds = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g;
			// Degrees and Decimal Minutes: DDD° MM.MMM'
			const latLongDegreesMinutes = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g;
			// Decimal Degrees: DDD.DDDDD°
			const latLongDegrees = /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
			const latLongFormats = [latLongDegreesMinutesSeconds, latLongDegreesMinutes, latLongDegrees];
			const latLongMatches = latLongFormats.map(latLongFormat => address.match(latLongFormat));

			/*
			 * Select the first latitude and longitude format that is matched.
			 * Ordering:
			 *   1. Degrees, minutes, and seconds,
			 *   2. Degrees, and decimal minutes,
			 *   3. Decimal degrees.
			 */
			const latLongMatch = latLongMatches.reduce((accumulator, value, index) => {
				if (!accumulator && value) {
					const latLongResult = latLongFormats[index].exec(address);
					const lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
					const lng = latLongResult.slice(latLongResult.length / 2 + 1, latLongResult.length);

					return {
						lat,
						lng,
					};
				}

				return accumulator;
			}, null);

			return new Promise((resolve, reject) => {
				// If we've got a match on latitude and longitude, use that and avoid geocoding
				if (latLongMatch) {
					const latDecimalDegrees = getDecimalDegrees(...latLongMatch.lat);
					const longDecimalDegrees = getDecimalDegrees(...latLongMatch.lng);

					resolve({
						lat: latDecimalDegrees,
						lng: longDecimalDegrees,
					});
				} else {
					// Otherwise, geocode the assumed address
					const geocoder = new google.maps.Geocoder();

					geocoder.geocode({ address }, (results, status) => {
						if (status !== google.maps.GeocoderStatus.OK || !results[0]) {
							reject(status);
						} else {
							resolve(results[0].geometry.location);
						}
					});
				}
			});
		}

		function getMapStyles(colors) {
			if (!colors) {
				return [];
			}

			return [
				{ elementType: 'geometry', stylers: [{ color: colors.e }] },
				{ elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
				{ elementType: 'labels.text.fill', stylers: [{ color: colors.a }] },
				{ elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] },
				{ featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
				{ featureType: 'administrative.country', stylers: [{ visibility: 'off' }] },
				{ featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
				{ featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] },
				{ featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] },
				{ featureType: 'poi', stylers: [{ visibility: 'off' }] },
				{ featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: colors.d }] },
				{ featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
				{ featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: colors.c }] },
				{ featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: colors.b }] },
				{ featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] },
				{ featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: colors.b }] },
				{ featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] },
				{ featureType: 'transit', stylers: [{ visibility: 'off' }] },
				{ featureType: 'water', elementType: 'geometry', stylers: [{ color: colors.f }] },
			];
		}

		function createMap(options) {
			const {
				container,
				address,
				zoom,
				colors,
			} = options;

			return getLatitudeLongitude(address)
				.then((latLong) => {
					const map = new google.maps.Map(container, {
						center: latLong,
						clickableIcons: false,
						disableDefaultUI: true,
						disableDoubleClickZoom: true,
						gestureHandling: 'none',
						keyboardShortcuts: false,
						maxZoom: zoom,
						minZoom: zoom,
						scrollWheel: false,
						styles: getMapStyles(colors),
						zoom,
						zoomControl: false,
					});

					new google.maps.Marker({
						clickable: false,
						map,
						position: map.getCenter(),
					});

					map.panBy(0, 0);
					new Promise.resolve(map);
				})
				.catch((status) => {
					const usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
					let errorMessage;

					switch (status) {
						case 'ZERO_RESULTS':
							errorMessage = `<p>Unable to find the address:</p> ${address}`;
							break;
						case 'OVER_QUERY_LIMIT':
							errorMessage = `
            <p>Unable to load Google Maps, you have reached your usage limit.</p>
            <p>
              Please visit
              <a href="${usageLimits}" target="_blank">${usageLimits}</a>
              for more details.
            </p>
          `;
							break;
						default:
							errorMessage = 'Unable to load Google Maps.';
							break;
					}
					throw errorMessage;
				});
		}

		function displayErrorInThemeEditor(container, errorMessage) {
			const isThemeEditor = window.Shopify && window.Shopify.designMode;

			if (!isThemeEditor) {
				return;
			}

			container.innerHTML = `<div class="map-error-message">${errorMessage}</div>`;
		}



		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-map/src/scripts/index.js



		class PxsMap {
			constructor(section) {
				this.map = null;

				const el = section.el.querySelector('[data-map]');
				const container = el.querySelector('[data-map-container]');
				const settings = section.data;
				const { address, colors } = settings;
				const apiKey = settings.api_key;
				// Scale so range is 12 ~ 17, rather than 1 to 6
				const zoom = Number.isNaN(settings.zoom) ? 13 : 11 + parseInt(settings.zoom, 10);

				if (apiKey) {
					if (window.googleMaps === undefined) {
						script_default()(`https://maps.googleapis.com/maps/api/js?key=${apiKey}`, () => {
							window.googleMaps = true;
							createMap({
								container,
								address,
								zoom,
								colors,
							}).then((map) => {
								this.map = map;
							}).catch(error => displayErrorInThemeEditor(container, error));
						});
					} else {
						createMap({
							container,
							address,
							zoom,
							colors,
						}).then((map) => {
							this.map = map;
						}).catch(error => displayErrorInThemeEditor(container, error));
					}
				}
			}
		}

		;// CONCATENATED MODULE: ./node_modules/@pixelunion/rimg/dist/index.es.js
		/*!
		 * @pixelunion/rimg v2.2.0
		 * (c) 2019 Pixel Union
		 */
		/**
		 * The default template render function. Turns a template string into an image
		 * URL.
		 *
		 * @param {String} template
		 * @param {Size} size
		 * @returns {String}
		 */
		function defaultTemplateRender(template, size) {
			return template.replace('{size}', size.width + 'x' + size.height);
		}

		/**
		 * @type Settings
		 */
		var defaults = {
			scale: 1,
			template: false,
			templateRender: defaultTemplateRender,
			max: { width: Infinity, height: Infinity },
			round: 32,
			placeholder: false,
			crop: null
		};

		/**
		 * Get a data attribute value from an element, with a default fallback and
		 * sanitization step.
		 *
		 * @param {Element} el
		 *
		 * @param {String} name
		 *        The data attribute name.
		 *
		 * @param {Object} options
		 *        An object holding fallback values if the data attribute does not
		 *        exist. If this object doesn't have the property, we further fallback
		 *        to our defaults.
		 *
		 * @param {Function} [sanitize]
		 *        A function to sanitize the data attribute value with.
		 *
		 * @returns {String|*}
		 */
		function getData(el, name, options, sanitize) {
			var attr = 'data-rimg-' + name;
			if (!el.hasAttribute(attr)) return options[name] || defaults[name];

			var value = el.getAttribute(attr);

			return sanitize ? sanitize(value) : value;
		}

		/**
		 * Sanitize data attributes that represent a size (in the form of `10x10`).
		 *
		 * @param {String} value
		 * @returns {Object} An object with `width` and `height` properties.
		 */
		function parseSize(value) {
			value = value.split('x');
			return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
		}

		/**
		 * Sanitize crop values to ensure they are valid, or null
		 *
		 * @param {String} value
		 * @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
		 */
		function processCropValue(value) {
			switch (value) {
				case 'top':
				case 'center':
				case 'bottom':
				case 'left':
				case 'right':
					return value;
				default:
					return null;
			}
		}

		/**
		 * Loads information about an element.
		 *
		 * Options can be set on the element itself using data attributes, or through
		 * the `options` parameter. Data attributes take priority.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 * @returns {Item}
		 */
		function parseItem(el) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var isImage = el.hasAttribute('data-rimg-template');

			/**
			 * @typedef {Settings} Item
			 */
			return {
				el: el,

				// Type of element
				isImage: isImage,
				isBackgroundImage: isImage && el.tagName !== 'IMG',

				// Image scale
				scale: getData(el, 'scale', options),

				// Device density
				density: window.devicePixelRatio || 1,

				// Image template URL
				template: getData(el, 'template', options),
				templateRender: options.templateRender || defaults.templateRender,

				// Maximum image dimensions
				max: getData(el, 'max', options, parseSize),

				// Round image dimensions to the nearest multiple
				round: getData(el, 'round', options),

				// Placeholder image dimensions
				placeholder: getData(el, 'placeholder', options, parseSize),

				// Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
				crop: getData(el, 'crop', options, processCropValue)
			};
		}

		/**
		 * Round to the nearest multiple.
		 *
		 * This is so we don't tax the image server too much.
		 *
		 * @param {Number} size The size, in pixels.
		 * @param {Number} [multiple] The multiple to round to the nearest.
		 * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
		 * @returns {Number}
		 */
		function roundSize(size) {
			var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
			var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;

			return size === 0 ? multiple : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
		}

		/**
		 * Get the size of an element.
		 *
		 * If it is too small, it's parent element is checked, and so on. This helps
		 * avoid the situation where an element doesn't have a size yet or is positioned
		 * out of the layout.
		 *
		 * @param {HTMLElement} el
		 * @return {Object} size
		 * @return {Number} size.width The width, in pixels.
		 * @return {Number} size.height The height, in pixels.
		 */
		function getElementSize(el) {
			var size = { width: 0, height: 0 };

			while (el) {
				size.width = el.offsetWidth;
				size.height = el.offsetHeight;
				if (size.width > 20 && size.height > 20) break;
				el = el.parentNode;
			}

			return size;
		}

		/**
		 * Trigger a custom event.
		 *
		 * Note: this approach is deprecated, but still required to support older
		 * browsers such as IE 10.
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
		 *
		 * @param {HTMLElement} el
		 *        The element to trigger the event on.
		 *
		 * @param {String} name
		 *        The event name.
		 *
		 * @returns {Boolean}
		 *          True if the event was canceled.
		 */
		function trigger(el, name) {
			var event = document.createEvent('Event');
			event.initEvent(name, true, true);
			return !el.dispatchEvent(event);
		}

		/**
		 * Return the maximum supported density of the image, given the container.
		 *
		 * @param {Item} item
		 * @param {Size} size
		 */
		function supportedDensity(item, size) {
			return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
		}

		/**
		 * Set the image URL on the element. Supports background images and `srcset`.
		 *
		 * @param {Item} item
		 * @param {Size} size
		 * @param {Boolean} isPlaceholder
		 */
		function setImage(item, size, isPlaceholder, onLoad) {
			var render = item.templateRender;
			var density = isPlaceholder ? 1 : supportedDensity(item, size);
			var round = isPlaceholder ? 1 : item.round;

			// Calculate the final display size, taking into account the image's
			// maximum dimensions.
			var targetWidth = size.width * density;
			var targetHeight = size.height * density;

			var displaySize = void 0;

			if (item.crop) {
				displaySize = {
					width: roundSize(targetWidth, round, item.max.width),
					height: roundSize(targetHeight, round, item.max.height)
				};
			} else {
				// Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
				// To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
				// This isn't a problem with cropped images which are served at the exact dimension requested.
				var containerAspectRatio = size.width / size.height;
				var imageAspectRatio = item.max.width / item.max.height;

				if (containerAspectRatio > imageAspectRatio) {
					// fit width
					displaySize = {
						width: roundSize(targetWidth, round, item.max.width),
						height: roundSize(targetWidth / imageAspectRatio, round, item.max.height)
					};
				} else {
					// fit height
					displaySize = {
						width: roundSize(targetHeight * imageAspectRatio, round, item.max.width),
						height: roundSize(targetHeight, round, item.max.height)
					};
				}
			}

			var url = render(item.template, displaySize);

			// On load callback
			var image = new Image();
			image.onload = onLoad;
			image.src = url;

			// Set image
			if (item.isBackgroundImage) {
				item.el.style.backgroundImage = 'url(\'' + url + '\')';
			} else {
				item.el.setAttribute('srcset', url + ' ' + density + 'x');
			}
		}

		/**
		 * Load the image, set loaded status, and trigger the load event.
		 *
		 * @fires rimg:load
		 * @fires rimg:error
		 * @param {Item} item
		 * @param {Size} size
		 */
		function loadFullImage(item, size) {
			var el = item.el;

			setImage(item, size, false, function (event) {
				if (event.type === 'load') {
					el.setAttribute('data-rimg', 'loaded');
				} else {
					el.setAttribute('data-rimg', 'error');
					trigger(el, 'rimg:error');
				}

				trigger(el, 'rimg:load');
			});
		}

		/**
		 * Load in a responsive image.
		 *
		 * Sets the image's `srcset` attribute to the final image URLs, calculated based
		 * on the actual size the image is being shown at.
		 *
		 * @fires rimg:loading
		 *        The image URLs have been set and we are waiting for them to load.
		 *
		 * @fires rimg:loaded
		 *        The final image has loaded.
		 *
		 * @fires rimg:error
		 *        The final image failed loading.
		 *
		 * @param {Item} item
		 */
		function loadImage(item) {
			var el = item.el;

			// Already loaded?
			var status = el.getAttribute('data-rimg');
			if (status === 'loading' || status === 'loaded') return;

			// Is the SVG loaded?
			// In Firefox, el.complete always returns true so we also check el.naturalWidth,
			// which equals 0 until the image loads
			if (el.naturalWidth == 0 && el.complete && !item.isBackgroundImage) {
				// Wait for the load event, then call load image
				el.addEventListener('load', function cb() {
					el.removeEventListener('load', cb);
					loadImage(item);
				});

				return;
			}

			// Trigger loading event, and stop if cancelled
			if (trigger(el, 'rimg:loading')) return;

			// Mark as loading
			el.setAttribute('data-rimg', 'loading');

			// Get element size. This is used as the ideal display size.
			var size = getElementSize(item.el);

			size.width *= item.scale;
			size.height *= item.scale;

			if (item.placeholder) {
				// Load a placeholder image first, followed by the full image. Force the
				// element to keep its dimensions while it loads. If the image is smaller
				// than the element size, use the image's size. Density is taken into account
				// for HiDPI devices to avoid blurry images.
				if (!item.isBackgroundImage) {
					el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
					el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
				}

				setImage(item, item.placeholder, true, function () {
					return loadFullImage(item, size);
				});
			} else {
				loadFullImage(item, size);
			}
		}

		/**
		 * Prepare an element to be displayed on the screen.
		 *
		 * Images have special logic applied to them to swap out the different sources.
		 *
		 * @fires rimg:enter
		 *        The element is entering the viewport.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 */
		function load(el, options) {
			if (!el) return;
			trigger(el, 'rimg:enter');

			var item = parseItem(el, options);

			if (item.isImage) {
				if (!item.isBackgroundImage) {
					el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
				}

				loadImage(item);
			}
		}

		/**
		 * Reset an element's state so that its image can be recalculated.
		 *
		 * @fires rimg:update
		 *        The element is being updated.
		 *
		 * @param {HTMLElement} el
		 * @param {Settings} options
		 */
		function update(el, options) {
			if (!el) return;
			trigger(el, 'rimg:update');

			var item = parseItem(el, options);

			if (item.isImage) {
				if (!item.isBackgroundImage) {
					el.setAttribute('data-rimg', 'lazy');
					el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
				}

				loadImage(item);
			}
		}

		/**
		 * Returns true if the element is within the viewport.
		 * @param {HTMLElement} el
		 * @returns {Boolean}
		 */
		function inViewport(el) {
			if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
				return false;
			}

			var root = document.documentElement;
			var width = Math.min(root.clientWidth, window.innerWidth);
			var height = Math.min(root.clientHeight, window.innerHeight);
			var rect = el.getBoundingClientRect();

			return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
		}

		/**
		 * @typedef {Object} Size
		 * @property {Number} width
		 * @property {Number} height
		 */

		/**
		 * A function to turn a template string into a URL.
		 *
		 * @callback TemplateRenderer
		 * @param {String} template
		 * @param {Size} size
		 * @returns {String}
		 */

		/**
		 * @typedef {Object} Settings
		 *
		 * @property {String} [template]
		 *           A template string used to generate URLs for an image. This allows us to
		 *           dynamically load images with sizes to match the container's size.
		 *
		 * @property {TemplateRenderer} [templateRender]
		 *           A function to turn a template string into a URL.
		 *
		 * @property {Size} [max]
		 *           The maximum available size for the image. This ensures we don't
		 *           try to load an image larger than is possible.
		 * 
		 * @property {Number} [scale]
		 *           A number to scale the final image dimensions by. 
		 *           Only applies to lazy-loaded images. Defaults to 1.
		 *
		 * @property {Number} [round]
		 *           Round image dimensions to the nearest multiple. This is intended to
		 *           tax the image server less by lowering the number of possible image
		 *           sizes requested.
		 *
		 * @property {Size} [placeholder]
		 *           The size of the lo-fi image to load before the full image.
		 * 
		 * @property {String} [crop]
		 *           Crop value; null if image is uncropped, otherwise equal 
		 *           to the Shopify crop parameter ('center', 'top', etc.).
		 */

		/**
		 * Initialize the responsive image handler.
		 *
		 * @param {String|HTMLElement|NodeList} selector
		 *        The CSS selector, element, or elements to track for lazy-loading.
		 *
		 * @param {Settings} options
		 *
		 * @returns {PublicApi}
		 */
		function rimg() {
			var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			// Intersections
			var io = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						io.unobserve(entry.target);
						load(entry.target, options);
					}
				});
			}, {
				// Watch the viewport, with 20% vertical margins
				rootMargin: '20% 0px'
			});

			/**
			 * @typedef {Object} PublicApi
			 */
			var api = {
				/**
				 * Track a new selector, element, or nodelist for lazy-loading.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				track: function track() {
					var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';

					var els = querySelector(selector);

					for (var i = 0; i < els.length; i++) {
						// If an element is already in the viewport, load it right away. This
						// fixes a race-condition with dynamically added elements.
						if (inViewport(els[i])) {
							load(els[i], options);
						} else {
							io.observe(els[i]);
						}
					}
				},


				/**
				 * Update element(s) that have already been loaded to force their images
				 * to be recalculated.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				update: function update$$1() {
					var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';

					var els = querySelector(selector);
					for (var i = 0; i < els.length; i++) {
						update(els[i], options);
					}
				},


				/**
				 * Stop tracking element(s) for lazy-loading.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				untrack: function untrack() {
					var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

					var els = querySelector(selector);
					for (var i = 0; i < els.length; i++) {
						io.unobserve(els[i]);
					}
				},


				/**
				 * Manually load images.
				 * @type Function
				 * @param {String|HTMLElement|NodeList} selector
				 */
				load: function load$$1() {
					var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

					var els = querySelector(selector);
					for (var i = 0; i < els.length; i++) {
						load(els[i], options);
					}
				},


				/**
				 * Unload all event handlers and observers.
				 * @type Function
				 */
				unload: function unload() {
					io.disconnect();
				}
			};

			// Add initial elements
			api.track(selector);

			return api;
		}

		/**
		 * Finds a group of elements on the page.
		 *
		 * @param {String|HTMLElement|NodeList} selector
		 * @returns {Object} An array-like object.
		 */
		function querySelector(selector) {
			if (typeof selector === 'string') {
				return document.querySelectorAll(selector);
			}

			if (selector instanceof HTMLElement) {
				return [selector];
			}

			if (selector instanceof NodeList) {
				return selector;
			}

			return [];
		}

/* harmony default export */ const index_es = (rimg);

		;// CONCATENATED MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
		/*!
		 * @pixelunion/rimg-shopify v2.5.2
		 * (c) 2020 Pixel Union
		 */


		/**
		 * Polyfill for Element.matches().
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
		 */
		if (!Element.prototype.matches) {
			Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
				var matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i = matches.length;

				while (--i >= 0 && matches.item(i) !== this) { }

				return i > -1;
			};
		}

		var state = {
			init: init,
			watch: watch,
			unwatch: unwatch,
			load: index_es_load
		};

		function init() {
			var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			state.selector = selector;
			state.instance = index_es(selector, options);
			state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Listen for Shopify theme editor events

			document.addEventListener('shopify:section:load', function (event) {
				return watch(event.target);
			});
			window.addEventListener('resize', function () {
				return _update();
			});
			document.addEventListener('shopify:section:unload', function (event) {
				return unwatch(event.target);
			}); // Listen for custom events to allow themes to hook into rimg

			document.addEventListener('theme:rimg:watch', function (event) {
				return watch(event.target);
			});
			document.addEventListener('theme:rimg:unwatch', function (event) {
				return unwatch(event.target);
			}); // Support custom events triggered through jQuery
			// See: https://github.com/jquery/jquery/issues/3347

			if (window.jQuery) {
				jQuery(document).on({
					'theme:rimg:watch': function themeRimgWatch(event) {
						return watch(event.target);
					},
					'theme:rimg:unwatch': function themeRimgUnwatch(event) {
						return unwatch(event.target);
					}
				});
			}
		}
		/**
		 * Track an element, and its children.
		 *
		 * @param {HTMLElement} el
		 */


		function watch(el) {
			// Track element
			if (typeof el.matches === 'function' && el.matches(state.selector)) {
				state.instance.track(el);
			} // Track element's children


			state.instance.track(el.querySelectorAll(state.selector));
		}
		/**
		 * Untrack an element, and its children
		 *
		 * @param {HTMLElement} el
		 * @private
		 */


		function unwatch(el) {
			// Untrack element's children
			state.instance.untrack(el.querySelectorAll(state.selector)); // Untrack element

			if (typeof el.matches === 'function' && el.matches(state.selector)) {
				state.instance.untrack(el);
			}
		}
		/**
		 * Manually load an image
		 *
		 * @param {HTMLElement} el
		 */


		function index_es_load(el) {
			// Load element
			if (typeof el.matches === 'function' && el.matches(state.selector)) {
				state.instance.on('load',el);
			} // Load element's children


			state.instance.on('load',el.querySelectorAll(state.selector));
		}
		/**
		 * Update an element, and its children.
		 *
		 * @param {HTMLElement} el
		 */


		function _update() {
			var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Return if we're not 2x smaller, or larger than the existing loading size

			if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
				return;
			}

			state.loadedWidth = currentWidth;
			state.instance.update();
		}

/* harmony default export */ const dist_index_es = (state);

		;// CONCATENATED MODULE: ./node_modules/shopify-sections-manager/dist/shopify-sections-manager.es.js

		/*!
		 * shopify-sections-manager v1.0.0
		 * (c) 2019 Pixel Union
		 */

		var classCallCheck = function (instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		};

		var createClass = function () {
			function defineProperties(target, props) {
				for (var i = 0; i < props.length; i++) {
					var descriptor = props[i];
					descriptor.enumerable = descriptor.enumerable || false;
					descriptor.configurable = true;
					if ("value" in descriptor) descriptor.writable = true;
					Object.defineProperty(target, descriptor.key, descriptor);
				}
			}

			return function (Constructor, protoProps, staticProps) {
				if (protoProps) defineProperties(Constructor.prototype, protoProps);
				if (staticProps) defineProperties(Constructor, staticProps);
				return Constructor;
			};
		}();

		function triggerInstanceEvent(instance, eventName) {
			if (instance && instance[eventName]) {
				for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
					args[_key - 2] = arguments[_key];
				}

				instance[eventName].apply(instance, args);
			}
		}

		function loadData(el) {
			var dataEl = el.querySelector('[data-section-data]');
			if (!dataEl) return {};

			// Load data from attribute, or innerHTML
			var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

			try {
				return JSON.parse(data);
			} catch (error) {
				console.warn('Sections: invalid section data found. ' + error.message);
				return {};
			}
		}

		var ShopifySectionsManager = function () {
			function ShopifySectionsManager() {
				classCallCheck(this, ShopifySectionsManager);

				this.handlers = {};
				this.instances = {};
				this._onSectionEvent = this._onSectionEvent.bind(this);

				document.addEventListener('shopify:section:load', this._onSectionEvent);
				document.addEventListener('shopify:section:unload', this._onSectionEvent);
				document.addEventListener('shopify:section:select', this._onSectionEvent);
				document.addEventListener('shopify:section:deselect', this._onSectionEvent);
				document.addEventListener('shopify:section:reorder', this._onSectionEvent);
				document.addEventListener('shopify:block:select', this._onSectionEvent);
				document.addEventListener('shopify:block:deselect', this._onSectionEvent);
			}

			/**
			 * Stop listening for section events, and unbind all handlers.
			 */


			createClass(ShopifySectionsManager, [{
				key: 'unbind',
				value: function unbind() {
					document.removeEventListener('shopify:section:load', this._onSectionEvent);
					document.removeEventListener('shopify:section:unload', this._onSectionEvent);
					document.removeEventListener('shopify:section:select', this._onSectionEvent);
					document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
					document.removeEventListener('shopify:section:reorder', this._onSectionEvent);
					document.removeEventListener('shopify:block:select', this._onSectionEvent);
					document.removeEventListener('shopify:block:deselect', this._onSectionEvent);

					// Unload all instances
					for (var i = 0; i < this.instances.length; i++) {
						triggerInstanceEvent(this.instances[i], 'onSectionUnload');
					}

					this.handlers = {};
					this.instances = {};
				}

				/**
				 * Register a section handler.
				 *
				 * @param {string} type
				 *        The section type to handle. The handler will be called for all
				 *        sections with this type.
				 *
				 * @param {function} handler
				 *        The handler function is passed information about a specific section
				 *        instance. The handler is expected to return an object that will be
				 *        associated with the section instance.
				 *
				 *        Section handlers are passed an object with the following parameters:
				 *          {string} id
				 *          An ID that maps to a specific section instance. Typically the
				 *          section's filename for static sections, or a generated ID for
				 *          dynamic sections.
				 *
				 *          {string} type
				 *          The section type, as supplied when registered.
				 *
				 *          {Element} el
				 *          The root DOM element for the section instance.
				 *
				 *          {Object} data
				 *          Data loaded from the section script element. Defaults to an
				 *          empty object.
				 *
				 *          {Function} postMessage
				 *          A function that can be called to pass messages between sections.
				 *          The function should be called with a message "name", and
				 *          optionally some data.
				 */

			}, {
				key: 'register',
				value: function register(type, handler) {
					if (this.handlers[type]) {
						console.warn('Sections: section handler already exists of type \'' + type + '\'.');
					}

					// Store the section handler
					this.handlers[type] = handler;

					// Init sections for this type
					this._initSections(type);
				}

				/**
				 * Initialize sections already on the page.
				 */

			}, {
				key: '_initSections',
				value: function _initSections(type) {
					// Fetch all existing sections of our type on the page
					var dataEls = document.querySelectorAll('[data-section-type="' + type + '"]');
					if (!dataEls) return;

					// Create an instance for each section
					for (var i = 0; i < dataEls.length; i++) {
						var dataEl = dataEls[i];
						var el = dataEl.parentNode;

						// Get instance ID
						var idEl = el.querySelector('[data-section-id]');

						if (!idEl) {
							console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
							return;
						}

						var sectionId = idEl.getAttribute('data-section-id');
						if (!sectionId) {
							console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
							return;
						}

						this._createInstance(sectionId, el);
					}
				}
			}, {
				key: '_onSectionEvent',
				value: function _onSectionEvent(event) {
					var el = event.target;
					var sectionId = event.detail.sectionId;
					var blockId = event.detail.blockId;
					var instance = this.instances[sectionId];

					switch (event.type) {
						case 'shopify:section:load':
							this._createInstance(sectionId, el);
							break;

						case 'shopify:section:unload':
							triggerInstanceEvent(instance, 'onSectionUnload', { el: el, id: sectionId });
							delete this.instances[sectionId];
							break;

						case 'shopify:section:select':
							triggerInstanceEvent(instance, 'onSectionSelect', { el: el, id: sectionId });
							break;

						case 'shopify:section:deselect':
							triggerInstanceEvent(instance, 'onSectionDeselect', { el: el, id: sectionId });
							break;

						case 'shopify:section:reorder':
							triggerInstanceEvent(instance, 'onSectionReorder', { el: el, id: sectionId });
							break;

						case 'shopify:block:select':
							triggerInstanceEvent(instance, 'onSectionBlockSelect', { el: el, id: blockId });
							break;

						case 'shopify:block:deselect':
							triggerInstanceEvent(instance, 'onSectionBlockDeselect', { el: el, id: blockId });
							break;

						default:
							break;
					}
				}
			}, {
				key: '_postMessage',
				value: function _postMessage(name, data) {
					var _this = this;

					Object.keys(this.instances).forEach(function (id) {
						triggerInstanceEvent(_this.instances[id], 'onSectionMessage', name, data);
					});
				}
			}, {
				key: '_createInstance',
				value: function _createInstance(id, el) {
					var typeEl = el.querySelector('[data-section-type]');
					if (!typeEl) return;

					var type = typeEl.getAttribute('data-section-type');
					if (!type) return;

					var handler = this.handlers[type];
					if (!handler) {
						console.warn('Sections: unable to find section handler for type \'' + type + '\'.');
						return;
					}

					var data = loadData(el);
					var postMessage = this._postMessage.bind(this);

					this.instances[id] = handler({ id: id, type: type, el: el, data: data, postMessage: postMessage });
				}
			}]);
			return ShopifySectionsManager;
		}();

/* harmony default export */ const shopify_sections_manager_es = (ShopifySectionsManager);

		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-slideshow/dist/index.es.js

		/*!
		 * @pixelunion/pxs-slideshow v1.1.7
		 * (c) 2021 Pixel Union
		 */

		function _classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function _defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function _createClass(Constructor, protoProps, staticProps) {
			if (protoProps) _defineProperties(Constructor.prototype, protoProps);
			if (staticProps) _defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

		function unwrapExports(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var evEmitter = createCommonjsModule(function (module) {
			/**
			 * EvEmitter v1.1.0
			 * Lil' event emitter
			 * MIT License
			 */

			/* jshint unused: true, undef: true, strict: true */

			(function (global, factory) {
				// universal module definition
				/* jshint strict: false */ /* globals define, module, window */
				if (module.exports) {
					// CommonJS - Browserify, Webpack
					module.exports = factory();
				} else {
					// Browser globals
					global.EvEmitter = factory();
				}

			}(typeof window != 'undefined' ? window : commonjsGlobal, function () {

				function EvEmitter() { }

				var proto = EvEmitter.prototype;

				proto.on = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// set events hash
					var events = this._events = this._events || {};
					// set listeners array
					var listeners = events[eventName] = events[eventName] || [];
					// only add once
					if (listeners.indexOf(listener) == -1) {
						listeners.push(listener);
					}

					return this;
				};

				proto.once = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// add event
					this.on(eventName, listener);
					// set once flag
					// set onceEvents hash
					var onceEvents = this._onceEvents = this._onceEvents || {};
					// set onceListeners object
					var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
					// set flag
					onceListeners[listener] = true;

					return this;
				};

				proto.off = function (eventName, listener) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					var index = listeners.indexOf(listener);
					if (index != -1) {
						listeners.splice(index, 1);
					}

					return this;
				};

				proto.emitEvent = function (eventName, args) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					// copy over to avoid interference if .off() in listener
					listeners = listeners.slice(0);
					args = args || [];
					// once stuff
					var onceListeners = this._onceEvents && this._onceEvents[eventName];

					for (var i = 0; i < listeners.length; i++) {
						var listener = listeners[i];
						var isOnce = onceListeners && onceListeners[listener];
						if (isOnce) {
							// remove listener
							// remove before trigger to prevent recursion
							this.off(eventName, listener);
							// unset once flag
							delete onceListeners[listener];
						}
						// trigger listener
						listener.apply(this, args);
					}

					return this;
				};

				proto.allOff = function () {
					delete this._events;
					delete this._onceEvents;
				};

				return EvEmitter;

			}));
		});

		var getSize = createCommonjsModule(function (module) {
			/*!
			 * getSize v2.0.3
			 * measure size of elements
			 * MIT license
			 */

			/* jshint browser: true, strict: true, undef: true, unused: true */
			/* globals console: false */

			(function (window, factory) {
				/* jshint strict: false */ /* globals define, module */
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.getSize = factory();
				}

			})(window, function factory() {

				// -------------------------- helpers -------------------------- //

				// get a number from a string, not a percentage
				function getStyleSize(value) {
					var num = parseFloat(value);
					// not a percent like '100%', and a number
					var isValid = value.indexOf('%') == -1 && !isNaN(num);
					return isValid && num;
				}

				function noop() { }

				var logError = typeof console == 'undefined' ? noop :
					function (message) {
						console.error(message);
					};

				// -------------------------- measurements -------------------------- //

				var measurements = [
					'paddingLeft',
					'paddingRight',
					'paddingTop',
					'paddingBottom',
					'marginLeft',
					'marginRight',
					'marginTop',
					'marginBottom',
					'borderLeftWidth',
					'borderRightWidth',
					'borderTopWidth',
					'borderBottomWidth'
				];

				var measurementsLength = measurements.length;

				function getZeroSize() {
					var size = {
						width: 0,
						height: 0,
						innerWidth: 0,
						innerHeight: 0,
						outerWidth: 0,
						outerHeight: 0
					};
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						size[measurement] = 0;
					}
					return size;
				}

				// -------------------------- getStyle -------------------------- //

				/**
				 * getStyle, get style of element, check for Firefox bug
				 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
				 */
				function getStyle(elem) {
					var style = getComputedStyle(elem);
					if (!style) {
						logError('Style returned ' + style +
							'. Are you running this code in a hidden iframe on Firefox? ' +
							'See https://bit.ly/getsizebug1');
					}
					return style;
				}

				// -------------------------- setup -------------------------- //

				var isSetup = false;

				var isBoxSizeOuter;

				/**
				 * setup
				 * check isBoxSizerOuter
				 * do on first getSize() rather than on page load for Firefox bug
				 */
				function setup() {
					// setup once
					if (isSetup) {
						return;
					}
					isSetup = true;

					// -------------------------- box sizing -------------------------- //

					/**
					 * Chrome & Safari measure the outer-width on style.width on border-box elems
					 * IE11 & Firefox<29 measures the inner-width
					 */
					var div = document.createElement('div');
					div.style.width = '200px';
					div.style.padding = '1px 2px 3px 4px';
					div.style.borderStyle = 'solid';
					div.style.borderWidth = '1px 2px 3px 4px';
					div.style.boxSizing = 'border-box';

					var body = document.body || document.documentElement;
					body.appendChild(div);
					var style = getStyle(div);
					// round value for browser zoom. desandro/masonry#928
					isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
					getSize.isBoxSizeOuter = isBoxSizeOuter;

					body.removeChild(div);
				}

				// -------------------------- getSize -------------------------- //

				function getSize(elem) {
					setup();

					// use querySeletor if elem is string
					if (typeof elem == 'string') {
						elem = document.querySelector(elem);
					}

					// do not proceed on non-objects
					if (!elem || typeof elem != 'object' || !elem.nodeType) {
						return;
					}

					var style = getStyle(elem);

					// if hidden, everything is 0
					if (style.display == 'none') {
						return getZeroSize();
					}

					var size = {};
					size.width = elem.offsetWidth;
					size.height = elem.offsetHeight;

					var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

					// get all measurements
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						var value = style[measurement];
						var num = parseFloat(value);
						// any 'auto', 'medium' value will be 0
						size[measurement] = !isNaN(num) ? num : 0;
					}

					var paddingWidth = size.paddingLeft + size.paddingRight;
					var paddingHeight = size.paddingTop + size.paddingBottom;
					var marginWidth = size.marginLeft + size.marginRight;
					var marginHeight = size.marginTop + size.marginBottom;
					var borderWidth = size.borderLeftWidth + size.borderRightWidth;
					var borderHeight = size.borderTopWidth + size.borderBottomWidth;

					var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

					// overwrite width and height if we can get it from style
					var styleWidth = getStyleSize(style.width);
					if (styleWidth !== false) {
						size.width = styleWidth +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
					}

					var styleHeight = getStyleSize(style.height);
					if (styleHeight !== false) {
						size.height = styleHeight +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
					}

					size.innerWidth = size.width - (paddingWidth + borderWidth);
					size.innerHeight = size.height - (paddingHeight + borderHeight);

					size.outerWidth = size.width + marginWidth;
					size.outerHeight = size.height + marginHeight;

					return size;
				}

				return getSize;

			});
		});

		var matchesSelector = createCommonjsModule(function (module) {
			/**
			 * matchesSelector v2.0.2
			 * matchesSelector( element, '.selector' )
			 * MIT license
			 */

			/*jshint browser: true, strict: true, undef: true, unused: true */

			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.matchesSelector = factory();
				}

			}(window, function factory() {

				var matchesMethod = (function () {
					var ElemProto = window.Element.prototype;
					// check for the standard method name first
					if (ElemProto.matches) {
						return 'matches';
					}
					// check un-prefixed
					if (ElemProto.matchesSelector) {
						return 'matchesSelector';
					}
					// check vendor prefixes
					var prefixes = ['webkit', 'moz', 'ms', 'o'];

					for (var i = 0; i < prefixes.length; i++) {
						var prefix = prefixes[i];
						var method = prefix + 'MatchesSelector';
						if (ElemProto[method]) {
							return method;
						}
					}
				})();

				return function matchesSelector(elem, selector) {
					return elem[matchesMethod](selector);
				};

			}));
		});

		var utils = createCommonjsModule(function (module) {
			/**
			 * Fizzy UI utils v2.0.7
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						matchesSelector
					);
				} else {
					// browser global
					window.fizzyUIUtils = factory(
						window,
						window.matchesSelector
					);
				}

			}(window, function factory(window, matchesSelector) {

				var utils = {};

				// ----- extend ----- //

				// extends objects
				utils.extend = function (a, b) {
					for (var prop in b) {
						a[prop] = b[prop];
					}
					return a;
				};

				// ----- modulo ----- //

				utils.modulo = function (num, div) {
					return ((num % div) + div) % div;
				};

				// ----- makeArray ----- //

				var arraySlice = Array.prototype.slice;

				// turn element or nodeList into an array
				utils.makeArray = function (obj) {
					if (Array.isArray(obj)) {
						// use object if already an array
						return obj;
					}
					// return empty array if undefined or null. #6
					if (obj === null || obj === undefined) {
						return [];
					}

					var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
					if (isArrayLike) {
						// convert nodeList to array
						return arraySlice.call(obj);
					}

					// array of single index
					return [obj];
				};

				// ----- removeFrom ----- //

				utils.removeFrom = function (ary, obj) {
					var index = ary.indexOf(obj);
					if (index != -1) {
						ary.splice(index, 1);
					}
				};

				// ----- getParent ----- //

				utils.getParent = function (elem, selector) {
					while (elem.parentNode && elem != document.body) {
						elem = elem.parentNode;
						if (matchesSelector(elem, selector)) {
							return elem;
						}
					}
				};

				// ----- getQueryElement ----- //

				// use element as selector string
				utils.getQueryElement = function (elem) {
					if (typeof elem == 'string') {
						return document.querySelector(elem);
					}
					return elem;
				};

				// ----- handleEvent ----- //

				// enable .ontype to trigger from .addEventListener( elem, 'type' )
				utils.handleEvent = function (event) {
					var method = 'on' + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// ----- filterFindElements ----- //

				utils.filterFindElements = function (elems, selector) {
					// make array of elems
					elems = utils.makeArray(elems);
					var ffElems = [];

					elems.forEach(function (elem) {
						// check that elem is an actual element
						if (!(elem instanceof HTMLElement)) {
							return;
						}
						// add elem if no selector
						if (!selector) {
							ffElems.push(elem);
							return;
						}
						// filter & find items if we have a selector
						// filter
						if (matchesSelector(elem, selector)) {
							ffElems.push(elem);
						}
						// find children
						var childElems = elem.querySelectorAll(selector);
						// concat childElems to filterFound array
						for (var i = 0; i < childElems.length; i++) {
							ffElems.push(childElems[i]);
						}
					});

					return ffElems;
				};

				// ----- debounceMethod ----- //

				utils.debounceMethod = function (_class, methodName, threshold) {
					threshold = threshold || 100;
					// original method
					var method = _class.prototype[methodName];
					var timeoutName = methodName + 'Timeout';

					_class.prototype[methodName] = function () {
						var timeout = this[timeoutName];
						clearTimeout(timeout);

						var args = arguments;
						var _this = this;
						this[timeoutName] = setTimeout(function () {
							method.apply(_this, args);
							delete _this[timeoutName];
						}, threshold);
					};
				};

				// ----- docReady ----- //

				utils.docReady = function (callback) {
					var readyState = document.readyState;
					if (readyState == 'complete' || readyState == 'interactive') {
						// do async to allow for other scripts to run. metafizzy/flickity#441
						setTimeout(callback);
					} else {
						document.addEventListener('DOMContentLoaded', callback);
					}
				};

				// ----- htmlInit ----- //

				// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
				utils.toDashed = function (str) {
					return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
						return $1 + '-' + $2;
					}).toLowerCase();
				};

				var console = window.console;
				/**
				 * allow user to initialize classes via [data-namespace] or .js-namespace class
				 * htmlInit( Widget, 'widgetName' )
				 * options are parsed from data-namespace-options
				 */
				utils.htmlInit = function (WidgetClass, namespace) {
					utils.docReady(function () {
						var dashedNamespace = utils.toDashed(namespace);
						var dataAttr = 'data-' + dashedNamespace;
						var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
						var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
						var elems = utils.makeArray(dataAttrElems)
							.concat(utils.makeArray(jsDashElems));
						var dataOptionsAttr = dataAttr + '-options';
						var jQuery = window.jQuery;

						elems.forEach(function (elem) {
							var attr = elem.getAttribute(dataAttr) ||
								elem.getAttribute(dataOptionsAttr);
							var options;
							try {
								options = attr && JSON.parse(attr);
							} catch (error) {
								// log error, do not initialize
								if (console) {
									console.error('Error parsing ' + dataAttr + ' on ' + elem.className +
										': ' + error);
								}
								return;
							}
							// initialize
							var instance = new WidgetClass(elem, options);
							// make available via $().data('namespace')
							if (jQuery) {
								jQuery.data(elem, namespace, instance);
							}
						});

					});
				};

				// -----  ----- //

				return utils;

			}));
		});

		var cell = createCommonjsModule(function (module) {
			// Flickity.Cell
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						getSize
					);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Cell = factory(
						window,
						window.getSize
					);
				}

			}(window, function factory(window, getSize) {

				function Cell(elem, parent) {
					this.element = elem;
					this.parent = parent;

					this.create();
				}

				var proto = Cell.prototype;

				proto.create = function () {
					this.element.style.position = 'absolute';
					this.element.setAttribute('aria-hidden', 'true');
					this.x = 0;
					this.shift = 0;
				};

				proto.destroy = function () {
					// reset style
					this.unselect();
					this.element.style.position = '';
					var side = this.parent.originSide;
					this.element.style[side] = '';
				};

				proto.getSize = function () {
					this.size = getSize(this.element);
				};

				proto.setPosition = function (x) {
					this.x = x;
					this.updateTarget();
					this.renderPosition(x);
				};

				// setDefaultTarget v1 method, backwards compatibility, remove in v3
				proto.updateTarget = proto.setDefaultTarget = function () {
					var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
					this.target = this.x + this.size[marginProperty] +
						this.size.width * this.parent.cellAlign;
				};

				proto.renderPosition = function (x) {
					// render position of cell with in slider
					var side = this.parent.originSide;
					this.element.style[side] = this.parent.getPositionValue(x);
				};

				proto.select = function () {
					this.element.classList.add('is-selected');
					this.element.removeAttribute('aria-hidden');
				};

				proto.unselect = function () {
					this.element.classList.remove('is-selected');
					this.element.setAttribute('aria-hidden', 'true');
				};

				/**
				 * @param {Integer} factor - 0, 1, or -1
				**/
				proto.wrapShift = function (shift) {
					this.shift = shift;
					this.renderPosition(this.x + this.parent.slideableWidth * shift);
				};

				proto.remove = function () {
					this.element.parentNode.removeChild(this.element);
				};

				return Cell;

			}));
		});

		var slide = createCommonjsModule(function (module) {
			// slide
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Slide = factory();
				}

			}(window, function factory() {

				function Slide(parent) {
					this.parent = parent;
					this.isOriginLeft = parent.originSide == 'left';
					this.cells = [];
					this.outerWidth = 0;
					this.height = 0;
				}

				var proto = Slide.prototype;

				proto.addCell = function (cell) {
					this.cells.push(cell);
					this.outerWidth += cell.size.outerWidth;
					this.height = Math.max(cell.size.outerHeight, this.height);
					// first cell stuff
					if (this.cells.length == 1) {
						this.x = cell.x; // x comes from first cell
						var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
						this.firstMargin = cell.size[beginMargin];
					}
				};

				proto.updateTarget = function () {
					var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
					var lastCell = this.getLastCell();
					var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
					var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
					this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.select = function () {
					this.cells.forEach(function (cell) {
						cell.select();
					});
				};

				proto.unselect = function () {
					this.cells.forEach(function (cell) {
						cell.unselect();
					});
				};

				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				return Slide;

			}));
		});

		var animate = createCommonjsModule(function (module) {
			// animate
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						utils
					);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.animatePrototype = factory(
						window,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, utils) {

				// -------------------------- animate -------------------------- //

				var proto = {};

				proto.startAnimation = function () {
					if (this.isAnimating) {
						return;
					}

					this.isAnimating = true;
					this.restingFrames = 0;
					this.animate();
				};

				proto.animate = function () {
					this.applyDragForce();
					this.applySelectedAttraction();

					var previousX = this.x;

					this.integratePhysics();
					this.positionSlider();
					this.settle(previousX);
					// animate next frame
					if (this.isAnimating) {
						var _this = this;
						requestAnimationFrame(function animateFrame() {
							_this.animate();
						});
					}
				};

				proto.positionSlider = function () {
					var x = this.x;
					// wrap position around
					if (this.options.wrapAround && this.cells.length > 1) {
						x = utils.modulo(x, this.slideableWidth);
						x = x - this.slideableWidth;
						this.shiftWrapCells(x);
					}

					this.setTranslateX(x, this.isAnimating);
					this.dispatchScrollEvent();
				};

				proto.setTranslateX = function (x, is3d) {
					x += this.cursorPosition;
					// reverse if right-to-left and using transform
					x = this.options.rightToLeft ? -x : x;
					var translateX = this.getPositionValue(x);
					// use 3D tranforms for hardware acceleration on iOS
					// but use 2D when settled, for better font-rendering
					this.slider.style.transform = is3d ?
						'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
				};

				proto.dispatchScrollEvent = function () {
					var firstSlide = this.slides[0];
					if (!firstSlide) {
						return;
					}
					var positionX = -this.x - firstSlide.target;
					var progress = positionX / this.slidesWidth;
					this.dispatchEvent('scroll', null, [progress, positionX]);
				};

				proto.positionSliderAtSelected = function () {
					if (!this.cells.length) {
						return;
					}
					this.x = -this.selectedSlide.target;
					this.velocity = 0; // stop wobble
					this.positionSlider();
				};

				proto.getPositionValue = function (position) {
					if (this.options.percentPosition) {
						// percent position, round to 2 digits, like 12.34%
						return (Math.round((position / this.size.innerWidth) * 10000) * 0.01) + '%';
					} else {
						// pixel positioning
						return Math.round(position) + 'px';
					}
				};

				proto.settle = function (previousX) {
					// keep track of frames where x hasn't moved
					if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
						this.restingFrames++;
					}
					// stop animating if resting for 3 or more frames
					if (this.restingFrames > 2) {
						this.isAnimating = false;
						delete this.isFreeScrolling;
						// render position with translateX when settled
						this.positionSlider();
						this.dispatchEvent('settle', null, [this.selectedIndex]);
					}
				};

				proto.shiftWrapCells = function (x) {
					// shift before cells
					var beforeGap = this.cursorPosition + x;
					this._shiftCells(this.beforeShiftCells, beforeGap, -1);
					// shift after cells
					var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
					this._shiftCells(this.afterShiftCells, afterGap, 1);
				};

				proto._shiftCells = function (cells, gap, shift) {
					for (var i = 0; i < cells.length; i++) {
						var cell = cells[i];
						var cellShift = gap > 0 ? shift : 0;
						cell.wrapShift(cellShift);
						gap -= cell.size.outerWidth;
					}
				};

				proto._unshiftCells = function (cells) {
					if (!cells || !cells.length) {
						return;
					}
					for (var i = 0; i < cells.length; i++) {
						cells[i].wrapShift(0);
					}
				};

				// -------------------------- physics -------------------------- //

				proto.integratePhysics = function () {
					this.x += this.velocity;
					this.velocity *= this.getFrictionFactor();
				};

				proto.applyForce = function (force) {
					this.velocity += force;
				};

				proto.getFrictionFactor = function () {
					return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
				};

				proto.getRestingPosition = function () {
					// my thanks to Steven Wittens, who simplified this math greatly
					return this.x + this.velocity / (1 - this.getFrictionFactor());
				};

				proto.applyDragForce = function () {
					if (!this.isDraggable || !this.isPointerDown) {
						return;
					}
					// change the position to drag position by applying force
					var dragVelocity = this.dragX - this.x;
					var dragForce = dragVelocity - this.velocity;
					this.applyForce(dragForce);
				};

				proto.applySelectedAttraction = function () {
					// do not attract if pointer down or no slides
					var dragDown = this.isDraggable && this.isPointerDown;
					if (dragDown || this.isFreeScrolling || !this.slides.length) {
						return;
					}
					var distance = this.selectedSlide.target * -1 - this.x;
					var force = distance * this.options.selectedAttraction;
					this.applyForce(force);
				};

				return proto;

			}));
		});

		var flickity = createCommonjsModule(function (module) {
			// Flickity main
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						evEmitter,
						getSize,
						utils,
						cell,
						slide,
						animate
					);
				} else {
					// browser global
					var _Flickity = window.Flickity;

					window.Flickity = factory(
						window,
						window.EvEmitter,
						window.getSize,
						window.fizzyUIUtils,
						_Flickity.Cell,
						_Flickity.Slide,
						_Flickity.animatePrototype
					);
				}

			}(window, function factory(window, EvEmitter, getSize,
				utils, Cell, Slide, animatePrototype) {

				// vars
				var jQuery = window.jQuery;
				var getComputedStyle = window.getComputedStyle;
				var console = window.console;

				function moveElements(elems, toElem) {
					elems = utils.makeArray(elems);
					while (elems.length) {
						toElem.appendChild(elems.shift());
					}
				}

				// -------------------------- Flickity -------------------------- //

				// globally unique identifiers
				var GUID = 0;
				// internal store of all Flickity intances
				var instances = {};

				function Flickity(element, options) {
					var queryElement = utils.getQueryElement(element);
					if (!queryElement) {
						if (console) {
							console.error('Bad element for Flickity: ' + (queryElement || element));
						}
						return;
					}
					this.element = queryElement;
					// do not initialize twice on same element
					if (this.element.flickityGUID) {
						var instance = instances[this.element.flickityGUID];
						instance.option(options);
						return instance;
					}

					// add jQuery
					if (jQuery) {
						this.$element = jQuery(this.element);
					}
					// options
					this.options = utils.extend({}, this.constructor.defaults);
					this.option(options);

					// kick things off
					this._create();
				}

				Flickity.defaults = {
					accessibility: true,
					// adaptiveHeight: false,
					cellAlign: 'center',
					// cellSelector: undefined,
					// contain: false,
					freeScrollFriction: 0.075, // friction when free-scrolling
					friction: 0.28, // friction when selecting
					namespaceJQueryEvents: true,
					// initialIndex: 0,
					percentPosition: true,
					resize: true,
					selectedAttraction: 0.025,
					setGallerySize: true
					// watchCSS: false,
					// wrapAround: false
				};

				// hash of methods triggered on _create()
				Flickity.createMethods = [];

				var proto = Flickity.prototype;
				// inherit EventEmitter
				utils.extend(proto, EvEmitter.prototype);

				proto._create = function () {
					// add id for Flickity.data
					var id = this.guid = ++GUID;
					this.element.flickityGUID = id; // expando
					instances[id] = this; // associate via id
					// initial properties
					this.selectedIndex = 0;
					// how many frames slider has been in same position
					this.restingFrames = 0;
					// initial physics properties
					this.x = 0;
					this.velocity = 0;
					this.originSide = this.options.rightToLeft ? 'right' : 'left';
					// create viewport & slider
					this.viewport = document.createElement('div');
					this.viewport.className = 'flickity-viewport';
					this._createSlider();

					if (this.options.resize || this.options.watchCSS) {
						window.addEventListener('resize', this);
					}

					// add listeners from on option
					for (var eventName in this.options.on) {
						var listener = this.options.on[eventName];
						this.on(eventName, listener);
					}

					Flickity.createMethods.forEach(function (method) {
						this[method]();
					}, this);

					if (this.options.watchCSS) {
						this.watchCSS();
					} else {
						this.activate();
					}

				};

				/**
				 * set options
				 * @param {Object} opts
				 */
				proto.option = function (opts) {
					utils.extend(this.options, opts);
				};

				proto.activate = function () {
					if (this.isActive) {
						return;
					}
					this.isActive = true;
					this.element.classList.add('flickity-enabled');
					if (this.options.rightToLeft) {
						this.element.classList.add('flickity-rtl');
					}

					this.getSize();
					// move initial cell elements so they can be loaded as cells
					var cellElems = this._filterFindCellElements(this.element.children);
					moveElements(cellElems, this.slider);
					this.viewport.appendChild(this.slider);
					this.element.appendChild(this.viewport);
					// get cells from children
					this.reloadCells();

					if (this.options.accessibility) {
						// allow element to focusable
						this.element.tabIndex = 0;
						// listen for key presses
						this.element.addEventListener('keydown', this);
					}

					this.emitEvent('activate');
					this.selectInitialIndex();
					// flag for initial activation, for using initialIndex
					this.isInitActivated = true;
					// ready event. #493
					this.dispatchEvent('ready');
				};

				// slider positions the cells
				proto._createSlider = function () {
					// slider element does all the positioning
					var slider = document.createElement('div');
					slider.className = 'flickity-slider';
					slider.style[this.originSide] = 0;
					this.slider = slider;
				};

				proto._filterFindCellElements = function (elems) {
					return utils.filterFindElements(elems, this.options.cellSelector);
				};

				// goes through all children
				proto.reloadCells = function () {
					// collection of item elements
					this.cells = this._makeCells(this.slider.children);
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
				};

				/**
				 * turn elements into Flickity.Cells
				 * @param {Array or NodeList or HTMLElement} elems
				 * @returns {Array} items - collection of new Flickity Cells
				 */
				proto._makeCells = function (elems) {
					var cellElems = this._filterFindCellElements(elems);

					// create new Flickity for collection
					var cells = cellElems.map(function (cellElem) {
						return new Cell(cellElem, this);
					}, this);

					return cells;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.getLastSlide = function () {
					return this.slides[this.slides.length - 1];
				};

				// positions all cells
				proto.positionCells = function () {
					// size all cells
					this._sizeCells(this.cells);
					// position all cells
					this._positionCells(0);
				};

				/**
				 * position certain cells
				 * @param {Integer} index - which cell to start with
				 */
				proto._positionCells = function (index) {
					index = index || 0;
					// also measure maxCellHeight
					// start 0 if positioning all cells
					this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
					var cellX = 0;
					// get cellX
					if (index > 0) {
						var startCell = this.cells[index - 1];
						cellX = startCell.x + startCell.size.outerWidth;
					}
					var len = this.cells.length;
					for (var i = index; i < len; i++) {
						var cell = this.cells[i];
						cell.setPosition(cellX);
						cellX += cell.size.outerWidth;
						this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
					}
					// keep track of cellX for wrap-around
					this.slideableWidth = cellX;
					// slides
					this.updateSlides();
					// contain slides target
					this._containSlides();
					// update slidesWidth
					this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
				};

				/**
				 * cell.getSize() on multiple cells
				 * @param {Array} cells
				 */
				proto._sizeCells = function (cells) {
					cells.forEach(function (cell) {
						cell.getSize();
					});
				};

				// --------------------------  -------------------------- //

				proto.updateSlides = function () {
					this.slides = [];
					if (!this.cells.length) {
						return;
					}

					var slide = new Slide(this);
					this.slides.push(slide);
					var isOriginLeft = this.originSide == 'left';
					var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

					var canCellFit = this._getCanCellFit();

					this.cells.forEach(function (cell, i) {
						// just add cell if first cell in slide
						if (!slide.cells.length) {
							slide.addCell(cell);
							return;
						}

						var slideWidth = (slide.outerWidth - slide.firstMargin) +
							(cell.size.outerWidth - cell.size[nextMargin]);

						if (canCellFit.call(this, i, slideWidth)) {
							slide.addCell(cell);
						} else {
							// doesn't fit, new slide
							slide.updateTarget();

							slide = new Slide(this);
							this.slides.push(slide);
							slide.addCell(cell);
						}
					}, this);
					// last slide
					slide.updateTarget();
					// update .selectedSlide
					this.updateSelectedSlide();
				};

				proto._getCanCellFit = function () {
					var groupCells = this.options.groupCells;
					if (!groupCells) {
						return function () {
							return false;
						};
					} else if (typeof groupCells == 'number') {
						// group by number. 3 -> [0,1,2], [3,4,5], ...
						var number = parseInt(groupCells, 10);
						return function (i) {
							return (i % number) !== 0;
						};
					}
					// default, group by width of slide
					// parse '75%
					var percentMatch = typeof groupCells == 'string' &&
						groupCells.match(/^(\d+)%$/);
					var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
					return function (i, slideWidth) {
						return slideWidth <= (this.size.innerWidth + 1) * percent;
					};
				};

				// alias _init for jQuery plugin .flickity()
				proto._init =
					proto.reposition = function () {
						this.positionCells();
						this.positionSliderAtSelected();
					};

				proto.getSize = function () {
					this.size = getSize(this.element);
					this.setCellAlign();
					this.cursorPosition = this.size.innerWidth * this.cellAlign;
				};

				var cellAlignShorthands = {
					// cell align, then based on origin side
					center: {
						left: 0.5,
						right: 0.5
					},
					left: {
						left: 0,
						right: 1
					},
					right: {
						right: 0,
						left: 1
					}
				};

				proto.setCellAlign = function () {
					var shorthand = cellAlignShorthands[this.options.cellAlign];
					this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
				};

				proto.setGallerySize = function () {
					if (this.options.setGallerySize) {
						var height = this.options.adaptiveHeight && this.selectedSlide ?
							this.selectedSlide.height : this.maxCellHeight;
						this.viewport.style.height = height + 'px';
					}
				};

				proto._getWrapShiftCells = function () {
					// only for wrap-around
					if (!this.options.wrapAround) {
						return;
					}
					// unshift previous cells
					this._unshiftCells(this.beforeShiftCells);
					this._unshiftCells(this.afterShiftCells);
					// get before cells
					// initial gap
					var gapX = this.cursorPosition;
					var cellIndex = this.cells.length - 1;
					this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
					// get after cells
					// ending gap between last cell and end of gallery viewport
					gapX = this.size.innerWidth - this.cursorPosition;
					// start cloning at first cell, working forwards
					this.afterShiftCells = this._getGapCells(gapX, 0, 1);
				};

				proto._getGapCells = function (gapX, cellIndex, increment) {
					// keep adding cells until the cover the initial gap
					var cells = [];
					while (gapX > 0) {
						var cell = this.cells[cellIndex];
						if (!cell) {
							break;
						}
						cells.push(cell);
						cellIndex += increment;
						gapX -= cell.size.outerWidth;
					}
					return cells;
				};

				// ----- contain ----- //

				// contain cell targets so no excess sliding
				proto._containSlides = function () {
					if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
						return;
					}
					var isRightToLeft = this.options.rightToLeft;
					var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
					var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
					var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
					// content is less than gallery size
					var isContentSmaller = contentWidth < this.size.innerWidth;
					// bounds
					var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
					var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
					// contain each cell target
					this.slides.forEach(function (slide) {
						if (isContentSmaller) {
							// all cells fit inside gallery
							slide.target = contentWidth * this.cellAlign;
						} else {
							// contain to bounds
							slide.target = Math.max(slide.target, beginBound);
							slide.target = Math.min(slide.target, endBound);
						}
					}, this);
				};

				// -----  ----- //

				/**
				 * emits events via eventEmitter and jQuery events
				 * @param {String} type - name of event
				 * @param {Event} event - original event
				 * @param {Array} args - extra arguments
				 */
				proto.dispatchEvent = function (type, event, args) {
					var emitArgs = event ? [event].concat(args) : args;
					this.emitEvent(type, emitArgs);

					if (jQuery && this.$element) {
						// default trigger with type if no event
						type += this.options.namespaceJQueryEvents ? '.flickity' : '';
						var $event = type;
						if (event) {
							// create jQuery event
							var jQEvent = jQuery.Event(event);
							jQEvent.type = type;
							$event = jQEvent;
						}
						this.$element.trigger($event, args);
					}
				};

				// -------------------------- select -------------------------- //

				/**
				 * @param {Integer} index - index of the slide
				 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
				 * @param {Boolean} isInstant - will immediately set position at selected cell
				 */
				proto.select = function (index, isWrap, isInstant) {
					if (!this.isActive) {
						return;
					}
					index = parseInt(index, 10);
					this._wrapSelect(index);

					if (this.options.wrapAround || isWrap) {
						index = utils.modulo(index, this.slides.length);
					}
					// bail if invalid index
					if (!this.slides[index]) {
						return;
					}
					var prevIndex = this.selectedIndex;
					this.selectedIndex = index;
					this.updateSelectedSlide();
					if (isInstant) {
						this.positionSliderAtSelected();
					} else {
						this.startAnimation();
					}
					if (this.options.adaptiveHeight) {
						this.setGallerySize();
					}
					// events
					this.dispatchEvent('select', null, [index]);
					// change event if new index
					if (index != prevIndex) {
						this.dispatchEvent('change', null, [index]);
					}
					// old v1 event name, remove in v3
					this.dispatchEvent('cellSelect');
				};

				// wraps position for wrapAround, to move to closest slide. #113
				proto._wrapSelect = function (index) {
					var len = this.slides.length;
					var isWrapping = this.options.wrapAround && len > 1;
					if (!isWrapping) {
						return index;
					}
					var wrapIndex = utils.modulo(index, len);
					// go to shortest
					var delta = Math.abs(wrapIndex - this.selectedIndex);
					var backWrapDelta = Math.abs((wrapIndex + len) - this.selectedIndex);
					var forewardWrapDelta = Math.abs((wrapIndex - len) - this.selectedIndex);
					if (!this.isDragSelect && backWrapDelta < delta) {
						index += len;
					} else if (!this.isDragSelect && forewardWrapDelta < delta) {
						index -= len;
					}
					// wrap position so slider is within normal area
					if (index < 0) {
						this.x -= this.slideableWidth;
					} else if (index >= len) {
						this.x += this.slideableWidth;
					}
				};

				proto.previous = function (isWrap, isInstant) {
					this.select(this.selectedIndex - 1, isWrap, isInstant);
				};

				proto.next = function (isWrap, isInstant) {
					this.select(this.selectedIndex + 1, isWrap, isInstant);
				};

				proto.updateSelectedSlide = function () {
					var slide = this.slides[this.selectedIndex];
					// selectedIndex could be outside of slides, if triggered before resize()
					if (!slide) {
						return;
					}
					// unselect previous selected slide
					this.unselectSelectedSlide();
					// update new selected slide
					this.selectedSlide = slide;
					slide.select();
					this.selectedCells = slide.cells;
					this.selectedElements = slide.getCellElements();
					// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
					// Remove in v3?
					this.selectedCell = slide.cells[0];
					this.selectedElement = this.selectedElements[0];
				};

				proto.unselectSelectedSlide = function () {
					if (this.selectedSlide) {
						this.selectedSlide.unselect();
					}
				};

				proto.selectInitialIndex = function () {
					var initialIndex = this.options.initialIndex;
					// already activated, select previous selectedIndex
					if (this.isInitActivated) {
						this.select(this.selectedIndex, false, true);
						return;
					}
					// select with selector string
					if (initialIndex && typeof initialIndex == 'string') {
						var cell = this.queryCell(initialIndex);
						if (cell) {
							this.selectCell(initialIndex, false, true);
							return;
						}
					}

					var index = 0;
					// select with number
					if (initialIndex && this.slides[initialIndex]) {
						index = initialIndex;
					}
					// select instantly
					this.select(index, false, true);
				};

				/**
				 * select slide from number or cell element
				 * @param {Element or Number} elem
				 */
				proto.selectCell = function (value, isWrap, isInstant) {
					// get cell
					var cell = this.queryCell(value);
					if (!cell) {
						return;
					}

					var index = this.getCellSlideIndex(cell);
					this.select(index, isWrap, isInstant);
				};

				proto.getCellSlideIndex = function (cell) {
					// get index of slides that has cell
					for (var i = 0; i < this.slides.length; i++) {
						var slide = this.slides[i];
						var index = slide.cells.indexOf(cell);
						if (index != -1) {
							return i;
						}
					}
				};

				// -------------------------- get cells -------------------------- //

				/**
				 * get Flickity.Cell, given an Element
				 * @param {Element} elem
				 * @returns {Flickity.Cell} item
				 */
				proto.getCell = function (elem) {
					// loop through cells to get the one that matches
					for (var i = 0; i < this.cells.length; i++) {
						var cell = this.cells[i];
						if (cell.element == elem) {
							return cell;
						}
					}
				};

				/**
				 * get collection of Flickity.Cells, given Elements
				 * @param {Element, Array, NodeList} elems
				 * @returns {Array} cells - Flickity.Cells
				 */
				proto.getCells = function (elems) {
					elems = utils.makeArray(elems);
					var cells = [];
					elems.forEach(function (elem) {
						var cell = this.getCell(elem);
						if (cell) {
							cells.push(cell);
						}
					}, this);
					return cells;
				};

				/**
				 * get cell elements
				 * @returns {Array} cellElems
				 */
				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				/**
				 * get parent cell from an element
				 * @param {Element} elem
				 * @returns {Flickit.Cell} cell
				 */
				proto.getParentCell = function (elem) {
					// first check if elem is cell
					var cell = this.getCell(elem);
					if (cell) {
						return cell;
					}
					// try to get parent cell elem
					elem = utils.getParent(elem, '.flickity-slider > *');
					return this.getCell(elem);
				};

				/**
				 * get cells adjacent to a slide
				 * @param {Integer} adjCount - number of adjacent slides
				 * @param {Integer} index - index of slide to start
				 * @returns {Array} cells - array of Flickity.Cells
				 */
				proto.getAdjacentCellElements = function (adjCount, index) {
					if (!adjCount) {
						return this.selectedSlide.getCellElements();
					}
					index = index === undefined ? this.selectedIndex : index;

					var len = this.slides.length;
					if (1 + (adjCount * 2) >= len) {
						return this.getCellElements();
					}

					var cellElems = [];
					for (var i = index - adjCount; i <= index + adjCount; i++) {
						var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
						var slide = this.slides[slideIndex];
						if (slide) {
							cellElems = cellElems.concat(slide.getCellElements());
						}
					}
					return cellElems;
				};

				/**
				 * select slide from number or cell element
				 * @param {Element, Selector String, or Number} selector
				 */
				proto.queryCell = function (selector) {
					if (typeof selector == 'number') {
						// use number as index
						return this.cells[selector];
					}
					if (typeof selector == 'string') {
						// do not select invalid selectors from hash: #123, #/. #791
						if (selector.match(/^[#\.]?[\d\/]/)) {
							return;
						}
						// use string as selector, get element
						selector = this.element.querySelector(selector);
					}
					// get cell from element
					return this.getCell(selector);
				};

				// -------------------------- events -------------------------- //

				proto.uiChange = function () {
					this.emitEvent('uiChange');
				};

				// keep focus on element when child UI elements are clicked
				proto.childUIPointerDown = function (event) {
					// HACK iOS does not allow touch events to bubble up?!
					if (event.type != 'touchstart') {
						event.preventDefault();
					}
					this.focus();
				};

				// ----- resize ----- //

				proto.onresize = function () {
					this.watchCSS();
					this.resize();
				};

				utils.debounceMethod(Flickity, 'onresize', 150);

				proto.resize = function () {
					if (!this.isActive) {
						return;
					}
					this.getSize();
					// wrap values
					if (this.options.wrapAround) {
						this.x = utils.modulo(this.x, this.slideableWidth);
					}
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
					this.emitEvent('resize');
					// update selected index for group slides, instant
					// TODO: position can be lost between groups of various numbers
					var selectedElement = this.selectedElements && this.selectedElements[0];
					this.selectCell(selectedElement, false, true);
				};

				// watches the :after property, activates/deactivates
				proto.watchCSS = function () {
					var watchOption = this.options.watchCSS;
					if (!watchOption) {
						return;
					}

					var afterContent = getComputedStyle(this.element, ':after').content;
					// activate if :after { content: 'flickity' }
					if (afterContent.indexOf('flickity') != -1) {
						this.activate();
					} else {
						this.deactivate();
					}
				};

				// ----- keydown ----- //

				// go previous/next if left/right keys pressed
				proto.onkeydown = function (event) {
					// only work if element is in focus
					var isNotFocused = document.activeElement && document.activeElement != this.element;
					if (!this.options.accessibility || isNotFocused) {
						return;
					}

					var handler = Flickity.keyboardHandlers[event.keyCode];
					if (handler) {
						handler.call(this);
					}
				};

				Flickity.keyboardHandlers = {
					// left arrow
					37: function () {
						var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
						this.uiChange();
						this[leftMethod]();
					},
					// right arrow
					39: function () {
						var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
						this.uiChange();
						this[rightMethod]();
					},
				};

				// ----- focus ----- //

				proto.focus = function () {
					// TODO remove scrollTo once focus options gets more support
					// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
					var prevScrollY = window.pageYOffset;
					this.element.focus({ preventScroll: true });
					// hack to fix scroll jump after focus, #76
					if (window.pageYOffset != prevScrollY) {
						window.scrollTo(window.pageXOffset, prevScrollY);
					}
				};

				// -------------------------- destroy -------------------------- //

				// deactivate all Flickity functionality, but keep stuff available
				proto.deactivate = function () {
					if (!this.isActive) {
						return;
					}
					this.element.classList.remove('flickity-enabled');
					this.element.classList.remove('flickity-rtl');
					this.unselectSelectedSlide();
					// destroy cells
					this.cells.forEach(function (cell) {
						cell.destroy();
					});
					this.element.removeChild(this.viewport);
					// move child elements back into element
					moveElements(this.slider.children, this.element);
					if (this.options.accessibility) {
						this.element.removeAttribute('tabIndex');
						this.element.removeEventListener('keydown', this);
					}
					// set flags
					this.isActive = false;
					this.emitEvent('deactivate');
				};

				proto.destroy = function () {
					this.deactivate();
					window.removeEventListener('resize', this);
					this.allOff();
					this.emitEvent('destroy');
					if (jQuery && this.$element) {
						jQuery.removeData(this.element, 'flickity');
					}
					delete this.element.flickityGUID;
					delete instances[this.guid];
				};

				// -------------------------- prototype -------------------------- //

				utils.extend(proto, animatePrototype);

				// -------------------------- extras -------------------------- //

				/**
				 * get Flickity instance from element
				 * @param {Element} elem
				 * @returns {Flickity}
				 */
				Flickity.data = function (elem) {
					elem = utils.getQueryElement(elem);
					var id = elem && elem.flickityGUID;
					return id && instances[id];
				};

				utils.htmlInit(Flickity, 'flickity');

				if (jQuery && jQuery.bridget) {
					jQuery.bridget('flickity', Flickity);
				}

				// set internal jQuery, for Webpack + jQuery v3, #478
				Flickity.setJQuery = function (jq) {
					jQuery = jq;
				};

				Flickity.Cell = Cell;
				Flickity.Slide = Slide;

				return Flickity;

			}));
		});

		var unipointer = createCommonjsModule(function (module) {
			/*!
			 * Unipointer v2.3.0
			 * base class for doing one thing with pointer event
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */ /*global define, module, require */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						evEmitter
					);
				} else {
					// browser global
					window.Unipointer = factory(
						window,
						window.EvEmitter
					);
				}

			}(window, function factory(window, EvEmitter) {

				function noop() { }

				function Unipointer() { }

				// inherit EvEmitter
				var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);

				proto.bindStartEvent = function (elem) {
					this._bindStartEvent(elem, true);
				};

				proto.unbindStartEvent = function (elem) {
					this._bindStartEvent(elem, false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd - remove if falsey
				 */
				proto._bindStartEvent = function (elem, isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

					// default to mouse events
					var startEvent = 'mousedown';
					if (window.PointerEvent) {
						// Pointer Events
						startEvent = 'pointerdown';
					} else if ('ontouchstart' in window) {
						// Touch Events. iOS Safari
						startEvent = 'touchstart';
					}
					elem[bindMethod](startEvent, this);
				};

				// trigger handler methods for events
				proto.handleEvent = function (event) {
					var method = 'on' + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// returns the touch that we're keeping track of
				proto.getTouch = function (touches) {
					for (var i = 0; i < touches.length; i++) {
						var touch = touches[i];
						if (touch.identifier == this.pointerIdentifier) {
							return touch;
						}
					}
				};

				// ----- start event ----- //

				proto.onmousedown = function (event) {
					// dismiss clicks from right or middle buttons
					var button = event.button;
					if (button && (button !== 0 && button !== 1)) {
						return;
					}
					this._pointerDown(event, event);
				};

				proto.ontouchstart = function (event) {
					this._pointerDown(event, event.changedTouches[0]);
				};

				proto.onpointerdown = function (event) {
					this._pointerDown(event, event);
				};

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto._pointerDown = function (event, pointer) {
					// dismiss right click and other pointers
					// button = 0 is okay, 1-4 not
					if (event.button || this.isPointerDown) {
						return;
					}

					this.isPointerDown = true;
					// save pointer identifier to match up touch events
					this.pointerIdentifier = pointer.pointerId !== undefined ?
						// pointerId for pointer events, touch.indentifier for touch events
						pointer.pointerId : pointer.identifier;

					this.pointerDown(event, pointer);
				};

				proto.pointerDown = function (event, pointer) {
					this._bindPostStartEvents(event);
					this.emitEvent('pointerDown', [event, pointer]);
				};

				// hash of events to be bound after start event
				var postStartEvents = {
					mousedown: ['mousemove', 'mouseup'],
					touchstart: ['touchmove', 'touchend', 'touchcancel'],
					pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
				};

				proto._bindPostStartEvents = function (event) {
					if (!event) {
						return;
					}
					// get proper events to match start event
					var events = postStartEvents[event.type];
					// bind events to node
					events.forEach(function (eventName) {
						window.addEventListener(eventName, this);
					}, this);
					// save these arguments
					this._boundPointerEvents = events;
				};

				proto._unbindPostStartEvents = function () {
					// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
					if (!this._boundPointerEvents) {
						return;
					}
					this._boundPointerEvents.forEach(function (eventName) {
						window.removeEventListener(eventName, this);
					}, this);

					delete this._boundPointerEvents;
				};

				// ----- move event ----- //

				proto.onmousemove = function (event) {
					this._pointerMove(event, event);
				};

				proto.onpointermove = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerMove(event, event);
					}
				};

				proto.ontouchmove = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerMove(event, touch);
					}
				};

				/**
				 * pointer move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerMove = function (event, pointer) {
					this.pointerMove(event, pointer);
				};

				// public
				proto.pointerMove = function (event, pointer) {
					this.emitEvent('pointerMove', [event, pointer]);
				};

				// ----- end event ----- //


				proto.onmouseup = function (event) {
					this._pointerUp(event, event);
				};

				proto.onpointerup = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerUp(event, event);
					}
				};

				proto.ontouchend = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerUp(event, touch);
					}
				};

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerUp = function (event, pointer) {
					this._pointerDone();
					this.pointerUp(event, pointer);
				};

				// public
				proto.pointerUp = function (event, pointer) {
					this.emitEvent('pointerUp', [event, pointer]);
				};

				// ----- pointer done ----- //

				// triggered on pointer up & pointer cancel
				proto._pointerDone = function () {
					this._pointerReset();
					this._unbindPostStartEvents();
					this.pointerDone();
				};

				proto._pointerReset = function () {
					// reset properties
					this.isPointerDown = false;
					delete this.pointerIdentifier;
				};

				proto.pointerDone = noop;

				// ----- pointer cancel ----- //

				proto.onpointercancel = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerCancel(event, event);
					}
				};

				proto.ontouchcancel = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerCancel(event, touch);
					}
				};

				/**
				 * pointer cancel
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerCancel = function (event, pointer) {
					this._pointerDone();
					this.pointerCancel(event, pointer);
				};

				// public
				proto.pointerCancel = function (event, pointer) {
					this.emitEvent('pointerCancel', [event, pointer]);
				};

				// -----  ----- //

				// utility function for getting x/y coords from event
				Unipointer.getPointerPoint = function (pointer) {
					return {
						x: pointer.pageX,
						y: pointer.pageY
					};
				};

				// -----  ----- //

				return Unipointer;

			}));
		});

		var unidragger = createCommonjsModule(function (module) {
			/*!
			 * Unidragger v2.3.0
			 * Draggable base class
			 * MIT license
			 */

			/*jshint browser: true, unused: true, undef: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						unipointer
					);
				} else {
					// browser global
					window.Unidragger = factory(
						window,
						window.Unipointer
					);
				}

			}(window, function factory(window, Unipointer) {

				// -------------------------- Unidragger -------------------------- //

				function Unidragger() { }

				// inherit Unipointer & EvEmitter
				var proto = Unidragger.prototype = Object.create(Unipointer.prototype);

				// ----- bind start ----- //

				proto.bindHandles = function () {
					this._bindHandles(true);
				};

				proto.unbindHandles = function () {
					this._bindHandles(false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd
				 */
				proto._bindHandles = function (isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					// bind each handle
					var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
					var touchAction = isAdd ? this._touchActionValue : '';
					for (var i = 0; i < this.handles.length; i++) {
						var handle = this.handles[i];
						this._bindStartEvent(handle, isAdd);
						handle[bindMethod]('click', this);
						// touch-action: none to override browser touch gestures. metafizzy/flickity#540
						if (window.PointerEvent) {
							handle.style.touchAction = touchAction;
						}
					}
				};

				// prototype so it can be overwriteable by Flickity
				proto._touchActionValue = 'none';

				// ----- start event ----- //

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerDown = function (event, pointer) {
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}
					// track start event position
					this.pointerDownPointer = pointer;

					event.preventDefault();
					this.pointerDownBlur();
					// bind move and end events
					this._bindPostStartEvents(event);
					this.emitEvent('pointerDown', [event, pointer]);
				};

				// nodes that have text fields
				var cursorNodes = {
					TEXTAREA: true,
					INPUT: true,
					SELECT: true,
					OPTION: true,
				};

				// input types that do not have text fields
				var clickTypes = {
					radio: true,
					checkbox: true,
					button: true,
					submit: true,
					image: true,
					file: true,
				};

				// dismiss inputs with text fields. flickity#403, flickity#404
				proto.okayPointerDown = function (event) {
					var isCursorNode = cursorNodes[event.target.nodeName];
					var isClickType = clickTypes[event.target.type];
					var isOkay = !isCursorNode || isClickType;
					if (!isOkay) {
						this._pointerReset();
					}
					return isOkay;
				};

				// kludge to blur previously focused input
				proto.pointerDownBlur = function () {
					var focused = document.activeElement;
					// do not blur body for IE10, metafizzy/flickity#117
					var canBlur = focused && focused.blur && focused != document.body;
					if (canBlur) {
						focused.blur();
					}
				};

				// ----- move event ----- //

				/**
				 * drag move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.emitEvent('pointerMove', [event, pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				// base pointer move logic
				proto._dragPointerMove = function (event, pointer) {
					var moveVector = {
						x: pointer.pageX - this.pointerDownPointer.pageX,
						y: pointer.pageY - this.pointerDownPointer.pageY
					};
					// start drag if pointer has moved far enough to start drag
					if (!this.isDragging && this.hasDragStarted(moveVector)) {
						this._dragStart(event, pointer);
					}
					return moveVector;
				};

				// condition if pointer has moved far enough to start drag
				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
				};

				// ----- end event ----- //

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerUp = function (event, pointer) {
					this.emitEvent('pointerUp', [event, pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto._dragPointerUp = function (event, pointer) {
					if (this.isDragging) {
						this._dragEnd(event, pointer);
					} else {
						// pointer didn't move enough for drag to start
						this._staticClick(event, pointer);
					}
				};

				// -------------------------- drag -------------------------- //

				// dragStart
				proto._dragStart = function (event, pointer) {
					this.isDragging = true;
					// prevent clicks
					this.isPreventingClicks = true;
					this.dragStart(event, pointer);
				};

				proto.dragStart = function (event, pointer) {
					this.emitEvent('dragStart', [event, pointer]);
				};

				// dragMove
				proto._dragMove = function (event, pointer, moveVector) {
					// do not drag if not dragging yet
					if (!this.isDragging) {
						return;
					}

					this.dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					event.preventDefault();
					this.emitEvent('dragMove', [event, pointer, moveVector]);
				};

				// dragEnd
				proto._dragEnd = function (event, pointer) {
					// set flags
					this.isDragging = false;
					// re-enable clicking async
					setTimeout(function () {
						delete this.isPreventingClicks;
					}.bind(this));

					this.dragEnd(event, pointer);
				};

				proto.dragEnd = function (event, pointer) {
					this.emitEvent('dragEnd', [event, pointer]);
				};

				// ----- onclick ----- //

				// handle all clicks and prevent clicks when dragging
				proto.onclick = function (event) {
					if (this.isPreventingClicks) {
						event.preventDefault();
					}
				};

				// ----- staticClick ----- //

				// triggered after pointer down & up with no/tiny movement
				proto._staticClick = function (event, pointer) {
					// ignore emulated mouse up clicks
					if (this.isIgnoringMouseUp && event.type == 'mouseup') {
						return;
					}

					this.staticClick(event, pointer);

					// set flag for emulated clicks 300ms after touchend
					if (event.type != 'mouseup') {
						this.isIgnoringMouseUp = true;
						// reset flag after 300ms
						setTimeout(function () {
							delete this.isIgnoringMouseUp;
						}.bind(this), 400);
					}
				};

				proto.staticClick = function (event, pointer) {
					this.emitEvent('staticClick', [event, pointer]);
				};

				// ----- utils ----- //

				Unidragger.getPointerPoint = Unipointer.getPointerPoint;

				// -----  ----- //

				return Unidragger;

			}));
		});

		var drag = createCommonjsModule(function (module) {
			// drag
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						flickity,
						unidragger,
						utils
					);
				} else {
					// browser global
					window.Flickity = factory(
						window,
						window.Flickity,
						window.Unidragger,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unidragger, utils) {

				// ----- defaults ----- //

				utils.extend(Flickity.defaults, {
					draggable: '>1',
					dragThreshold: 3,
				});

				// ----- create ----- //

				Flickity.createMethods.push('_createDrag');

				// -------------------------- drag prototype -------------------------- //

				var proto = Flickity.prototype;
				utils.extend(proto, Unidragger.prototype);
				proto._touchActionValue = 'pan-y';

				// --------------------------  -------------------------- //

				var isTouch = 'createTouch' in document;
				var isTouchmoveScrollCanceled = false;

				proto._createDrag = function () {
					this.on('activate', this.onActivateDrag);
					this.on('uiChange', this._uiChangeDrag);
					this.on('deactivate', this.onDeactivateDrag);
					this.on('cellChange', this.updateDraggable);
					// TODO updateDraggable on resize? if groupCells & slides change
					// HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
					// #457, RubaXa/Sortable#973
					if (isTouch && !isTouchmoveScrollCanceled) {
						window.addEventListener('touchmove', function () { });
						isTouchmoveScrollCanceled = true;
					}
				};

				proto.onActivateDrag = function () {
					this.handles = [this.viewport];
					this.bindHandles();
					this.updateDraggable();
				};

				proto.onDeactivateDrag = function () {
					this.unbindHandles();
					this.element.classList.remove('is-draggable');
				};

				proto.updateDraggable = function () {
					// disable dragging if less than 2 slides. #278
					if (this.options.draggable == '>1') {
						this.isDraggable = this.slides.length > 1;
					} else {
						this.isDraggable = this.options.draggable;
					}
					if (this.isDraggable) {
						this.element.classList.add('is-draggable');
					} else {
						this.element.classList.remove('is-draggable');
					}
				};

				// backwards compatibility
				proto.bindDrag = function () {
					this.options.draggable = true;
					this.updateDraggable();
				};

				proto.unbindDrag = function () {
					this.options.draggable = false;
					this.updateDraggable();
				};

				proto._uiChangeDrag = function () {
					delete this.isFreeScrolling;
				};

				// -------------------------- pointer events -------------------------- //

				proto.pointerDown = function (event, pointer) {
					if (!this.isDraggable) {
						this._pointerDownDefault(event, pointer);
						return;
					}
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}

					this._pointerDownPreventDefault(event);
					this.pointerDownFocus(event);
					// blur
					if (document.activeElement != this.element) {
						// do not blur if already focused
						this.pointerDownBlur();
					}

					// stop if it was moving
					this.dragX = this.x;
					this.viewport.classList.add('is-pointer-down');
					// track scrolling
					this.pointerDownScroll = getScrollPosition();
					window.addEventListener('scroll', this);

					this._pointerDownDefault(event, pointer);
				};

				// default pointerDown logic, used for staticClick
				proto._pointerDownDefault = function (event, pointer) {
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};
					// bind move and end events
					this._bindPostStartEvents(event);
					this.dispatchEvent('pointerDown', event, [pointer]);
				};

				var focusNodes = {
					INPUT: true,
					TEXTAREA: true,
					SELECT: true,
				};

				proto.pointerDownFocus = function (event) {
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isFocusNode) {
						this.focus();
					}
				};

				proto._pointerDownPreventDefault = function (event) {
					var isTouchStart = event.type == 'touchstart';
					var isTouchPointer = event.pointerType == 'touch';
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isTouchStart && !isTouchPointer && !isFocusNode) {
						event.preventDefault();
					}
				};

				// ----- move ----- //

				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > this.options.dragThreshold;
				};

				// ----- up ----- //

				proto.pointerUp = function (event, pointer) {
					delete this.isTouchScrolling;
					this.viewport.classList.remove('is-pointer-down');
					this.dispatchEvent('pointerUp', event, [pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto.pointerDone = function () {
					window.removeEventListener('scroll', this);
					delete this.pointerDownScroll;
				};

				// -------------------------- dragging -------------------------- //

				proto.dragStart = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					this.dragStartPosition = this.x;
					this.startAnimation();
					window.removeEventListener('scroll', this);
					this.dispatchEvent('dragStart', event, [pointer]);
				};

				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					if (!this.isDraggable) {
						return;
					}
					event.preventDefault();

					this.previousDragX = this.dragX;
					// reverse if right-to-left
					var direction = this.options.rightToLeft ? -1 : 1;
					if (this.options.wrapAround) {
						// wrap around move. #589
						moveVector.x = moveVector.x % this.slideableWidth;
					}
					var dragX = this.dragStartPosition + moveVector.x * direction;

					if (!this.options.wrapAround && this.slides.length) {
						// slow drag
						var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
						dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
						var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
						dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
					}

					this.dragX = dragX;

					this.dragMoveTime = new Date();
					this.dispatchEvent('dragMove', event, [pointer, moveVector]);
				};

				proto.dragEnd = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					if (this.options.freeScroll) {
						this.isFreeScrolling = true;
					}
					// set selectedIndex based on where flick will end up
					var index = this.dragEndRestingSelect();

					if (this.options.freeScroll && !this.options.wrapAround) {
						// if free-scroll & not wrap around
						// do not free-scroll if going outside of bounding slides
						// so bounding slides can attract slider, and keep it in bounds
						var restingX = this.getRestingPosition();
						this.isFreeScrolling = -restingX > this.slides[0].target &&
							-restingX < this.getLastSlide().target;
					} else if (!this.options.freeScroll && index == this.selectedIndex) {
						// boost selection if selected index has not changed
						index += this.dragEndBoostSelect();
					}
					delete this.previousDragX;
					// apply selection
					// TODO refactor this, selecting here feels weird
					// HACK, set flag so dragging stays in correct direction
					this.isDragSelect = this.options.wrapAround;
					this.select(index);
					delete this.isDragSelect;
					this.dispatchEvent('dragEnd', event, [pointer]);
				};

				proto.dragEndRestingSelect = function () {
					var restingX = this.getRestingPosition();
					// how far away from selected slide
					var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
					// get closet resting going up and going down
					var positiveResting = this._getClosestResting(restingX, distance, 1);
					var negativeResting = this._getClosestResting(restingX, distance, -1);
					// use closer resting for wrap-around
					var index = positiveResting.distance < negativeResting.distance ?
						positiveResting.index : negativeResting.index;
					return index;
				};

				/**
				 * given resting X and distance to selected cell
				 * get the distance and index of the closest cell
				 * @param {Number} restingX - estimated post-flick resting position
				 * @param {Number} distance - distance to selected cell
				 * @param {Integer} increment - +1 or -1, going up or down
				 * @returns {Object} - { distance: {Number}, index: {Integer} }
				 */
				proto._getClosestResting = function (restingX, distance, increment) {
					var index = this.selectedIndex;
					var minDistance = Infinity;
					var condition = this.options.contain && !this.options.wrapAround ?
						// if contain, keep going if distance is equal to minDistance
						function (d, md) { return d <= md; } : function (d, md) { return d < md; };
					while (condition(distance, minDistance)) {
						// measure distance to next cell
						index += increment;
						minDistance = distance;
						distance = this.getSlideDistance(-restingX, index);
						if (distance === null) {
							break;
						}
						distance = Math.abs(distance);
					}
					return {
						distance: minDistance,
						// selected was previous index
						index: index - increment
					};
				};

				/**
				 * measure distance between x and a slide target
				 * @param {Number} x
				 * @param {Integer} index - slide index
				 */
				proto.getSlideDistance = function (x, index) {
					var len = this.slides.length;
					// wrap around if at least 2 slides
					var isWrapAround = this.options.wrapAround && len > 1;
					var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
					var slide = this.slides[slideIndex];
					if (!slide) {
						return null;
					}
					// add distance for wrap-around slides
					var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
					return x - (slide.target + wrap);
				};

				proto.dragEndBoostSelect = function () {
					// do not boost if no previousDragX or dragMoveTime
					if (this.previousDragX === undefined || !this.dragMoveTime ||
						// or if drag was held for 100 ms
						new Date() - this.dragMoveTime > 100) {
						return 0;
					}

					var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
					var delta = this.previousDragX - this.dragX;
					if (distance > 0 && delta > 0) {
						// boost to next if moving towards the right, and positive velocity
						return 1;
					} else if (distance < 0 && delta < 0) {
						// boost to previous if moving towards the left, and negative velocity
						return -1;
					}
					return 0;
				};

				// ----- staticClick ----- //

				proto.staticClick = function (event, pointer) {
					// get clickedCell, if cell was clicked
					var clickedCell = this.getParentCell(event.target);
					var cellElem = clickedCell && clickedCell.element;
					var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
					this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
				};

				// ----- scroll ----- //

				proto.onscroll = function () {
					var scroll = getScrollPosition();
					var scrollMoveX = this.pointerDownScroll.x - scroll.x;
					var scrollMoveY = this.pointerDownScroll.y - scroll.y;
					// cancel click/tap if scroll is too much
					if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
						this._pointerDone();
					}
				};

				// ----- utils ----- //

				function getScrollPosition() {
					return {
						x: window.pageXOffset,
						y: window.pageYOffset
					};
				}

				// -----  ----- //

				return Flickity;

			}));
		});

		var prevNextButton = createCommonjsModule(function (module) {
			// prev/next buttons
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						flickity,
						unipointer,
						utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unipointer, utils) {

				var svgURI = 'http://www.w3.org/2000/svg';

				// -------------------------- PrevNextButton -------------------------- //

				function PrevNextButton(direction, parent) {
					this.direction = direction;
					this.parent = parent;
					this._create();
				}

				PrevNextButton.prototype = Object.create(Unipointer.prototype);

				PrevNextButton.prototype._create = function () {
					// properties
					this.isEnabled = true;
					this.isPrevious = this.direction == -1;
					var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
					this.isLeft = this.direction == leftDirection;

					var element = this.element = document.createElement('button');
					element.className = 'flickity-button flickity-prev-next-button';
					element.className += this.isPrevious ? ' previous' : ' next';
					// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
					element.setAttribute('type', 'button');
					// init as disabled
					this.disable();

					element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

					// create arrow
					var svg = this.createSVG();
					element.appendChild(svg);
					// events
					this.parent.on('select', this.update.bind(this));
					this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
				};

				PrevNextButton.prototype.activate = function () {
					this.bindStartEvent(this.element);
					this.element.addEventListener('click', this);
					// add to DOM
					this.parent.element.appendChild(this.element);
				};

				PrevNextButton.prototype.deactivate = function () {
					// remove from DOM
					this.parent.element.removeChild(this.element);
					// click events
					this.unbindStartEvent(this.element);
					this.element.removeEventListener('click', this);
				};

				PrevNextButton.prototype.createSVG = function () {
					var svg = document.createElementNS(svgURI, 'svg');
					svg.setAttribute('class', 'flickity-button-icon');
					svg.setAttribute('viewBox', '0 0 100 100');
					var path = document.createElementNS(svgURI, 'path');
					var pathMovements = getArrowMovements(this.parent.options.arrowShape);
					path.setAttribute('d', pathMovements);
					path.setAttribute('class', 'arrow');
					// rotate arrow
					if (!this.isLeft) {
						path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
					}
					svg.appendChild(path);
					return svg;
				};

				// get SVG path movmement
				function getArrowMovements(shape) {
					// use shape as movement if string
					if (typeof shape == 'string') {
						return shape;
					}
					// create movement string
					return 'M ' + shape.x0 + ',50' +
						' L ' + shape.x1 + ',' + (shape.y1 + 50) +
						' L ' + shape.x2 + ',' + (shape.y2 + 50) +
						' L ' + shape.x3 + ',50 ' +
						' L ' + shape.x2 + ',' + (50 - shape.y2) +
						' L ' + shape.x1 + ',' + (50 - shape.y1) +
						' Z';
				}

				PrevNextButton.prototype.handleEvent = utils.handleEvent;

				PrevNextButton.prototype.onclick = function () {
					if (!this.isEnabled) {
						return;
					}
					this.parent.uiChange();
					var method = this.isPrevious ? 'previous' : 'next';
					this.parent[method]();
				};

				// -----  ----- //

				PrevNextButton.prototype.enable = function () {
					if (this.isEnabled) {
						return;
					}
					this.element.disabled = false;
					this.isEnabled = true;
				};

				PrevNextButton.prototype.disable = function () {
					if (!this.isEnabled) {
						return;
					}
					this.element.disabled = true;
					this.isEnabled = false;
				};

				PrevNextButton.prototype.update = function () {
					// index of first or last slide, if previous or next
					var slides = this.parent.slides;
					// enable is wrapAround and at least 2 slides
					if (this.parent.options.wrapAround && slides.length > 1) {
						this.enable();
						return;
					}
					var lastIndex = slides.length ? slides.length - 1 : 0;
					var boundIndex = this.isPrevious ? 0 : lastIndex;
					var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
					this[method]();
				};

				PrevNextButton.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				// -------------------------- Flickity prototype -------------------------- //

				utils.extend(Flickity.defaults, {
					prevNextButtons: true,
					arrowShape: {
						x0: 10,
						x1: 60, y1: 50,
						x2: 70, y2: 40,
						x3: 30
					}
				});

				Flickity.createMethods.push('_createPrevNextButtons');
				var proto = Flickity.prototype;

				proto._createPrevNextButtons = function () {
					if (!this.options.prevNextButtons) {
						return;
					}

					this.prevButton = new PrevNextButton(-1, this);
					this.nextButton = new PrevNextButton(1, this);

					this.on('activate', this.activatePrevNextButtons);
				};

				proto.activatePrevNextButtons = function () {
					this.prevButton.activate();
					this.nextButton.activate();
					this.on('deactivate', this.deactivatePrevNextButtons);
				};

				proto.deactivatePrevNextButtons = function () {
					this.prevButton.deactivate();
					this.nextButton.deactivate();
					this.off('deactivate', this.deactivatePrevNextButtons);
				};

				// --------------------------  -------------------------- //

				Flickity.PrevNextButton = PrevNextButton;

				return Flickity;

			}));
		});

		var pageDots = createCommonjsModule(function (module) {
			// page dots
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						flickity,
						unipointer,
						utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unipointer, utils) {

				function PageDots(parent) {
					this.parent = parent;
					this._create();
				}

				PageDots.prototype = Object.create(Unipointer.prototype);

				PageDots.prototype._create = function () {
					// create holder element
					this.holder = document.createElement('ol');
					this.holder.className = 'flickity-page-dots';
					// create dots, array of elements
					this.dots = [];
					// events
					this.handleClick = this.onClick.bind(this);
					this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
				};

				PageDots.prototype.activate = function () {
					this.setDots();
					this.holder.addEventListener('click', this.handleClick);
					this.bindStartEvent(this.holder);
					// add to DOM
					this.parent.element.appendChild(this.holder);
				};

				PageDots.prototype.deactivate = function () {
					this.holder.removeEventListener('click', this.handleClick);
					this.unbindStartEvent(this.holder);
					// remove from DOM
					this.parent.element.removeChild(this.holder);
				};

				PageDots.prototype.setDots = function () {
					// get difference between number of slides and number of dots
					var delta = this.parent.slides.length - this.dots.length;
					if (delta > 0) {
						this.addDots(delta);
					} else if (delta < 0) {
						this.removeDots(-delta);
					}
				};

				PageDots.prototype.addDots = function (count) {
					var fragment = document.createDocumentFragment();
					var newDots = [];
					var length = this.dots.length;
					var max = length + count;

					for (var i = length; i < max; i++) {
						var dot = document.createElement('li');
						dot.className = 'dot';
						dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
						fragment.appendChild(dot);
						newDots.push(dot);
					}

					this.holder.appendChild(fragment);
					this.dots = this.dots.concat(newDots);
				};

				PageDots.prototype.removeDots = function (count) {
					// remove from this.dots collection
					var removeDots = this.dots.splice(this.dots.length - count, count);
					// remove from DOM
					removeDots.forEach(function (dot) {
						this.holder.removeChild(dot);
					}, this);
				};

				PageDots.prototype.updateSelected = function () {
					// remove selected class on previous
					if (this.selectedDot) {
						this.selectedDot.className = 'dot';
						this.selectedDot.removeAttribute('aria-current');
					}
					// don't proceed if no dots
					if (!this.dots.length) {
						return;
					}
					this.selectedDot = this.dots[this.parent.selectedIndex];
					this.selectedDot.className = 'dot is-selected';
					this.selectedDot.setAttribute('aria-current', 'step');
				};

				PageDots.prototype.onTap = // old method name, backwards-compatible
					PageDots.prototype.onClick = function (event) {
						var target = event.target;
						// only care about dot clicks
						if (target.nodeName != 'LI') {
							return;
						}

						this.parent.uiChange();
						var index = this.dots.indexOf(target);
						this.parent.select(index);
					};

				PageDots.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				Flickity.PageDots = PageDots;

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pageDots: true
				});

				Flickity.createMethods.push('_createPageDots');

				var proto = Flickity.prototype;

				proto._createPageDots = function () {
					if (!this.options.pageDots) {
						return;
					}
					this.pageDots = new PageDots(this);
					// events
					this.on('activate', this.activatePageDots);
					this.on('select', this.updateSelectedPageDots);
					this.on('cellChange', this.updatePageDots);
					this.on('resize', this.updatePageDots);
					this.on('deactivate', this.deactivatePageDots);
				};

				proto.activatePageDots = function () {
					this.pageDots.activate();
				};

				proto.updateSelectedPageDots = function () {
					this.pageDots.updateSelected();
				};

				proto.updatePageDots = function () {
					this.pageDots.setDots();
				};

				proto.deactivatePageDots = function () {
					this.pageDots.deactivate();
				};

				// -----  ----- //

				Flickity.PageDots = PageDots;

				return Flickity;

			}));
		});

		var player = createCommonjsModule(function (module) {
			// player & autoPlay
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						evEmitter,
						utils,
						flickity
					);
				} else {
					// browser global
					factory(
						window.EvEmitter,
						window.fizzyUIUtils,
						window.Flickity
					);
				}

			}(window, function factory(EvEmitter, utils, Flickity) {

				// -------------------------- Player -------------------------- //

				function Player(parent) {
					this.parent = parent;
					this.state = 'stopped';
					// visibility change event handler
					this.onVisibilityChange = this.visibilityChange.bind(this);
					this.onVisibilityPlay = this.visibilityPlay.bind(this);
				}

				Player.prototype = Object.create(EvEmitter.prototype);

				// start play
				Player.prototype.play = function () {
					if (this.state == 'playing') {
						return;
					}
					// do not play if page is hidden, start playing when page is visible
					var isPageHidden = document.hidden;
					if (isPageHidden) {
						document.addEventListener('visibilitychange', this.onVisibilityPlay);
						return;
					}

					this.state = 'playing';
					// listen to visibility change
					document.addEventListener('visibilitychange', this.onVisibilityChange);
					// start ticking
					this.tick();
				};

				Player.prototype.tick = function () {
					// do not tick if not playing
					if (this.state != 'playing') {
						return;
					}

					var time = this.parent.options.autoPlay;
					// default to 3 seconds
					time = typeof time == 'number' ? time : 3000;
					var _this = this;
					// HACK: reset ticks if stopped and started within interval
					this.clear();
					this.timeout = setTimeout(function () {
						_this.parent.next(true);
						_this.tick();
					}, time);
				};

				Player.prototype.stop = function () {
					this.state = 'stopped';
					this.clear();
					// remove visibility change event
					document.removeEventListener('visibilitychange', this.onVisibilityChange);
				};

				Player.prototype.clear = function () {
					clearTimeout(this.timeout);
				};

				Player.prototype.pause = function () {
					if (this.state == 'playing') {
						this.state = 'paused';
						this.clear();
					}
				};

				Player.prototype.unpause = function () {
					// re-start play if paused
					if (this.state == 'paused') {
						this.play();
					}
				};

				// pause if page visibility is hidden, unpause if visible
				Player.prototype.visibilityChange = function () {
					var isPageHidden = document.hidden;
					this[isPageHidden ? 'pause' : 'unpause']();
				};

				Player.prototype.visibilityPlay = function () {
					this.play();
					document.removeEventListener('visibilitychange', this.onVisibilityPlay);
				};

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pauseAutoPlayOnHover: true
				});

				Flickity.createMethods.push('_createPlayer');
				var proto = Flickity.prototype;

				proto._createPlayer = function () {
					this.player = new Player(this);

					this.on('activate', this.activatePlayer);
					this.on('uiChange', this.stopPlayer);
					this.on('pointerDown', this.stopPlayer);
					this.on('deactivate', this.deactivatePlayer);
				};

				proto.activatePlayer = function () {
					if (!this.options.autoPlay) {
						return;
					}
					this.player.play();
					this.element.addEventListener('mouseenter', this);
				};

				// Player API, don't hate the ... thanks I know where the door is

				proto.playPlayer = function () {
					this.player.play();
				};

				proto.stopPlayer = function () {
					this.player.stop();
				};

				proto.pausePlayer = function () {
					this.player.pause();
				};

				proto.unpausePlayer = function () {
					this.player.unpause();
				};

				proto.deactivatePlayer = function () {
					this.player.stop();
					this.element.removeEventListener('mouseenter', this);
				};

				// ----- mouseenter/leave ----- //

				// pause auto-play on hover
				proto.onmouseenter = function () {
					if (!this.options.pauseAutoPlayOnHover) {
						return;
					}
					this.player.pause();
					this.element.addEventListener('mouseleave', this);
				};

				// resume auto-play on hover off
				proto.onmouseleave = function () {
					this.player.unpause();
					this.element.removeEventListener('mouseleave', this);
				};

				// -----  ----- //

				Flickity.Player = Player;

				return Flickity;

			}));
		});

		var addRemoveCell = createCommonjsModule(function (module) {
			// add, remove cell
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						flickity,
						utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, utils) {

				// append cells to a document fragment
				function getCellsFragment(cells) {
					var fragment = document.createDocumentFragment();
					cells.forEach(function (cell) {
						fragment.appendChild(cell.element);
					});
					return fragment;
				}

				// -------------------------- add/remove cell prototype -------------------------- //

				var proto = Flickity.prototype;

				/**
				 * Insert, prepend, or append cells
				 * @param {Element, Array, NodeList} elems
				 * @param {Integer} index
				 */
				proto.insert = function (elems, index) {
					var cells = this._makeCells(elems);
					if (!cells || !cells.length) {
						return;
					}
					var len = this.cells.length;
					// default to append
					index = index === undefined ? len : index;
					// add cells with document fragment
					var fragment = getCellsFragment(cells);
					// append to slider
					var isAppend = index == len;
					if (isAppend) {
						this.slider.appendChild(fragment);
					} else {
						var insertCellElement = this.cells[index].element;
						this.slider.insertBefore(fragment, insertCellElement);
					}
					// add to this.cells
					if (index === 0) {
						// prepend, add to start
						this.cells = cells.concat(this.cells);
					} else if (isAppend) {
						// append, add to end
						this.cells = this.cells.concat(cells);
					} else {
						// insert in this.cells
						var endCells = this.cells.splice(index, len - index);
						this.cells = this.cells.concat(cells).concat(endCells);
					}

					this._sizeCells(cells);
					this.cellChange(index, true);
				};

				proto.append = function (elems) {
					this.insert(elems, this.cells.length);
				};

				proto.prepend = function (elems) {
					this.insert(elems, 0);
				};

				/**
				 * Remove cells
				 * @param {Element, Array, NodeList} elems
				 */
				proto.remove = function (elems) {
					var cells = this.getCells(elems);
					if (!cells || !cells.length) {
						return;
					}

					var minCellIndex = this.cells.length - 1;
					// remove cells from collection & DOM
					cells.forEach(function (cell) {
						cell.remove();
						var index = this.cells.indexOf(cell);
						minCellIndex = Math.min(index, minCellIndex);
						utils.removeFrom(this.cells, cell);
					}, this);

					this.cellChange(minCellIndex, true);
				};

				/**
				 * logic to be run after a cell's size changes
				 * @param {Element} elem - cell's element
				 */
				proto.cellSizeChange = function (elem) {
					var cell = this.getCell(elem);
					if (!cell) {
						return;
					}
					cell.getSize();

					var index = this.cells.indexOf(cell);
					this.cellChange(index);
				};

				/**
				 * logic any time a cell is changed: added, removed, or size changed
				 * @param {Integer} changedCellIndex - index of the changed cell, optional
				 */
				proto.cellChange = function (changedCellIndex, isPositioningSlider) {
					var prevSelectedElem = this.selectedElement;
					this._positionCells(changedCellIndex);
					this._getWrapShiftCells();
					this.setGallerySize();
					// update selectedIndex
					// try to maintain position & select previous selected element
					var cell = this.getCell(prevSelectedElem);
					if (cell) {
						this.selectedIndex = this.getCellSlideIndex(cell);
					}
					this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);

					this.emitEvent('cellChange', [changedCellIndex]);
					// position slider
					this.select(this.selectedIndex);
					// do not position slider after lazy load
					if (isPositioningSlider) {
						this.positionSliderAtSelected();
					}
				};

				// -----  ----- //

				return Flickity;

			}));
		});

		var lazyload = createCommonjsModule(function (module) {
			// lazyload
			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						flickity,
						utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, utils) {

				Flickity.createMethods.push('_createLazyload');
				var proto = Flickity.prototype;

				proto._createLazyload = function () {
					this.on('select', this.lazyLoad);
				};

				proto.lazyLoad = function () {
					var lazyLoad = this.options.lazyLoad;
					if (!lazyLoad) {
						return;
					}
					// get adjacent cells, use lazyLoad option for adjacent count
					var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
					var cellElems = this.getAdjacentCellElements(adjCount);
					// get lazy images in those cells
					var lazyImages = [];
					cellElems.forEach(function (cellElem) {
						var lazyCellImages = getCellLazyImages(cellElem);
						lazyImages = lazyImages.concat(lazyCellImages);
					});
					// load lazy images
					lazyImages.forEach(function (img) {
						new LazyLoader(img, this);
					}, this);
				};

				function getCellLazyImages(cellElem) {
					// check if cell element is lazy image
					if (cellElem.nodeName == 'IMG') {
						var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
						var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
						var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
						if (lazyloadAttr || srcAttr || srcsetAttr) {
							return [cellElem];
						}
					}
					// select lazy images in cell
					var lazySelector = 'img[data-flickity-lazyload], ' +
						'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
					var imgs = cellElem.querySelectorAll(lazySelector);
					return utils.makeArray(imgs);
				}

				// -------------------------- LazyLoader -------------------------- //

				/**
				 * class to handle loading images
				 */
				function LazyLoader(img, flickity) {
					this.img = img;
					this.flickity = flickity;
					this.on('load');
				}

				LazyLoader.prototype.handleEvent = utils.handleEvent;

				LazyLoader.prototype.load = function () {
					this.img.addEventListener('load', this);
					this.img.addEventListener('error', this);
					// get src & srcset
					var src = this.img.getAttribute('data-flickity-lazyload') ||
						this.img.getAttribute('data-flickity-lazyload-src');
					var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
					// set src & serset
					this.img.src = src;
					if (srcset) {
						this.img.setAttribute('srcset', srcset);
					}
					// remove attr
					this.img.removeAttribute('data-flickity-lazyload');
					this.img.removeAttribute('data-flickity-lazyload-src');
					this.img.removeAttribute('data-flickity-lazyload-srcset');
				};

				LazyLoader.prototype.onload = function (event) {
					this.complete(event, 'flickity-lazyloaded');
				};

				LazyLoader.prototype.onerror = function (event) {
					this.complete(event, 'flickity-lazyerror');
				};

				LazyLoader.prototype.complete = function (event, className) {
					// unbind events
					this.img.removeEventListener('load', this);
					this.img.removeEventListener('error', this);

					var cell = this.flickity.getParentCell(this.img);
					var cellElem = cell && cell.element;
					this.flickity.cellSizeChange(cellElem);

					this.img.classList.add(className);
					this.flickity.dispatchEvent('lazyLoad', event, cellElem);
				};

				// -----  ----- //

				Flickity.LazyLoader = LazyLoader;

				return Flickity;

			}));
		});

		var js = createCommonjsModule(function (module) {
			/*!
			 * Flickity v2.2.1
			 * Touch, responsive, flickable carousels
			 *
			 * Licensed GPLv3 for open source use
			 * or Flickity Commercial License for commercial use
			 *
			 * https://flickity.metafizzy.co
			 * Copyright 2015-2019 Metafizzy
			 */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						flickity,
						drag,
						prevNextButton,
						pageDots,
						player,
						addRemoveCell,
						lazyload
					);
				}

			})(window, function factory(Flickity) {
				/*jshint strict: false*/
				return Flickity;
			});
		});

		var flickityFade = createCommonjsModule(function (module) {
			/**
			 * Flickity fade v1.0.0
			 * Fade between Flickity slides
			 */

			/* jshint browser: true, undef: true, unused: true */

			(function (window, factory) {
				// universal module definition
				/*globals define, module, require */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						js,
						utils
					);
				} else {
					// browser global
					factory(
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(commonjsGlobal, function factory(Flickity, utils) {

				// ---- Slide ---- //

				var Slide = Flickity.Slide;

				var slideUpdateTarget = Slide.prototype.updateTarget;
				Slide.prototype.updateTarget = function () {
					slideUpdateTarget.apply(this, arguments);
					if (!this.parent.options.fade) {
						return;
					}
					// position cells at selected target
					var slideTargetX = this.target - this.x;
					var firstCellX = this.cells[0].x;
					this.cells.forEach(function (cell) {
						var targetX = cell.x - firstCellX - slideTargetX;
						cell.renderPosition(targetX);
					});
				};

				Slide.prototype.setOpacity = function (alpha) {
					this.cells.forEach(function (cell) {
						cell.element.style.opacity = alpha;
					});
				};

				// ---- Flickity ---- //

				var proto = Flickity.prototype;

				Flickity.createMethods.push('_createFade');

				proto._createFade = function () {
					this.fadeIndex = this.selectedIndex;
					this.prevSelectedIndex = this.selectedIndex;
					this.on('select', this.onSelectFade);
					this.on('dragEnd', this.onDragEndFade);
					this.on('settle', this.onSettleFade);
					this.on('activate', this.onActivateFade);
					this.on('deactivate', this.onDeactivateFade);
				};

				var updateSlides = proto.updateSlides;
				proto.updateSlides = function () {
					updateSlides.apply(this, arguments);
					if (!this.options.fade) {
						return;
					}
					// set initial opacity
					this.slides.forEach(function (slide, i) {
						var alpha = i == this.selectedIndex ? 1 : 0;
						slide.setOpacity(alpha);
					}, this);
				};

				/* ---- events ---- */

				proto.onSelectFade = function () {
					// in case of resize, keep fadeIndex within current count
					this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
					this.prevSelectedIndex = this.selectedIndex;
				};

				proto.onSettleFade = function () {
					delete this.didDragEnd;
					if (!this.options.fade) {
						return;
					}
					// set full and 0 opacity on selected & faded slides
					this.selectedSlide.setOpacity(1);
					var fadedSlide = this.slides[this.fadeIndex];
					if (fadedSlide && this.fadeIndex != this.selectedIndex) {
						this.slides[this.fadeIndex].setOpacity(0);
					}
				};

				proto.onDragEndFade = function () {
					// set flag
					this.didDragEnd = true;
				};

				proto.onActivateFade = function () {
					if (this.options.fade) {
						this.element.classList.add('is-fade');
					}
				};

				proto.onDeactivateFade = function () {
					if (!this.options.fade) {
						return;
					}
					this.element.classList.remove('is-fade');
					// reset opacity
					this.slides.forEach(function (slide) {
						slide.setOpacity('');
					});
				};

				/* ---- position & fading ---- */

				var positionSlider = proto.positionSlider;
				proto.positionSlider = function () {
					if (!this.options.fade) {
						positionSlider.apply(this, arguments);
						return;
					}

					this.fadeSlides();
					this.dispatchScrollEvent();
				};

				var positionSliderAtSelected = proto.positionSliderAtSelected;
				proto.positionSliderAtSelected = function () {
					if (this.options.fade) {
						// position fade slider at origin
						this.setTranslateX(0);
					}
					positionSliderAtSelected.apply(this, arguments);
				};

				proto.fadeSlides = function () {
					if (this.slides.length < 2) {
						return;
					}
					// get slides to fade-in & fade-out
					var indexes = this.getFadeIndexes();
					var fadeSlideA = this.slides[indexes.a];
					var fadeSlideB = this.slides[indexes.b];
					var distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
					var progress = this.wrapDifference(fadeSlideA.target, -this.x);
					progress = progress / distance;

					fadeSlideA.setOpacity(1 - progress);
					fadeSlideB.setOpacity(progress);

					// hide previous slide
					var fadeHideIndex = indexes.a;
					if (this.isDragging) {
						fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
					}
					var isNewHideIndex = this.fadeHideIndex != undefined &&
						this.fadeHideIndex != fadeHideIndex &&
						this.fadeHideIndex != indexes.a &&
						this.fadeHideIndex != indexes.b;
					if (isNewHideIndex) {
						// new fadeHideSlide set, hide previous
						this.slides[this.fadeHideIndex].setOpacity(0);
					}
					this.fadeHideIndex = fadeHideIndex;
				};

				proto.getFadeIndexes = function () {
					if (!this.isDragging && !this.didDragEnd) {
						return {
							a: this.fadeIndex,
							b: this.selectedIndex,
						};
					}
					if (this.options.wrapAround) {
						return this.getFadeDragWrapIndexes();
					} else {
						return this.getFadeDragLimitIndexes();
					}
				};

				proto.getFadeDragWrapIndexes = function () {
					var distances = this.slides.map(function (slide, i) {
						return this.getSlideDistance(-this.x, i);
					}, this);
					var absDistances = distances.map(function (distance) {
						return Math.abs(distance);
					});
					var minDistance = Math.min.apply(Math, absDistances);
					var closestIndex = absDistances.indexOf(minDistance);
					var distance = distances[closestIndex];
					var len = this.slides.length;

					var delta = distance >= 0 ? 1 : -1;
					return {
						a: closestIndex,
						b: utils.modulo(closestIndex + delta, len),
					};
				};

				proto.getFadeDragLimitIndexes = function () {
					// calculate closest previous slide
					var dragIndex = 0;
					for (var i = 0; i < this.slides.length - 1; i++) {
						var slide = this.slides[i];
						if (-this.x < slide.target) {
							break;
						}
						dragIndex = i;
					}
					return {
						a: dragIndex,
						b: dragIndex + 1,
					};
				};

				proto.wrapDifference = function (a, b) {
					var diff = b - a;

					if (!this.options.wrapAround) {
						return diff;
					}

					var diffPlus = diff + this.slideableWidth;
					var diffMinus = diff - this.slideableWidth;
					if (Math.abs(diffPlus) < Math.abs(diff)) {
						diff = diffPlus;
					}
					if (Math.abs(diffMinus) < Math.abs(diff)) {
						diff = diffMinus;
					}
					return diff;
				};

				// ---- wrapAround ---- //

				var _getWrapShiftCells = proto._getWrapShiftCells;
				proto._getWrapShiftCells = function () {
					if (!this.options.fade) {
						_getWrapShiftCells.apply(this, arguments);
					}
				};

				var shiftWrapCells = proto.shiftWrapCells;
				proto.shiftWrapCells = function () {
					if (!this.options.fade) {
						shiftWrapCells.apply(this, arguments);
					}
				};

				return Flickity;

			}));
		});

		var EventHandler_1 = createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener)
						return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el, event = _a.event, listener = _a.listener;
					if (!el || !event || !listener)
						return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el
							|| event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			}());
			exports["default"] = EventHandler;
		});

		var EventHandler = unwrapExports(EventHandler_1);

		var Slideshow = /*#__PURE__*/function () {
			function Slideshow(section, config) {
				var _this = this;

				_classCallCheck(this, Slideshow);

				this.el = section.el;
				this.settings = section.data || config;
				this.paginationClicked = false;
				this.events = new EventHandler();
				this.carousel = this.el.querySelector('[data-slideshow-wrapper]');
				this.slides = this.el.querySelectorAll('[data-slideshow-slide]');
				this.pagination = this.el.querySelector('[data-slideshow-pagination]');
				this.paginationButtons = this.pagination ? this.pagination.querySelectorAll('[data-slide-button]') : null;
				this.counter = this.el.querySelector('[data-slide-counter]');
				this.el.style.setProperty('--slide-text-color', "".concat(this.slides[0].dataset.textColor));

				if (this.carousel && this.slides.length > 1) {
					this.flickity = new flickityFade(this.carousel, {
						accessibility: false,
						// Flickity's inherent "accessibility" actually makes it worse
						adaptiveHeight: typeof this.settings.adaptiveHeight != "undefined" ? this.settings.adaptiveHeight : true,
						autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_interval * 1000 : false,
						cellAlign: 'left',
						cellSelector: '[data-slideshow-slide]',
						contain: true,
						fade: this.settings.transition_fade,
						imagesLoaded: true,
						pageDots: this.settings.show_pagination,
						pauseAutoPlayOnHover: true,
						selectedAttraction: this.settings.slide_attraction ? parseFloat(this.settings.slide_attraction) : 0.03,
						friction: this.settings.slide_friction ? parseFloat(this.settings.slide_friction) : 0.3,
						wrapAround: this.settings.wrapAround ?? true,
						groupCells: this.settings.groupCells ?? false,
						arrowShape: {
							x0: 10,
							x1: 60,
							y1: 50,
							x2: 65,
							y2: 45,
							x3: 20
						}
					});
					this.prevNextButtons = this.el.querySelectorAll('.flickity-prev-next-button');

					if (this.prevNextButtons.length === 2) {
						this.prevNextButtons[0].setAttribute('aria-label', this.settings.previous_text);
						this.prevNextButtons[1].setAttribute('aria-label', this.settings.next_text);
					}

					this._updateTabindex();

					this._positionNavigation();

					this._updateCounter(1);

					this.flickity.on('change', function (index) {
						_this.el.style.setProperty('--slide-text-color', "".concat(_this.slides[index].dataset.textColor));

						_this._updatePagination();

						_this._positionNavigation();

						_this._updateTabindex();

						_this._updateCounter(index + 1);
					}); // On any interaction on the slideshow, we want it to pause

					this.flickity.on('pointerDown', function () {
						return _this.flickity.pausePlayer();
					});
					this.events.register(this.carousel, 'rimg:load', function () {
						_this.flickity.resize();

						_this._positionNavigation();
					}); // As soon as the slideshow receives keyboard or mouse focus, we want it to pause

					this.events.register(this.carousel, 'focusin', function () {
						return _this.flickity.pausePlayer();
					});
					this.events.register(window, 'resize', function () {
						_this._positionNavigation();
					}); // We want to focus on the new slide if the pagination buttons were clicked
					// If we don't wait until "settle" then the slideshow experiences a weird jump issue

					this.flickity.on('settle', function (index) {
						if (_this.paginationClicked) {
							_this.slides[index].focus();

							_this.paginationClicked = false;
						}
					}); // We had to add in our own pagination buttons since the flickity ones
					// are not elements that can be tabbed to. This replicates their behaviour.

					if (this.pagination) {
						var _loop = function _loop(i) {
							_this.events.register(_this.paginationButtons[i], 'click', function () {
								var index = parseInt(_this.paginationButtons[i].dataset.slideButton, 10);

								_this.flickity.pausePlayer();

								_this.flickity.select(index, true, false);

								_this.paginationClicked = true;
							});
						};

						for (var i = 0; i < this.paginationButtons.length; i++) {
							_loop(i);
						}
					}
				}
			}

			_createClass(Slideshow, [{
				key: "_updatePagination",
				value: function _updatePagination() {
					if (this.pagination) {
						for (var i = 0; i < this.paginationButtons.length; i++) {
							this.paginationButtons[i].dataset.selected = 'false';
							this.paginationButtons[i].setAttribute('aria-selected', 'false');
						}

						this.paginationButtons[this.flickity.selectedIndex].dataset.selected = 'true';
						this.paginationButtons[this.flickity.selectedIndex].setAttribute('aria-selected', 'true');
					}
				}
			}, {
				key: "_positionNavigation",
				value: function _positionNavigation() {
					if (this.settings.mobile_navigation_adjust) {
						var arrowButtons = this.el.querySelectorAll('.flickity-prev-next-button');
						var currentSlideheight = this.flickity.selectedElement.querySelector('[data-slide-image-wrapper]').offsetHeight;

						if (arrowButtons) {
							var top = '50%';

							if (this.viewportIsMobile()) {
								top = "".concat(currentSlideheight / 2, "px");
							}

							arrowButtons[0].style.top = top;
							arrowButtons[1].style.top = top;
						}

						if (this.pagination) {
							var _top = 'auto';

							if (this.viewportIsMobile()) {
								var content = this.flickity.selectedElement.querySelector('[data-slide-content]');

								if (content) {
									_top = "".concat(currentSlideheight, "px");
								} else {
									var paginationHeight = this.pagination.offsetHeight; // If no content, and mobile, offset by height of dots, and the bottom gutter

									_top = "".concat(currentSlideheight - paginationHeight, "px");
								}
							}

							this.pagination.style.top = _top;
						}
					}
				}
			}, {
				key: "_updateTabindex",
				value: function _updateTabindex() {
					// We need to remove tabindex from the slides that are not currently
					// selected, so that slides not currently shown cannot receive keyboard focus.
					for (var i = 0; i < this.slides.length; i++) {
						var links = this.slides[i].querySelectorAll('a');

						for (var j = 0; j < links.length; j++) {
							links[j].setAttribute('tabindex', i === this.flickity.selectedIndex ? '0' : '-1');
						}
					}
				} // This updates the counter which is used for accessibility. This gets read out to a user
				// who uses a screen reader every time the slide changes.

			}, {
				key: "_updateCounter",
				value: function _updateCounter(index) {
					var counterText = this.counter.dataset.counterTemplate.replace("\{\{ count \}\}", index).replace("\{\{ total \}\}", this.slides.length);
					this.counter.innerHTML = counterText;
				} // This method can be overridden by the theme if the breakpoint is different than 720.

			}, {
				key: "viewportIsMobile",
				value: function viewportIsMobile() {
					return window.innerWidth < 720;
				}
			}, {
				key: "onSectionUnload",
				value: function onSectionUnload() {
					this.events.unregisterAll();
					this.flickity.destroy();
				}
			}, {
				key: "onSectionBlockSelect",
				value: function onSectionBlockSelect(e) {
					var slideIndex = e.el.dataset.slideIndex;
					this.flickity.select(slideIndex);
					this.flickity.pausePlayer();
					this.flickity.resize();
				}
			}, {
				key: "onSectionBlockDeselect",
				value: function onSectionBlockDeselect() {
					if (this.settings.enable_autoplay) {
						this.flickity.playPlayer();
					}
				}
			}]);

			return Slideshow;
		}();

/* harmony default export */ const pxs_slideshow_dist_index_es = (Slideshow);

		class FlickitySlideshow extends HTMLElement {
			constructor() {
					super();
					this.el = this;
					this.config = JSON.parse(this.getAttribute('flickity-config'));
					this.slideshow = new Slideshow(this, this.config);
			}
		}
		customElements.define('flickity-slideshow', FlickitySlideshow);


		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-video/dist/index.es.js

		/*!
		 * @pixelunion/pxs-video v1.0.8
		 * (c) 2021 Pixel Union
		 */

		function index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function index_es_createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var index_es_script = index_es_createCommonjsModule(function (module) {
			/*!
				* $script.js JS loader & dependency manager
				* https://github.com/ded/script.js
				* (c) Dustin Diaz 2014 | License MIT
				*/

			(function (name, definition) {
				if (module.exports) module.exports = definition();
				else this[name] = definition();
			})('$script', function () {
				var doc = document
					, head = doc.getElementsByTagName('head')[0]
					, f = false
					, push = 'push'
					, readyState = 'readyState'
					, onreadystatechange = 'onreadystatechange'
					, list = {}
					, delay = {}
					, scripts = {}
					, scriptpath
					, urlArgs;

				function every(ar, fn) {
					for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
					return 1
				}
				function each(ar, fn) {
					every(ar, function (el) {
						fn(el);
						return 1
					});
				}

				function $script(paths, idOrDone, optDone) {
					paths = paths[push] ? paths : [paths];
					var idOrDoneIsDone = idOrDone && idOrDone.call
						, done = idOrDoneIsDone ? idOrDone : optDone
						, id = idOrDoneIsDone ? paths.join('') : idOrDone
						, queue = paths.length;
					function loopFn(item) {
						return item.call ? item() : list[item]
					}
					function callback() {
						if (!--queue) {
							list[id] = 1;
							done && done();
							for (var dset in delay) {
								every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
							}
						}
					}
					setTimeout(function () {
						each(paths, function loading(path, force) {
							if (path === null) return callback()

							if (!force && !/^https?:\/\//.test(path) && scriptpath) {
								path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
							}

							if (scripts[path]) {
								return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true); }, 0)
							}

							scripts[path] = 1;
							create(path, callback);
						});
					}, 0);
					return $script
				}

				function create(path, fn) {
					var el = doc.createElement('script'), loaded;
					el.onload = el.onerror = el[onreadystatechange] = function () {
						if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
						el.onload = el[onreadystatechange] = null;
						loaded = 1;
						scripts[path] = 2;
						fn();
					};
					el.async = 1;
					el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
					head.insertBefore(el, head.lastChild);
				}

				$script.get = create;

				$script.order = function (scripts, id, done) {
					(function callback(s) {
						s = scripts.shift();
						!scripts.length ? $script(s, id, done) : $script(s, callback);
					}());
				};

				$script.path = function (p) {
					scriptpath = p;
				};
				$script.urlArgs = function (str) {
					urlArgs = str;
				};
				$script.ready = function (deps, ready, req) {
					deps = deps[push] ? deps : [deps];
					var missing = [];
					!each(deps, function (dep) {
						list[dep] || missing[push](dep);
					}) && every(deps, function (dep) { return list[dep] }) ?
						ready() : !function (key) {
							delay[key] = delay[key] || [];
							delay[key][push](ready);
							req && req(missing);
						}(deps.join('|'));
					return $script
				};

				$script.done = function (idOrDone) {
					$script([null], idOrDone);
				};

				return $script
			});
		});

		var api = 'https://www.youtube.com/iframe_api';
		var apiLoadedCallbacks = [];
		var apiLoaded = false;

		window.onYouTubeIframeAPIReady = function () {
			apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
				return apiLoadedCallback();
			});
			apiLoadedCallbacks = [];
			apiLoaded = true;
		};

		var Youtube = /*#__PURE__*/function () {
			function Youtube(el, id, options) {
				index_es_classCallCheck(this, Youtube);

				this.el = el;
				this.id = id;
				this.startMuted = options.startMuted;
				this.loopVideo = options.loopVideo;
				this.iframeEl = document.createElement('div');
				this.el.appendChild(this.iframeEl);
				this.onApiLoaded = this._onApiLoaded.bind(this);
				this.isReady = false;
				this.onReady = this._onReady.bind(this);
				this.onReadyCallback = null;
				this.playerState = null;
				this.onStateChange = this._onStateChange.bind(this);
				this.onPlayCallback = null;
				this.onPlayError = null;

				if (apiLoaded) {
					this._onApiLoaded();
				} else {
					apiLoadedCallbacks.push(this.onApiLoaded);
					index_es_script(api);
				}
			}

			index_es_createClass(Youtube, [{
				key: "play",
				value: function play() {
					var _this = this;

					return new Promise(function (resolve, reject) {
						_this.onPlayCallback = resolve;
						_this.onPlayError = reject;

						if (_this.isReady) {
							_this.player.playVideo();
						} else {
							_this.onReadyCallback = function () {
								_this.player.playVideo();
							};
						}
					});
				}
			}, {
				key: "pause",
				value: function pause() {
					this.player.pauseVideo();
				}
			}, {
				key: "unload",
				value: function unload() {
					this.player.destroy();
				}
			}, {
				key: "_onApiLoaded",
				value: function _onApiLoaded() {
					var playerVars = {
						modestbranding: true,
						showinfo: false,
						controls: false,
						loop: this.loopVideo,
						mute: this.startMuted,
						rel: 0
					};

					if (this.loopVideo) {
						// This is required to allow 'loop' to work based on the YouTube api
						playerVars.playlist = this.id;
					}

					this.player = new YT.Player(this.iframeEl, {
						videoId: this.id,
						playerVars: playerVars,
						events: {
							onReady: this.onReady,
							onStateChange: this.onStateChange
						}
					});
				}
			}, {
				key: "_onReady",
				value: function _onReady() {
					this.isReady = true;

					if (this.onReadyCallback) {
						this.onReadyCallback();
					}
				}
			}, {
				key: "_onStateChange",
				value: function _onStateChange(event) {
					var state = event.data;

					if (this.onPlayCallback) {
						if (state === YT.PlayerState.PLAYING) {
							this.onPlayCallback();
							this.onPlayCallback = null;
							this.onPlayError = null;
						} else if (this.playerState === YT.PlayerState.BUFFERING && (state === YT.PlayerState.UNSTARTED || state === YT.PlayerState.PAUSED)) {
							this.onPlayError();
							this.onPlayCallback = null;
							this.onPlayError = null;
						}
					}

					this.playerState = state;
				}
			}]);

			return Youtube;
		}();

		var api$1 = 'https://player.vimeo.com/api/player.js';
		var thumbnailApi = 'http://vimeo.com/api/v2/video/{id}.json';
		var apiLoaded$1 = false;

		var VimeoPlayer = /*#__PURE__*/function () {
			function VimeoPlayer(section, el, id, options) {
				var _this = this;

				index_es_classCallCheck(this, VimeoPlayer);

				this.section = section;
				this.el = el;
				this.id = id;
				this.startMuted = options.startMuted;
				this.loopVideo = options.loopVideo;
				this.coverImage = this.section.querySelector('[data-vimeo-image]');
				this.onApiLoaded = this._onApiLoaded.bind(this);
				this.isReady = false;
				this.onReady = this._onReady.bind(this);
				this.onReadyCallback = null;
				this.onPlayCallback = null;
				this.startedPlaying = false;
				this.onProgress = this._onProgress.bind(this);

				if (apiLoaded$1) {
					this._onApiLoaded();
				} else {
					index_es_script(api$1, this.onApiLoaded);
				}

				if (this.coverImage) {
					// Add the cover image for vimeo videos
					fetch(thumbnailApi.replace('{id}', this.id)).then(function (response) {
						return response.json();
					}).then(function (data) {
						_this.coverImage.setAttribute('src', data[0].thumbnail_large);
					});
				}
			}

			index_es_createClass(VimeoPlayer, [{
				key: "play",
				value: function play() {
					var _this2 = this;

					return new Promise(function (resolve, reject) {
						_this2.onPlayCallback = resolve;
						_this2.onPlayError = reject;

						if (_this2.isReady) {
							_this2.player.play().then(function () {
								_this2.player.on('progress', _this2.onProgress);
							})["catch"](function (error) {
								_this2.player.off('progress', _this2.onProgress);

								_this2.onPlayError();
							});
						} else {
							_this2.onReadyCallback = function () {
								_this2.player.play().then(function () {
									_this2.player.on('progress', _this2.onProgress);
								})["catch"](function (error) {
									_this2.player.off('progress', _this2.onProgress);

									_this2.onPlayError();
								});
							};
						}
					});
				}
			}, {
				key: "pause",
				value: function pause() {
					this.player.pause()["catch"]();
				}
			}, {
				key: "unload",
				value: function unload() {
					this.player.unload()["catch"]();
				}
			}, {
				key: "_onApiLoaded",
				value: function _onApiLoaded() {
					var _this3 = this;

					this.player = new window.Vimeo.Player(this.el, {
						id: this.id,
						muted: this.startMuted,
						loop: this.loopVideo
					});
					this.player.ready().then(function () {
						_this3._onReady();
					})["catch"](function () {
						_this3.onPlayError();
					});
					apiLoaded$1 = true;
				}
			}, {
				key: "_onReady",
				value: function _onReady() {
					this.isReady = true;

					if (this.onReadyCallback) {
						this.onReadyCallback();
					}
				}
			}, {
				key: "_onProgress",
				value: function _onProgress() {
					this.startedPlaying = true;
					this.player.off('progress', this.onProgress);

					if (this.onPlayCallback) {
						this.onPlayCallback();
						this.onPlayCallback = null;
					}
				}
			}]);

			return VimeoPlayer;
		}();

		var loadPlyrStyles = null;

		var HTML5Video = /*#__PURE__*/function () {
			function HTML5Video(section, el, options) {
				var _this = this;

				index_es_classCallCheck(this, HTML5Video);

				this.section = section;
				this.videoElement = el.querySelector('[data-html5-video]');
				this.startMuted = options.startMuted;
				this.loopVideo = options.loopVideo;
				this.aspectRatio = options.aspectRatio;
				this.setupVideo = this.setupVideo.bind(this);
				this.play = this.play.bind(this);
				this.pause = this.pause.bind(this);
				this.unload = this.unload.bind(this);

				if (!(loadPlyrStyles instanceof Promise)) {
					loadPlyrStyles = new Promise(function (resolve) {
						var stylesheet = document.createElement('link');
						stylesheet.setAttribute('rel', 'stylesheet');
						stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
						stylesheet.onload = resolve;
						document.body.appendChild(stylesheet);
					});
				}

				window.Shopify.loadFeatures([{
					name: 'video-ui',
					version: '1.0',
					onLoad: function onLoad() {
						return loadPlyrStyles.then(function () {
							return _this.setupVideo();
						});
					}
				}]);
			}

			index_es_createClass(HTML5Video, [{
				key: "setupVideo",
				value: function setupVideo() {
					if (!Shopify.Plyr) {
						return;
					}

					this.player = new Shopify.Plyr(this.videoElement, {
						muted: this.startMuted,
						loop: {
							active: this.loopVideo
						},
						ratio: this.aspectRatio
					});
				}
			}, {
				key: "play",
				value: function play() {
					var _this2 = this;

					return new Promise(function (resolve, reject) {
						if (_this2.player) {
							_this2.player.play();

							resolve();
						}
					});
				}
			}, {
				key: "pause",
				value: function pause() {
					this.player.pause();
				}
			}, {
				key: "unload",
				value: function unload() {
					if (this.player) {
						this.player.destroy();
					}
				}
			}]);

			return HTML5Video;
		}();

		var Video = /*#__PURE__*/function () {
			function Video(section) {
				var _this = this;

				index_es_classCallCheck(this, Video);

				this.el = section.el;
				this.settings = section.data;
				this.playButton = this.el.querySelector('[data-video-play-button]');
				this.videoEl = this.el.querySelector('[data-video]');
				this.video = null;
				this.playButtonClicked = false;
				var autoplay = this.settings.autoplay || false;
				var startMuted = this.settings.startMuted != null ? this.settings.startMuted : true;
				var loopVideo = this.settings.loopVideo || false;
				var aspectRatio = this.settings.aspectRatio;
				var type = this.videoEl.getAttribute('data-video');
				var id = this.videoEl.getAttribute('data-video-id');

				switch (type) {
					case 'youtube':
						this.video = new Youtube(this.videoEl, id, {
							startMuted: startMuted,
							loopVideo: loopVideo
						});
						break;

					case 'vimeo':
						this.video = new VimeoPlayer(this.el, this.videoEl, id, {
							startMuted: startMuted,
							loopVideo: loopVideo
						});
						break;

					case 'html5':
						this.video = new HTML5Video(this.el, this.videoEl, {
							startMuted: startMuted,
							loopVideo: loopVideo,
							aspectRatio: aspectRatio
						});
						break;

					default:
						this.video = null;
						break;
				}

				this._play = this._play.bind(this);

				if (this.playButton) {
					this.onPlayButtonClick = function () {
						_this.playButtonClicked = true;

						_this._play();
					};

					this.playButton.addEventListener('click', this.onPlayButtonClick);
				}

				if (!this.viewportIsMobile() && autoplay) {
					// Set up autoplay for when the video is in the viewport
					this.observer = new IntersectionObserver(function (entries) {
						var isIntersecting = entries[0].isIntersecting;

						if (isIntersecting) {
							_this._play();

							_this.observer.unobserve(_this.videoEl);
						}
					});
					this.observer.observe(this.videoEl);
				}
			}

			index_es_createClass(Video, [{
				key: "_play",
				value: function _play() {
					var _this2 = this;

					this.el.dataset.videoLoading = true;
					this.video.play().then(function () {
						_this2.el.dataset.videoTransitioning = true;
						setTimeout(function () {
							_this2.el.dataset.videoLoading = false;
							_this2.el.dataset.videoTransitioning = false;
							_this2.el.dataset.videoPlaying = true; // This is for accessibility, the video should receive focus after playing.

							if (_this2.playButtonClicked) {
								_this2.videoEl.focus();
							}
						}, 200);
					})["catch"](function () {
						// We should pause the video in case it does start
						// playing underneath the overlay
						_this2.video.pause();

						_this2.el.dataset.videoLoading = false;
						_this2.el.dataset.videoPlaying = false;
					});
				} // This method can be overridden by the theme if the breakpoint is different than 720.

			}, {
				key: "viewportIsMobile",
				value: function viewportIsMobile() {
					return window.innerWidth < 720;
				}
			}, {
				key: "onSectionUnload",
				value: function onSectionUnload() {
					if (this.playButton) {
						this.playButton.removeEventListener('click', this.onPlayClick);
					}

					if (this.video) {
						this.video.unload();
					}
				}
			}]);

			return Video;
		}();

/* harmony default export */ const pxs_video_dist_index_es = (Video);

		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-testimonials/dist/index.es.js

		/*!
		 * @pixelunion/pxs-testimonials v1.0.5
		 * (c) 2021 Pixel Union
		 */

		function dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		var index_es_commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

		function index_es_unwrapExports(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function dist_index_es_createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var index_es_evEmitter = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * EvEmitter v1.1.0
			 * Lil' event emitter
			 * MIT License
			 */

			/* jshint unused: true, undef: true, strict: true */

			(function (global, factory) {
				// universal module definition
				/* jshint strict: false */ /* globals define, module, window */
				if (module.exports) {
					// CommonJS - Browserify, Webpack
					module.exports = factory();
				} else {
					// Browser globals
					global.EvEmitter = factory();
				}

			}(typeof window != 'undefined' ? window : index_es_commonjsGlobal, function () {

				function EvEmitter() { }

				var proto = EvEmitter.prototype;

				proto.on = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// set events hash
					var events = this._events = this._events || {};
					// set listeners array
					var listeners = events[eventName] = events[eventName] || [];
					// only add once
					if (listeners.indexOf(listener) == -1) {
						listeners.push(listener);
					}

					return this;
				};

				proto.once = function (eventName, listener) {
					if (!eventName || !listener) {
						return;
					}
					// add event
					this.on(eventName, listener);
					// set once flag
					// set onceEvents hash
					var onceEvents = this._onceEvents = this._onceEvents || {};
					// set onceListeners object
					var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
					// set flag
					onceListeners[listener] = true;

					return this;
				};

				proto.off = function (eventName, listener) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					var index = listeners.indexOf(listener);
					if (index != -1) {
						listeners.splice(index, 1);
					}

					return this;
				};

				proto.emitEvent = function (eventName, args) {
					var listeners = this._events && this._events[eventName];
					if (!listeners || !listeners.length) {
						return;
					}
					// copy over to avoid interference if .off() in listener
					listeners = listeners.slice(0);
					args = args || [];
					// once stuff
					var onceListeners = this._onceEvents && this._onceEvents[eventName];

					for (var i = 0; i < listeners.length; i++) {
						var listener = listeners[i];
						var isOnce = onceListeners && onceListeners[listener];
						if (isOnce) {
							// remove listener
							// remove before trigger to prevent recursion
							this.off(eventName, listener);
							// unset once flag
							delete onceListeners[listener];
						}
						// trigger listener
						listener.apply(this, args);
					}

					return this;
				};

				proto.allOff = function () {
					delete this._events;
					delete this._onceEvents;
				};

				return EvEmitter;

			}));
		});

		var index_es_getSize = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * getSize v2.0.3
			 * measure size of elements
			 * MIT license
			 */

			/* jshint browser: true, strict: true, undef: true, unused: true */
			/* globals console: false */

			(function (window, factory) {
				/* jshint strict: false */ /* globals define, module */
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.getSize = factory();
				}

			})(window, function factory() {

				// -------------------------- helpers -------------------------- //

				// get a number from a string, not a percentage
				function getStyleSize(value) {
					var num = parseFloat(value);
					// not a percent like '100%', and a number
					var isValid = value.indexOf('%') == -1 && !isNaN(num);
					return isValid && num;
				}

				function noop() { }

				var logError = typeof console == 'undefined' ? noop :
					function (message) {
						console.error(message);
					};

				// -------------------------- measurements -------------------------- //

				var measurements = [
					'paddingLeft',
					'paddingRight',
					'paddingTop',
					'paddingBottom',
					'marginLeft',
					'marginRight',
					'marginTop',
					'marginBottom',
					'borderLeftWidth',
					'borderRightWidth',
					'borderTopWidth',
					'borderBottomWidth'
				];

				var measurementsLength = measurements.length;

				function getZeroSize() {
					var size = {
						width: 0,
						height: 0,
						innerWidth: 0,
						innerHeight: 0,
						outerWidth: 0,
						outerHeight: 0
					};
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						size[measurement] = 0;
					}
					return size;
				}

				// -------------------------- getStyle -------------------------- //

				/**
				 * getStyle, get style of element, check for Firefox bug
				 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
				 */
				function getStyle(elem) {
					var style = getComputedStyle(elem);
					if (!style) {
						logError('Style returned ' + style +
							'. Are you running this code in a hidden iframe on Firefox? ' +
							'See https://bit.ly/getsizebug1');
					}
					return style;
				}

				// -------------------------- setup -------------------------- //

				var isSetup = false;

				var isBoxSizeOuter;

				/**
				 * setup
				 * check isBoxSizerOuter
				 * do on first getSize() rather than on page load for Firefox bug
				 */
				function setup() {
					// setup once
					if (isSetup) {
						return;
					}
					isSetup = true;

					// -------------------------- box sizing -------------------------- //

					/**
					 * Chrome & Safari measure the outer-width on style.width on border-box elems
					 * IE11 & Firefox<29 measures the inner-width
					 */
					var div = document.createElement('div');
					div.style.width = '200px';
					div.style.padding = '1px 2px 3px 4px';
					div.style.borderStyle = 'solid';
					div.style.borderWidth = '1px 2px 3px 4px';
					div.style.boxSizing = 'border-box';

					var body = document.body || document.documentElement;
					body.appendChild(div);
					var style = getStyle(div);
					// round value for browser zoom. desandro/masonry#928
					isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
					getSize.isBoxSizeOuter = isBoxSizeOuter;

					body.removeChild(div);
				}

				// -------------------------- getSize -------------------------- //

				function getSize(elem) {
					setup();

					// use querySeletor if elem is string
					if (typeof elem == 'string') {
						elem = document.querySelector(elem);
					}

					// do not proceed on non-objects
					if (!elem || typeof elem != 'object' || !elem.nodeType) {
						return;
					}

					var style = getStyle(elem);

					// if hidden, everything is 0
					if (style.display == 'none') {
						return getZeroSize();
					}

					var size = {};
					size.width = elem.offsetWidth;
					size.height = elem.offsetHeight;

					var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

					// get all measurements
					for (var i = 0; i < measurementsLength; i++) {
						var measurement = measurements[i];
						var value = style[measurement];
						var num = parseFloat(value);
						// any 'auto', 'medium' value will be 0
						size[measurement] = !isNaN(num) ? num : 0;
					}

					var paddingWidth = size.paddingLeft + size.paddingRight;
					var paddingHeight = size.paddingTop + size.paddingBottom;
					var marginWidth = size.marginLeft + size.marginRight;
					var marginHeight = size.marginTop + size.marginBottom;
					var borderWidth = size.borderLeftWidth + size.borderRightWidth;
					var borderHeight = size.borderTopWidth + size.borderBottomWidth;

					var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

					// overwrite width and height if we can get it from style
					var styleWidth = getStyleSize(style.width);
					if (styleWidth !== false) {
						size.width = styleWidth +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
					}

					var styleHeight = getStyleSize(style.height);
					if (styleHeight !== false) {
						size.height = styleHeight +
							// add padding and border unless it's already including it
							(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
					}

					size.innerWidth = size.width - (paddingWidth + borderWidth);
					size.innerHeight = size.height - (paddingHeight + borderHeight);

					size.outerWidth = size.width + marginWidth;
					size.outerHeight = size.height + marginHeight;

					return size;
				}

				return getSize;

			});
		});

		var index_es_matchesSelector = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * matchesSelector v2.0.2
			 * matchesSelector( element, '.selector' )
			 * MIT license
			 */

			/*jshint browser: true, strict: true, undef: true, unused: true */

			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.matchesSelector = factory();
				}

			}(window, function factory() {

				var matchesMethod = (function () {
					var ElemProto = window.Element.prototype;
					// check for the standard method name first
					if (ElemProto.matches) {
						return 'matches';
					}
					// check un-prefixed
					if (ElemProto.matchesSelector) {
						return 'matchesSelector';
					}
					// check vendor prefixes
					var prefixes = ['webkit', 'moz', 'ms', 'o'];

					for (var i = 0; i < prefixes.length; i++) {
						var prefix = prefixes[i];
						var method = prefix + 'MatchesSelector';
						if (ElemProto[method]) {
							return method;
						}
					}
				})();

				return function matchesSelector(elem, selector) {
					return elem[matchesMethod](selector);
				};

			}));
		});

		var index_es_utils = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * Fizzy UI utils v2.0.7
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_matchesSelector
					);
				} else {
					// browser global
					window.fizzyUIUtils = factory(
						window,
						window.matchesSelector
					);
				}

			}(window, function factory(window, matchesSelector) {

				var utils = {};

				// ----- extend ----- //

				// extends objects
				utils.extend = function (a, b) {
					for (var prop in b) {
						a[prop] = b[prop];
					}
					return a;
				};

				// ----- modulo ----- //

				utils.modulo = function (num, div) {
					return ((num % div) + div) % div;
				};

				// ----- makeArray ----- //

				var arraySlice = Array.prototype.slice;

				// turn element or nodeList into an array
				utils.makeArray = function (obj) {
					if (Array.isArray(obj)) {
						// use object if already an array
						return obj;
					}
					// return empty array if undefined or null. #6
					if (obj === null || obj === undefined) {
						return [];
					}

					var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
					if (isArrayLike) {
						// convert nodeList to array
						return arraySlice.call(obj);
					}

					// array of single index
					return [obj];
				};

				// ----- removeFrom ----- //

				utils.removeFrom = function (ary, obj) {
					var index = ary.indexOf(obj);
					if (index != -1) {
						ary.splice(index, 1);
					}
				};

				// ----- getParent ----- //

				utils.getParent = function (elem, selector) {
					while (elem.parentNode && elem != document.body) {
						elem = elem.parentNode;
						if (matchesSelector(elem, selector)) {
							return elem;
						}
					}
				};

				// ----- getQueryElement ----- //

				// use element as selector string
				utils.getQueryElement = function (elem) {
					if (typeof elem == 'string') {
						return document.querySelector(elem);
					}
					return elem;
				};

				// ----- handleEvent ----- //

				// enable .ontype to trigger from .addEventListener( elem, 'type' )
				utils.handleEvent = function (event) {
					var method = 'on' + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// ----- filterFindElements ----- //

				utils.filterFindElements = function (elems, selector) {
					// make array of elems
					elems = utils.makeArray(elems);
					var ffElems = [];

					elems.forEach(function (elem) {
						// check that elem is an actual element
						if (!(elem instanceof HTMLElement)) {
							return;
						}
						// add elem if no selector
						if (!selector) {
							ffElems.push(elem);
							return;
						}
						// filter & find items if we have a selector
						// filter
						if (matchesSelector(elem, selector)) {
							ffElems.push(elem);
						}
						// find children
						var childElems = elem.querySelectorAll(selector);
						// concat childElems to filterFound array
						for (var i = 0; i < childElems.length; i++) {
							ffElems.push(childElems[i]);
						}
					});

					return ffElems;
				};

				// ----- debounceMethod ----- //

				utils.debounceMethod = function (_class, methodName, threshold) {
					threshold = threshold || 100;
					// original method
					var method = _class.prototype[methodName];
					var timeoutName = methodName + 'Timeout';

					_class.prototype[methodName] = function () {
						var timeout = this[timeoutName];
						clearTimeout(timeout);

						var args = arguments;
						var _this = this;
						this[timeoutName] = setTimeout(function () {
							method.apply(_this, args);
							delete _this[timeoutName];
						}, threshold);
					};
				};

				// ----- docReady ----- //

				utils.docReady = function (callback) {
					var readyState = document.readyState;
					if (readyState == 'complete' || readyState == 'interactive') {
						// do async to allow for other scripts to run. metafizzy/flickity#441
						setTimeout(callback);
					} else {
						document.addEventListener('DOMContentLoaded', callback);
					}
				};

				// ----- htmlInit ----- //

				// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
				utils.toDashed = function (str) {
					return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
						return $1 + '-' + $2;
					}).toLowerCase();
				};

				var console = window.console;
				/**
				 * allow user to initialize classes via [data-namespace] or .js-namespace class
				 * htmlInit( Widget, 'widgetName' )
				 * options are parsed from data-namespace-options
				 */
				utils.htmlInit = function (WidgetClass, namespace) {
					utils.docReady(function () {
						var dashedNamespace = utils.toDashed(namespace);
						var dataAttr = 'data-' + dashedNamespace;
						var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
						var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
						var elems = utils.makeArray(dataAttrElems)
							.concat(utils.makeArray(jsDashElems));
						var dataOptionsAttr = dataAttr + '-options';
						var jQuery = window.jQuery;

						elems.forEach(function (elem) {
							var attr = elem.getAttribute(dataAttr) ||
								elem.getAttribute(dataOptionsAttr);
							var options;
							try {
								options = attr && JSON.parse(attr);
							} catch (error) {
								// log error, do not initialize
								if (console) {
									console.error('Error parsing ' + dataAttr + ' on ' + elem.className +
										': ' + error);
								}
								return;
							}
							// initialize
							var instance = new WidgetClass(elem, options);
							// make available via $().data('namespace')
							if (jQuery) {
								jQuery.data(elem, namespace, instance);
							}
						});

					});
				};

				// -----  ----- //

				return utils;

			}));
		});

		var index_es_cell = dist_index_es_createCommonjsModule(function (module) {
			// Flickity.Cell
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_getSize
					);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Cell = factory(
						window,
						window.getSize
					);
				}

			}(window, function factory(window, getSize) {

				function Cell(elem, parent) {
					this.element = elem;
					this.parent = parent;

					this.create();
				}

				var proto = Cell.prototype;

				proto.create = function () {
					this.element.style.position = 'absolute';
					this.element.setAttribute('aria-hidden', 'true');
					this.x = 0;
					this.shift = 0;
				};

				proto.destroy = function () {
					// reset style
					this.unselect();
					this.element.style.position = '';
					var side = this.parent.originSide;
					this.element.style[side] = '';
					this.element.removeAttribute('aria-hidden');
				};

				proto.getSize = function () {
					this.size = getSize(this.element);
				};

				proto.setPosition = function (x) {
					this.x = x;
					this.updateTarget();
					this.renderPosition(x);
				};

				// setDefaultTarget v1 method, backwards compatibility, remove in v3
				proto.updateTarget = proto.setDefaultTarget = function () {
					var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
					this.target = this.x + this.size[marginProperty] +
						this.size.width * this.parent.cellAlign;
				};

				proto.renderPosition = function (x) {
					// render position of cell with in slider
					var side = this.parent.originSide;
					this.element.style[side] = this.parent.getPositionValue(x);
				};

				proto.select = function () {
					this.element.classList.add('is-selected');
					this.element.removeAttribute('aria-hidden');
				};

				proto.unselect = function () {
					this.element.classList.remove('is-selected');
					this.element.setAttribute('aria-hidden', 'true');
				};

				/**
				 * @param {Integer} shift - 0, 1, or -1
				 */
				proto.wrapShift = function (shift) {
					this.shift = shift;
					this.renderPosition(this.x + this.parent.slideableWidth * shift);
				};

				proto.remove = function () {
					this.element.parentNode.removeChild(this.element);
				};

				return Cell;

			}));
		});

		var index_es_slide = dist_index_es_createCommonjsModule(function (module) {
			// slide
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory();
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.Slide = factory();
				}

			}(window, function factory() {

				function Slide(parent) {
					this.parent = parent;
					this.isOriginLeft = parent.originSide == 'left';
					this.cells = [];
					this.outerWidth = 0;
					this.height = 0;
				}

				var proto = Slide.prototype;

				proto.addCell = function (cell) {
					this.cells.push(cell);
					this.outerWidth += cell.size.outerWidth;
					this.height = Math.max(cell.size.outerHeight, this.height);
					// first cell stuff
					if (this.cells.length == 1) {
						this.x = cell.x; // x comes from first cell
						var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
						this.firstMargin = cell.size[beginMargin];
					}
				};

				proto.updateTarget = function () {
					var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
					var lastCell = this.getLastCell();
					var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
					var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
					this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.select = function () {
					this.cells.forEach(function (cell) {
						cell.select();
					});
				};

				proto.unselect = function () {
					this.cells.forEach(function (cell) {
						cell.unselect();
					});
				};

				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				return Slide;

			}));
		});

		var index_es_animate = dist_index_es_createCommonjsModule(function (module) {
			// animate
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_utils
					);
				} else {
					// browser global
					window.Flickity = window.Flickity || {};
					window.Flickity.animatePrototype = factory(
						window,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, utils) {

				// -------------------------- animate -------------------------- //

				var proto = {};

				proto.startAnimation = function () {
					if (this.isAnimating) {
						return;
					}

					this.isAnimating = true;
					this.restingFrames = 0;
					this.animate();
				};

				proto.animate = function () {
					this.applyDragForce();
					this.applySelectedAttraction();

					var previousX = this.x;

					this.integratePhysics();
					this.positionSlider();
					this.settle(previousX);
					// animate next frame
					if (this.isAnimating) {
						var _this = this;
						requestAnimationFrame(function animateFrame() {
							_this.animate();
						});
					}
				};

				proto.positionSlider = function () {
					var x = this.x;
					// wrap position around
					if (this.options.wrapAround && this.cells.length > 1) {
						x = utils.modulo(x, this.slideableWidth);
						x -= this.slideableWidth;
						this.shiftWrapCells(x);
					}

					this.setTranslateX(x, this.isAnimating);
					this.dispatchScrollEvent();
				};

				proto.setTranslateX = function (x, is3d) {
					x += this.cursorPosition;
					// reverse if right-to-left and using transform
					x = this.options.rightToLeft ? -x : x;
					var translateX = this.getPositionValue(x);
					// use 3D transforms for hardware acceleration on iOS
					// but use 2D when settled, for better font-rendering
					this.slider.style.transform = is3d ?
						'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
				};

				proto.dispatchScrollEvent = function () {
					var firstSlide = this.slides[0];
					if (!firstSlide) {
						return;
					}
					var positionX = -this.x - firstSlide.target;
					var progress = positionX / this.slidesWidth;
					this.dispatchEvent('scroll', null, [progress, positionX]);
				};

				proto.positionSliderAtSelected = function () {
					if (!this.cells.length) {
						return;
					}
					this.x = -this.selectedSlide.target;
					this.velocity = 0; // stop wobble
					this.positionSlider();
				};

				proto.getPositionValue = function (position) {
					if (this.options.percentPosition) {
						// percent position, round to 2 digits, like 12.34%
						return (Math.round((position / this.size.innerWidth) * 10000) * 0.01) + '%';
					} else {
						// pixel positioning
						return Math.round(position) + 'px';
					}
				};

				proto.settle = function (previousX) {
					// keep track of frames where x hasn't moved
					var isResting = !this.isPointerDown &&
						Math.round(this.x * 100) == Math.round(previousX * 100);
					if (isResting) {
						this.restingFrames++;
					}
					// stop animating if resting for 3 or more frames
					if (this.restingFrames > 2) {
						this.isAnimating = false;
						delete this.isFreeScrolling;
						// render position with translateX when settled
						this.positionSlider();
						this.dispatchEvent('settle', null, [this.selectedIndex]);
					}
				};

				proto.shiftWrapCells = function (x) {
					// shift before cells
					var beforeGap = this.cursorPosition + x;
					this._shiftCells(this.beforeShiftCells, beforeGap, -1);
					// shift after cells
					var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
					this._shiftCells(this.afterShiftCells, afterGap, 1);
				};

				proto._shiftCells = function (cells, gap, shift) {
					for (var i = 0; i < cells.length; i++) {
						var cell = cells[i];
						var cellShift = gap > 0 ? shift : 0;
						cell.wrapShift(cellShift);
						gap -= cell.size.outerWidth;
					}
				};

				proto._unshiftCells = function (cells) {
					if (!cells || !cells.length) {
						return;
					}
					for (var i = 0; i < cells.length; i++) {
						cells[i].wrapShift(0);
					}
				};

				// -------------------------- physics -------------------------- //

				proto.integratePhysics = function () {
					this.x += this.velocity;
					this.velocity *= this.getFrictionFactor();
				};

				proto.applyForce = function (force) {
					this.velocity += force;
				};

				proto.getFrictionFactor = function () {
					return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
				};

				proto.getRestingPosition = function () {
					// my thanks to Steven Wittens, who simplified this math greatly
					return this.x + this.velocity / (1 - this.getFrictionFactor());
				};

				proto.applyDragForce = function () {
					if (!this.isDraggable || !this.isPointerDown) {
						return;
					}
					// change the position to drag position by applying force
					var dragVelocity = this.dragX - this.x;
					var dragForce = dragVelocity - this.velocity;
					this.applyForce(dragForce);
				};

				proto.applySelectedAttraction = function () {
					// do not attract if pointer down or no slides
					var dragDown = this.isDraggable && this.isPointerDown;
					if (dragDown || this.isFreeScrolling || !this.slides.length) {
						return;
					}
					var distance = this.selectedSlide.target * -1 - this.x;
					var force = distance * this.options.selectedAttraction;
					this.applyForce(force);
				};

				return proto;

			}));
		});

		var index_es_flickity = dist_index_es_createCommonjsModule(function (module) {
			// Flickity main
			/* eslint-disable max-params */
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_evEmitter,
						index_es_getSize,
						index_es_utils,
						index_es_cell,
						index_es_slide,
						index_es_animate
					);
				} else {
					// browser global
					var _Flickity = window.Flickity;

					window.Flickity = factory(
						window,
						window.EvEmitter,
						window.getSize,
						window.fizzyUIUtils,
						_Flickity.Cell,
						_Flickity.Slide,
						_Flickity.animatePrototype
					);
				}

			}(window, function factory(window, EvEmitter, getSize,
				utils, Cell, Slide, animatePrototype) {

				// vars
				var jQuery = window.jQuery;
				var getComputedStyle = window.getComputedStyle;
				var console = window.console;

				function moveElements(elems, toElem) {
					elems = utils.makeArray(elems);
					while (elems.length) {
						toElem.appendChild(elems.shift());
					}
				}

				// -------------------------- Flickity -------------------------- //

				// globally unique identifiers
				var GUID = 0;
				// internal store of all Flickity intances
				var instances = {};

				function Flickity(element, options) {
					var queryElement = utils.getQueryElement(element);
					if (!queryElement) {
						if (console) {
							console.error('Bad element for Flickity: ' + (queryElement || element));
						}
						return;
					}
					this.element = queryElement;
					// do not initialize twice on same element
					if (this.element.flickityGUID) {
						var instance = instances[this.element.flickityGUID];
						if (instance) instance.option(options);
						return instance;
					}

					// add jQuery
					if (jQuery) {
						this.$element = jQuery(this.element);
					}
					// options
					this.options = utils.extend({}, this.constructor.defaults);
					this.option(options);

					// kick things off
					this._create();
				}

				Flickity.defaults = {
					accessibility: true,
					// adaptiveHeight: false,
					cellAlign: 'center',
					// cellSelector: undefined,
					// contain: false,
					freeScrollFriction: 0.075, // friction when free-scrolling
					friction: 0.28, // friction when selecting
					namespaceJQueryEvents: true,
					// initialIndex: 0,
					percentPosition: true,
					resize: true,
					selectedAttraction: 0.025,
					setGallerySize: true,
					// watchCSS: false,
					// wrapAround: false
				};

				// hash of methods triggered on _create()
				Flickity.createMethods = [];

				var proto = Flickity.prototype;
				// inherit EventEmitter
				utils.extend(proto, EvEmitter.prototype);

				proto._create = function () {
					// add id for Flickity.data
					var id = this.guid = ++GUID;
					this.element.flickityGUID = id; // expando
					instances[id] = this; // associate via id
					// initial properties
					this.selectedIndex = 0;
					// how many frames slider has been in same position
					this.restingFrames = 0;
					// initial physics properties
					this.x = 0;
					this.velocity = 0;
					this.originSide = this.options.rightToLeft ? 'right' : 'left';
					// create viewport & slider
					this.viewport = document.createElement('div');
					this.viewport.className = 'flickity-viewport';
					this._createSlider();

					if (this.options.resize || this.options.watchCSS) {
						window.addEventListener('resize', this);
					}

					// add listeners from on option
					for (var eventName in this.options.on) {
						var listener = this.options.on[eventName];
						this.on(eventName, listener);
					}

					Flickity.createMethods.forEach(function (method) {
						this[method]();
					}, this);

					if (this.options.watchCSS) {
						this.watchCSS();
					} else {
						this.activate();
					}

				};

				/**
				 * set options
				 * @param {Object} opts - options to extend
				 */
				proto.option = function (opts) {
					utils.extend(this.options, opts);
				};

				proto.activate = function () {
					if (this.isActive) {
						return;
					}
					this.isActive = true;
					this.element.classList.add('flickity-enabled');
					if (this.options.rightToLeft) {
						this.element.classList.add('flickity-rtl');
					}

					this.getSize();
					// move initial cell elements so they can be loaded as cells
					var cellElems = this._filterFindCellElements(this.element.children);
					moveElements(cellElems, this.slider);
					this.viewport.appendChild(this.slider);
					this.element.appendChild(this.viewport);
					// get cells from children
					this.reloadCells();

					if (this.options.accessibility) {
						// allow element to focusable
						this.element.tabIndex = 0;
						// listen for key presses
						this.element.addEventListener('keydown', this);
					}

					this.emitEvent('activate');
					this.selectInitialIndex();
					// flag for initial activation, for using initialIndex
					this.isInitActivated = true;
					// ready event. #493
					this.dispatchEvent('ready');
				};

				// slider positions the cells
				proto._createSlider = function () {
					// slider element does all the positioning
					var slider = document.createElement('div');
					slider.className = 'flickity-slider';
					slider.style[this.originSide] = 0;
					this.slider = slider;
				};

				proto._filterFindCellElements = function (elems) {
					return utils.filterFindElements(elems, this.options.cellSelector);
				};

				// goes through all children
				proto.reloadCells = function () {
					// collection of item elements
					this.cells = this._makeCells(this.slider.children);
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
				};

				/**
				 * turn elements into Flickity.Cells
				 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
				 * @returns {Array} items - collection of new Flickity Cells
				 */
				proto._makeCells = function (elems) {
					var cellElems = this._filterFindCellElements(elems);

					// create new Flickity for collection
					var cells = cellElems.map(function (cellElem) {
						return new Cell(cellElem, this);
					}, this);

					return cells;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.getLastSlide = function () {
					return this.slides[this.slides.length - 1];
				};

				// positions all cells
				proto.positionCells = function () {
					// size all cells
					this._sizeCells(this.cells);
					// position all cells
					this._positionCells(0);
				};

				/**
				 * position certain cells
				 * @param {Integer} index - which cell to start with
				 */
				proto._positionCells = function (index) {
					index = index || 0;
					// also measure maxCellHeight
					// start 0 if positioning all cells
					this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
					var cellX = 0;
					// get cellX
					if (index > 0) {
						var startCell = this.cells[index - 1];
						cellX = startCell.x + startCell.size.outerWidth;
					}
					var len = this.cells.length;
					for (var i = index; i < len; i++) {
						var cell = this.cells[i];
						cell.setPosition(cellX);
						cellX += cell.size.outerWidth;
						this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
					}
					// keep track of cellX for wrap-around
					this.slideableWidth = cellX;
					// slides
					this.updateSlides();
					// contain slides target
					this._containSlides();
					// update slidesWidth
					this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
				};

				/**
				 * cell.getSize() on multiple cells
				 * @param {Array} cells - cells to size
				 */
				proto._sizeCells = function (cells) {
					cells.forEach(function (cell) {
						cell.getSize();
					});
				};

				// --------------------------  -------------------------- //

				proto.updateSlides = function () {
					this.slides = [];
					if (!this.cells.length) {
						return;
					}

					var slide = new Slide(this);
					this.slides.push(slide);
					var isOriginLeft = this.originSide == 'left';
					var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

					var canCellFit = this._getCanCellFit();

					this.cells.forEach(function (cell, i) {
						// just add cell if first cell in slide
						if (!slide.cells.length) {
							slide.addCell(cell);
							return;
						}

						var slideWidth = (slide.outerWidth - slide.firstMargin) +
							(cell.size.outerWidth - cell.size[nextMargin]);

						if (canCellFit.call(this, i, slideWidth)) {
							slide.addCell(cell);
						} else {
							// doesn't fit, new slide
							slide.updateTarget();

							slide = new Slide(this);
							this.slides.push(slide);
							slide.addCell(cell);
						}
					}, this);
					// last slide
					slide.updateTarget();
					// update .selectedSlide
					this.updateSelectedSlide();
				};

				proto._getCanCellFit = function () {
					var groupCells = this.options.groupCells;
					if (!groupCells) {
						return function () {
							return false;
						};
					} else if (typeof groupCells == 'number') {
						// group by number. 3 -> [0,1,2], [3,4,5], ...
						var number = parseInt(groupCells, 10);
						return function (i) {
							return (i % number) !== 0;
						};
					}
					// default, group by width of slide
					// parse '75%
					var percentMatch = typeof groupCells == 'string' &&
						groupCells.match(/^(\d+)%$/);
					var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
					return function (i, slideWidth) {
						/* eslint-disable-next-line no-invalid-this */
						return slideWidth <= (this.size.innerWidth + 1) * percent;
					};
				};

				// alias _init for jQuery plugin .flickity()
				proto._init =
					proto.reposition = function () {
						this.positionCells();
						this.positionSliderAtSelected();
					};

				proto.getSize = function () {
					this.size = getSize(this.element);
					this.setCellAlign();
					this.cursorPosition = this.size.innerWidth * this.cellAlign;
				};

				var cellAlignShorthands = {
					// cell align, then based on origin side
					center: {
						left: 0.5,
						right: 0.5,
					},
					left: {
						left: 0,
						right: 1,
					},
					right: {
						right: 0,
						left: 1,
					},
				};

				proto.setCellAlign = function () {
					var shorthand = cellAlignShorthands[this.options.cellAlign];
					this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
				};

				proto.setGallerySize = function () {
					if (this.options.setGallerySize) {
						var height = this.options.adaptiveHeight && this.selectedSlide ?
							this.selectedSlide.height : this.maxCellHeight;
						this.viewport.style.height = height + 'px';
					}
				};

				proto._getWrapShiftCells = function () {
					// only for wrap-around
					if (!this.options.wrapAround) {
						return;
					}
					// unshift previous cells
					this._unshiftCells(this.beforeShiftCells);
					this._unshiftCells(this.afterShiftCells);
					// get before cells
					// initial gap
					var gapX = this.cursorPosition;
					var cellIndex = this.cells.length - 1;
					this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
					// get after cells
					// ending gap between last cell and end of gallery viewport
					gapX = this.size.innerWidth - this.cursorPosition;
					// start cloning at first cell, working forwards
					this.afterShiftCells = this._getGapCells(gapX, 0, 1);
				};

				proto._getGapCells = function (gapX, cellIndex, increment) {
					// keep adding cells until the cover the initial gap
					var cells = [];
					while (gapX > 0) {
						var cell = this.cells[cellIndex];
						if (!cell) {
							break;
						}
						cells.push(cell);
						cellIndex += increment;
						gapX -= cell.size.outerWidth;
					}
					return cells;
				};

				// ----- contain ----- //

				// contain cell targets so no excess sliding
				proto._containSlides = function () {
					if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
						return;
					}
					var isRightToLeft = this.options.rightToLeft;
					var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
					var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
					var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
					// content is less than gallery size
					var isContentSmaller = contentWidth < this.size.innerWidth;
					// bounds
					var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
					var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
					// contain each cell target
					this.slides.forEach(function (slide) {
						if (isContentSmaller) {
							// all cells fit inside gallery
							slide.target = contentWidth * this.cellAlign;
						} else {
							// contain to bounds
							slide.target = Math.max(slide.target, beginBound);
							slide.target = Math.min(slide.target, endBound);
						}
					}, this);
				};

				// -----  ----- //

				/**
				 * emits events via eventEmitter and jQuery events
				 * @param {String} type - name of event
				 * @param {Event} event - original event
				 * @param {Array} args - extra arguments
				 */
				proto.dispatchEvent = function (type, event, args) {
					var emitArgs = event ? [event].concat(args) : args;
					this.emitEvent(type, emitArgs);

					if (jQuery && this.$element) {
						// default trigger with type if no event
						type += this.options.namespaceJQueryEvents ? '.flickity' : '';
						var $event = type;
						if (event) {
							// create jQuery event
							var jQEvent = new jQuery.Event(event);
							jQEvent.type = type;
							$event = jQEvent;
						}
						this.$element.trigger($event, args);
					}
				};

				// -------------------------- select -------------------------- //

				/**
				 * @param {Integer} index - index of the slide
				 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
				 * @param {Boolean} isInstant - will immediately set position at selected cell
				 */
				proto.select = function (index, isWrap, isInstant) {
					if (!this.isActive) {
						return;
					}
					index = parseInt(index, 10);
					this._wrapSelect(index);

					if (this.options.wrapAround || isWrap) {
						index = utils.modulo(index, this.slides.length);
					}
					// bail if invalid index
					if (!this.slides[index]) {
						return;
					}
					var prevIndex = this.selectedIndex;
					this.selectedIndex = index;
					this.updateSelectedSlide();
					if (isInstant) {
						this.positionSliderAtSelected();
					} else {
						this.startAnimation();
					}
					if (this.options.adaptiveHeight) {
						this.setGallerySize();
					}
					// events
					this.dispatchEvent('select', null, [index]);
					// change event if new index
					if (index != prevIndex) {
						this.dispatchEvent('change', null, [index]);
					}
					// old v1 event name, remove in v3
					this.dispatchEvent('cellSelect');
				};

				// wraps position for wrapAround, to move to closest slide. #113
				proto._wrapSelect = function (index) {
					var len = this.slides.length;
					var isWrapping = this.options.wrapAround && len > 1;
					if (!isWrapping) {
						return index;
					}
					var wrapIndex = utils.modulo(index, len);
					// go to shortest
					var delta = Math.abs(wrapIndex - this.selectedIndex);
					var backWrapDelta = Math.abs((wrapIndex + len) - this.selectedIndex);
					var forewardWrapDelta = Math.abs((wrapIndex - len) - this.selectedIndex);
					if (!this.isDragSelect && backWrapDelta < delta) {
						index += len;
					} else if (!this.isDragSelect && forewardWrapDelta < delta) {
						index -= len;
					}
					// wrap position so slider is within normal area
					if (index < 0) {
						this.x -= this.slideableWidth;
					} else if (index >= len) {
						this.x += this.slideableWidth;
					}
				};

				proto.previous = function (isWrap, isInstant) {
					this.select(this.selectedIndex - 1, isWrap, isInstant);
				};

				proto.next = function (isWrap, isInstant) {
					this.select(this.selectedIndex + 1, isWrap, isInstant);
				};

				proto.updateSelectedSlide = function () {
					var slide = this.slides[this.selectedIndex];
					// selectedIndex could be outside of slides, if triggered before resize()
					if (!slide) {
						return;
					}
					// unselect previous selected slide
					this.unselectSelectedSlide();
					// update new selected slide
					this.selectedSlide = slide;
					slide.select();
					this.selectedCells = slide.cells;
					this.selectedElements = slide.getCellElements();
					// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
					// Remove in v3?
					this.selectedCell = slide.cells[0];
					this.selectedElement = this.selectedElements[0];
				};

				proto.unselectSelectedSlide = function () {
					if (this.selectedSlide) {
						this.selectedSlide.unselect();
					}
				};

				proto.selectInitialIndex = function () {
					var initialIndex = this.options.initialIndex;
					// already activated, select previous selectedIndex
					if (this.isInitActivated) {
						this.select(this.selectedIndex, false, true);
						return;
					}
					// select with selector string
					if (initialIndex && typeof initialIndex == 'string') {
						var cell = this.queryCell(initialIndex);
						if (cell) {
							this.selectCell(initialIndex, false, true);
							return;
						}
					}

					var index = 0;
					// select with number
					if (initialIndex && this.slides[initialIndex]) {
						index = initialIndex;
					}
					// select instantly
					this.select(index, false, true);
				};

				/**
				 * select slide from number or cell element
				 * @param {[Element, Number]} value - zero-based index or element to select
				 * @param {Boolean} isWrap - enables wrapping around for extra index
				 * @param {Boolean} isInstant - disables slide animation
				 */
				proto.selectCell = function (value, isWrap, isInstant) {
					// get cell
					var cell = this.queryCell(value);
					if (!cell) {
						return;
					}

					var index = this.getCellSlideIndex(cell);
					this.select(index, isWrap, isInstant);
				};

				proto.getCellSlideIndex = function (cell) {
					// get index of slides that has cell
					for (var i = 0; i < this.slides.length; i++) {
						var slide = this.slides[i];
						var index = slide.cells.indexOf(cell);
						if (index != -1) {
							return i;
						}
					}
				};

				// -------------------------- get cells -------------------------- //

				/**
				 * get Flickity.Cell, given an Element
				 * @param {Element} elem - matching cell element
				 * @returns {Flickity.Cell} cell - matching cell
				 */
				proto.getCell = function (elem) {
					// loop through cells to get the one that matches
					for (var i = 0; i < this.cells.length; i++) {
						var cell = this.cells[i];
						if (cell.element == elem) {
							return cell;
						}
					}
				};

				/**
				 * get collection of Flickity.Cells, given Elements
				 * @param {[Element, Array, NodeList]} elems - multiple elements
				 * @returns {Array} cells - Flickity.Cells
				 */
				proto.getCells = function (elems) {
					elems = utils.makeArray(elems);
					var cells = [];
					elems.forEach(function (elem) {
						var cell = this.getCell(elem);
						if (cell) {
							cells.push(cell);
						}
					}, this);
					return cells;
				};

				/**
				 * get cell elements
				 * @returns {Array} cellElems
				 */
				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				/**
				 * get parent cell from an element
				 * @param {Element} elem - child element
				 * @returns {Flickit.Cell} cell - parent cell
				 */
				proto.getParentCell = function (elem) {
					// first check if elem is cell
					var cell = this.getCell(elem);
					if (cell) {
						return cell;
					}
					// try to get parent cell elem
					elem = utils.getParent(elem, '.flickity-slider > *');
					return this.getCell(elem);
				};

				/**
				 * get cells adjacent to a slide
				 * @param {Integer} adjCount - number of adjacent slides
				 * @param {Integer} index - index of slide to start
				 * @returns {Array} cells - array of Flickity.Cells
				 */
				proto.getAdjacentCellElements = function (adjCount, index) {
					if (!adjCount) {
						return this.selectedSlide.getCellElements();
					}
					index = index === undefined ? this.selectedIndex : index;

					var len = this.slides.length;
					if (1 + (adjCount * 2) >= len) {
						return this.getCellElements();
					}

					var cellElems = [];
					for (var i = index - adjCount; i <= index + adjCount; i++) {
						var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
						var slide = this.slides[slideIndex];
						if (slide) {
							cellElems = cellElems.concat(slide.getCellElements());
						}
					}
					return cellElems;
				};

				/**
				 * select slide from number or cell element
				 * @param {[Element, String, Number]} selector - element, selector string, or index
				 * @returns {Flickity.Cell} - matching cell
				 */
				proto.queryCell = function (selector) {
					if (typeof selector == 'number') {
						// use number as index
						return this.cells[selector];
					}
					if (typeof selector == 'string') {
						// do not select invalid selectors from hash: #123, #/. #791
						if (selector.match(/^[#.]?[\d/]/)) {
							return;
						}
						// use string as selector, get element
						selector = this.element.querySelector(selector);
					}
					// get cell from element
					return this.getCell(selector);
				};

				// -------------------------- events -------------------------- //

				proto.uiChange = function () {
					this.emitEvent('uiChange');
				};

				// keep focus on element when child UI elements are clicked
				proto.childUIPointerDown = function (event) {
					// HACK iOS does not allow touch events to bubble up?!
					if (event.type != 'touchstart') {
						event.preventDefault();
					}
					this.focus();
				};

				// ----- resize ----- //

				proto.onresize = function () {
					this.watchCSS();
					this.resize();
				};

				utils.debounceMethod(Flickity, 'onresize', 150);

				proto.resize = function () {
					if (!this.isActive) {
						return;
					}
					this.getSize();
					// wrap values
					if (this.options.wrapAround) {
						this.x = utils.modulo(this.x, this.slideableWidth);
					}
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
					this.emitEvent('resize');
					// update selected index for group slides, instant
					// TODO: position can be lost between groups of various numbers
					var selectedElement = this.selectedElements && this.selectedElements[0];
					this.selectCell(selectedElement, false, true);
				};

				// watches the :after property, activates/deactivates
				proto.watchCSS = function () {
					var watchOption = this.options.watchCSS;
					if (!watchOption) {
						return;
					}

					var afterContent = getComputedStyle(this.element, ':after').content;
					// activate if :after { content: 'flickity' }
					if (afterContent.indexOf('flickity') != -1) {
						this.activate();
					} else {
						this.deactivate();
					}
				};

				// ----- keydown ----- //

				// go previous/next if left/right keys pressed
				proto.onkeydown = function (event) {
					// only work if element is in focus
					var isNotFocused = document.activeElement && document.activeElement != this.element;
					if (!this.options.accessibility || isNotFocused) {
						return;
					}

					var handler = Flickity.keyboardHandlers[event.keyCode];
					if (handler) {
						handler.call(this);
					}
				};

				Flickity.keyboardHandlers = {
					// left arrow
					37: function () {
						var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
						this.uiChange();
						this[leftMethod]();
					},
					// right arrow
					39: function () {
						var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
						this.uiChange();
						this[rightMethod]();
					},
				};

				// ----- focus ----- //

				proto.focus = function () {
					// TODO remove scrollTo once focus options gets more support
					// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
					//    #Browser_compatibility
					var prevScrollY = window.pageYOffset;
					this.element.focus({ preventScroll: true });
					// hack to fix scroll jump after focus, #76
					if (window.pageYOffset != prevScrollY) {
						window.scrollTo(window.pageXOffset, prevScrollY);
					}
				};

				// -------------------------- destroy -------------------------- //

				// deactivate all Flickity functionality, but keep stuff available
				proto.deactivate = function () {
					if (!this.isActive) {
						return;
					}
					this.element.classList.remove('flickity-enabled');
					this.element.classList.remove('flickity-rtl');
					this.unselectSelectedSlide();
					// destroy cells
					this.cells.forEach(function (cell) {
						cell.destroy();
					});
					this.element.removeChild(this.viewport);
					// move child elements back into element
					moveElements(this.slider.children, this.element);
					if (this.options.accessibility) {
						this.element.removeAttribute('tabIndex');
						this.element.removeEventListener('keydown', this);
					}
					// set flags
					this.isActive = false;
					this.emitEvent('deactivate');
				};

				proto.destroy = function () {
					this.deactivate();
					window.removeEventListener('resize', this);
					this.allOff();
					this.emitEvent('destroy');
					if (jQuery && this.$element) {
						jQuery.removeData(this.element, 'flickity');
					}
					delete this.element.flickityGUID;
					delete instances[this.guid];
				};

				// -------------------------- prototype -------------------------- //

				utils.extend(proto, animatePrototype);

				// -------------------------- extras -------------------------- //

				/**
				 * get Flickity instance from element
				 * @param {[Element, String]} elem - element or selector string
				 * @returns {Flickity} - Flickity instance
				 */
				Flickity.data = function (elem) {
					elem = utils.getQueryElement(elem);
					var id = elem && elem.flickityGUID;
					return id && instances[id];
				};

				utils.htmlInit(Flickity, 'flickity');

				if (jQuery && jQuery.bridget) {
					jQuery.bridget('flickity', Flickity);
				}

				// set internal jQuery, for Webpack + jQuery v3, #478
				Flickity.setJQuery = function (jq) {
					jQuery = jq;
				};

				Flickity.Cell = Cell;
				Flickity.Slide = Slide;

				return Flickity;

			}));
		});

		var index_es_unipointer = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Unipointer v2.3.0
			 * base class for doing one thing with pointer event
			 * MIT license
			 */

			/*jshint browser: true, undef: true, unused: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/* jshint strict: false */ /*global define, module, require */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_evEmitter
					);
				} else {
					// browser global
					window.Unipointer = factory(
						window,
						window.EvEmitter
					);
				}

			}(window, function factory(window, EvEmitter) {

				function noop() { }

				function Unipointer() { }

				// inherit EvEmitter
				var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);

				proto.bindStartEvent = function (elem) {
					this._bindStartEvent(elem, true);
				};

				proto.unbindStartEvent = function (elem) {
					this._bindStartEvent(elem, false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd - remove if falsey
				 */
				proto._bindStartEvent = function (elem, isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

					// default to mouse events
					var startEvent = 'mousedown';
					if (window.PointerEvent) {
						// Pointer Events
						startEvent = 'pointerdown';
					} else if ('ontouchstart' in window) {
						// Touch Events. iOS Safari
						startEvent = 'touchstart';
					}
					elem[bindMethod](startEvent, this);
				};

				// trigger handler methods for events
				proto.handleEvent = function (event) {
					var method = 'on' + event.type;
					if (this[method]) {
						this[method](event);
					}
				};

				// returns the touch that we're keeping track of
				proto.getTouch = function (touches) {
					for (var i = 0; i < touches.length; i++) {
						var touch = touches[i];
						if (touch.identifier == this.pointerIdentifier) {
							return touch;
						}
					}
				};

				// ----- start event ----- //

				proto.onmousedown = function (event) {
					// dismiss clicks from right or middle buttons
					var button = event.button;
					if (button && (button !== 0 && button !== 1)) {
						return;
					}
					this._pointerDown(event, event);
				};

				proto.ontouchstart = function (event) {
					this._pointerDown(event, event.changedTouches[0]);
				};

				proto.onpointerdown = function (event) {
					this._pointerDown(event, event);
				};

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto._pointerDown = function (event, pointer) {
					// dismiss right click and other pointers
					// button = 0 is okay, 1-4 not
					if (event.button || this.isPointerDown) {
						return;
					}

					this.isPointerDown = true;
					// save pointer identifier to match up touch events
					this.pointerIdentifier = pointer.pointerId !== undefined ?
						// pointerId for pointer events, touch.indentifier for touch events
						pointer.pointerId : pointer.identifier;

					this.pointerDown(event, pointer);
				};

				proto.pointerDown = function (event, pointer) {
					this._bindPostStartEvents(event);
					this.emitEvent('pointerDown', [event, pointer]);
				};

				// hash of events to be bound after start event
				var postStartEvents = {
					mousedown: ['mousemove', 'mouseup'],
					touchstart: ['touchmove', 'touchend', 'touchcancel'],
					pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
				};

				proto._bindPostStartEvents = function (event) {
					if (!event) {
						return;
					}
					// get proper events to match start event
					var events = postStartEvents[event.type];
					// bind events to node
					events.forEach(function (eventName) {
						window.addEventListener(eventName, this);
					}, this);
					// save these arguments
					this._boundPointerEvents = events;
				};

				proto._unbindPostStartEvents = function () {
					// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
					if (!this._boundPointerEvents) {
						return;
					}
					this._boundPointerEvents.forEach(function (eventName) {
						window.removeEventListener(eventName, this);
					}, this);

					delete this._boundPointerEvents;
				};

				// ----- move event ----- //

				proto.onmousemove = function (event) {
					this._pointerMove(event, event);
				};

				proto.onpointermove = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerMove(event, event);
					}
				};

				proto.ontouchmove = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerMove(event, touch);
					}
				};

				/**
				 * pointer move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerMove = function (event, pointer) {
					this.pointerMove(event, pointer);
				};

				// public
				proto.pointerMove = function (event, pointer) {
					this.emitEvent('pointerMove', [event, pointer]);
				};

				// ----- end event ----- //


				proto.onmouseup = function (event) {
					this._pointerUp(event, event);
				};

				proto.onpointerup = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerUp(event, event);
					}
				};

				proto.ontouchend = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerUp(event, touch);
					}
				};

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerUp = function (event, pointer) {
					this._pointerDone();
					this.pointerUp(event, pointer);
				};

				// public
				proto.pointerUp = function (event, pointer) {
					this.emitEvent('pointerUp', [event, pointer]);
				};

				// ----- pointer done ----- //

				// triggered on pointer up & pointer cancel
				proto._pointerDone = function () {
					this._pointerReset();
					this._unbindPostStartEvents();
					this.pointerDone();
				};

				proto._pointerReset = function () {
					// reset properties
					this.isPointerDown = false;
					delete this.pointerIdentifier;
				};

				proto.pointerDone = noop;

				// ----- pointer cancel ----- //

				proto.onpointercancel = function (event) {
					if (event.pointerId == this.pointerIdentifier) {
						this._pointerCancel(event, event);
					}
				};

				proto.ontouchcancel = function (event) {
					var touch = this.getTouch(event.changedTouches);
					if (touch) {
						this._pointerCancel(event, touch);
					}
				};

				/**
				 * pointer cancel
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 * @private
				 */
				proto._pointerCancel = function (event, pointer) {
					this._pointerDone();
					this.pointerCancel(event, pointer);
				};

				// public
				proto.pointerCancel = function (event, pointer) {
					this.emitEvent('pointerCancel', [event, pointer]);
				};

				// -----  ----- //

				// utility function for getting x/y coords from event
				Unipointer.getPointerPoint = function (pointer) {
					return {
						x: pointer.pageX,
						y: pointer.pageY
					};
				};

				// -----  ----- //

				return Unipointer;

			}));
		});

		var index_es_unidragger = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Unidragger v2.3.1
			 * Draggable base class
			 * MIT license
			 */

			/*jshint browser: true, unused: true, undef: true, strict: true */

			(function (window, factory) {
				// universal module definition
				/*jshint strict: false */ /*globals define, module, require */

				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_unipointer
					);
				} else {
					// browser global
					window.Unidragger = factory(
						window,
						window.Unipointer
					);
				}

			}(window, function factory(window, Unipointer) {

				// -------------------------- Unidragger -------------------------- //

				function Unidragger() { }

				// inherit Unipointer & EvEmitter
				var proto = Unidragger.prototype = Object.create(Unipointer.prototype);

				// ----- bind start ----- //

				proto.bindHandles = function () {
					this._bindHandles(true);
				};

				proto.unbindHandles = function () {
					this._bindHandles(false);
				};

				/**
				 * Add or remove start event
				 * @param {Boolean} isAdd
				 */
				proto._bindHandles = function (isAdd) {
					// munge isAdd, default to true
					isAdd = isAdd === undefined ? true : isAdd;
					// bind each handle
					var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
					var touchAction = isAdd ? this._touchActionValue : '';
					for (var i = 0; i < this.handles.length; i++) {
						var handle = this.handles[i];
						this._bindStartEvent(handle, isAdd);
						handle[bindMethod]('click', this);
						// touch-action: none to override browser touch gestures. metafizzy/flickity#540
						if (window.PointerEvent) {
							handle.style.touchAction = touchAction;
						}
					}
				};

				// prototype so it can be overwriteable by Flickity
				proto._touchActionValue = 'none';

				// ----- start event ----- //

				/**
				 * pointer start
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerDown = function (event, pointer) {
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};

					event.preventDefault();
					this.pointerDownBlur();
					// bind move and end events
					this._bindPostStartEvents(event);
					this.emitEvent('pointerDown', [event, pointer]);
				};

				// nodes that have text fields
				var cursorNodes = {
					TEXTAREA: true,
					INPUT: true,
					SELECT: true,
					OPTION: true,
				};

				// input types that do not have text fields
				var clickTypes = {
					radio: true,
					checkbox: true,
					button: true,
					submit: true,
					image: true,
					file: true,
				};

				// dismiss inputs with text fields. flickity#403, flickity#404
				proto.okayPointerDown = function (event) {
					var isCursorNode = cursorNodes[event.target.nodeName];
					var isClickType = clickTypes[event.target.type];
					var isOkay = !isCursorNode || isClickType;
					if (!isOkay) {
						this._pointerReset();
					}
					return isOkay;
				};

				// kludge to blur previously focused input
				proto.pointerDownBlur = function () {
					var focused = document.activeElement;
					// do not blur body for IE10, metafizzy/flickity#117
					var canBlur = focused && focused.blur && focused != document.body;
					if (canBlur) {
						focused.blur();
					}
				};

				// ----- move event ----- //

				/**
				 * drag move
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.emitEvent('pointerMove', [event, pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				// base pointer move logic
				proto._dragPointerMove = function (event, pointer) {
					var moveVector = {
						x: pointer.pageX - this.pointerDownPointer.pageX,
						y: pointer.pageY - this.pointerDownPointer.pageY
					};
					// start drag if pointer has moved far enough to start drag
					if (!this.isDragging && this.hasDragStarted(moveVector)) {
						this._dragStart(event, pointer);
					}
					return moveVector;
				};

				// condition if pointer has moved far enough to start drag
				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
				};

				// ----- end event ----- //

				/**
				 * pointer up
				 * @param {Event} event
				 * @param {Event or Touch} pointer
				 */
				proto.pointerUp = function (event, pointer) {
					this.emitEvent('pointerUp', [event, pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto._dragPointerUp = function (event, pointer) {
					if (this.isDragging) {
						this._dragEnd(event, pointer);
					} else {
						// pointer didn't move enough for drag to start
						this._staticClick(event, pointer);
					}
				};

				// -------------------------- drag -------------------------- //

				// dragStart
				proto._dragStart = function (event, pointer) {
					this.isDragging = true;
					// prevent clicks
					this.isPreventingClicks = true;
					this.dragStart(event, pointer);
				};

				proto.dragStart = function (event, pointer) {
					this.emitEvent('dragStart', [event, pointer]);
				};

				// dragMove
				proto._dragMove = function (event, pointer, moveVector) {
					// do not drag if not dragging yet
					if (!this.isDragging) {
						return;
					}

					this.dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					event.preventDefault();
					this.emitEvent('dragMove', [event, pointer, moveVector]);
				};

				// dragEnd
				proto._dragEnd = function (event, pointer) {
					// set flags
					this.isDragging = false;
					// re-enable clicking async
					setTimeout(function () {
						delete this.isPreventingClicks;
					}.bind(this));

					this.dragEnd(event, pointer);
				};

				proto.dragEnd = function (event, pointer) {
					this.emitEvent('dragEnd', [event, pointer]);
				};

				// ----- onclick ----- //

				// handle all clicks and prevent clicks when dragging
				proto.onclick = function (event) {
					if (this.isPreventingClicks) {
						event.preventDefault();
					}
				};

				// ----- staticClick ----- //

				// triggered after pointer down & up with no/tiny movement
				proto._staticClick = function (event, pointer) {
					// ignore emulated mouse up clicks
					if (this.isIgnoringMouseUp && event.type == 'mouseup') {
						return;
					}

					this.staticClick(event, pointer);

					// set flag for emulated clicks 300ms after touchend
					if (event.type != 'mouseup') {
						this.isIgnoringMouseUp = true;
						// reset flag after 300ms
						setTimeout(function () {
							delete this.isIgnoringMouseUp;
						}.bind(this), 400);
					}
				};

				proto.staticClick = function (event, pointer) {
					this.emitEvent('staticClick', [event, pointer]);
				};

				// ----- utils ----- //

				Unidragger.getPointerPoint = Unipointer.getPointerPoint;

				// -----  ----- //

				return Unidragger;

			}));
		});

		var index_es_drag = dist_index_es_createCommonjsModule(function (module) {
			// drag
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_flickity,
						index_es_unidragger,
						index_es_utils
					);
				} else {
					// browser global
					window.Flickity = factory(
						window,
						window.Flickity,
						window.Unidragger,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unidragger, utils) {

				// ----- defaults ----- //

				utils.extend(Flickity.defaults, {
					draggable: '>1',
					dragThreshold: 3,
				});

				// ----- create ----- //

				Flickity.createMethods.push('_createDrag');

				// -------------------------- drag prototype -------------------------- //

				var proto = Flickity.prototype;
				utils.extend(proto, Unidragger.prototype);
				proto._touchActionValue = 'pan-y';

				// --------------------------  -------------------------- //

				var isTouch = 'createTouch' in document;
				var isTouchmoveScrollCanceled = false;

				proto._createDrag = function () {
					this.on('activate', this.onActivateDrag);
					this.on('uiChange', this._uiChangeDrag);
					this.on('deactivate', this.onDeactivateDrag);
					this.on('cellChange', this.updateDraggable);
					// TODO updateDraggable on resize? if groupCells & slides change
					// HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
					// #457, RubaXa/Sortable#973
					if (isTouch && !isTouchmoveScrollCanceled) {
						window.addEventListener('touchmove', function () { });
						isTouchmoveScrollCanceled = true;
					}
				};

				proto.onActivateDrag = function () {
					this.handles = [this.viewport];
					this.bindHandles();
					this.updateDraggable();
				};

				proto.onDeactivateDrag = function () {
					this.unbindHandles();
					this.element.classList.remove('is-draggable');
				};

				proto.updateDraggable = function () {
					// disable dragging if less than 2 slides. #278
					if (this.options.draggable == '>1') {
						this.isDraggable = this.slides.length > 1;
					} else {
						this.isDraggable = this.options.draggable;
					}
					if (this.isDraggable) {
						this.element.classList.add('is-draggable');
					} else {
						this.element.classList.remove('is-draggable');
					}
				};

				// backwards compatibility
				proto.bindDrag = function () {
					this.options.draggable = true;
					this.updateDraggable();
				};

				proto.unbindDrag = function () {
					this.options.draggable = false;
					this.updateDraggable();
				};

				proto._uiChangeDrag = function () {
					delete this.isFreeScrolling;
				};

				// -------------------------- pointer events -------------------------- //

				proto.pointerDown = function (event, pointer) {
					if (!this.isDraggable) {
						this._pointerDownDefault(event, pointer);
						return;
					}
					var isOkay = this.okayPointerDown(event);
					if (!isOkay) {
						return;
					}

					this._pointerDownPreventDefault(event);
					this.pointerDownFocus(event);
					// blur
					if (document.activeElement != this.element) {
						// do not blur if already focused
						this.pointerDownBlur();
					}

					// stop if it was moving
					this.dragX = this.x;
					this.viewport.classList.add('is-pointer-down');
					// track scrolling
					this.pointerDownScroll = getScrollPosition();
					window.addEventListener('scroll', this);

					this._pointerDownDefault(event, pointer);
				};

				// default pointerDown logic, used for staticClick
				proto._pointerDownDefault = function (event, pointer) {
					// track start event position
					// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
					this.pointerDownPointer = {
						pageX: pointer.pageX,
						pageY: pointer.pageY,
					};
					// bind move and end events
					this._bindPostStartEvents(event);
					this.dispatchEvent('pointerDown', event, [pointer]);
				};

				var focusNodes = {
					INPUT: true,
					TEXTAREA: true,
					SELECT: true,
				};

				proto.pointerDownFocus = function (event) {
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isFocusNode) {
						this.focus();
					}
				};

				proto._pointerDownPreventDefault = function (event) {
					var isTouchStart = event.type == 'touchstart';
					var isTouchPointer = event.pointerType == 'touch';
					var isFocusNode = focusNodes[event.target.nodeName];
					if (!isTouchStart && !isTouchPointer && !isFocusNode) {
						event.preventDefault();
					}
				};

				// ----- move ----- //

				proto.hasDragStarted = function (moveVector) {
					return Math.abs(moveVector.x) > this.options.dragThreshold;
				};

				// ----- up ----- //

				proto.pointerUp = function (event, pointer) {
					delete this.isTouchScrolling;
					this.viewport.classList.remove('is-pointer-down');
					this.dispatchEvent('pointerUp', event, [pointer]);
					this._dragPointerUp(event, pointer);
				};

				proto.pointerDone = function () {
					window.removeEventListener('scroll', this);
					delete this.pointerDownScroll;
				};

				// -------------------------- dragging -------------------------- //

				proto.dragStart = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					this.dragStartPosition = this.x;
					this.startAnimation();
					window.removeEventListener('scroll', this);
					this.dispatchEvent('dragStart', event, [pointer]);
				};

				proto.pointerMove = function (event, pointer) {
					var moveVector = this._dragPointerMove(event, pointer);
					this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
					this._dragMove(event, pointer, moveVector);
				};

				proto.dragMove = function (event, pointer, moveVector) {
					if (!this.isDraggable) {
						return;
					}
					event.preventDefault();

					this.previousDragX = this.dragX;
					// reverse if right-to-left
					var direction = this.options.rightToLeft ? -1 : 1;
					if (this.options.wrapAround) {
						// wrap around move. #589
						moveVector.x %= this.slideableWidth;
					}
					var dragX = this.dragStartPosition + moveVector.x * direction;

					if (!this.options.wrapAround && this.slides.length) {
						// slow drag
						var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
						dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
						var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
						dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
					}

					this.dragX = dragX;

					this.dragMoveTime = new Date();
					this.dispatchEvent('dragMove', event, [pointer, moveVector]);
				};

				proto.dragEnd = function (event, pointer) {
					if (!this.isDraggable) {
						return;
					}
					if (this.options.freeScroll) {
						this.isFreeScrolling = true;
					}
					// set selectedIndex based on where flick will end up
					var index = this.dragEndRestingSelect();

					if (this.options.freeScroll && !this.options.wrapAround) {
						// if free-scroll & not wrap around
						// do not free-scroll if going outside of bounding slides
						// so bounding slides can attract slider, and keep it in bounds
						var restingX = this.getRestingPosition();
						this.isFreeScrolling = -restingX > this.slides[0].target &&
							-restingX < this.getLastSlide().target;
					} else if (!this.options.freeScroll && index == this.selectedIndex) {
						// boost selection if selected index has not changed
						index += this.dragEndBoostSelect();
					}
					delete this.previousDragX;
					// apply selection
					// TODO refactor this, selecting here feels weird
					// HACK, set flag so dragging stays in correct direction
					this.isDragSelect = this.options.wrapAround;
					this.select(index);
					delete this.isDragSelect;
					this.dispatchEvent('dragEnd', event, [pointer]);
				};

				proto.dragEndRestingSelect = function () {
					var restingX = this.getRestingPosition();
					// how far away from selected slide
					var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
					// get closet resting going up and going down
					var positiveResting = this._getClosestResting(restingX, distance, 1);
					var negativeResting = this._getClosestResting(restingX, distance, -1);
					// use closer resting for wrap-around
					var index = positiveResting.distance < negativeResting.distance ?
						positiveResting.index : negativeResting.index;
					return index;
				};

				/**
				 * given resting X and distance to selected cell
				 * get the distance and index of the closest cell
				 * @param {Number} restingX - estimated post-flick resting position
				 * @param {Number} distance - distance to selected cell
				 * @param {Integer} increment - +1 or -1, going up or down
				 * @returns {Object} - { distance: {Number}, index: {Integer} }
				 */
				proto._getClosestResting = function (restingX, distance, increment) {
					var index = this.selectedIndex;
					var minDistance = Infinity;
					var condition = this.options.contain && !this.options.wrapAround ?
						// if contain, keep going if distance is equal to minDistance
						function (dist, minDist) {
							return dist <= minDist;
						} : function (dist, minDist) {
							return dist < minDist;
						};
					while (condition(distance, minDistance)) {
						// measure distance to next cell
						index += increment;
						minDistance = distance;
						distance = this.getSlideDistance(-restingX, index);
						if (distance === null) {
							break;
						}
						distance = Math.abs(distance);
					}
					return {
						distance: minDistance,
						// selected was previous index
						index: index - increment,
					};
				};

				/**
				 * measure distance between x and a slide target
				 * @param {Number} x - horizontal position
				 * @param {Integer} index - slide index
				 * @returns {Number} - slide distance
				 */
				proto.getSlideDistance = function (x, index) {
					var len = this.slides.length;
					// wrap around if at least 2 slides
					var isWrapAround = this.options.wrapAround && len > 1;
					var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
					var slide = this.slides[slideIndex];
					if (!slide) {
						return null;
					}
					// add distance for wrap-around slides
					var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
					return x - (slide.target + wrap);
				};

				proto.dragEndBoostSelect = function () {
					// do not boost if no previousDragX or dragMoveTime
					if (this.previousDragX === undefined || !this.dragMoveTime ||
						// or if drag was held for 100 ms
						new Date() - this.dragMoveTime > 100) {
						return 0;
					}

					var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
					var delta = this.previousDragX - this.dragX;
					if (distance > 0 && delta > 0) {
						// boost to next if moving towards the right, and positive velocity
						return 1;
					} else if (distance < 0 && delta < 0) {
						// boost to previous if moving towards the left, and negative velocity
						return -1;
					}
					return 0;
				};

				// ----- staticClick ----- //

				proto.staticClick = function (event, pointer) {
					// get clickedCell, if cell was clicked
					var clickedCell = this.getParentCell(event.target);
					var cellElem = clickedCell && clickedCell.element;
					var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
					this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
				};

				// ----- scroll ----- //

				proto.onscroll = function () {
					var scroll = getScrollPosition();
					var scrollMoveX = this.pointerDownScroll.x - scroll.x;
					var scrollMoveY = this.pointerDownScroll.y - scroll.y;
					// cancel click/tap if scroll is too much
					if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
						this._pointerDone();
					}
				};

				// ----- utils ----- //

				function getScrollPosition() {
					return {
						x: window.pageXOffset,
						y: window.pageYOffset,
					};
				}

				// -----  ----- //

				return Flickity;

			}));
		});

		var index_es_prevNextButton = dist_index_es_createCommonjsModule(function (module) {
			// prev/next buttons
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_flickity,
						index_es_unipointer,
						index_es_utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unipointer, utils) {

				var svgURI = 'http://www.w3.org/2000/svg';

				// -------------------------- PrevNextButton -------------------------- //

				function PrevNextButton(direction, parent) {
					this.direction = direction;
					this.parent = parent;
					this._create();
				}

				PrevNextButton.prototype = Object.create(Unipointer.prototype);

				PrevNextButton.prototype._create = function () {
					// properties
					this.isEnabled = true;
					this.isPrevious = this.direction == -1;
					var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
					this.isLeft = this.direction == leftDirection;

					var element = this.element = document.createElement('button');
					element.className = 'flickity-button flickity-prev-next-button';
					element.className += this.isPrevious ? ' previous' : ' next';
					// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
					element.setAttribute('type', 'button');
					// init as disabled
					this.disable();

					element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

					// create arrow
					var svg = this.createSVG();
					element.appendChild(svg);
					// events
					this.parent.on('select', this.update.bind(this));
					this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
				};

				PrevNextButton.prototype.activate = function () {
					this.bindStartEvent(this.element);
					this.element.addEventListener('click', this);
					// add to DOM
					this.parent.element.appendChild(this.element);
				};

				PrevNextButton.prototype.deactivate = function () {
					// remove from DOM
					this.parent.element.removeChild(this.element);
					// click events
					this.unbindStartEvent(this.element);
					this.element.removeEventListener('click', this);
				};

				PrevNextButton.prototype.createSVG = function () {
					var svg = document.createElementNS(svgURI, 'svg');
					svg.setAttribute('class', 'flickity-button-icon');
					svg.setAttribute('viewBox', '0 0 100 100');
					var path = document.createElementNS(svgURI, 'path');
					var pathMovements = getArrowMovements(this.parent.options.arrowShape);
					path.setAttribute('d', pathMovements);
					path.setAttribute('class', 'arrow');
					// rotate arrow
					if (!this.isLeft) {
						path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
					}
					svg.appendChild(path);
					return svg;
				};

				// get SVG path movmement
				function getArrowMovements(shape) {
					// use shape as movement if string
					if (typeof shape == 'string') {
						return shape;
					}
					// create movement string
					return 'M ' + shape.x0 + ',50' +
						' L ' + shape.x1 + ',' + (shape.y1 + 50) +
						' L ' + shape.x2 + ',' + (shape.y2 + 50) +
						' L ' + shape.x3 + ',50 ' +
						' L ' + shape.x2 + ',' + (50 - shape.y2) +
						' L ' + shape.x1 + ',' + (50 - shape.y1) +
						' Z';
				}

				PrevNextButton.prototype.handleEvent = utils.handleEvent;

				PrevNextButton.prototype.onclick = function () {
					if (!this.isEnabled) {
						return;
					}
					this.parent.uiChange();
					var method = this.isPrevious ? 'previous' : 'next';
					this.parent[method]();
				};

				// -----  ----- //

				PrevNextButton.prototype.enable = function () {
					if (this.isEnabled) {
						return;
					}
					this.element.disabled = false;
					this.isEnabled = true;
				};

				PrevNextButton.prototype.disable = function () {
					if (!this.isEnabled) {
						return;
					}
					this.element.disabled = true;
					this.isEnabled = false;
				};

				PrevNextButton.prototype.update = function () {
					// index of first or last slide, if previous or next
					var slides = this.parent.slides;
					// enable is wrapAround and at least 2 slides
					if (this.parent.options.wrapAround && slides.length > 1) {
						this.enable();
						return;
					}
					var lastIndex = slides.length ? slides.length - 1 : 0;
					var boundIndex = this.isPrevious ? 0 : lastIndex;
					var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
					this[method]();
				};

				PrevNextButton.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				// -------------------------- Flickity prototype -------------------------- //

				utils.extend(Flickity.defaults, {
					prevNextButtons: true,
					arrowShape: {
						x0: 10,
						x1: 60, y1: 50,
						x2: 70, y2: 40,
						x3: 30,
					},
				});

				Flickity.createMethods.push('_createPrevNextButtons');
				var proto = Flickity.prototype;

				proto._createPrevNextButtons = function () {
					if (!this.options.prevNextButtons) {
						return;
					}

					this.prevButton = new PrevNextButton(-1, this);
					this.nextButton = new PrevNextButton(1, this);

					this.on('activate', this.activatePrevNextButtons);
				};

				proto.activatePrevNextButtons = function () {
					this.prevButton.activate();
					this.nextButton.activate();
					this.on('deactivate', this.deactivatePrevNextButtons);
				};

				proto.deactivatePrevNextButtons = function () {
					this.prevButton.deactivate();
					this.nextButton.deactivate();
					this.off('deactivate', this.deactivatePrevNextButtons);
				};

				// --------------------------  -------------------------- //

				Flickity.PrevNextButton = PrevNextButton;

				return Flickity;

			}));
		});

		var index_es_pageDots = dist_index_es_createCommonjsModule(function (module) {
			// page dots
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_flickity,
						index_es_unipointer,
						index_es_utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.Unipointer,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, Unipointer, utils) {

				function PageDots(parent) {
					this.parent = parent;
					this._create();
				}

				PageDots.prototype = Object.create(Unipointer.prototype);

				PageDots.prototype._create = function () {
					// create holder element
					this.holder = document.createElement('ol');
					this.holder.className = 'flickity-page-dots';
					// create dots, array of elements
					this.dots = [];
					// events
					this.handleClick = this.onClick.bind(this);
					this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
				};

				PageDots.prototype.activate = function () {
					this.setDots();
					this.holder.addEventListener('click', this.handleClick);
					this.bindStartEvent(this.holder);
					// add to DOM
					this.parent.element.appendChild(this.holder);
				};

				PageDots.prototype.deactivate = function () {
					this.holder.removeEventListener('click', this.handleClick);
					this.unbindStartEvent(this.holder);
					// remove from DOM
					this.parent.element.removeChild(this.holder);
				};

				PageDots.prototype.setDots = function () {
					// get difference between number of slides and number of dots
					var delta = this.parent.slides.length - this.dots.length;
					if (delta > 0) {
						this.addDots(delta);
					} else if (delta < 0) {
						this.removeDots(-delta);
					}
				};

				PageDots.prototype.addDots = function (count) {
					var fragment = document.createDocumentFragment();
					var newDots = [];
					var length = this.dots.length;
					var max = length + count;

					for (var i = length; i < max; i++) {
						var dot = document.createElement('li');
						dot.className = 'dot';
						dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
						fragment.appendChild(dot);
						newDots.push(dot);
					}

					this.holder.appendChild(fragment);
					this.dots = this.dots.concat(newDots);
				};

				PageDots.prototype.removeDots = function (count) {
					// remove from this.dots collection
					var removeDots = this.dots.splice(this.dots.length - count, count);
					// remove from DOM
					removeDots.forEach(function (dot) {
						this.holder.removeChild(dot);
					}, this);
				};

				PageDots.prototype.updateSelected = function () {
					// remove selected class on previous
					if (this.selectedDot) {
						this.selectedDot.className = 'dot';
						this.selectedDot.removeAttribute('aria-current');
					}
					// don't proceed if no dots
					if (!this.dots.length) {
						return;
					}
					this.selectedDot = this.dots[this.parent.selectedIndex];
					this.selectedDot.className = 'dot is-selected';
					this.selectedDot.setAttribute('aria-current', 'step');
				};

				PageDots.prototype.onTap = // old method name, backwards-compatible
					PageDots.prototype.onClick = function (event) {
						var target = event.target;
						// only care about dot clicks
						if (target.nodeName != 'LI') {
							return;
						}

						this.parent.uiChange();
						var index = this.dots.indexOf(target);
						this.parent.select(index);
					};

				PageDots.prototype.destroy = function () {
					this.deactivate();
					this.allOff();
				};

				Flickity.PageDots = PageDots;

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pageDots: true,
				});

				Flickity.createMethods.push('_createPageDots');

				var proto = Flickity.prototype;

				proto._createPageDots = function () {
					if (!this.options.pageDots) {
						return;
					}
					this.pageDots = new PageDots(this);
					// events
					this.on('activate', this.activatePageDots);
					this.on('select', this.updateSelectedPageDots);
					this.on('cellChange', this.updatePageDots);
					this.on('resize', this.updatePageDots);
					this.on('deactivate', this.deactivatePageDots);
				};

				proto.activatePageDots = function () {
					this.pageDots.activate();
				};

				proto.updateSelectedPageDots = function () {
					this.pageDots.updateSelected();
				};

				proto.updatePageDots = function () {
					this.pageDots.setDots();
				};

				proto.deactivatePageDots = function () {
					this.pageDots.deactivate();
				};

				// -----  ----- //

				Flickity.PageDots = PageDots;

				return Flickity;

			}));
		});

		var index_es_player = dist_index_es_createCommonjsModule(function (module) {
			// player & autoPlay
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						index_es_evEmitter,
						index_es_utils,
						index_es_flickity
					);
				} else {
					// browser global
					factory(
						window.EvEmitter,
						window.fizzyUIUtils,
						window.Flickity
					);
				}

			}(window, function factory(EvEmitter, utils, Flickity) {

				// -------------------------- Player -------------------------- //

				function Player(parent) {
					this.parent = parent;
					this.state = 'stopped';
					// visibility change event handler
					this.onVisibilityChange = this.visibilityChange.bind(this);
					this.onVisibilityPlay = this.visibilityPlay.bind(this);
				}

				Player.prototype = Object.create(EvEmitter.prototype);

				// start play
				Player.prototype.play = function () {
					if (this.state == 'playing') {
						return;
					}
					// do not play if page is hidden, start playing when page is visible
					var isPageHidden = document.hidden;
					if (isPageHidden) {
						document.addEventListener('visibilitychange', this.onVisibilityPlay);
						return;
					}

					this.state = 'playing';
					// listen to visibility change
					document.addEventListener('visibilitychange', this.onVisibilityChange);
					// start ticking
					this.tick();
				};

				Player.prototype.tick = function () {
					// do not tick if not playing
					if (this.state != 'playing') {
						return;
					}

					var time = this.parent.options.autoPlay;
					// default to 3 seconds
					time = typeof time == 'number' ? time : 3000;
					var _this = this;
					// HACK: reset ticks if stopped and started within interval
					this.clear();
					this.timeout = setTimeout(function () {
						_this.parent.next(true);
						_this.tick();
					}, time);
				};

				Player.prototype.stop = function () {
					this.state = 'stopped';
					this.clear();
					// remove visibility change event
					document.removeEventListener('visibilitychange', this.onVisibilityChange);
				};

				Player.prototype.clear = function () {
					clearTimeout(this.timeout);
				};

				Player.prototype.pause = function () {
					if (this.state == 'playing') {
						this.state = 'paused';
						this.clear();
					}
				};

				Player.prototype.unpause = function () {
					// re-start play if paused
					if (this.state == 'paused') {
						this.play();
					}
				};

				// pause if page visibility is hidden, unpause if visible
				Player.prototype.visibilityChange = function () {
					var isPageHidden = document.hidden;
					this[isPageHidden ? 'pause' : 'unpause']();
				};

				Player.prototype.visibilityPlay = function () {
					this.play();
					document.removeEventListener('visibilitychange', this.onVisibilityPlay);
				};

				// -------------------------- Flickity -------------------------- //

				utils.extend(Flickity.defaults, {
					pauseAutoPlayOnHover: true,
				});

				Flickity.createMethods.push('_createPlayer');
				var proto = Flickity.prototype;

				proto._createPlayer = function () {
					this.player = new Player(this);

					this.on('activate', this.activatePlayer);
					this.on('uiChange', this.stopPlayer);
					this.on('pointerDown', this.stopPlayer);
					this.on('deactivate', this.deactivatePlayer);
				};

				proto.activatePlayer = function () {
					if (!this.options.autoPlay) {
						return;
					}
					this.player.play();
					this.element.addEventListener('mouseenter', this);
				};

				// Player API, don't hate the ... thanks I know where the door is

				proto.playPlayer = function () {
					this.player.play();
				};

				proto.stopPlayer = function () {
					this.player.stop();
				};

				proto.pausePlayer = function () {
					this.player.pause();
				};

				proto.unpausePlayer = function () {
					this.player.unpause();
				};

				proto.deactivatePlayer = function () {
					this.player.stop();
					this.element.removeEventListener('mouseenter', this);
				};

				// ----- mouseenter/leave ----- //

				// pause auto-play on hover
				proto.onmouseenter = function () {
					if (!this.options.pauseAutoPlayOnHover) {
						return;
					}
					this.player.pause();
					this.element.addEventListener('mouseleave', this);
				};

				// resume auto-play on hover off
				proto.onmouseleave = function () {
					this.player.unpause();
					this.element.removeEventListener('mouseleave', this);
				};

				// -----  ----- //

				Flickity.Player = Player;

				return Flickity;

			}));
		});

		var index_es_addRemoveCell = dist_index_es_createCommonjsModule(function (module) {
			// add, remove cell
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_flickity,
						index_es_utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, utils) {

				// append cells to a document fragment
				function getCellsFragment(cells) {
					var fragment = document.createDocumentFragment();
					cells.forEach(function (cell) {
						fragment.appendChild(cell.element);
					});
					return fragment;
				}

				// -------------------------- add/remove cell prototype -------------------------- //

				var proto = Flickity.prototype;

				/**
				 * Insert, prepend, or append cells
				 * @param {[Element, Array, NodeList]} elems - Elements to insert
				 * @param {Integer} index - Zero-based number to insert
				 */
				proto.insert = function (elems, index) {
					var cells = this._makeCells(elems);
					if (!cells || !cells.length) {
						return;
					}
					var len = this.cells.length;
					// default to append
					index = index === undefined ? len : index;
					// add cells with document fragment
					var fragment = getCellsFragment(cells);
					// append to slider
					var isAppend = index == len;
					if (isAppend) {
						this.slider.appendChild(fragment);
					} else {
						var insertCellElement = this.cells[index].element;
						this.slider.insertBefore(fragment, insertCellElement);
					}
					// add to this.cells
					if (index === 0) {
						// prepend, add to start
						this.cells = cells.concat(this.cells);
					} else if (isAppend) {
						// append, add to end
						this.cells = this.cells.concat(cells);
					} else {
						// insert in this.cells
						var endCells = this.cells.splice(index, len - index);
						this.cells = this.cells.concat(cells).concat(endCells);
					}

					this._sizeCells(cells);
					this.cellChange(index, true);
				};

				proto.append = function (elems) {
					this.insert(elems, this.cells.length);
				};

				proto.prepend = function (elems) {
					this.insert(elems, 0);
				};

				/**
				 * Remove cells
				 * @param {[Element, Array, NodeList]} elems - ELements to remove
				 */
				proto.remove = function (elems) {
					var cells = this.getCells(elems);
					if (!cells || !cells.length) {
						return;
					}

					var minCellIndex = this.cells.length - 1;
					// remove cells from collection & DOM
					cells.forEach(function (cell) {
						cell.remove();
						var index = this.cells.indexOf(cell);
						minCellIndex = Math.min(index, minCellIndex);
						utils.removeFrom(this.cells, cell);
					}, this);

					this.cellChange(minCellIndex, true);
				};

				/**
				 * logic to be run after a cell's size changes
				 * @param {Element} elem - cell's element
				 */
				proto.cellSizeChange = function (elem) {
					var cell = this.getCell(elem);
					if (!cell) {
						return;
					}
					cell.getSize();

					var index = this.cells.indexOf(cell);
					this.cellChange(index);
				};

				/**
				 * logic any time a cell is changed: added, removed, or size changed
				 * @param {Integer} changedCellIndex - index of the changed cell, optional
				 * @param {Boolean} isPositioningSlider - Positions slider after selection
				 */
				proto.cellChange = function (changedCellIndex, isPositioningSlider) {
					var prevSelectedElem = this.selectedElement;
					this._positionCells(changedCellIndex);
					this._getWrapShiftCells();
					this.setGallerySize();
					// update selectedIndex
					// try to maintain position & select previous selected element
					var cell = this.getCell(prevSelectedElem);
					if (cell) {
						this.selectedIndex = this.getCellSlideIndex(cell);
					}
					this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);

					this.emitEvent('cellChange', [changedCellIndex]);
					// position slider
					this.select(this.selectedIndex);
					// do not position slider after lazy load
					if (isPositioningSlider) {
						this.positionSliderAtSelected();
					}
				};

				// -----  ----- //

				return Flickity;

			}));
		});

		var index_es_lazyload = dist_index_es_createCommonjsModule(function (module) {
			// lazyload
			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						window,
						index_es_flickity,
						index_es_utils
					);
				} else {
					// browser global
					factory(
						window,
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(window, function factory(window, Flickity, utils) {

				Flickity.createMethods.push('_createLazyload');
				var proto = Flickity.prototype;

				proto._createLazyload = function () {
					this.on('select', this.lazyLoad);
				};

				proto.lazyLoad = function () {
					var lazyLoad = this.options.lazyLoad;
					if (!lazyLoad) {
						return;
					}
					// get adjacent cells, use lazyLoad option for adjacent count
					var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
					var cellElems = this.getAdjacentCellElements(adjCount);
					// get lazy images in those cells
					var lazyImages = [];
					cellElems.forEach(function (cellElem) {
						var lazyCellImages = getCellLazyImages(cellElem);
						lazyImages = lazyImages.concat(lazyCellImages);
					});
					// load lazy images
					lazyImages.forEach(function (img) {
						new LazyLoader(img, this);
					}, this);
				};

				function getCellLazyImages(cellElem) {
					// check if cell element is lazy image
					if (cellElem.nodeName == 'IMG') {
						var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
						var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
						var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
						if (lazyloadAttr || srcAttr || srcsetAttr) {
							return [cellElem];
						}
					}
					// select lazy images in cell
					var lazySelector = 'img[data-flickity-lazyload], ' +
						'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
					var imgs = cellElem.querySelectorAll(lazySelector);
					return utils.makeArray(imgs);
				}

				// -------------------------- LazyLoader -------------------------- //

				/**
				 * class to handle loading images
				 * @param {Image} img - Image element
				 * @param {Flickity} flickity - Flickity instance
				 */
				function LazyLoader(img, flickity) {
					this.img = img;
					this.flickity = flickity;
					this.on('load');
				}

				LazyLoader.prototype.handleEvent = utils.handleEvent;

				LazyLoader.prototype.load = function () {
					this.img.addEventListener('load', this);
					this.img.addEventListener('error', this);
					// get src & srcset
					var src = this.img.getAttribute('data-flickity-lazyload') ||
						this.img.getAttribute('data-flickity-lazyload-src');
					var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
					// set src & serset
					this.img.src = src;
					if (srcset) {
						this.img.setAttribute('srcset', srcset);
					}
					// remove attr
					this.img.removeAttribute('data-flickity-lazyload');
					this.img.removeAttribute('data-flickity-lazyload-src');
					this.img.removeAttribute('data-flickity-lazyload-srcset');
				};

				LazyLoader.prototype.onload = function (event) {
					this.complete(event, 'flickity-lazyloaded');
				};

				LazyLoader.prototype.onerror = function (event) {
					this.complete(event, 'flickity-lazyerror');
				};

				LazyLoader.prototype.complete = function (event, className) {
					// unbind events
					this.img.removeEventListener('load', this);
					this.img.removeEventListener('error', this);

					var cell = this.flickity.getParentCell(this.img);
					var cellElem = cell && cell.element;
					this.flickity.cellSizeChange(cellElem);

					this.img.classList.add(className);
					this.flickity.dispatchEvent('lazyLoad', event, cellElem);
				};

				// -----  ----- //

				Flickity.LazyLoader = LazyLoader;

				return Flickity;

			}));
		});

		var index_es_js = dist_index_es_createCommonjsModule(function (module) {
			/*!
			 * Flickity v2.2.2
			 * Touch, responsive, flickable carousels
			 *
			 * Licensed GPLv3 for open source use
			 * or Flickity Commercial License for commercial use
			 *
			 * https://flickity.metafizzy.co
			 * Copyright 2015-2021 Metafizzy
			 */

			(function (window, factory) {
				// universal module definition
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						index_es_flickity,
						index_es_drag,
						index_es_prevNextButton,
						index_es_pageDots,
						index_es_player,
						index_es_addRemoveCell,
						index_es_lazyload
					);
				}

			})(window, function factory(Flickity) {
				return Flickity;
			});
		});

		var index_es_flickityFade = dist_index_es_createCommonjsModule(function (module) {
			/**
			 * Flickity fade v1.0.0
			 * Fade between Flickity slides
			 */

			/* jshint browser: true, undef: true, unused: true */

			(function (window, factory) {
				// universal module definition
				/*globals define, module, require */
				if (module.exports) {
					// CommonJS
					module.exports = factory(
						index_es_js,
						index_es_utils
					);
				} else {
					// browser global
					factory(
						window.Flickity,
						window.fizzyUIUtils
					);
				}

			}(index_es_commonjsGlobal, function factory(Flickity, utils) {

				// ---- Slide ---- //

				var Slide = Flickity.Slide;

				var slideUpdateTarget = Slide.prototype.updateTarget;
				Slide.prototype.updateTarget = function () {
					slideUpdateTarget.apply(this, arguments);
					if (!this.parent.options.fade) {
						return;
					}
					// position cells at selected target
					var slideTargetX = this.target - this.x;
					var firstCellX = this.cells[0].x;
					this.cells.forEach(function (cell) {
						var targetX = cell.x - firstCellX - slideTargetX;
						cell.renderPosition(targetX);
					});
				};

				Slide.prototype.setOpacity = function (alpha) {
					this.cells.forEach(function (cell) {
						cell.element.style.opacity = alpha;
					});
				};

				// ---- Flickity ---- //

				var proto = Flickity.prototype;

				Flickity.createMethods.push('_createFade');

				proto._createFade = function () {
					this.fadeIndex = this.selectedIndex;
					this.prevSelectedIndex = this.selectedIndex;
					this.on('select', this.onSelectFade);
					this.on('dragEnd', this.onDragEndFade);
					this.on('settle', this.onSettleFade);
					this.on('activate', this.onActivateFade);
					this.on('deactivate', this.onDeactivateFade);
				};

				var updateSlides = proto.updateSlides;
				proto.updateSlides = function () {
					updateSlides.apply(this, arguments);
					if (!this.options.fade) {
						return;
					}
					// set initial opacity
					this.slides.forEach(function (slide, i) {
						var alpha = i == this.selectedIndex ? 1 : 0;
						slide.setOpacity(alpha);
					}, this);
				};

				/* ---- events ---- */

				proto.onSelectFade = function () {
					// in case of resize, keep fadeIndex within current count
					this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
					this.prevSelectedIndex = this.selectedIndex;
				};

				proto.onSettleFade = function () {
					delete this.didDragEnd;
					if (!this.options.fade) {
						return;
					}
					// set full and 0 opacity on selected & faded slides
					this.selectedSlide.setOpacity(1);
					var fadedSlide = this.slides[this.fadeIndex];
					if (fadedSlide && this.fadeIndex != this.selectedIndex) {
						this.slides[this.fadeIndex].setOpacity(0);
					}
				};

				proto.onDragEndFade = function () {
					// set flag
					this.didDragEnd = true;
				};

				proto.onActivateFade = function () {
					if (this.options.fade) {
						this.element.classList.add('is-fade');
					}
				};

				proto.onDeactivateFade = function () {
					if (!this.options.fade) {
						return;
					}
					this.element.classList.remove('is-fade');
					// reset opacity
					this.slides.forEach(function (slide) {
						slide.setOpacity('');
					});
				};

				/* ---- position & fading ---- */

				var positionSlider = proto.positionSlider;
				proto.positionSlider = function () {
					if (!this.options.fade) {
						positionSlider.apply(this, arguments);
						return;
					}

					this.fadeSlides();
					this.dispatchScrollEvent();
				};

				var positionSliderAtSelected = proto.positionSliderAtSelected;
				proto.positionSliderAtSelected = function () {
					if (this.options.fade) {
						// position fade slider at origin
						this.setTranslateX(0);
					}
					positionSliderAtSelected.apply(this, arguments);
				};

				proto.fadeSlides = function () {
					if (this.slides.length < 2) {
						return;
					}
					// get slides to fade-in & fade-out
					var indexes = this.getFadeIndexes();
					var fadeSlideA = this.slides[indexes.a];
					var fadeSlideB = this.slides[indexes.b];
					var distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
					var progress = this.wrapDifference(fadeSlideA.target, -this.x);
					progress = progress / distance;

					fadeSlideA.setOpacity(1 - progress);
					fadeSlideB.setOpacity(progress);

					// hide previous slide
					var fadeHideIndex = indexes.a;
					if (this.isDragging) {
						fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
					}
					var isNewHideIndex = this.fadeHideIndex != undefined &&
						this.fadeHideIndex != fadeHideIndex &&
						this.fadeHideIndex != indexes.a &&
						this.fadeHideIndex != indexes.b;
					if (isNewHideIndex) {
						// new fadeHideSlide set, hide previous
						this.slides[this.fadeHideIndex].setOpacity(0);
					}
					this.fadeHideIndex = fadeHideIndex;
				};

				proto.getFadeIndexes = function () {
					if (!this.isDragging && !this.didDragEnd) {
						return {
							a: this.fadeIndex,
							b: this.selectedIndex,
						};
					}
					if (this.options.wrapAround) {
						return this.getFadeDragWrapIndexes();
					} else {
						return this.getFadeDragLimitIndexes();
					}
				};

				proto.getFadeDragWrapIndexes = function () {
					var distances = this.slides.map(function (slide, i) {
						return this.getSlideDistance(-this.x, i);
					}, this);
					var absDistances = distances.map(function (distance) {
						return Math.abs(distance);
					});
					var minDistance = Math.min.apply(Math, absDistances);
					var closestIndex = absDistances.indexOf(minDistance);
					var distance = distances[closestIndex];
					var len = this.slides.length;

					var delta = distance >= 0 ? 1 : -1;
					return {
						a: closestIndex,
						b: utils.modulo(closestIndex + delta, len),
					};
				};

				proto.getFadeDragLimitIndexes = function () {
					// calculate closest previous slide
					var dragIndex = 0;
					for (var i = 0; i < this.slides.length - 1; i++) {
						var slide = this.slides[i];
						if (-this.x < slide.target) {
							break;
						}
						dragIndex = i;
					}
					return {
						a: dragIndex,
						b: dragIndex + 1,
					};
				};

				proto.wrapDifference = function (a, b) {
					var diff = b - a;

					if (!this.options.wrapAround) {
						return diff;
					}

					var diffPlus = diff + this.slideableWidth;
					var diffMinus = diff - this.slideableWidth;
					if (Math.abs(diffPlus) < Math.abs(diff)) {
						diff = diffPlus;
					}
					if (Math.abs(diffMinus) < Math.abs(diff)) {
						diff = diffMinus;
					}
					return diff;
				};

				// ---- wrapAround ---- //

				var _getWrapShiftCells = proto._getWrapShiftCells;
				proto._getWrapShiftCells = function () {
					if (!this.options.fade) {
						_getWrapShiftCells.apply(this, arguments);
					}
				};

				var shiftWrapCells = proto.shiftWrapCells;
				proto.shiftWrapCells = function () {
					if (!this.options.fade) {
						shiftWrapCells.apply(this, arguments);
					}
				};

				return Flickity;

			}));
		});

		var index_es_EventHandler_1 = dist_index_es_createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener)
						return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el, event = _a.event, listener = _a.listener;
					if (!el || !event || !listener)
						return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el
							|| event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			}());
			exports["default"] = EventHandler;
		});

		var index_es_EventHandler = index_es_unwrapExports(index_es_EventHandler_1);

		var Testimonials = /*#__PURE__*/function () {
			function Testimonials(section) {
				dist_index_es_classCallCheck(this, Testimonials);

				this.el = section.el;
				this.settings = section.data;
				this.slider = this.el.querySelector('[data-testimonials-content]');
				this.slides = this.el.querySelectorAll('[data-testimonial]');
				this.flickity = false;
				this.events = new index_es_EventHandler();

				if (this.settings.init_slider === true && this.slides.length > 1) {
					this.initFlickity();
				}
			}

			dist_index_es_createClass(Testimonials, [{
				key: "initFlickity",
				value: function initFlickity() {
					var _this = this;

					this.flickity = new index_es_flickityFade(this.slider, {
						adaptiveHeight: true,
						autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_interval * 1000 : false,
						groupCells: this.settings.group_testimonials,
						fade: this.settings.use_fade,
						cellAlign: 'left',
						cellSelector: '[data-testimonial]',
						contain: true,
						imagesLoaded: true,
						pageDots: this.settings.show_pagination,
						pauseAutoPlayOnHover: true,
						wrapAround: true,
						arrowShape: {
							x0: 10,
							x1: 60,
							y1: 50,
							x2: 65,
							y2: 45,
							x3: 20
						}
					});
					this.events.register(this.slider, 'rimg:load', function () {
						_this.flickity.resize();
					});
				}
			}, {
				key: "onSectionBlockSelect",
				value: function onSectionBlockSelect(block) {
					if (this.flickity) {
						var index = block.el.dataset.index;
						this.flickity.select(index);
					}
				}
			}, {
				key: "onSectionUnload",
				value: function onSectionUnload() {
					this.events.unregisterAll();

					if (this.flickity) {
						this.flickity.destroy();
						this.flickity = false;
					}
				}
			}]);

			return Testimonials;
		}();

/* harmony default export */ const pxs_testimonials_dist_index_es = (Testimonials);

		// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
		var intersection_observer = __webpack_require__(337);
		;// CONCATENATED MODULE: ./source/scripts/polyfills.js
		// eslint-disable-line

		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-surface-pick-up/dist/index.es.js
		function shopify_surface_pick_up_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function shopify_surface_pick_up_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function shopify_surface_pick_up_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) shopify_surface_pick_up_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) shopify_surface_pick_up_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function _defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly) symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function _objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					ownKeys(Object(source), true).forEach(function (key) {
						_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
				} else {
					ownKeys(Object(source)).forEach(function (key) {
						Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
					});
				}
			}

			return target;
		}

		var LOCAL_STORAGE_KEY = 'pxu-shopify-surface-pick-up';
		var loadingClass = 'surface-pick-up--loading';

		var isNotExpired = function isNotExpired(timestamp) {
			return timestamp + 1000 * 60 * 60 <= Date.now();
		};

		var removeTrailingSlash = function removeTrailingSlash(s) {
			return s.replace(/(.*)\/$/, '$1');
		}; // Haversine Distance
		// The haversine formula is an equation giving great-circle distances between
		// two points on a sphere from their longitudes and latitudes


		var calculateDistance = function calculateDistance(latitude1, longitude1, latitude2, longitude2, unitSystem) {
			var dtor = Math.PI / 180;
			var radius = unitSystem === 'metric' ? 6378.14 : 3959;
			var rlat1 = latitude1 * dtor;
			var rlong1 = longitude1 * dtor;
			var rlat2 = latitude2 * dtor;
			var rlong2 = longitude2 * dtor;
			var dlon = rlong1 - rlong2;
			var dlat = rlat1 - rlat2;
			var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return radius * c;
		};

		var getGeoLocation = function getGeoLocation() {
			return new Promise(function (resolve, reject) {
				var options = {
					maximumAge: 3600000,
					// 1 hour
					timeout: 5000
				};

				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (_ref) {
						var coords = _ref.coords;
						return resolve(coords);
					}, reject, options);
				} else {
					reject();
				}
			});
		};

		var index_es_location = null;

		var setLocation = function setLocation(_ref2) {
			var latitude = _ref2.latitude,
				longitude = _ref2.longitude;
			return new Promise(function (resolve) {
				var cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
				var newData = {
					latitude: latitude,
					longitude: longitude,
					timestamp: Date.now()
				};
				index_es_location = newData;
				localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));

				if (cachedLocation !== null && cachedLocation.latitude === latitude && cachedLocation.longitude === longitude // Valid for 1 hour - per Debut's example
					&& isNotExpired(cachedLocation.timestamp)) {
					resolve({
						latitude: latitude,
						longitude: longitude
					});
					return;
				}

				fetch('/localization.json', {
					method: 'PUT',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						latitude: latitude,
						longitude: longitude
					})
				}).then(function () {
					return resolve({
						latitude: latitude,
						longitude: longitude
					});
				});
			});
		};

		var getLocation = function getLocation() {
			return new Promise(function (resolve) {
				if (index_es_location && isNotExpired(index_es_location.timestamp)) {
					resolve(index_es_location);
					return;
				}

				resolve(getGeoLocation().then(setLocation));
			});
		};

		var SurfacePickUp = /*#__PURE__*/function () {
			function SurfacePickUp(el, options) {
				shopify_surface_pick_up_dist_index_es_classCallCheck(this, SurfacePickUp);

				this.el = el;
				this.options = _objectSpread2({
					root_url: window.Theme && window.Theme.routes && window.Theme.routes.root_url || ''
				}, options);
				this.options.root_url = removeTrailingSlash(this.options.root_url);
				this.callbacks = [];
				this.onBtnPress = null;
				this.latestVariantId = null;
				this.pickUpEnabled = localStorage.getItem(LOCAL_STORAGE_KEY) !== null;
			}

			shopify_surface_pick_up_dist_index_es_createClass(SurfacePickUp, [{
				key: "load",
				value: function load(variantId) {
					var _this = this;

					// Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
					// don't know if the variant might be, or is definitely not available for pick up.
					// Until we know the shop has > 0 pick up locations, we want to avoid prompting the
					// user for location data (it's annoying, and only makes sense to do if we use it).
					//
					// Instead, we have to make an initial request, check and see if any pick up locations
					// were returned, then ask for the users location, then make another request to get the
					// location-aware pick up locations.
					//
					// As far as I can tell the pick up aware locations differ only in sort order - which
					// we could do on the front end - but we're following this approach to ensure future
					// compatibility with any changes Shopify makes (maybe disabling options based on
					// user location, or whatever else).
					//
					// Shopify has indicated they will look into adding pick_up_enabled data to the shop
					// object, which which case this method can be greatly simplifed into 2 simple cases.
					this.latestVariantId = variantId;

					var getLocationThenInjectData = function getLocationThenInjectData() {
						return getLocation() // If we get a location, inject data using that location
							.then(function (coords) {
								return _this._getData(variantId).then(function (data) {
									return _this._injectData(data, coords);
								});
							}) // Otherwise, inject data without location
						["catch"](function () {
							return _this._getData(variantId).then(function (data) {
								return _this._injectData(data, null);
							});
						});
					};

					this.el.classList.add(loadingClass); // If we've previously seen some pick up locations we know this variant may be available
					// for pick up, so we request browser location data.

					if (this.pickUpEnabled) {
						return getLocationThenInjectData();
					}

					return this._getData(variantId).then(function (data) {
						if (data.items.length > 0) {
							_this.pickUpEnabled = true; // Inject initial data - the store displayed may not be the closest, since it was
							// determined by IP geolocation, instead of browser side location. But better
							// than nothing.

							_this._injectData(data, null); // Then get browser location and go through the process again with the new location
							// data. Any subsequent variants will skip the initial request and go
							// directly to the browser based location data.


							return getLocationThenInjectData();
						} // If there are no items (pick up locations), just inject the (empty) data and return.
						// We will continue to check for pick up locations on any new variants, since depending
						// on product availability, the first product may have no pick up locations even if the
						// store does have some.


						return _this._injectData(data, null);
					});
				}
			}, {
				key: "onModalRequest",
				value: function onModalRequest(callback) {
					if (this.callbacks.indexOf(callback) >= 0) return;
					this.callbacks.push(callback);
				}
			}, {
				key: "offModalRequest",
				value: function offModalRequest(callback) {
					this.callbacks.splice(this.callbacks.indexOf(callback));
				}
			}, {
				key: "unload",
				value: function unload() {
					this.callbacks = [];
					this.el.innerHTML = '';
				}
			}, {
				key: "_getData",
				value: function _getData(variantId) {
					var _this2 = this;

					return new Promise(function (resolve) {
						var xhr = new XMLHttpRequest();
						var requestUrl = "".concat(_this2.options.root_url, "/variants/").concat(variantId, "/?section_id=surface-pick-up");
						xhr.open('GET', requestUrl, true);

						xhr.onload = function () {
							var el = xhr.response;
							var embed = el.querySelector('[data-html="surface-pick-up-embed"]');
							var itemsContainer = el.querySelector('[data-html="surface-pick-up-items"]');
							var items = itemsContainer.content.querySelectorAll('[data-surface-pick-up-item]');
							resolve({
								embed: embed,
								itemsContainer: itemsContainer,
								items: items,
								variantId: variantId
							});
						};

						xhr.onerror = function () {
							resolve({
								embed: {
									innerHTML: ''
								},
								itemsContainer: {
									innerHTML: ''
								},
								items: [],
								variantId: variantId
							});
						};

						xhr.responseType = 'document';
						xhr.send();
					});
				}
			}, {
				key: "_injectData",
				value: function _injectData(_ref3, userCoords) {
					var _this3 = this;

					var embed = _ref3.embed,
						itemsContainer = _ref3.itemsContainer,
						items = _ref3.items,
						variantId = _ref3.variantId;

					if (variantId !== this.latestVariantId) {
						return null;
					}

					this.el.innerHTML = embed.innerHTML;
					this.el.classList.remove(loadingClass);

					if (items.length === 0) {
						return this.el;
					}

					var processedDistances = false;

					var processDistances = function processDistances() {
						if (processedDistances) return;
						processedDistances = true;
						items.forEach(function (item) {
							var distanceEl = item.querySelector('[data-distance]');
							var distanceUnitEl = item.querySelector('[data-distance-unit]');
							var unitSystem = distanceUnitEl.dataset.distanceUnit;
							var itemLatitude = parseFloat(distanceEl.dataset.latitude);
							var itemLongitude = parseFloat(distanceEl.dataset.longitude);

							if (userCoords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
								var distance = calculateDistance(userCoords.latitude, userCoords.longitude, itemLatitude, itemLongitude, unitSystem);
								distanceEl.innerHTML = distance.toFixed(1);
							} else {
								distanceEl.remove();
								distanceUnitEl.remove();
							}
						});
					};

					this.el.querySelector('[data-surface-pick-up-embed-modal-btn]').addEventListener('click', function () {
						processDistances();

						_this3.callbacks.forEach(function (callback) {
							return callback(itemsContainer.innerHTML);
						});
					});
					return this.el;
				}
			}]);

			return SurfacePickUp;
		}();

/* harmony default export */ const shopify_surface_pick_up_dist_index_es = (SurfacePickUp);

		// EXTERNAL MODULE: ./node_modules/@pixelunion/events/dist/EventHandler.js
		var dist_EventHandler = __webpack_require__(766);
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/animations/dist/animations.es.js

		/*!
		 * @pixelunion/animations v0.1.0
		 * (c) 2019 Pixel Union
		 * Released under the UNLICENSED license.
		*/

		function animations_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function animations_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function animations_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) animations_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) animations_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function animations_es_defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function animations_es_ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly) symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function animations_es_objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					animations_es_ownKeys(source, true).forEach(function (key) {
						animations_es_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
				} else {
					animations_es_ownKeys(source).forEach(function (key) {
						Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
					});
				}
			}

			return target;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */


		var Animation =
			/*#__PURE__*/
			function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					animations_es_classCallCheck(this, Animation);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || 'initial';
					this.initialState = this._state;
					this.stateAttribute = options.stateAttribute || 'data-animation-state';
					this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
					this.endEvent = options.endEvent || 'transitionend';
					this.hold = !!options.hold;

					this.onStart = options.onStart || function () {
						/* do nothing */
					};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */


				animations_es_createClass(Animation, [{
					key: "isState",

					/**
					 * Check if a state is active
					 * @param {String} state State to compare
					 *
					 * @return {Boolean}
					 */
					value: function isState(state) {
						return state === this._state;
					}
					/**
					 * Sequences a change to a new state.
					 * @param {String} state Target state
					 *
					 * @param {Boolean} options.force Switch to final state immediately
					 *
					 * @param {Function} options.onStart Callback to execute immediately after
					 * applying stateChangeAttribute for this state change only.
					 *
					 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
					 * next state change.
					 *
					 * @return {Promise} Resolves when endEvent triggered
					 */

				}, {
					key: "animateTo",
					value: function animateTo(state) {
						var _this = this;

						var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						var from = this._el.dataset[this.stateAttribute] || this._state;
						var to = state || this.initialState;
						var force = options.force;
						var hold = 'hold' in options ? options.hold : this.hold;
						return new Promise(function (resolve) {
							if (_this.cancelRunning) {
								_this.cancelRunning();
							}

							if (from === to) {
								// Removing this here fixes some lingering attributes. But why?
								_this._el.removeAttribute(_this.stateChangeAttribute);

								resolve(from, null);
								return;
							}

							var running = true;

							_this.cancelRunning = function () {
								running = false;
								resolve(null, null);
							};

							_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

							_this.activeEventHandler = null;

							if (force) {
								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;

								if (!hold) {
									_this._el.removeAttribute(_this.stateChangeAttribute);
								}

								resolve(to, null);
								return;
							}

							raf().then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								return raf();
							}).then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

								_this.activeEventHandler = function (e) {
									// Ignore any events bubbling up
									if (e.target !== _this._el || !running) return;

									_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, e);
								};

								_this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;
							})["catch"](function (error) {
								// Only catch 'cancelled' errors.
								if (error.message !== 'cancelled') throw error;
							});
						});
					}
					/**
					 * Remove any event listeners
					 */

				}, {
					key: "unload",
					value: function unload() {
						this._el.removeEventListener(this.endEvent, this.activeEventHandler);

						this.activeEventHandler = null;
					}
				}, {
					key: "el",
					get: function get() {
						return this._el;
					}
					/**
					 * Returns current state
					 *
					 * @return {String} Current state
					 */

				}, {
					key: "state",
					get: function get() {
						return this._state;
					}
				}]);

				return Animation;
			}();

		/**
		 * Manage state changes for a set of elements
		 */

		var AnimationsManager =
			/*#__PURE__*/
			(/* unused pure expression or super */ null && (function () {
				function AnimationsManager() {
					animations_es_classCallCheck(this, AnimationsManager);

					this.animations = new Map();
				}
				/**
				 * Add a new element and return an animation for that element. If element already has an associated animation, return that animation.
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event name to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after applying stateChangeAttribute.
				 *
				 * @return {Animation}
				 */


				animations_es_createClass(AnimationsManager, [{
					key: "add",
					value: function add(options) {
						if (this.animations.has(options.el)) return this.animations.get(options.el);
						var animation = new Animation(options);
						this.animations.set(options.el, animation);
						return animation;
					}
					/**
					 * Remove a single animation
					 * @param {Animation} animation Animation to remove. Any event listeners will also be removed.
					 */

				}, {
					key: "remove",
					value: function remove(animation) {
						this.animations["delete"](animation.el);
						animation.unload();
					}
					/**
					 * Remove all animations, including all event listeners.
					 */

				}, {
					key: "removeAll",
					value: function removeAll() {
						this.animations.forEach(function (animation) {
							return animation.unload();
						});
					}
				}]);

				return AnimationsManager;
			}()));

		function animation(options) {
			var setOptions = {
				endEvent: 'animationend',
				hold: true
			};
			return new Animation(animations_es_objectSpread2({
				options: options
			}, setOptions));
		}

		function transition(options) {
			return new Animation(options);
		}



		;// CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
		/**
		 * A11y Helpers
		 * -----------------------------------------------------------------------------
		 * A collection of useful functions that help make your theme more accessible
		 */

		/**
		 * Moves focus to an HTML element
		 * eg for In-page links, after scroll, focus shifts to content area so that
		 * next `tab` is where user expects. Used in bindInPageLinks()
		 * eg move focus to a modal that is opened. Used in trapFocus()
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */
		function forceFocus(element, options) {
			options = options || {};

			var savedTabIndex = element.tabIndex;

			element.tabIndex = -1;
			element.dataset.tabIndex = savedTabIndex;
			element.focus();
			if (typeof options.className !== 'undefined') {
				element.classList.add(options.className);
			}
			element.addEventListener('blur', callback);

			function callback(event) {
				event.target.removeEventListener(event.type, callback);

				element.tabIndex = savedTabIndex;
				delete element.dataset.tabIndex;
				if (typeof options.className !== 'undefined') {
					element.classList.remove(options.className);
				}
			}
		}

		/**
		 * If there's a hash in the url, focus the appropriate element
		 * This compensates for older browsers that do not move keyboard focus to anchor links.
		 * Recommendation: To be called once the page in loaded.
		 *
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 * @param {string} options.ignore - Selector for elements to not include.
		 */

		function focusHash(options) {
			options = options || {};
			var hash = window.location.hash;
			var element = document.getElementById(hash.slice(1));

			// if we are to ignore this element, early return
			if (element && options.ignore && element.matches(options.ignore)) {
				return false;
			}

			if (hash && element) {
				forceFocus(element, options);
			}
		}

		/**
		 * When an in-page (url w/hash) link is clicked, focus the appropriate element
		 * This compensates for older browsers that do not move keyboard focus to anchor links.
		 * Recommendation: To be called once the page in loaded.
		 *
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 * @param {string} options.ignore - CSS selector for elements to not include.
		 */

		function bindInPageLinks(options) {
			options = options || {};
			var links = Array.prototype.slice.call(
				document.querySelectorAll('a[href^="#"]')
			);

			return links.filter(function (link) {
				if (link.hash === '#' || link.hash === '') {
					return false;
				}

				if (options.ignore && link.matches(options.ignore)) {
					return false;
				}

				var element = document.querySelector(link.hash);

				if (!element) {
					return false;
				}

				link.addEventListener('click', function () {
					forceFocus(element, options);
				});

				return true;
			});
		}

		function focusable(container) {
			var elements = Array.prototype.slice.call(
				container.querySelectorAll(
					'[tabindex],' +
					'[draggable],' +
					'a[href],' +
					'area,' +
					'button:enabled,' +
					'input:not([type=hidden]):enabled,' +
					'object,' +
					'select:enabled,' +
					'textarea:enabled'
				)
			);

			// Filter out elements that are not visible.
			// Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
			return elements.filter(function (element) {
				return !!(
					element.offsetWidth ||
					element.offsetHeight ||
					element.getClientRects().length
				);
			});
		}

		/**
		 * Traps the focus in a particular container
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Element} elementToFocus - Element to be focused on first
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */

		var trapFocusHandlers = {};

		function trapFocus(container, options) {
			options = options || {};
			var elements = focusable(container);
			var elementToFocus = options.elementToFocus || container;
			var first = elements[0];
			var last = elements[elements.length - 1];

			removeTrapFocus();

			trapFocusHandlers.focusin = function (event) {
				if (container !== event.target && !container.contains(event.target)) {
					first.focus();
				}

				if (
					event.target !== container &&
					event.target !== last &&
					event.target !== first
				)
					return;
				document.addEventListener('keydown', trapFocusHandlers.keydown);
			};

			trapFocusHandlers.focusout = function () {
				document.removeEventListener('keydown', trapFocusHandlers.keydown);
			};

			trapFocusHandlers.keydown = function (event) {
				if (event.keyCode !== 9) return; // If not TAB key

				// On the last focusable element and tab forward, focus the first element.
				if (event.target === last && !event.shiftKey) {
					event.preventDefault();
					first.focus();
				}

				//  On the first focusable element and tab backward, focus the last element.
				if (
					(event.target === container || event.target === first) &&
					event.shiftKey
				) {
					event.preventDefault();
					last.focus();
				}
			};

			document.addEventListener('focusout', trapFocusHandlers.focusout);
			document.addEventListener('focusin', trapFocusHandlers.focusin);

			forceFocus(elementToFocus, options);
		}

		/**
		 * Removes the trap of focus from the page
		 */
		function removeTrapFocus() {
			document.removeEventListener('focusin', trapFocusHandlers.focusin);
			document.removeEventListener('focusout', trapFocusHandlers.focusout);
			document.removeEventListener('keydown', trapFocusHandlers.keydown);
		}

		/**
		 * Add a preventive message to external links and links that open to a new window.
		 * @param {string} elements - Specific elements to be targeted
		 * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
		 * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
		 * @param {string} options.messages.external - When the link is to a different host domain.
		 * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
		 * @param {object} options.prefix - Prefix to namespace "id" of the messages
		 */
		function accessibleLinks(elements, options) {
			if (typeof elements !== 'string') {
				throw new TypeError(elements + ' is not a String.');
			}

			elements = document.querySelectorAll(elements);

			if (elements.length === 0) {
				return;
			}

			options = options || {};
			options.messages = options.messages || {};

			var messages = {
				newWindow: options.messages.newWindow || 'Opens in a new window.',
				external: options.messages.external || 'Opens external website.',
				newWindowExternal:
					options.messages.newWindowExternal ||
					'Opens external website in a new window.'
			};

			var prefix = options.prefix || 'a11y';

			var messageSelectors = {
				newWindow: prefix + '-new-window-message',
				external: prefix + '-external-message',
				newWindowExternal: prefix + '-new-window-external-message'
			};

			function generateHTML(messages) {
				var container = document.createElement('ul');
				var htmlMessages = Object.keys(messages).reduce(function (html, key) {
					return (html +=
						'<li id=' + messageSelectors[key] + '>' + messages[key] + '</li>');
				}, '');

				container.setAttribute('hidden', true);
				container.innerHTML = htmlMessages;

				document.body.appendChild(container);
			}

			function externalSite(link) {
				return link.hostname !== window.location.hostname;
			}

			elements.forEach(function (link) {
				var target = link.getAttribute('target');
				var rel = link.getAttribute('rel');
				var isExternal = externalSite(link);
				var isTargetBlank = target === '_blank';
				var missingRelNoopener = rel === null || rel.indexOf('noopener') === -1;

				if (isTargetBlank && missingRelNoopener) {
					var relValue = rel === null ? 'noopener' : rel + ' noopener';
					link.setAttribute('rel', relValue);
				}

				if (isExternal && isTargetBlank) {
					link.setAttribute('aria-describedby', messageSelectors.newWindowExternal);
				} else if (isExternal) {
					link.setAttribute('aria-describedby', messageSelectors.external);
				} else if (isTargetBlank) {
					link.setAttribute('aria-describedby', messageSelectors.newWindow);
				}
			});

			generateHTML(messages);
		}
		;// CONCATENATED MODULE: ./source/scripts/utils/ScrollLock.js
		const {
			body
		} = document;
		const html = document.querySelector('html');

		function _blockScroll(event) {
			// Only block events that occur outside the modal
			if (event.target.closest('.allow-scroll-while-locked')) return;
			event.preventDefault();
			event.stopPropagation();
		}

		class ScrollLock {
			/**
			 * Prevents all scrolling of the document
			 * @param {HTMLElement} modal Element within which scrolling is allowed
			 */
			static lock(modal) {
				if (modal) {
					modal.classList.add('allow-scroll-while-locked');
				}

				html.classList.add('scroll-locked');
				body.style.top = -1 * window.pageYOffset;
				body.addEventListener('scroll', _blockScroll, false);
				body.addEventListener('touchmove', _blockScroll, {
					passive: false
				});
			}
			/**
			 * Removes scroll lock
			 */


			static unlock() {
				document.querySelectorAll('.allow-scroll-while-locked').forEach(modal => modal.classList.remove('allow-scroll-while-locked'));
				html.classList.remove('scroll-locked');
				body.style.top = '';
				body.removeEventListener('scroll', _blockScroll, false);
				body.removeEventListener('touchmove', _blockScroll, {
					passive: false
				});
			}

			static get isLocked() {
				return html.classList.contains('scroll-locked');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/components/Modal.js





		class Modal {
			constructor() {
				this.container = document.querySelector('[data-modal-container]');
				if (!this.container) return; // Fast exit if not found on page

				this.drawer = this.container.querySelector('[data-modal]');
				this.header = this.container.querySelector('[data-modal-header]');
				this.closeButton = this.container.querySelector('[data-modal-close]');
				this.content = this.container.querySelector('[data-modal-content]');
				this.trigger = null;
				this.events = new dist_EventHandler/* default */.Z();
				this.events.register(this.closeButton, 'click', () => this.close());
				this.events.register(window, 'keydown', e => {
					if (e.key === 'Escape') {
						this.close();
					}
				});
				this.events.register(this.container, 'click', e => {
					if (e.target !== this.container) return;
					this.close();
				});
				this.animation = transition({
					state: 'closed',
					el: this.container,
					stateAttribute: 'data-modal-animation-state',
					stateChangeAttribute: 'data-modal-animation'
				});
			}

			open({
				header,
				content
			}) {
				this.trigger = document.activeElement;
				ScrollLock.lock(this.container);
				this.header.innerHTML = header;
				this.content.innerHTML = content;
				return this.animation.animateTo('open').then(() => {
					trapFocus(this.container);
					return this.container;
				});
			}

			close() {
				return this.animation.animateTo('closed').then(() => {
					removeTrapFocus(this.container);
					ScrollLock.unlock();

					if (this.trigger) {
						this.trigger.focus();
					}
				});
			}

			unload() {
				this.events.unregisterAll();
			}

		}

/* harmony default export */ const components_Modal = (new Modal());
		// EXTERNAL MODULE: ./node_modules/@pixelunion/breakpoint/dist/cjs/index.js
		var cjs = __webpack_require__(646);
		;// CONCATENATED MODULE: ./source/scripts/components/ImageZoom.js

		class ImageZoom {
			constructor(options) {
				this.$el = jquery_default()(options.el);
				this.zoomImageSrc = options.el.dataset.imageZoomSrc;
				this.zoomArea = jquery_default()('.product-gallery--image-zoom-container', this.$el);
				this.$newImage = null;
				jquery_default()('img', this.$el).one('rimg:load.image-zoom', () => this.prepareZoom());
			}

			prepareZoom() {
				const photoAreaWidth = this.$el.width();
				const photoAreaHeight = this.$el.height();
				const newImage = new Image();
				this.$newImage = jquery_default()(newImage);
				this.$newImage.on('load', () => {
					this.zoomImageWidth = newImage.width;
					this.zoomImageHeight = newImage.height;
					const ratios = [];
					ratios[0] = this.zoomImageWidth / photoAreaWidth;
					ratios[1] = this.zoomImageHeight / photoAreaHeight;
					const ratio = Math.max(...ratios); // Only enable the zoom if a certain zooming ratio is met.

					if (ratio < 1.4) {
						this.$el.removeClass('zoom-enabled');
						return;
					}

					this.$el.addClass('zoom-enabled');
					this.zoomArea.css({
						backgroundImage: `url(${newImage.src})`
					});
				});
				newImage.src = this.zoomImageSrc;
				this.$el.on('click.image-zoom', event => this.toggleZoom(event));
				this.zoomArea.on('mouseout.image-zoom', event => this.toggleZoom(event));
				this.zoomArea.on('mousemove.image-zoom', event => this.zoomImage(event));
			}

			toggleZoom(e) {
				if (this.$el.hasClass('zoom-enabled')) {
					if (e.type === 'mouseout') {
						this.zoomArea.removeClass('active');
						return;
					}

					if (this.zoomArea.hasClass('active')) {
						this.zoomArea.removeClass('active');
					} else {
						this.zoomArea.addClass('active');
					}

					this.zoomImage(e);
				}
			}

			zoomImage(e) {
				const zoomWidth = this.zoomArea.width();
				const zoomHeight = this.zoomArea.height();
				const bigImageOffset = this.$el.offset();
				const bigImageX = Math.round(bigImageOffset.left);
				const bigImageY = Math.round(bigImageOffset.top);
				const mousePositionX = e.pageX - bigImageX;
				const mousePositionY = e.pageY - bigImageY; // Make sure our mouse position is still inside our box.

				if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
					if (this.zoomArea.hasClass('active')) {
						// Figure out how to position the zoomed image.
						let ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
						let ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;

						if (ratioX > 0) {
							ratioX = 0;
						}

						if (ratioY > 0) {
							ratioY = 0;
						}

						if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
							ratioX = -(this.zoomImageWidth - zoomWidth);
						}

						if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
							ratioY = -(this.zoomImageHeight - zoomHeight);
						}

						const newBackgroundPosition = `${ratioX}px ${ratioY}px`;
						this.zoomArea.css({
							backgroundPosition: newBackgroundPosition
						});
					}
				}
			}

			unload() {
				if (this.$newImage) {
					this.$newImage.off('load');
				}

				this.$el.off('click.image-zoom');
				this.zoomArea.off('mouseout.image-zoom');
				this.zoomArea.off('mousemove.image-zoom');
				jquery_default()('img', this.$el).off('rimg:load.image-zoom');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/utils/youtubeIframeAPIHelper.js
		let apiReadyResolve = null;
		let apiReady = null;
		function youtubeIframeAPIHelper_load() {
			if (apiReady) return apiReady;
			apiReady = new Promise(resolve => {
				apiReadyResolve = resolve;
			});

			if (window.onYouTubeIframeAPIReady) {
				// If onYouTubeIframeAPIReady is already defined, we need to call it
				const {
					onYouTubeIframeAPIReady
				} = window;

				window.onYouTubeIframeAPIReady = () => {
					onYouTubeIframeAPIReady();
					apiReadyResolve();
				};
			} else {
				window.onYouTubeIframeAPIReady = apiReadyResolve;
			}

			if (!document.querySelector('#youtube-api-script')) {
				const script = document.createElement('script');
				script.setAttribute('id', 'youtube-api-script');
				script.setAttribute('type', 'text/javascript');
				script.setAttribute('src', 'https://www.youtube.com/iframe_api');
				document.body.appendChild(script);
			}

			if (window.YT && YT.loaded) {
				apiReadyResolve();
			}

			return apiReady;
		}
		;// CONCATENATED MODULE: ./source/scripts/components/ProductGallery.js




		class ProductGallery {
			constructor(el, settings) {
				this.el = el;
				this.settings = settings;
				this.viewport = this.el.querySelector('[data-product-gallery-viewport]');
				this.navigation = this.el.querySelector('[data-product-gallery-navigation]');
				this.figures = this.viewport.querySelectorAll('[data-product-gallery-figure]');
				this.media = [];
				this.selected = {
					figure: this.viewport.querySelector('[data-product-gallery-selected="true"]'),
					thumbnail: this.navigation ? this.navigation.querySelector('[data-product-gallery-selected="true"]') : null
				};
				this.imageZoom = null;
				this.events = new dist_EventHandler/* default */.Z();

				if (this.navigation) {
					this.thumbnails = this.navigation.querySelectorAll('[data-product-gallery-thumbnail]');

					this.onThumbnailClick = e => this._selectMediaByIndex(e.currentTarget.dataset.productGalleryThumbnail);

					this.thumbnails.forEach(thumbnail => this.events.register(thumbnail, 'click', this.onThumbnailClick));
				}

				if (this.settings.enable_zoom) {
					this.figures.forEach(figure => {
						if (figure.dataset.mediaType !== 'image') return;
						const player = new ImageZoom({
							el: figure
						});
						this.media.push({
							type: 'image',
							figure,
							player,
							focus: () => { },
							restart: () => { },
							pause: () => { },
							play: () => { },
							unload: () => player.unload()
						});
					});
				}

				const features = [];

				if (this.el.querySelector('[data-media-type="model"]')) {
					this.events.register(this.viewport, 'click', e => {
						if ('shopifyXr' in e.target.dataset) {
							this._onViewInYourSpaceClick(e.target);
						}
					});
					features.push({
						name: 'model-viewer-ui',
						version: '1.0',
						onLoad: () => this._onModelLibraryLoad()
					});
					features.push({
						name: 'shopify-xr',
						version: '1.0'
					});
				}

				if (this.el.querySelector('[data-media-type="video"]')) {
					Promise.all([new Promise(resolve => {
						if (!document.querySelector('#plyr-stylesheet')) {
							const link = document.createElement('link');
							link.setAttribute('id', 'plyr-stylesheet');
							link.setAttribute('rel', 'stylesheet');
							link.setAttribute('href', 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');
							link.onload = resolve;
							document.body.appendChild(link);
						} else {
							resolve();
						}
					}), new Promise(resolve => {
						features.push({
							name: 'video-ui',
							version: '1.0',
							onLoad: resolve
						});
					})]).then(() => this._onVideoLibraryLoad());
				}

				youtubeIframeAPIHelper_load().then(() => this._onExternalVideoLibraryLoad());

				if (features.length) {
					Shopify.loadFeatures(features);
				}
			}

			selectMediaByVariant(variant) {
				if (!variant.featured_media) return;
				const figure = this.viewport.querySelector(`[data-media="${variant.featured_media.id}"]`);

				this._selectMediaByIndex(figure.dataset.productGalleryFigure);
			}

			unload() {
				this.events.unregisterAll();
				this.media.forEach(m => m.unload());
			}

			_onModelLibraryLoad() {
				const modelFigures = this.viewport.querySelectorAll('[data-media-type="model"]');
				const controls = ['zoom-in', 'zoom-out'];
				if (document.fullscreenEnabled) controls.push('fullscreen');
				modelFigures.forEach(figure => {
					const player = new Shopify.ModelViewerUI(figure.querySelector('model-viewer'), {
						controls
					});
					this.media.push({
						type: 'model',
						figure,
						player,
						focus: () => { },
						restart: () => { },
						pause: () => player.pause(),
						play: () => player.play(),
						unload: () => { }
					});
				});
			}

			_onViewInYourSpaceClick(target) {
				if (target.dataset.shopifyModel3dId === this.selected.figure.dataset.media) return;
				const figure = this.viewport.querySelector(`[data-media="${target.dataset.shopifyModel3dId}"]`);

				this._selectMediaByEl(figure);
			}

			_selectMediaByEl(el) {
				this._selectMediaByIndex(parseInt(el.dataset.productGalleryFigure, 10));
			}

			_onVideoLibraryLoad() {
				const videoFigures = this.viewport.querySelectorAll('[data-media-type="video"]');
				videoFigures.forEach(videoFigure => {
					const player = new Shopify.Plyr(videoFigure.querySelector('video'), {
						loop: {
							active: this.settings.enable_video_looping
						}
					});
					const plyrEl = videoFigure.querySelector('.plyr');
					const video = {
						type: 'video',
						figure: videoFigure,
						player,
						focus: () => plyrEl.focus(),
						restart: () => {
							player.restart();
							player.play();
						},
						pause: () => player.pause(),
						play: () => player.play(),
						unload: () => player.destroy()
					};
					this.events.register(videoFigure, 'play', () => this._pauseMedia(video));
					this.media.push(video);
				});
			}

			_onExternalVideoLibraryLoad() {
				const videoFigures = this.viewport.querySelectorAll('[data-media-type="external_video"]');
				videoFigures.forEach(videoFigure => {
					const player = new YT.Player(videoFigure.querySelector('iframe'));
					const video = {
						type: 'video',
						figure: videoFigure,
						player,
						focus: () => player.getIframe().focus(),
						restart: () => {
							player.seekTo(0);
							player.playVideo();
						},
						pause: () => player.pauseVideo(),
						play: () => player.playVideo(),
						unload: () => { }
					};
					this.events.register(player, 'onStateChange', ({
						data
					}) => {
						if (data === YT.PlayerState.ENDED && this.settings.enable_video_looping) {
							video.restart();
						} else if (data === YT.PlayerState.PLAYING) {
							this._pauseMedia(video);
						}
					});
					this.media.push(video);
				});
			}

			_onMediaSelect(media) {
				if (!media) return;

				switch (media.type) {
					case 'video':
						media.focus();

						if (this.settings.enable_video_autoplay && cjs/* min */.VV('L') && this.layout !== 'list') {
							media.play();
						}

						break;

					case 'model':
						if (document.querySelector('html').classList.contains('no-touch')) {
							media.play();
						}

						break;

					default:
						break;
				}
			}

			_pauseMedia(excludeMedia = null) {
				this.media.forEach(m => {
					if (m !== excludeMedia) {
						m.pause();
					}
				});
			}

			_selectMediaByIndex(index) {
				const figure = this.figures[index];
				this.selected.figure.dataset.productGallerySelected = false;
				this.selected.figure.setAttribute('aria-hidden', true);
				this.selected.figure = figure;
				this.selected.figure.dataset.productGallerySelected = true;
				this.selected.figure.setAttribute('aria-hidden', false);

				if (this.navigation) {
					const thumbnail = this.thumbnails[index];
					this.selected.thumbnail.dataset.productGallerySelected = false;
					this.selected.thumbnail = thumbnail;
					this.selected.thumbnail.dataset.productGallerySelected = true;
				}

				this._pauseMedia();

				this._onMediaSelect(this.media.filter(m => m.figure === this.selected.figure)[0]);
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/utils/ThemeUtils.js

		class ThemeUtils {
			static extend(dest, ...objs) {
				for (const obj in objs) {
					for (const k in objs[obj]) {
						const v = objs[obj][k];
						dest[k] = v;
					}
				}

				return dest;
			}

			static windowWidth() {
				const documentWidth = document.documentElement.clientWidth;
				const windowWidth = window.innerWidth;
				const width = documentWidth < windowWidth ? windowWidth : documentWidth;
				return width;
			}

			static debounce(func, wait, immediate) {
				let timeout = null;
				return () => {
					const context = this;
					const args = arguments;

					const later = () => {
						timeout = null;

						if (!immediate) {
							func.apply(context, args);
						}
					};

					const callNow = immediate && !timeout;
					clearTimeout(timeout);
					timeout = setTimeout(later, wait);

					if (callNow) {
						func.apply(context, args);
					}
				};
			}

			static inViewport(el) {
				// special bonus for those using jQuery
				let element = el;
				let viewportHeight;
				let viewportWidth;

				if (typeof jQuery === 'function' && el instanceof jQuery) {
					element = el.eq(0);
				}

				const rect = element.getBoundingClientRect();

				if (document.documentElement.clientWidth < window.innerWidth) {
					viewportWidth = document.documentElement.clientWidth;
				} else {
					viewportWidth = window.innerHeight;
				}

				if (document.documentElement.clientHeight < window.innerHeight) {
					viewportHeight = document.documentElement.clientHeight;
				} else {
					viewportHeight = window.innerHeight;
				}

				return rect.bottom >= 0 && rect.right >= 0 && rect.top <= viewportHeight && rect.left <= viewportWidth;
			}

			static externalLinks($el) {
				const anchors = $el.find('a[href^="http"]').filter((i, el) => el.href.indexOf(window.location.hostname) === -1);
				anchors.attr('target', '_blank');
			}

			static unique(array) {
				let key;
				let asc;
				let end;
				const output = {};

				for (key = 0, end = array.length, asc = end >= 0; asc ? key < end : key > end; asc ? key++ : key--) {
					output[array[key]] = array[key];
				}

				return (() => {
					const result = [];

					for (key in output) {
						const value = output[key];
						result.push(value);
					}

					return result;
				})();
			}

			static scrollTarget($el) {
				let $element = $el;

				if (!($el instanceof jQuery)) {
					$element = jquery_default()($el);
				}

				jquery_default()('html, body').animate({
					scrollTop: $element.offset().top
				}, 500, 'linear');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/components/LinkedOptions.js


		class LinkedOptions {
			constructor(options) {
				this.options = options;

				this._init();
			}

			_init() {
				this._mapVariants(this.options.productJSON);
			}

			_getCurrent(optionIndex) {
				let key;
				let selector;

				if (this.options.type === 'select') {
					switch (optionIndex) {
						case 0:
							key = 'root';
							selector = this.options.$selector.eq(0);
							break;

						case 1:
							key = this.options.$selector.eq(0).val();
							selector = this.options.$selector.eq(1);
							break;

						case 2:
							key = `${this.options.$selector.eq(0).val()} / ${this.options.$selector.eq(1).val()}`;
							selector = this.options.$selector.eq(2);
							break;

						default:
							break;
					}
				}

				if (this.options.type === 'radio') {
					let option1;
					let option2;

					switch (optionIndex) {
						case 0:
							key = 'root';
							selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
							break;

						case 1:
							key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
							selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
							break;

						case 2:
							option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
							option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
							key = `${option1} / ${option2}`;
							selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
							break;

						default:
							break;
					}
				}

				return {
					key,
					selector
				};
			}

			_updateOptions(optionIndex, optionsMap) {
				let $option;
				let $selector;
				const nextSelector = optionIndex + 1;
				let updateSelected = false;

				const {
					key,
					selector
				} = this._getCurrent(optionIndex);

				const availableOptions = optionsMap[key] || [];

				if (this.options.type === 'select') {
					$selector = this.options.$productForm.find(selector);
					const initialValue = $selector.val();
					const $selectorOptions = $selector.find('option');
					$selectorOptions.each((index, option) => {
						$option = jquery_default()(option);

						if (availableOptions.indexOf(option.value) === -1) {
							if (option.selected) {
								updateSelected = true;
							}

							$option.prop('disabled', true).prop('selected', false);
						} else {
							$option.prop('disabled', false);
						}
					});

					if (availableOptions.indexOf(initialValue) !== -1) {
						$selector.val(initialValue);
					}

					if (updateSelected) {
						$selectorOptions.filter(':not(:disabled)').eq(0).prop('selected', true);
					}
				}

				if (this.options.type === 'radio') {
					$selector = this.options.$selector.filter(`[data-option-index=${optionIndex}]`);
					$selector.each((index, option) => {
						$option = jquery_default()(option);

						if (availableOptions.indexOf(option.value) === -1) {
							if (option.checked) {
								updateSelected = true;
							}

							$option.prop('disabled', true).prop('checked', false);
						} else {
							$option.prop('disabled', false);
						}
					});

					if (updateSelected) {
						$selector.filter(':not(:disabled)').eq(0).attr('checked', true).trigger('click');
					}
				}

				$selector.trigger('change');
				const $nextOption = this.options.$selector.filter(`[data-option-index=${nextSelector}]`);

				if ($nextOption.length !== 0) {
					this._updateOptions(nextSelector, optionsMap);
				}
			}

			_mapVariants(product) {
				const optionsMap = [];
				optionsMap.root = [];
				product.variants.forEach(variant => {
					if (variant.available) {
						let key;
						optionsMap.root.push(variant.option1);
						optionsMap.root = ThemeUtils.unique(optionsMap.root); // Gather values for the 2nd option type

						if (product.options.length > 1) {
							key = variant.option1;
							optionsMap[key] = optionsMap[key] || [];
							optionsMap[key].push(variant.option2);
							optionsMap[key] = ThemeUtils.unique(optionsMap[key]);
						} // Gather values for the 3rd option type


						if (product.options.length > 2) {
							key = `${variant.option1} / ${variant.option2}`;
							optionsMap[key] = optionsMap[key] || [];
							optionsMap[key].push(variant.option3);
							optionsMap[key] = ThemeUtils.unique(optionsMap[key]);
						}
					}
				});

				this._updateOptions(0, optionsMap);

				this.options.$selector.on('change', event => {
					const index = parseInt(jquery_default()(event.currentTarget).attr('data-option-index'), 10);
					const nextSelector = index + 1;

					this._updateOptions(nextSelector, optionsMap);
				});
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/utils/VariantHelper.js



		class VariantHelper {
			constructor(options) {
				const defaultOptions = {
					$addToCartButton: null,
					// Set with object of add to cart button
					$priceFields: null,
					// Set with object containing price(s)
					$productForm: null,
					// Set with object containing the `data-product-form` attribute
					$productThumbnails: null,
					// Set with object containing thumbnails
					$selector: null,
					// Set with an object that contains select/input[type=checkbox] objects
					type: 'select',
					// Or radio
					productJSON: null,
					// Set with product JSON information
					productSettings: null,
					// Set with JSON containing product message and/or display options
					onVariantChange: () => { },
					// Callback to run on variant change
					quantityInput: null // Quantity input element

				};
				this.options = ThemeUtils.extend(defaultOptions, options);
				this.$body = jquery_default()(document.body);
				this.linkedOptions = null;
				this.enableHistory = false;
				this.$masterSelect = this.options.$productForm.find(`#product-select-${this.options.formID}`); // Disabled history state updating in the TE

				const isShopify = window.Shopify && window.Shopify.preview_host;

				if (window.history && window.history.replaceState && this.options.productSettings.enableHistory && !isShopify) {
					this.enableHistory = true;
				}

				this._init();

				this._bindEvents();
			}

			getSelectedVariant() {
				return this._getVariantFromOptions(this._getCurrentOptions());
			}

			_init() {
				if (this.options.type === 'select') {
					for (let i = 0; i < this.options.$selector.length; i++) {
						const select = this.options.$selector[i];

						this._setSelectLabel(null, jquery_default()(select));
					}
				}

				if (this.options.productSettings.linkedOptions) {
					this.linkedOptions = new LinkedOptions(this.options);
				}
			}

			_bindEvents() {
				return this.options.$selector.on('change', event => this._variantChange(event));
			}

			_setSelectLabel(event = null, $target) {
				let $element = $target;

				if ($target == null) {
					$element = false;
				}

				if (!$target) {
					$element = jquery_default()(event.currentTarget);
				}

				const selectedOption = $element.find('option:selected').val();
				return $element.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
			}

			_getCurrentOptions() {
				const productOptions = [];
				let $inputs = this.options.$selector;

				if (this.options.type === 'radio') {
					$inputs = $inputs.filter(':checked');
				}

				$inputs.each((index, element) => productOptions.push(jquery_default()(element).val()));
				return productOptions;
			}

			_getVariantFromOptions(productOptions) {
				if (this.options.productJSON.variants == null) {
					return;
				}

				let foundVariant = null;
				this.options.productJSON.variants.forEach(variant => {
					let productOption = productOptions[0];

					for (let i = 1; i < productOptions.length; i++) {
						productOption += ` / ${productOptions[i]}`;
					}

					if (productOption === variant.title) {
						foundVariant = variant;
					}
				});
				return foundVariant;
			}

			_updateMasterSelect(variant) {
				if (variant == null) {
					return;
				}

				this.$masterSelect.find(`[data-variant-id=${variant.id}]`).prop('selected', true);
				this.$masterSelect.trigger('change');
			}

			_updatePrice(variant) {
				const {
					$addToCartButton
				} = this.options;
				const {
					$priceFields
				} = this.options;
				const {
					productSettings
				} = this.options;

				if (variant != null) {
					if (variant.available) {
						$addToCartButton.val(productSettings.addToCartText).removeClass('disabled').removeAttr('disabled');
					} else {
						$addToCartButton.val(productSettings.soldOutText).addClass('disabled').attr('disabled', 'disabled');
					}

				if (variant.compare_at_price > variant.price) {
					const discountPercentage = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
					$priceFields.find('.price .money:first-child').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).addClass('price-on-sale');
					$priceFields.find('.original').html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).removeClass('hidden');
					
					let $badge = $priceFields.find('[data-discount-badge]');
					if ($badge.length) {
						$badge.text('-' + discountPercentage + '%').show();
					} else {
						$priceFields.find('.price').append('<span class="discount-badge" data-discount-badge>-' + discountPercentage + '%</span>');
					}
				} else {
					$priceFields.find('.price .money').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).removeClass('price-on-sale');
					$priceFields.find('.original').addClass('hidden');
					$priceFields.find('[data-discount-badge]').hide();
				}

					const unitPrice = $priceFields.find('[data-unit-price]')[0];

					if (unitPrice && variant.unit_price_measurement) {
						const totalQuantity = unitPrice.querySelector('[data-total-quantity]');
						const unitPriceAmount = unitPrice.querySelector('[data-unit-price-amount]');
						const unitPriceMeasure = unitPrice.querySelector('[data-unit-price-measure]');
						totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;
						unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, Theme.moneyFormat);

						if (variant.unit_price_measurement.reference_value === 1) {
							unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
						} else {
							unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
						}

						unitPrice.classList.remove('hidden');
					} else if (unitPrice) {
						unitPrice.classList.add('hidden');
					}
				} else {
					// Variant doesn't exist
					$addToCartButton.val(productSettings.unavailableText).addClass('disabled').attr('disabled', 'disabled');
				}
			}

			_updateTaxLine(variant) {
				if (!variant) return;
				let taxLine;

				if (this.options.$priceFields.length > 0) {
					taxLine = this.options.$priceFields[0].querySelector('[data-tax-line]');
				}

				if (taxLine) {
					if (variant.taxable) {
						taxLine.classList.remove('product-price__tax-label--hidden');
					} else {
						taxLine.classList.add('product-price__tax-label--hidden');
					}
				}

				let taxInfo;

				if (this.options.$priceFields.length > 0) {
					taxInfo = this.options.$priceFields[0].querySelector('[data-tax-info]');
				}

				if(taxInfo && window.taxInfo && window.taxInfo[variant.id]) {
					taxInfo.innerHTML = window.taxInfo[variant.id];
				}
			}

			_updateImages(variant) {
				let imageId;

				if (variant && variant.featured_media && variant.featured_media.id) {
					imageId = variant.featured_media.id;
				} else {
					imageId = null;
				}

				if (imageId == null) {
					return;
				}

				this.options.$productThumbnails.filter(`[data-media='${imageId}']`).trigger('click');
			}

			_updateHistory(variant) {
				if (!this.enableHistory || variant == null) {
					return;
				}

				const variantRegex = /variant=([^&]*)/gi;
				let search = `?variant=${variant.id}`;

				if (window.location.search.length > 0) {
					if (window.location.search.match(variantRegex)) {
						search = window.location.search.replace(variantRegex, `variant=${variant.id}`);
					} else {
						search = `${window.location.search}&variant=${variant.id}`;
					}
				}

				const newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, search];
				const variantUrl = newUrl.join('');
				window.history.replaceState({
					path: variantUrl
				}, '', variantUrl);
			}

			_variantChange(event) {
				if (this.options.type === 'select') {
					this._setSelectLabel(event);
				}

				const productOptions = this._getCurrentOptions();

				const variant = this._getVariantFromOptions(productOptions);

				this.options.onVariantChange(variant);

				this._updateMasterSelect(variant);

				this._updatePrice(variant);

				if (variant) {
					this._updateTaxLine(variant);

					this._updateImages(variant);

					if (event.isTrusted || (event.originalEvent && event.originalEvent.isTrusted)) {
						this._updateHistory(variant);
					}
				}
			}

			prepareRemove() {
				this.options.$selector.off('change');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/helpers/PaymentTerms.js
		class PaymentTerms {
			constructor(el) {
				this._el = el;
				this._reference = this._el.querySelector('[data-payment-terms-reference]');
				this._paymentTerms = this._el.querySelector('shopify-payment-terms');
				this._target = this._el.querySelector('[data-payment-terms-target]');
				if (!this._paymentTerms) return;

				if (!this._target) {
					this._reference.style.display = null;
				} else {
					this._input = document.createElement('input');
					this._input.name = 'id';
					this._input.type = 'hidden';

					this._target.appendChild(this._input);

					this._target.appendChild(this._paymentTerms);

					this._target.style.display = null;
				}
			}

			update(variantId) {
				if (!this._paymentTerms || !this._target) return;
				this._input.value = variantId;

				this._input.dispatchEvent(new Event('change', {
					bubbles: true
				}));
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/Product.js







		class Product {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.el = section.el;
				this.data = section.data;
				this.variantHelpers = null;
				this.$productForm = jquery_default()('[data-product-form]', this.$el);
				this.formID = this.$productForm.attr('data-product-form'); // Form selectors

				this.productForm = `product-form-${this.formID}`;
				this.$addToCartButton = jquery_default()('.add-to-cart input', this.$el);
				this.$priceArea = jquery_default()('.product-price', this.$el);
				this.$productMessage = jquery_default()('[data-product-message]', this.$el); // Gallery
				this.surfacePickUp = new shopify_surface_pick_up_dist_index_es(this.el.querySelector('[data-surface-pick-up]'));

				const gallery = this.el.querySelector('[data-product-gallery]');

				if (gallery) {
					this.productGallery = new ProductGallery(gallery, {
						enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
						enable_video_looping: this.data.settings.gallery_enable_video_looping,
						enable_zoom: this.data.settings.gallery_enable_zoom
					});
				} // Setup product information


				const $productJSON = jquery_default()(`[data-product-json-${this.formID}]`, this.$el);
				const $productSettings = jquery_default()(`[data-product-settings-${this.formID}]`, this.$el);

				if (!$productJSON.length) {
					return;
				}

				this.productJSON = JSON.parse($productJSON.text());
				this.productSettings = JSON.parse($productSettings.text());
				this.$variantDropdowns = jquery_default()(`[data-option-select=${this.formID}]`, this.$el);
				this.$variantRadio = jquery_default()(`[data-option-input=${this.formID}]`, this.$el);
				this.options = this.productJSON.options;
				this.variants = this.productJSON.variants;
				this.processing = false;
				this.paymentTerms = new PaymentTerms(this.el);
				this.setupVariants();

				this._bindEvents();

				Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
			}

			_bindEvents() {
				this.$addToCartButton.on('click', event => this.addToCart(event));
			}

			setupVariants() {
				const variantHelperDefaults = {
					$addToCartButton: this.$addToCartButton,
					$priceFields: this.$priceArea,
					$productForm: this.$productForm,
					$productThumbnails: jquery_default()('[data-product-gallery-thumbnail]', this.el),
					formID: this.formID,
					productSettings: this.productSettings,
					productJSON: this.productJSON,
					onVariantChange: variant => this._onVariantChangeCallback(variant),
					enableHistory: this.data.enable_history
				};

				if (this.$variantDropdowns.length) {
					let dropdownSettings = {
						$selector: this.$variantDropdowns,
						type: 'select'
					};
					dropdownSettings = ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
					this.variantHelpers = new VariantHelper(dropdownSettings);
					this.$variantDropdowns.trigger('change');
				}

				if (this.$variantRadio.length) {
					let radioSettings = {
						$selector: this.$variantRadio,
						type: 'radio'
					};
					radioSettings = ThemeUtils.extend(variantHelperDefaults, radioSettings);
					this.variantHelpers = new VariantHelper(radioSettings);
					this.$variantRadio.trigger('change');
				}

				const selectedVariant = () => this.variantHelpers ? this.variantHelpers.getSelectedVariant() : this.productJSON.variants[0]; // product has only default variant


				this.surfacePickUp.load(selectedVariant().id);
				this.surfacePickUp.onModalRequest(content => {
					const variantTitle = this.variantHelpers ? `<div class="modal__surface-pick-up-variant">${selectedVariant().title}</div>` : '';
					const header = `
          <h2 class="modal__surface-pick-up-title">${this.productJSON.title}</h2>
          ${variantTitle}
        `;
					components_Modal.open({
						header,
						content
					});
				});
			}

			_onVariantChangeCallback(variant) {
				if (variant && window.productVariants) {
					this.surfacePickUp.load(variant.id);
					this.paymentTerms.update(variant.id);
					const customHTMLElements = ["#product_custom_subline_1","#product_custom_subline_2","#product_custom_paragraph_1","#product_custom_paragraph_2","#product_custom_paragraph_3","#product_custom_paragraph_4","#product_custom_paragraph_5"];
          			const variantData = window.productVariants.filter((data) => data.id === variant.id)[0];

					for (const element of customHTMLElements) {
						const htmlElement = document.querySelector(element);
						if (htmlElement) {
							htmlElement.style.display = "none";
						}
					}

					if(variantData) {
						for (const element of customHTMLElements) {
							const dataName = element.replace("#product_custom_", "");
							const htmlElement = document.querySelector(element);
							if (variantData[dataName] && htmlElement) {
								htmlElement.style.display = "block";
								htmlElement.innerHTML = variantData[dataName];
							}
						}
					}
				} else {
					this.el.querySelector('[data-surface-pick-up]').innerHTML = '';
				}
			}

			addToCart(e) {
				const cartDrawer = document.querySelector("#sidebar-cart");
				if (!cartDrawer && this.productSettings.cartRedirect) {
					return;
				}

				e.preventDefault();

				if (this.processing) {
					return;
				}

				this.processing = true;

				if (Modernizr.cssanimations) {
					jquery_default()('.add-to-cart', this.$el).addClass('loading');
				} else {
					this.$addToCartButton.val(this.productSettings.processingText);
				}

				const quantity = jquery_default()('input[name="quantity"]', this.$el).val();

				if (quantity === '' || quantity === '0') {
					setTimeout(() => {
						jquery_default()('input[name="quantity"]', this.$el).addClass('error');
						this.$productMessage.removeClass('success').addClass('error').text(this.productSettings.setQuantityText);
						jquery_default()('.add-to-cart', this.$el).removeClass('loading');
						this.processing = false;
					}, 500);
				}

				Shopify.addItemFromForm(this.productForm, cartItem => setTimeout(() => {
					Shopify.getCart(cart => {
						document.dispatchEvent(new CustomEvent('cart:count', {
							detail: {
								count: cart.item_count
							}
						}));
						document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
								variant: cartItem,
                quantity: quantity
              }
            }));
					});
					const successMessage = this.productSettings.successMessage.replace('** product **', cartItem.title);
					jquery_default()('input[name="quantity"]', this.$el).removeClass('error');
					jquery_default()('.add-to-cart', this.$el).removeClass('loading');
					this.$productMessage.removeClass('error').addClass('success').html(successMessage);

					if (!Modernizr.cssanimations) {
						this.$addToCartButton.val(this.productSettings.addToCartText);
					}

					this.processing = false;
				}, 1000));
			}

			handleErrors(errors) {
				const errorMessage = jquery_default().parseJSON(errors.responseText);
				const productTitle = this.productJSON.title;
				let errorDescription = errorMessage.description;

				if (errorMessage.description.indexOf(productTitle) > -1) {
					errorDescription = errorDescription.replace(productTitle, `<em>${productTitle}</em>`);
				}

				if (errorMessage.message === 'Cart Error') {
					setTimeout(() => {
						jquery_default()('input[name="quantity"]', this.$el).removeClass('error');
						this.$productMessage.removeClass('success').addClass('error').html(errorDescription);
						jquery_default()('.add-to-cart', this.$el).removeClass('loading added-success').addClass('added-error');

						if (!Modernizr.cssanimations) {
							this.$addToCartButton.val(this.productSettings.addToCartText);
						}

						this.processing = false;
					}, 1000);
				}
			}

			onSectionUnload() {
				if (this.variantHelpers != null) {
					this.variantHelpers.prepareRemove();
				}

				if (this.ImageZoom != null) {
					this.ImageZoom.prepareRemove();
				}

				if (this.productGallery) {
					this.productGallery.unload();
				}

				jquery_default()('.product-form', this.$el).off('submit');
			}

		}
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-faq/dist/index.es.js

		/*!
		 * @pixelunion/pxs-faq v1.0.6
		 * (c) 2021 Pixel Union
		 */

		function pxs_faq_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_faq_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_faq_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) pxs_faq_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) pxs_faq_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function dist_index_es_unwrapExports(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function pxs_faq_dist_index_es_createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var dist_index_es_EventHandler_1 = pxs_faq_dist_index_es_createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener)
						return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el, event = _a.event, listener = _a.listener;
					if (!el || !event || !listener)
						return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el
							|| event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			}());
			exports["default"] = EventHandler;
		});

		var dist_index_es_EventHandler = dist_index_es_unwrapExports(dist_index_es_EventHandler_1);

		/*!
			 * @pixelunion/animations v0.1.0
			 * (c) 2019 Pixel Union
			 * Released under the UNLICENSED license.
			*/

		function _classCallCheck$1(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function _defineProperties$1(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function _createClass$1(Constructor, protoProps, staticProps) {
			if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
			if (staticProps) _defineProperties$1(Constructor, staticProps);
			return Constructor;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function index_es_raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */


		var index_es_Animation =
			/*#__PURE__*/
			function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					_classCallCheck$1(this, Animation);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || 'initial';
					this.initialState = this._state;
					this.stateAttribute = options.stateAttribute || 'data-animation-state';
					this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
					this.endEvent = options.endEvent || 'transitionend';
					this.hold = !!options.hold;

					this.onStart = options.onStart || function () {
						/* do nothing */
					};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */


				_createClass$1(Animation, [{
					key: "isState",

					/**
					 * Check if a state is active
					 * @param {String} state State to compare
					 *
					 * @return {Boolean}
					 */
					value: function isState(state) {
						return state === this._state;
					}
					/**
					 * Sequences a change to a new state.
					 * @param {String} state Target state
					 *
					 * @param {Boolean} options.force Switch to final state immediately
					 *
					 * @param {Function} options.onStart Callback to execute immediately after
					 * applying stateChangeAttribute for this state change only.
					 *
					 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
					 * next state change.
					 *
					 * @return {Promise} Resolves when endEvent triggered
					 */

				}, {
					key: "animateTo",
					value: function animateTo(state) {
						var _this = this;

						var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						var from = this._el.dataset[this.stateAttribute] || this._state;
						var to = state || this.initialState;
						var force = options.force;
						var hold = 'hold' in options ? options.hold : this.hold;
						return new Promise(function (resolve) {
							if (_this.cancelRunning) {
								_this.cancelRunning();
							}

							if (from === to) {
								// Removing this here fixes some lingering attributes. But why?
								_this._el.removeAttribute(_this.stateChangeAttribute);

								resolve(from, null);
								return;
							}

							var running = true;

							_this.cancelRunning = function () {
								running = false;
								resolve(null, null);
							};

							_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

							_this.activeEventHandler = null;

							if (force) {
								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;

								if (!hold) {
									_this._el.removeAttribute(_this.stateChangeAttribute);
								}

								resolve(to, null);
								return;
							}

							index_es_raf().then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								return index_es_raf();
							}).then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

								_this.activeEventHandler = function (e) {
									// Ignore any events bubbling up
									if (e.target !== _this._el || !running) return;

									_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, e);
								};

								_this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;
							})["catch"](function (error) {
								// Only catch 'cancelled' errors.
								if (error.message !== 'cancelled') throw error;
							});
						});
					}
					/**
					 * Remove any event listeners
					 */

				}, {
					key: "unload",
					value: function unload() {
						this._el.removeEventListener(this.endEvent, this.activeEventHandler);

						this.activeEventHandler = null;
					}
				}, {
					key: "el",
					get: function get() {
						return this._el;
					}
					/**
					 * Returns current state
					 *
					 * @return {String} Current state
					 */

				}, {
					key: "state",
					get: function get() {
						return this._state;
					}
				}]);

				return Animation;
			}();

		function index_es_transition(options) {
			return new index_es_Animation(options);
		}

		var FAQ = /*#__PURE__*/function () {
			function FAQ(section) {
				var _this = this;

				pxs_faq_dist_index_es_classCallCheck(this, FAQ);

				this.el = section.el;
				this.summaryEls = this.el.querySelectorAll('[data-faq-summary]');
				this.events = new dist_index_es_EventHandler();
				this.animations = {};
				this.closedState = 'closed';
				this.openState = 'open';
				this.initAnimations();
				this.summaryEls.forEach(function (summary) {
					_this.events.register(summary, 'click', function (event) {
						return _this.animateAccordion(event);
					});
				});
			}

			pxs_faq_dist_index_es_createClass(FAQ, [{
				key: "initAnimations",
				value: function initAnimations() {
					var _this2 = this;

					this.summaryEls.forEach(function (summary) {
						var currentAnswerEl = summary.nextElementSibling;
						var currentDetailsEl = summary.closest('[data-faq-details]');
						var index = currentAnswerEl.dataset.faqAnswerIndex;
						_this2.animations[index] = index_es_transition({
							el: currentAnswerEl,
							state: _this2.closedState
						});
						currentDetailsEl.style.setProperty('--closed-height', "".concat(summary.offsetHeight, "px"));
					});
				}
			}, {
				key: "animateAccordion",
				value: function animateAccordion(event) {
					event.preventDefault();
					var summary = event.currentTarget;
					var currentAnswerEl = summary.nextElementSibling;
					var currentDetailsEl = summary.closest('[data-faq-details]');
					if (currentAnswerEl.dataset.animation) return;

					if (currentAnswerEl.dataset.animationState == this.openState) {
						this.closeAccordion(currentDetailsEl);
					} else {
						this.openAccordion(currentDetailsEl);
					}
				}
			}, {
				key: "openAccordion",
				value: function openAccordion(detailsEl) {
					var answerEl = detailsEl.querySelector('[data-faq-answer]');
					var answerIndex = answerEl.dataset.faqAnswerIndex;
					detailsEl.setAttribute('open', '');
					this.animations[answerIndex].animateTo(this.openState, {
						onStart: function onStart(_ref) {
							var el = _ref.el;
							el.style.setProperty('--open-height', "".concat(el.offsetHeight, "px"));
						}
					});
				}
			}, {
				key: "closeAccordion",
				value: function closeAccordion(detailsEl) {
					var answerIndex = detailsEl.querySelector('[data-faq-answer]').dataset.faqAnswerIndex;
					this.animations[answerIndex].animateTo(this.closedState).then(function () {
						detailsEl.removeAttribute('open');
					});
				}
			}, {
				key: "onSectionBlockSelect",
				value: function onSectionBlockSelect(block) {
					this.openAccordion(block.el);
				}
			}, {
				key: "onSectionBlockDeselect",
				value: function onSectionBlockDeselect(block) {
					this.closeAccordion(block.el);
				}
			}, {
				key: "onSectionUnload",
				value: function onSectionUnload() {
					var _this3 = this;

					this.events.unregisterAll();
					Object.keys(this.animations).forEach(function (key) {
						_this3.animations[key].unload();
					});
					this.animations = {};
				}
			}]);

			return FAQ;
		}();

/* harmony default export */ const pxs_faq_dist_index_es = (FAQ);

		;// CONCATENATED MODULE: ./source/scripts/sections/DynamicFAQ.js


		class DynamicFAQ extends pxs_faq_dist_index_es {
			constructor(section) {
				super(section);
				this.el = section.el;
				this.allAnswerElements = this.el.querySelectorAll('[data-faq-answer]');
				this._onBreakpointChange = this._onBreakpointChange.bind(this);
				cjs/* onChange */.z2(this._onBreakpointChange);
			}

			_resizeAnswerElements() {
				this.allAnswerElements.forEach(answersEl => {
					if (answersEl.dataset.animationState === 'open') {
						answersEl.style.setProperty('--open-height', 'auto');
					}
				});
			}

			_onBreakpointChange() {
				this._resizeAnswerElements();
			}

		}
		// EXTERNAL MODULE: ./node_modules/twitter-fetcher/js/twitterFetcher_min.js
		var twitterFetcher_min = __webpack_require__(637);
		var twitterFetcher_min_default = /*#__PURE__*/__webpack_require__.n(twitterFetcher_min);
		;// CONCATENATED MODULE: ./source/scripts/sections/DynamicTwitter.js


		class DynamicTwitter {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.initializedClass = 'twitter-initialized';

				this._validate();
			}

			_validate() {
				this.tweetContainer = jquery_default()('[data-twitter-tweets]', this.$el);
				const username = jquery_default()('[data-twitter-username]', this.$el).attr('data-twitter-username');
				const retweets = jquery_default()('[data-show-retweets]', this.$el).length;
				const showImages = jquery_default()('[data-show-images]', this.$el).length;
				const isInitialized = this.$el.hasClass(this.initializedClass);

				if (this.tweetContainer.length) {
					if (!isInitialized) {
						this._fetchTweets(username, retweets, showImages);
					}
				} else {
					this._toggleOnBoarding();
				}
			}

			_toggleOnBoarding() {
				this.$el.removeClass('module-hidden').removeClass(this.initializedClass);
			}

			_fetchTweets(username, retweets, showImages) {
				const config = {
					profile: {
						screenName: username
					},
					maxTweets: 1,
					enableLinks: true,
					showUser: true,
					showTime: true,
					showRetweet: retweets,
					customCallback: tweets => this.renderTweets(tweets),
					showInteraction: false,
					useEmoji: true,
					showImages: showImages
				};
				twitterFetcher_min_default().fetch(config);
			}

			renderTweets(tweets) {
				if (tweets.length) {
					const $tweet = jquery_default()(tweets[0]);
					const media = jquery_default()($tweet[3]);
					this.tweetContainer.html($tweet[1]);
					this.$el.removeClass('module-hidden').addClass(this.initializedClass);

					if (media.length) {
						this.tweetContainer.addClass('has-image').prepend(media);
					}
				} else {
					// twitterFetcher changes the view element to window, so we cannot use @$el here
					this.tweetContainer.html();
					this.$el.addClass('module-hidden').removeClass(this.initializedClass);
				}
			}

			update($el) {
				// Resets the @$el for the current closure
				this.$el = $el;

				this._validate();
			}

		}
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-header-standard/dist/index.es.js

		/*!
		 * @pixelunion/pxs-header-standard v1.0.15
		 * (c) 2021 Pixel Union
		 */

		function pxs_header_standard_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_header_standard_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_header_standard_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) pxs_header_standard_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) pxs_header_standard_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function pxs_header_standard_dist_index_es_unwrapExports(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function pxs_header_standard_dist_index_es_createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var pxs_header_standard_dist_index_es_EventHandler_1 = pxs_header_standard_dist_index_es_createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener)
						return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el, event = _a.event, listener = _a.listener;
					if (!el || !event || !listener)
						return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el
							|| event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			}());
			exports["default"] = EventHandler;
		});

		var pxs_header_standard_dist_index_es_EventHandler = pxs_header_standard_dist_index_es_unwrapExports(pxs_header_standard_dist_index_es_EventHandler_1);

		/*!
			 * @pixelunion/animations v0.1.0
			 * (c) 2019 Pixel Union
			 * Released under the UNLICENSED license.
			*/

		function index_es_classCallCheck$1(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function index_es_defineProperties$1(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function index_es_createClass$1(Constructor, protoProps, staticProps) {
			if (protoProps) index_es_defineProperties$1(Constructor.prototype, protoProps);
			if (staticProps) index_es_defineProperties$1(Constructor, staticProps);
			return Constructor;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function dist_index_es_raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */


		var dist_index_es_Animation =
			/*#__PURE__*/
			function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					index_es_classCallCheck$1(this, Animation);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || 'initial';
					this.initialState = this._state;
					this.stateAttribute = options.stateAttribute || 'data-animation-state';
					this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
					this.endEvent = options.endEvent || 'transitionend';
					this.hold = !!options.hold;

					this.onStart = options.onStart || function () {
						/* do nothing */
					};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */


				index_es_createClass$1(Animation, [{
					key: "isState",

					/**
					 * Check if a state is active
					 * @param {String} state State to compare
					 *
					 * @return {Boolean}
					 */
					value: function isState(state) {
						return state === this._state;
					}
					/**
					 * Sequences a change to a new state.
					 * @param {String} state Target state
					 *
					 * @param {Boolean} options.force Switch to final state immediately
					 *
					 * @param {Function} options.onStart Callback to execute immediately after
					 * applying stateChangeAttribute for this state change only.
					 *
					 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
					 * next state change.
					 *
					 * @return {Promise} Resolves when endEvent triggered
					 */

				}, {
					key: "animateTo",
					value: function animateTo(state) {
						var _this = this;

						var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						var from = this._el.dataset[this.stateAttribute] || this._state;
						var to = state || this.initialState;
						var force = options.force;
						var hold = 'hold' in options ? options.hold : this.hold;
						return new Promise(function (resolve) {
							if (_this.cancelRunning) {
								_this.cancelRunning();
							}

							if (from === to) {
								// Removing this here fixes some lingering attributes. But why?
								_this._el.removeAttribute(_this.stateChangeAttribute);

								resolve(from, null);
								return;
							}

							var running = true;

							_this.cancelRunning = function () {
								running = false;
								resolve(null, null);
							};

							_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

							_this.activeEventHandler = null;

							if (force) {
								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;

								if (!hold) {
									_this._el.removeAttribute(_this.stateChangeAttribute);
								}

								resolve(to, null);
								return;
							}

							dist_index_es_raf().then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								return dist_index_es_raf();
							}).then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

								_this.activeEventHandler = function (e) {
									// Ignore any events bubbling up
									if (e.target !== _this._el || !running) return;

									_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, e);
								};

								_this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;
							})["catch"](function (error) {
								// Only catch 'cancelled' errors.
								if (error.message !== 'cancelled') throw error;
							});
						});
					}
					/**
					 * Remove any event listeners
					 */

				}, {
					key: "unload",
					value: function unload() {
						this._el.removeEventListener(this.endEvent, this.activeEventHandler);

						this.activeEventHandler = null;
					}
				}, {
					key: "el",
					get: function get() {
						return this._el;
					}
					/**
					 * Returns current state
					 *
					 * @return {String} Current state
					 */

				}, {
					key: "state",
					get: function get() {
						return this._state;
					}
				}]);

				return Animation;
			}();

		function dist_index_es_transition(options) {
			return new dist_index_es_Animation(options);
		}

		var HeaderNavParent = /*#__PURE__*/function () {
			function HeaderNavParent(options) {
				var _this = this;

				pxs_header_standard_dist_index_es_classCallCheck(this, HeaderNavParent);

				this.menuItem = options.menuItem;
				this.detailsItem = options.menuItem.querySelector('[data-header-nav-details]');
				this.parentMenu = options.parentMenu;
				this.menuLink = this.detailsItem.querySelector('[data-header-nav-link]');
				this.submenuEl = this.menuItem.querySelector('[data-header-nav-submenu]');
				this._isOpen = false;
				this.submenu = null;
				this.events = new pxs_header_standard_dist_index_es_EventHandler();
				this._open = this._open.bind(this);
				this._close = this._close.bind(this);
				this.close = this.close.bind(this); // When a user hits the escape key all of the menus should close and the keyboard focus should return
				// to the parent link. This will bubble up to the top parent menu.

				this.closeEsc = function (e) {
					if (e.key === 'Escape') {
						_this.menuLink.focus();

						_this._close();
					}
				}; // When the mouse leaves the open menu, we don't want to close it right away. Setting a delay on close
				// allows situations where you might go to another parent menu but your mouse would drag slightly outside
				// of the open menu, causing you to have to go back and open the menu again. This improves accessibility
				// as well as general usability.


				this.closeTimer = null;

				this.mouseover = function () {
					clearTimeout(_this.closeTimer);

					_this._open();
				};

				this.mouseout = function () {
					_this.closeTimer = setTimeout(_this.close, 400);
				};

				this.click = function (e) {
					e.stopPropagation(); // If the menu is already open, we want to continue to the link in the <a> tag.
					// For mouse hover, this is pretty straightforward, but with keyboard and touch navigation
					// you will have to touch or trigger that link a second time. This is maybe not the best for
					// accessibility, but it's a good compromise for now.

					var clickedParent = e.target.closest('[data-header-nav-link]');

					if (clickedParent && clickedParent.dataset.href) {
						// We only prevent the click through if the menu wasn't already open.
						e.preventDefault();

						if (_this._isOpen) {
							window.location = clickedParent.dataset.href;
							return;
						}
					} // If the submenu isn't open, open it


					_this._open();
				}; // During keyboard navigation, when you focus onto the parent menuItem, this will close the other
				// menu items that were previously open. This usually happens when you were navigating within
				// a submenu and then tab out of it to the next menu item at a lower tier.


				this.focusin = function (e) {
					e.stopPropagation();

					_this.parentMenu.closeSiblings(_this);
				}; // Set up animation event


				this.animation = dist_index_es_transition({
					el: this.submenuEl,
					state: 'closed'
				});
				this.events.register(this.menuItem, 'mouseover', function () {
					return _this.mouseover();
				});
				this.events.register(this.menuItem, 'mouseout', function () {
					return _this.mouseout();
				});
				this.events.register(this.menuItem, 'click', function (e) {
					return _this.click(e);
				});
				this.events.register(this.menuItem, 'touchend', function (e) {
					return _this.click(e);
				});
				this.events.register(this.menuItem, 'focusin', function (e) {
					return _this.focusin(e);
				}); // If the user clicks, taps, or their keyboard focus reaches outside of the menu
				// we should close this menu.

				this.events.register(document.body, 'click', function () {
					return _this._close();
				});
				this.events.register(document.body, 'focusin', function () {
					return _this._close();
				});
			}

			pxs_header_standard_dist_index_es_createClass(HeaderNavParent, [{
				key: "forceOpen",
				value: function forceOpen() {
					return this._open();
				}
			}, {
				key: "forceClose",
				value: function forceClose() {
					return this._close();
				}
			}, {
				key: "close",
				value: function close() {
					this._close();
				}
			}, {
				key: "_open",
				value: function _open() {
					var _this2 = this;

					if (this._isOpen) return;
					this._isOpen = true;
					this.parentMenu.closeSiblings(this);
					this.closeEscEvent = this.events.register(window, 'keydown', function (e) {
						return _this2.closeEsc(e);
					});

					if (!this.submenu) {
						this.submenu = new HeaderNavMenu({
							navList: this.submenuEl
						});
					}

					this.submenuEl.classList.remove('alternate-drop');
					this.animation.animateTo('open', {
						onStart: function onStart(_ref) {
							var el = _ref.el;
							// Check to see if dropdown is offscreen and apply a class so it can be styled differently.
							var menuBounds = el.getBoundingClientRect();

							if (menuBounds.right > document.documentElement.clientWidth) {
								el.classList.add('alternate-drop');
							}

							if (menuBounds.left < 0) {
								el.classList.add('alternate-drop-left');
							}
						}
					});
					this.menuLink.setAttribute('aria-expanded', true);
					this.detailsItem.setAttribute('open', 'open');
				}
			}, {
				key: "_close",
				value: function _close() {
					var _this3 = this;

					if (!this._isOpen) return;

					if (this.submenu) {
						this.submenu.unload();
						this.submenu = null;
					}

					this._isOpen = false;
					this.events.unregister(this.closeEscEvent);
					this.animation.animateTo('closed').then(function () {
						if (_this3._isOpen) return;
						_this3.submenuEl.classList.remove('alternate-drop');

						_this3.menuLink.setAttribute('aria-expanded', false);

						_this3.detailsItem.removeAttribute('open');
					});
				}
			}, {
				key: "unload",
				value: function unload() {
					this.forceClose();
					this.events.unregisterAll();

					if (this.closeEscEvent) {
						this.events.unregister(this.closeEscEvent);
					}
				}
			}]);

			return HeaderNavParent;
		}();

		var HeaderNavMenu = /*#__PURE__*/function () {
			function HeaderNavMenu(options) {
				var _this = this;

				pxs_header_standard_dist_index_es_classCallCheck(this, HeaderNavMenu);

				this.navList = options.navList;
				this.menuItems = this.navList.children;
				this.parents = [];
				this.events = new pxs_header_standard_dist_index_es_EventHandler();

				for (var i = 0; i < this.menuItems.length; i++) {
					var menuItem = this.menuItems[i];

					if (menuItem.dataset.headerNavParent !== undefined) {
						this.parents.push(new HeaderNavParent({
							menuItem: menuItem,
							parentMenu: this
						}));
					} else {
						// If the keyboard navigation moves to another menuItem, we should close any
						// other existing menus that are open.
						this.events.register(menuItem, 'focusin', function () {
							return _this.closeAllMenus();
						});
					}
				}
			} // This function will close all menus that are not the current menu.
			// This is mostly used by the HeaderNavParent class.


			pxs_header_standard_dist_index_es_createClass(HeaderNavMenu, [{
				key: "closeSiblings",
				value: function closeSiblings(current) {
					this.parents.forEach(function (parent) {
						if (parent !== current) {
							parent.close();
						}
					});
				}
			}, {
				key: "closeAllMenus",
				value: function closeAllMenus() {
					this.parents.forEach(function (parent) {
						return parent.close();
					});
				}
			}, {
				key: "unload",
				value: function unload() {
					this.parents.forEach(function (parent) {
						parent.unload();
					});
					this.events.unregisterAll();
				}
			}]);

			return HeaderNavMenu;
		}();

		// It is a separate class so that we can initialize it on its own with different headers.

		var HeaderNav = /*#__PURE__*/function () {
			function HeaderNav(options) {
				pxs_header_standard_dist_index_es_classCallCheck(this, HeaderNav);

				this.header = options.header;
				this.navTier1 = this.header.querySelector('[data-header-nav-tier-1]');

				if (this.navTier1) {
					this.headerNavMenu = new HeaderNavMenu({
						navList: this.navTier1
					});
				}
			}

			pxs_header_standard_dist_index_es_createClass(HeaderNav, [{
				key: "unload",
				value: function unload() {
					if (this.headerNavMenu) {
						this.headerNavMenu.unload();
					}
				}
			}]);

			return HeaderNav;
		}();

		var HeaderStandard = /*#__PURE__*/function () {
			function HeaderStandard(section) {
				var _this = this;

				pxs_header_standard_dist_index_es_classCallCheck(this, HeaderStandard);

				this.el = section.el;
				this.data = section.data;
				this.sticky = this.data.sticky;
				this.transparent = this.data.transparent;
				this.events = new pxs_header_standard_dist_index_es_EventHandler();
				this.header = this.el.querySelector('[data-site-header]');
				this.headerLogo = this.el.querySelector('[data-header-logo]');
				this.logoImage = this.el.querySelector('[data-logo-image]');
				this.logoImageTransparent = this.el.querySelector('[data-logo-image-transparent]');
				this.logoImageMobile = this.el.querySelector('[data-logo-image-mobile]');
				this.cartCount = this.el.querySelector('[data-cart-count]');
				this.scrollObserver = null;
				this.scrollObserverPoint = this.el.querySelector('[data-header-scroll-observer]'); // We need to place the scroll observer point to be outside of the header within the body tag.

				document.body.appendChild(this.scrollObserverPoint);
				this._setTransparency = this._setTransparency.bind(this);
				this.events.register(window, 'resize', function () {
					return _this._recordSizeVariables();
				});
				this.events.register(this.header, 'rimg:load', function () {
					return _this._recordSizeVariables();
				});
				this.events.register(document, 'cart:count', function (e) {
					return _this._updateCartCount(e);
				}); // In the editor, listen for events when another section is moved (in case it is first)

				this.events.register(window, 'shopify:section:reorder', function () {
					return _this._initTransparency();
				});

				this._initTransparency();

				this._recordSizeVariables();

				this.headerNav = new HeaderNav({
					header: this.header
				});
			}

			pxs_header_standard_dist_index_es_createClass(HeaderStandard, [{
				key: "_recordSizeVariables",
				value: function _recordSizeVariables() {
					this._recordHeaderHeight();

					this._recordLogoWidth();
				}
			}, {
				key: "_recordHeaderHeight",
				value: function _recordHeaderHeight() {
					document.body.style.setProperty('--header-height', "".concat(this.header.offsetHeight, "px"));
				}
			}, {
				key: "_recordLogoWidth",
				value: function _recordLogoWidth() {
					// If the image exists and is visible, record its width in a CSS variable.
					if (this.logoImage && this.logoImage.offsetParent) {
						this.header.style.setProperty('--logo-width', "".concat(this.logoImage.getBoundingClientRect().width, "px"));
					} else if (this.logoImageTransparent && this.logoImageTransparent.offsetParent) {
						this.header.style.setProperty('--logo-width', "".concat(this.logoImageTransparent.getBoundingClientRect().width, "px"));
					} else if (this.logoImageMobile && this.logoImageMobile.offsetParent) {
						this.header.style.setProperty('--logo-width', "".concat(this.logoImageMobile.getBoundingClientRect().width, "px"));
					} else {
						this.header.style.setProperty('--logo-width', "".concat(this.headerLogo.getBoundingClientRect().width, "px"));
					}
				}
			}, {
				key: "_initTransparency",
				value: function _initTransparency() {
					var _this2 = this;

					document.body.removeAttribute('data-transparent-header'); // We only want to change transparency if the header is sticky
					// and if the first section is a banner.

					if (this.firstSectionIsBanner()) {
						if (this.sticky && this.transparent) {
							document.body.dataset.transparentHeader = true;
							this.scrollObserver = new IntersectionObserver(function (entries) {
								return _this2._setTransparency(entries);
							});
							this.scrollObserver.observe(this.scrollObserverPoint);
						} else if (this.transparent) {
							document.body.dataset.transparentHeader = true;
						}
					}
				}
			}, {
				key: "_setTransparency",
				value: function _setTransparency(entries) {
					if (!entries) {
						return;
					}

					if (entries[0].isIntersecting || !this.sticky) {
						document.body.dataset.transparentHeader = true;
					} else {
						document.body.dataset.transparentHeader = false;
					}

					this._recordHeaderHeight();
				}
			}, {
				key: "_updateCartCount",
				value: function _updateCartCount(e) {
					var count = e.detail.count;
					this.cartCount.innerHTML = count;
				}
			}, {
				key: "firstSectionIsBanner",
				value: function firstSectionIsBanner() {
					var firstSection = document.querySelector('main section');
					return firstSection && firstSection.dataset.banner === 'true';
				}
			}, {
				key: "onSectionUnload",
				value: function onSectionUnload() {
					this.headerNav.unload();
					this.events.unregisterAll();

					if (this.scrollObserver) {
						this.scrollObserver.disconnect();
					}

					document.body.removeAttribute('data-transparent-header');
				}
			}]);

			return HeaderStandard;
		}();

/* harmony default export */ const pxs_header_standard_dist_index_es = (HeaderStandard);

		;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-drawer-nav-standard/dist/index.es.js

		/*!
		 * @pixelunion/pxs-drawer-nav-standard v1.0.3
		 * (c) 2021 Pixel Union
		 */

		function pxs_drawer_nav_standard_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function pxs_drawer_nav_standard_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function pxs_drawer_nav_standard_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) pxs_drawer_nav_standard_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) pxs_drawer_nav_standard_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function pxs_drawer_nav_standard_dist_index_es_unwrapExports(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function pxs_drawer_nav_standard_dist_index_es_createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}

		var pxs_drawer_nav_standard_dist_index_es_EventHandler_1 = pxs_drawer_nav_standard_dist_index_es_createCommonjsModule(function (module, exports) {
			exports.__esModule = true;
			var EventHandler = /** @class */ (function () {
				function EventHandler() {
					this.events = [];
				}
				EventHandler.prototype.register = function (el, event, listener) {
					if (!el || !event || !listener)
						return null;
					this.events.push({ el: el, event: event, listener: listener });
					el.addEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregister = function (_a) {
					var el = _a.el, event = _a.event, listener = _a.listener;
					if (!el || !event || !listener)
						return null;
					this.events = this.events.filter(function (e) {
						return el !== e.el
							|| event !== e.event || listener !== e.listener;
					});
					el.removeEventListener(event, listener);
					return { el: el, event: event, listener: listener };
				};
				EventHandler.prototype.unregisterAll = function () {
					this.events.forEach(function (_a) {
						var el = _a.el, event = _a.event, listener = _a.listener;
						return el.removeEventListener(event, listener);
					});
					this.events = [];
				};
				return EventHandler;
			}());
			exports["default"] = EventHandler;
		});

		var pxs_drawer_nav_standard_dist_index_es_EventHandler = pxs_drawer_nav_standard_dist_index_es_unwrapExports(pxs_drawer_nav_standard_dist_index_es_EventHandler_1);

		function dist_index_es_classCallCheck$1(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function dist_index_es_defineProperties$1(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function dist_index_es_createClass$1(Constructor, protoProps, staticProps) {
			if (protoProps) dist_index_es_defineProperties$1(Constructor.prototype, protoProps);
			if (staticProps) dist_index_es_defineProperties$1(Constructor, staticProps);
			return Constructor;
		}

		function getDefaultExportFromCjs(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function createCommonjsModule$1(fn) {
			var module = { exports: {} };
			return fn(module, module.exports), module.exports;
		}

		var EventHandler_1$1 = createCommonjsModule$1(function (module, exports) {

			exports.__esModule = true;

			var EventHandler =
				/** @class */
				function () {
					function EventHandler() {
						this.events = [];
					}

					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({
							el: el,
							event: event,
							listener: listener
						});
						el.addEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener
						};
					};

					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return el !== e.el || event !== e.event || listener !== e.listener;
						});
						el.removeEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener
						};
					};

					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};

					return EventHandler;
				}();

			exports["default"] = EventHandler;
		});

		var Events = /*@__PURE__*/getDefaultExportFromCjs(EventHandler_1$1);

		var selectors = {
			disclosureList: '[data-disclosure-list]',
			disclosureToggle: '[data-disclosure-toggle]',
			disclosureInput: '[data-disclosure-input]',
			disclosureOptions: '[data-disclosure-option]'
		};
		var classes = {
			listVisible: 'disclosure-list--visible',
			alternateDrop: 'disclosure-list--alternate-drop'
		};

		var Disclosure = /*#__PURE__*/function () {
			function Disclosure(el) {
				dist_index_es_classCallCheck$1(this, Disclosure);

				this.el = el;
				this.events = new Events();
				this.cache = {};

				this._cacheSelectors();

				this._connectOptions();

				this._connectToggle();

				this._onFocusOut();
			}

			dist_index_es_createClass$1(Disclosure, [{
				key: "_cacheSelectors",
				value: function _cacheSelectors() {
					this.cache = {
						disclosureList: this.el.querySelector(selectors.disclosureList),
						disclosureToggle: this.el.querySelector(selectors.disclosureToggle),
						disclosureInput: this.el.querySelector(selectors.disclosureInput),
						disclosureOptions: this.el.querySelectorAll(selectors.disclosureOptions)
					};
				}
			}, {
				key: "_connectToggle",
				value: function _connectToggle() {
					var _this = this;

					this.events.register(this.cache.disclosureToggle, 'click', function (e) {
						var ariaExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
						e.currentTarget.setAttribute('aria-expanded', !ariaExpanded);

						_this.cache.disclosureList.classList.remove(classes.alternateDrop);

						_this.cache.disclosureList.classList.toggle(classes.listVisible);

						window.requestAnimationFrame(function () {
							var _this$cache$disclosur = _this.cache.disclosureList.getBoundingClientRect(),
								left = _this$cache$disclosur.left,
								width = _this$cache$disclosur.width;

							var _window = window,
								innerWidth = _window.innerWidth;
							var gutter = 30;

							if (left + width + gutter > innerWidth) {
								_this.cache.disclosureList.classList.add(classes.alternateDrop);
							}
						});
					});
				}
			}, {
				key: "_connectOptions",
				value: function _connectOptions() {
					var _this2 = this;

					var options = this.cache.disclosureOptions;

					for (var i = 0; i < options.length; i++) {
						var option = options[i];
						this.events.register(option, 'click', function (e) {
							return _this2._submitForm(e.currentTarget.dataset.value);
						});
					}
				}
			}, {
				key: "_onFocusOut",
				value: function _onFocusOut() {
					var _this3 = this;

					this.events.register(this.cache.disclosureToggle, 'focusout', function (e) {
						var disclosureLostFocus = !_this3.el.contains(e.relatedTarget);

						if (disclosureLostFocus) {
							_this3._hideList();
						}
					});
					this.events.register(this.cache.disclosureList, 'focusout', function (e) {
						var childInFocus = e.currentTarget.contains(e.relatedTarget);

						var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);

						if (isVisible && !childInFocus) {
							_this3._hideList();
						}
					});
					this.events.register(this.el, 'keyup', function (e) {
						if (e.defaultPrevented) {
							return; // Do nothing if the event was already processed
						}

						if (e.key !== 'Escape' || e.key !== 'Esc') return;

						_this3._hideList();

						_this3.cache.disclosureToggle.focus();
					});
					this.events.register(document.body, 'click', function (e) {
						var isOption = _this3.el.contains(e.target);

						var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);

						if (isVisible && !isOption) {
							_this3._hideList();
						}
					});
				}
			}, {
				key: "_submitForm",
				value: function _submitForm(value) {
					this.cache.disclosureInput.value = value;
					this.el.closest('form').submit();
				}
			}, {
				key: "_hideList",
				value: function _hideList() {
					this.cache.disclosureList.classList.remove(classes.listVisible);
					this.cache.disclosureToggle.setAttribute('aria-expanded', false);
				}
			}, {
				key: "unload",
				value: function unload() {
					this.events.unregisterAll();
				}
			}]);

			return Disclosure;
		}();

		if (!Element.prototype.matches) {
			Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function closest(s) {
				var el = this;

				do {
					if (el.matches(s)) return el;
					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);

				return null;
			};
		}

		/*!
			 * @pixelunion/animations v0.1.0
			 * (c) 2019 Pixel Union
			 * Released under the UNLICENSED license.
			*/

		function _classCallCheck$2(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function _defineProperties$2(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function _createClass$2(Constructor, protoProps, staticProps) {
			if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
			if (staticProps) _defineProperties$2(Constructor, staticProps);
			return Constructor;
		}

		/**
		 * Promisified version of window.requestAnimationFrame.
		 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
		 */
		function pxs_drawer_nav_standard_dist_index_es_raf() {
			return new Promise(function (resolve) {
				window.requestAnimationFrame(resolve);
			});
		}
		/**
		 * Represents an HTML element with associate states
		 */


		var pxs_drawer_nav_standard_dist_index_es_Animation =
			/*#__PURE__*/
			function () {
				/**
				 * @param {Object} options
				 * @param {HTMLElement}  options.el Target element
				 * @param {String} [options.state=initial] Initial state. This is also the default state.
				 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
				 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
				 * update with change of state.
				 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
				 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
				 * next state change.
				 * @param {Function} [options.onStart] Callback to execute immediate after
				 * applying stateChangeAttribute.
				 */
				function Animation(options) {
					_classCallCheck$2(this, Animation);

					this._el = options.el;
					this.cancelRunning = null;
					this._state = options.state || 'initial';
					this.initialState = this._state;
					this.stateAttribute = options.stateAttribute || 'data-animation-state';
					this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
					this.endEvent = options.endEvent || 'transitionend';
					this.hold = !!options.hold;

					this.onStart = options.onStart || function () {
						/* do nothing */
					};

					this.activeEventHandler = null;
				}
				/**
				 * Returns target element
				 *
				 * @return {HTMLElement} Target element
				 */


				_createClass$2(Animation, [{
					key: "isState",

					/**
					 * Check if a state is active
					 * @param {String} state State to compare
					 *
					 * @return {Boolean}
					 */
					value: function isState(state) {
						return state === this._state;
					}
					/**
					 * Sequences a change to a new state.
					 * @param {String} state Target state
					 *
					 * @param {Boolean} options.force Switch to final state immediately
					 *
					 * @param {Function} options.onStart Callback to execute immediately after
					 * applying stateChangeAttribute for this state change only.
					 *
					 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
					 * next state change.
					 *
					 * @return {Promise} Resolves when endEvent triggered
					 */

				}, {
					key: "animateTo",
					value: function animateTo(state) {
						var _this = this;

						var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						var from = this._el.dataset[this.stateAttribute] || this._state;
						var to = state || this.initialState;
						var force = options.force;
						var hold = 'hold' in options ? options.hold : this.hold;
						return new Promise(function (resolve) {
							if (_this.cancelRunning) {
								_this.cancelRunning();
							}

							if (from === to) {
								// Removing this here fixes some lingering attributes. But why?
								_this._el.removeAttribute(_this.stateChangeAttribute);

								resolve(from, null);
								return;
							}

							var running = true;

							_this.cancelRunning = function () {
								running = false;
								resolve(null, null);
							};

							_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

							_this.activeEventHandler = null;

							if (force) {
								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;

								if (!hold) {
									_this._el.removeAttribute(_this.stateChangeAttribute);
								}

								resolve(to, null);
								return;
							}

							pxs_drawer_nav_standard_dist_index_es_raf().then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

								_this.onStart({
									el: _this._el,
									from: from,
									to: to
								});

								if (typeof options.onStart === 'function') {
									options.onStart({
										el: _this._el,
										from: from,
										to: to
									});
								}

								return pxs_drawer_nav_standard_dist_index_es_raf();
							}).then(function () {
								if (!running) throw new Error('cancelled');

								_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

								_this.activeEventHandler = function (e) {
									// Ignore any events bubbling up
									if (e.target !== _this._el || !running) return;

									_this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

									if (!hold) {
										_this._el.removeAttribute(_this.stateChangeAttribute);
									}

									resolve(to, e);
								};

								_this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;
							})["catch"](function (error) {
								// Only catch 'cancelled' errors.
								if (error.message !== 'cancelled') throw error;
							});
						});
					}
					/**
					 * Remove any event listeners
					 */

				}, {
					key: "unload",
					value: function unload() {
						this._el.removeEventListener(this.endEvent, this.activeEventHandler);

						this.activeEventHandler = null;
					}
				}, {
					key: "el",
					get: function get() {
						return this._el;
					}
					/**
					 * Returns current state
					 *
					 * @return {String} Current state
					 */

				}, {
					key: "state",
					get: function get() {
						return this._state;
					}
				}]);

				return Animation;
			}();

		function pxs_drawer_nav_standard_dist_index_es_transition(options) {
			return new pxs_drawer_nav_standard_dist_index_es_Animation(options);
		}

		/**
		 * A11y Helpers
		 * -----------------------------------------------------------------------------
		 * A collection of useful functions that help make your theme more accessible
		 */

		/**
		 * Moves focus to an HTML element
		 * eg for In-page links, after scroll, focus shifts to content area so that
		 * next `tab` is where user expects. Used in bindInPageLinks()
		 * eg move focus to a modal that is opened. Used in trapFocus()
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */
		function index_es_forceFocus(element, options) {
			options = options || {};

			var savedTabIndex = element.tabIndex;

			element.tabIndex = -1;
			element.dataset.tabIndex = savedTabIndex;
			element.focus();
			if (typeof options.className !== 'undefined') {
				element.classList.add(options.className);
			}
			element.addEventListener('blur', callback);

			function callback(event) {
				event.target.removeEventListener(event.type, callback);

				element.tabIndex = savedTabIndex;
				delete element.dataset.tabIndex;
				if (typeof options.className !== 'undefined') {
					element.classList.remove(options.className);
				}
			}
		}

		function index_es_focusable(container) {
			var elements = Array.prototype.slice.call(
				container.querySelectorAll(
					'[tabindex],' +
					'[draggable],' +
					'a[href],' +
					'area,' +
					'button:enabled,' +
					'input:not([type=hidden]):enabled,' +
					'object,' +
					'select:enabled,' +
					'textarea:enabled'
				)
			);

			// Filter out elements that are not visible.
			// Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
			return elements.filter(function (element) {
				return !!(
					element.offsetWidth ||
					element.offsetHeight ||
					element.getClientRects().length
				);
			});
		}

		/**
		 * Traps the focus in a particular container
		 *
		 * @param {Element} container - Container DOM element to trap focus inside of
		 * @param {Element} elementToFocus - Element to be focused on first
		 * @param {Object} options - Settings unique to your theme
		 * @param {string} options.className - Class name to apply to element on focus.
		 */

		var index_es_trapFocusHandlers = {};

		function index_es_trapFocus(container, options) {
			options = options || {};
			var elements = index_es_focusable(container);
			var elementToFocus = options.elementToFocus || container;
			var first = elements[0];
			var last = elements[elements.length - 1];

			index_es_removeTrapFocus();

			index_es_trapFocusHandlers.focusin = function (event) {
				if (container !== event.target && !container.contains(event.target)) {
					first.focus();
				}

				if (
					event.target !== container &&
					event.target !== last &&
					event.target !== first
				)
					return;
				document.addEventListener('keydown', index_es_trapFocusHandlers.keydown);
			};

			index_es_trapFocusHandlers.focusout = function () {
				document.removeEventListener('keydown', index_es_trapFocusHandlers.keydown);
			};

			index_es_trapFocusHandlers.keydown = function (event) {
				if (event.keyCode !== 9) return; // If not TAB key

				// On the last focusable element and tab forward, focus the first element.
				if (event.target === last && !event.shiftKey) {
					event.preventDefault();
					first.focus();
				}

				//  On the first focusable element and tab backward, focus the last element.
				if (
					(event.target === container || event.target === first) &&
					event.shiftKey
				) {
					event.preventDefault();
					last.focus();
				}
			};

			document.addEventListener('focusout', index_es_trapFocusHandlers.focusout);
			document.addEventListener('focusin', index_es_trapFocusHandlers.focusin);

			index_es_forceFocus(elementToFocus, options);
		}

		/**
		 * Removes the trap of focus from the page
		 */
		function index_es_removeTrapFocus() {
			document.removeEventListener('focusin', index_es_trapFocusHandlers.focusin);
			document.removeEventListener('focusout', index_es_trapFocusHandlers.focusout);
			document.removeEventListener('keydown', index_es_trapFocusHandlers.keydown);
		}

		var DrawerNavSubmenu = /*#__PURE__*/function () {
			function DrawerNavSubmenu(settings) {
				var _this = this;

				pxs_drawer_nav_standard_dist_index_es_classCallCheck(this, DrawerNavSubmenu);

				this.menu = settings.submenu;
				this.trigger = settings.trigger;
				this.parentMenu = settings.parentMenu;
				this.tier = settings.tier;
				this.drawerMenu = settings.drawerMenu;
				this.submenu = null;
				this.backButton = this.menu.querySelector('[data-drawer-back-button]');
				this.closeButton = this.menu.querySelector('[data-drawer-close-button]');
				this.flyout = this.menu.querySelector('[data-drawer-submenu-flyout]');
				this.overlay = this.menu.querySelector('[data-drawer-submenu-overlay]');
				this.submenuTriggers = this.menu.querySelectorAll("[data-drawer-submenu-button=\"tier-".concat(this.tier, "\"]"));
				this.events = new pxs_drawer_nav_standard_dist_index_es_EventHandler();
				this.flyoutAnimation = pxs_drawer_nav_standard_dist_index_es_transition({
					el: this.flyout,
					state: 'closed'
				});
				this.overlayAnimation = pxs_drawer_nav_standard_dist_index_es_transition({
					el: this.overlay,
					state: 'closed'
				});
				this.events.register(this.backButton, 'click', function () {
					return _this.close();
				});
				this.events.register(this.closeButton, 'click', function () {
					return _this.drawerMenu.close();
				});
				this.submenuTriggers.forEach(function (submenuTrigger) {
					_this.events.register(submenuTrigger, 'click', function (e) {
						return _this.openSubmenu(e);
					});
				});
				this.open();
			}

			pxs_drawer_nav_standard_dist_index_es_createClass(DrawerNavSubmenu, [{
				key: "open",
				value: function open() {
          console.log("NAV SUB MENU")
					this.menu.dataset.open = true;
					this.flyoutAnimation.animateTo('open');
					this.overlayAnimation.animateTo('open');
					this.menu.focus();
					index_es_trapFocus(this.menu);
				}
			}, {
				key: "close",
				value: function close() {
					var _this2 = this;

					index_es_removeTrapFocus(this.menu);
					this.trigger.focus();
					index_es_trapFocus(this.parentMenu);
					this.parentMenu.dataset.childOpen = false;
					this.overlayAnimation.animateTo('closed');
					this.flyoutAnimation.animateTo('closed').then(function () {
						_this2.unload();
					});
				}
			}, {
				key: "openSubmenu",
				value: function openSubmenu(e) {
					var submenuTrigger = e.target;
					var submenu = submenuTrigger.nextElementSibling;
					this.menu.dataset.childOpen = true;
					this.submenu = new DrawerNavSubmenu({
						submenu: submenu,
						trigger: submenuTrigger,
						parentMenu: this.menu,
						tier: this.tier + 1,
						drawerMenu: this.drawerMenu
					});
				}
			}, {
				key: "unload",
				value: function unload() {
					if (this.submenu) {
						this.submenu.unload();
					}

					this.menu.dataset.open = false;
					this.menu.dataset.childOpen = false;
					this.flyoutAnimation.animateTo('closed', {
						force: true
					});
					this.overlayAnimation.animateTo('closed', {
						force: true
					});
					this.flyoutAnimation.unload();
					this.overlayAnimation.unload();
					this.events.unregisterAll();
				}
			}]);

			return DrawerNavSubmenu;
		}();

		var DrawerNavStandard = /*#__PURE__*/function () {
			function DrawerNavStandard(_ref) {
				var _this = this;

				var drawerTrigger = _ref.drawerTrigger;

				pxs_drawer_nav_standard_dist_index_es_classCallCheck(this, DrawerNavStandard);

				this.drawerTrigger = drawerTrigger;
				this.submenu = null;
				this.drawerNav = document.querySelector('[data-drawer-nav]');
				this.closeButton = this.drawerNav.querySelector('[data-drawer-nav-close]');
				this.mainFlyout = this.drawerNav.querySelector('[data-drawer-main-flyout]');
				this.overlay = this.drawerNav.querySelector('[data-drawer-overlay]');
				this.submenuTriggers = this.drawerNav.querySelectorAll('[data-drawer-submenu-button="tier-1"]');
				this.events = new pxs_drawer_nav_standard_dist_index_es_EventHandler();
				this.flyoutAnimation = pxs_drawer_nav_standard_dist_index_es_transition({
					el: this.mainFlyout,
					state: 'closed'
				});
				this.overlayAnimation = pxs_drawer_nav_standard_dist_index_es_transition({
					el: this.overlay,
					state: 'closed'
				});

				this.closeEsc = function (e) {
					if (e.key === 'Escape') {
						_this.close();
					}
				};

				this.events.register(this.drawerTrigger, 'click', function () {
					return _this.open();
				});
				this.events.register(this.closeButton, 'click', function () {
					return _this.close();
				});
				this.events.register(this.overlay, 'click', function () {
					return _this.close();
				});
				this.submenuTriggers.forEach(function (submenuTrigger) {
					_this.events.register(submenuTrigger, 'click', function (e) {
						return _this.openSubmenu(e);
					});
				}); // Currency and Language selectors

				this.currencyDisclosureEl = this.drawerNav.querySelector('[data-disclosure-currency]');
				this.localeDisclosureEl = this.drawerNav.querySelector('[data-disclosure-locale]');
				this.disclosures = [];

				if (this.currencyDisclosureEl) {
					this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
				}

				if (this.localeDisclosureEl) {
					this.disclosures.push(new Disclosure(this.localeDisclosureEl));
				}
			}

			pxs_drawer_nav_standard_dist_index_es_createClass(DrawerNavStandard, [{
				key: "open",
				value: function open() {
          const topBar = document.getElementById('top-bar');
          if (topBar) {
              topBar.style.zIndex = '1000';
          }
					var _this2 = this;

					this.drawerNav.dataset.open = true;
					this.flyoutAnimation.animateTo('open');
					this.overlayAnimation.animateTo('open');
					this.closeEvent = this.events.register(window, 'keydown', function (e) {
						return _this2.closeEsc(e);
					});
					this.drawerNav.focus();
					index_es_trapFocus(this.drawerNav);
				}
			}, {
				key: "close",
				value: function close() {
          const topBar = document.getElementById('top-bar');
          if (topBar) {
              topBar.style.zIndex = '1002';
          }
					var _this3 = this;

					index_es_removeTrapFocus(this.drawerNav);
					this.drawerTrigger.focus();
					this.drawerNav.dataset.childOpen = false;
					this.events.unregister(this.closeEvent);
					this.flyoutAnimation.animateTo('closed');
					this.overlayAnimation.animateTo('closed').then(function () {
						_this3.drawerNav.dataset.open = false;

						if (_this3.submenu) {
							_this3.submenu.unload();
						}
					});
				}
			}, {
				key: "openSubmenu",
				value: function openSubmenu(e) {
					var submenuTrigger = e.target;
					var submenu = submenuTrigger.nextElementSibling;
					this.drawerNav.dataset.childOpen = true;
					this.submenu = new DrawerNavSubmenu({
						submenu: submenu,
						trigger: submenuTrigger,
						parentMenu: this.drawerNav,
						tier: 2,
						drawerMenu: this
					});
				}
			}, {
				key: "unload",
				value: function unload() {
					if (this.submenu) {
						this.submenu.unload();
					}

					this.flyoutAnimation.animateTo('closed', {
						force: true
					});
					this.overlayAnimation.animateTo('closed', {
						force: true
					});
					this.flyoutAnimation.unload();
					this.overlayAnimation.unload();
					this.disclosures.forEach(function (disclosure) {
						return disclosure.unload();
					});
					this.events.unregisterAll();
				}
			}]);

			return DrawerNavStandard;
		}();

/* harmony default export */ const pxs_drawer_nav_standard_dist_index_es = (DrawerNavStandard);

		;// CONCATENATED MODULE: ./source/scripts/components/DrawerNav.js


		class DrawerNav extends pxs_drawer_nav_standard_dist_index_es {
			constructor(settings) {
				super(settings);
				this.menuLinks = this.drawerNav.querySelectorAll('[data-drawer-link-tier-1]');
			}

			open() {
				ScrollLock.lock(this.drawerNav);
				super.open();
				this.menuLinks.forEach((menuLink, i) => {
					// Delay is staggered for each menu item
					const delay = 600 + i * 100;
					setTimeout(() => menuLink.classList.add('drawer-menu__tier-1-link--open'), delay);
				});
			}

			close() {
				ScrollLock.unlock();
				super.close();
				this.menuLinks.forEach(menuLink => {
					menuLink.classList.remove('drawer-menu__tier-1-link--open');
				});
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticHeader.js



		class StaticHeader extends pxs_header_standard_dist_index_es {
			constructor(section) {
				super(section); // In Startup, only the last (right) header controls are available in the header
				// on desktop. The animation is currently only intended to work on desktop

				this.searchButton = this.el.querySelectorAll('[data-search-button]')[1];
				this.headerControls = this.el.querySelectorAll('[data-header-controls]')[1];
				this.headerAccountButton = this.headerControls.querySelector('[data-account-button]');
				this.headerCartButton = this.headerControls.querySelector('[data-cart-button]');
				this.searchContainer = this.el.querySelector('[data-header-search]');
				this.searchForm = this.el.querySelector('[data-header-search-form]');
				this.searchInput = this.el.querySelector('[data-header-search-input]');
				this.searchCloseButton = this.el.querySelector('[data-search-close]');
				this.searchSubmitButton = this.el.querySelector('[data-search-submit]');
				this.headerNavEl = this.el.querySelector('[data-header-nav]');
				this.localizationForm = this.el.querySelector('.shopify-localization-form');
				this.closedState = 'closed';
				this.openState = 'open';
				this.searchIsOpen = false;
				this.navShouldAnimate = typeof this.headerNavEl !== 'undefined' && this.headerNavEl !== null && this.searchForm.dataset.headerNavPosition !== 'below';
				this.drawerTrigger = this.el.querySelector('[data-menu-button]');
				this.drawerNav = new DrawerNav({
					drawerTrigger: this.drawerTrigger
				});

				if (this.searchButton) {
					this.events.register(this.searchCloseButton, 'click', event => this._closeSearchForm(event));
					this.events.register(this.searchButton, 'click', event => this._handleSearchButtonClick(event));

					this._initAnimations();

					this._insertSearchForm();
				} // Currency and Language selectors

				this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
				this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
				this.disclosures = [];

				if (this.currencyDisclosureEl) {
					this.disclosures.push(new shopify_cross_border_dist_index_es(this.currencyDisclosureEl));
				}

				if (this.localeDisclosureEl) {
					this.disclosures.push(new shopify_cross_border_dist_index_es(this.localeDisclosureEl));
				}
			}

			_initAnimations() {
				// Responsible for animating the search icon's underline
				// that expands across the search form
				this.searchButtonAnimation = transition({
					el: this.searchButton,
					state: this.closedState
				}); // Responsible for animating the appearance of the
				// input's placeholder text

				this.searchInputAnimation = transition({
					el: this.searchInput,
					state: this.closedState
				}); // Responsible for the fade in/out of the close button
				// on the search form

				this.searchCloseButtonAnimation = transition({
					el: this.searchCloseButton,
					state: this.closedState
				}); // Responsible for the fade in/out of the header icons

				this.searchContainerAnimation = transition({
					el: this.searchContainer,
					state: this.closedState
				});

				if (this.navShouldAnimate) {
					// Responsible for the fade in/out of the navigation
					this.headerNavAnimation = transition({
						el: this.headerNavEl,
						state: this.openState
					});

					if(this.localizationForm) {
						this.localizationFormAnimation = transition({
							el: this.localizationForm,
							state: this.openState
						});
					}
				} // Responsible for fade in/out on header control icons
				// (Account, if they're enabled, and cart)


				if (this.headerAccountButton) {
					this.headerAccountButtonAnimation = transition({
						el: this.headerAccountButton,
						state: this.openState
					});
				}

				if (this.headerCartButton) {
					this.headerCartButtonAnimation = transition({
						el: this.headerCartButton,
						state: this.openState
					});
				}
			}

			_handleSearchButtonClick(event) {
				event.preventDefault();

				if (this.searchIsOpen) {
					this.searchForm.submit();
				} else {
					let controlsWidth = 0;
					controlsWidth = this.headerCartButton ? controlsWidth + this.headerCartButton.getBoundingClientRect().width : controlsWidth;
					controlsWidth = this.headerAccountButton ? controlsWidth + this.headerAccountButton.getBoundingClientRect().width : controlsWidth;
					controlsWidth = this.searchButton ? controlsWidth + this.searchButton.getBoundingClientRect().width : controlsWidth;
					this.headerControls.style.setProperty('--header-controls-width', `${controlsWidth}px`);

					this._openSearch();
				}
			}

			_insertSearchForm() {
				// We need to insert the search form directly after the search button
				// so that users using keyboard navigation can access the submit button
				this.searchButton.parentNode.insertBefore(this.searchContainer, this.searchButton.nextSibling);
			}

			_openSearch() {
				this._runSearchAnimations(this.openState);

				this._runHeaderAnimations(this.closedState).then(() => this.searchContainerAnimation.animateTo(this.openState)).then(() => {
					this.searchInput.focus();
					this.closeSearchEscEvent = this.events.register(window, 'keydown', event => this._closeSearchFormEsc(event));
					this.searchIsOpen = true;
				});
			}

			_closeSearch() {
				this._runSearchAnimations(this.closedState).then(() => {
					this._runHeaderAnimations(this.openState);

					this.searchContainerAnimation.animateTo(this.closedState);
					this.events.unregister(this.closeSearchEscEvent);
					this.searchIsOpen = false;
					this.searchInput.value = '';
				});
			}

			_runHeaderAnimations(state) {
				return new Promise((resolve, reject) => {
					if (this.headerAccountButton) {
						this.headerAccountButtonAnimation.animateTo(state);
					}

					if (this.headerCartButton) {
						this.headerCartButtonAnimation.animateTo(state);
					}

					if (this.navShouldAnimate) {
						this.headerNavAnimation.animateTo(state).then(() => resolve()).catch(() => reject());
						if(this.localizationFormAnimation) {
							this.localizationFormAnimation.animateTo(state).then(() => resolve()).catch(() => reject());
						}
					} else {
						resolve();
					}
				});
			}

			_runSearchAnimations(state) {
				return new Promise((resolve, reject) => {
					this.searchCloseButtonAnimation.animateTo(state);
					this.searchInputAnimation.animateTo(state);
					this.searchButtonAnimation.animateTo(state).then(() => resolve()).catch(() => reject());
				});
			}

			_closeSearchForm(event) {
				event.preventDefault();

				this._closeSearch();
			}

			_closeSearchFormEsc(event) {
				if (event.key === 'Escape') {
					this._closeSearchForm(event);

					this.searchButton.focus();
				}
			}

			onSectionUnload() {
				super.onSectionUnload();
				this.drawerNav.unload();
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/components/FacetedFiltering.js


		class FacetedFiltering {
			constructor(section) {
				this.el = section.el;
				this.filtersEnabled = this.el.querySelector('[data-faceted-filter]');
				if (!this.filtersEnabled) return;
				this.events = new dist_EventHandler/* default */.Z();
				this.filterInputs = null;
				this.dropdowns = this.el.querySelectorAll('[data-filter-group]');
				this.summaryEls = this.el.querySelectorAll('[data-filter-group-summary]');
				this.filterContents = this.el.querySelectorAll('[data-filter-group-content]');
				this.filterCheckboxes = this.el.querySelectorAll('.filter-icon--checkbox');
				this.fillAnimations = {};
				this.checkAnimations = {};
				this.closedState = 'closed';
				this.openState = 'open';
				this.disclosureAnimations = {};
				this.filterRange = this.el.querySelectorAll('[data-filter-range]');
				this.rangeNames = [];
				this.filterRange.forEach(el => {
					this.rangeNames.push(el.name);
				});
				this.updateTimeout = null;
				this._initFilterEvents = this._initFilterEvents.bind(this);
				this._updatePrice = this._updatePrice.bind(this);
				this._buildFilterQuery = this._buildFilterQuery.bind(this);

				if (this.dropdowns.length) {
					this._setDropdownHeight();
				}

				this._initAnimations();

				this._initFilterEvents();
			}

			_setDropdownHeight() {
				const filterWrapper = this.el.querySelector('[data-faceted-filter]');
				let maxHeight = 0;
				this.dropdowns.forEach(el => {
					const height = el.offsetHeight;

					if (height > maxHeight) {
						maxHeight = height;
					}
				});
				filterWrapper.style.setProperty('--closed-filter-height', `${maxHeight}px`);
			}

			_initFilterEvents() {
				/* For radio buttons */
				this.filterInputs = this.el.querySelectorAll('[data-filter-input]');
				this.filterInputs.forEach(filter => {
					this.events.register(filter, 'click', e => {
						e.preventDefault();
						const target = e.currentTarget;
						const url = target.dataset.url;
						if (target.dataset.hasOwnProperty('disabled')) return;
						const handle = target.getAttribute('data-handle');
						let animateTo = 'checked';

						if (target.hasAttribute('data-filter-active')) {
							animateTo = 'unchecked';
							target.removeAttribute('data-filter-active');
						} else {
							target.setAttribute('data-filter-active', '');
						}

						if (this.fillAnimations[handle] && this.checkAnimations[handle]) {
							this.fillAnimations[handle].animateTo(animateTo);
							this.checkAnimations[handle].animateTo(animateTo).then(() => {
								window.location = url;
							});
						}
					});
				});
				this.filterContents.forEach(content => {
					this.events.register(window, 'resize', () => this._setStyleVariables(content));
				});
				this.events.register(window, 'keyup', e => {
					if (e.key === 'Escape') {
						this._closeAllDropdowns();
					}
				});
				/* For range input */

				this.filterRange.forEach(filter => {
					this.events.register(filter, 'change', e => this._updatePrice(e.currentTarget));
					this.events.register(filter, 'keyup', e => {
						// Don't update if the user is tabbing through the elements
						if (e.key !== 'Tab') {
							this._updatePrice(e.currentTarget);
						}
					});
				});
				this.summaryEls.forEach(summary => {
					this.events.register(summary, 'click', event => this._animateDisclosure(event));
				});
				/* When clicking outside dropdown element, close dropdown */

				this.events.register(document.body, 'click', e => {
					if (!e.target.closest('[data-filter-group]')) {
						this._closeAllDropdowns();
					}
				});
			}
			/*
			 * Initialize animations on checkbox container
			 * using filter tag as JSON key
			 */


			_initAnimations() {
				this.filterCheckboxes.forEach(el => {
					const tagHandle = el.dataset.handle;
					const checkmark = el.querySelector('.checkmark');
					const checkmarkCheck = el.querySelector('.checkmark__check');
					let state = 'unchecked';

					if (el.closest('[data-filter-input]').hasAttribute('data-filter-active')) {
						state = 'checked';
					}

					const fillAnimation = transition({
						el: checkmark,
						state
					});
					const checkAnimation = transition({
						el: checkmarkCheck,
						state
					});
					this.fillAnimations[tagHandle] = fillAnimation;
					this.checkAnimations[tagHandle] = checkAnimation;
				});
				this.summaryEls.forEach(summary => {
					const filterList = summary.nextElementSibling;
					const currentDetailsEl = summary.closest('[data-filter-group]');
					const index = summary.dataset.filterGroupIndex;
					this.disclosureAnimations[index] = transition({
						el: filterList,
						state: this.closedState
					});
					currentDetailsEl.style.setProperty('--closed-height', `${summary.offsetHeight}px`);
				});
			}

			_buildFilterQuery(element) {
				let searchParameters; // If input is price range, the url_to_add property is not available, so we
				// need to build the query manually

				if (element.dataset.hasOwnProperty('filterRange')) {
					const currentSearch = window.location.search.replace('?', '');
					const formData = new FormData(element.closest('form'));
					const newSearch = new URLSearchParams(formData).toString(); // Filter through current search string to see if price range input already exists,
					// if it does, create new string without current price range parameters

					const splitCurrentSearch = currentSearch.split('&');
					let filteredCurrentSearch = splitCurrentSearch.filter(search => {
						if (search.includes(this.rangeNames[0]) || search.includes(this.rangeNames[1])) {
							return false;
						}

						return true;
					});
					filteredCurrentSearch = filteredCurrentSearch.join('&'); // If current search parameters exist, append new search parameters
					// on to existing parameters

					if (filteredCurrentSearch.length > 0) {
						searchParameters = `${filteredCurrentSearch}&${newSearch}`;
					} else {
						searchParameters = `${newSearch}`;
					}
				}

				let urlQueryString = '';
				urlQueryString = `?${searchParameters}`;
				return urlQueryString;
			}

			_updatePrice(element) {
				// cancel any pending requests
				if (this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				} // Wait for user to finish entering input before reloading page


				this.updateTimeout = setTimeout(() => {
					this._getFilteredResults(element);
				}, 2000);
			}

			_getFilteredResults(element) {
				const filterQuery = this._buildFilterQuery(element);

				window.location.search = filterQuery;
			}

			_animateDisclosure(event) {
				event.preventDefault();
				const summary = event.currentTarget;
				const filterList = summary.nextElementSibling;
				const currentDetailsEl = summary.closest('[data-filter-group]');
				/* Handle dropdowns on click event outside disclosure */

				if (filterList == null) {
					this._closeAllDropdowns();
				} else {
					if (filterList.dataset.animation) return;

					if (filterList.dataset.animationState === this.openState) {
						this._closeDisclosure(currentDetailsEl);
					} else {
						/* Close any open dropdowns before opening new dropdown */
						this._closeAllDropdowns();

						this._openDisclosure(currentDetailsEl);
					}
				}
			}

			_setStyleVariables(el) {
				const main = document.querySelector('[data-main-content]');
				const mobileWidth = main.getBoundingClientRect().width - 30;
				el.style.setProperty('--mobile-width', `${mobileWidth}px`);
				el.style.setProperty('--open-height', `${el.offsetHeight}px`);
			}

			_openDisclosure(detailsEl) {
				const index = detailsEl.querySelector('[data-filter-group-summary]').dataset.filterGroupIndex;
				detailsEl.setAttribute('open', '');
				this.disclosureAnimations[index].animateTo(this.openState, {
					onStart: ({
						el
					}) => {
						this._setStyleVariables(el);
					}
				});
				detailsEl.classList.add('dropdown-expanded');
			}

			_closeDisclosure(detailsEl) {
				const index = detailsEl.querySelector('[data-filter-group-summary]').dataset.filterGroupIndex;
				this.disclosureAnimations[index].animateTo(this.closedState).then(() => {
					detailsEl.removeAttribute('open');
				});
				detailsEl.classList.remove('dropdown-expanded');
			}

			_closeAllDropdowns() {
				this.dropdowns.forEach(dropdown => {
					if (dropdown.classList.contains('dropdown-expanded')) {
						this._closeDisclosure(dropdown);
					}
				});
			}

			unload() {
				if (this.events) {
					this.events.unregisterAll();
				}
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js


		class StaticCollection {
			constructor(section) {
				this.el = section.el;
				this.events = new dist_EventHandler/* default */.Z();
				this.facetedFilters = new FacetedFiltering(section);
				this.sortSelect = this.el.querySelector('[data-collection-sort]');

				if (this.sortSelect) {
					this.events.register(this.sortSelect, 'change', () => this._updateSort());
				}
			}

			_updateSort() {
				let search;
				const Sorting = {};
				Sorting.sort_by = this.sortSelect.value;
				const currentVendorSelected = this.sortSelect.classList.contains('vendor-collection');

				if (currentVendorSelected || this.facetedFilters !== null) {
					const currentSearch = window.location.search;
					const searchParts = currentSearch.split('&');

					for (let index = 0; index < searchParts.length; index++) {
						const part = searchParts[index];

						if (part.indexOf('sort_by') !== -1) {
							searchParts.splice(index, 1);
						}
					}

					search = searchParts.join('&');
					window.location.search = `${search}&${Object.keys(Sorting).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`).join('&')}`;
				} else {
					window.location.search = Object.keys(Sorting).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`).join('&');
				}
			}

			onSectionUnload() {
				this.facetedFilters.unload();
				this.events.unregisterAll();
			}

		}
		;// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-cross-border/dist/index.es.js
		function shopify_cross_border_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function shopify_cross_border_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function shopify_cross_border_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) shopify_cross_border_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) shopify_cross_border_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function index_es_getDefaultExportFromCjs(x) {
			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
		}

		function shopify_cross_border_dist_index_es_createCommonjsModule(fn) {
			var module = { exports: {} };
			return fn(module, module.exports), module.exports;
		}

		var shopify_cross_border_dist_index_es_EventHandler_1 = shopify_cross_border_dist_index_es_createCommonjsModule(function (module, exports) {

			exports.__esModule = true;

			var EventHandler =
				/** @class */
				function () {
					function EventHandler() {
						this.events = [];
					}

					EventHandler.prototype.register = function (el, event, listener) {
						if (!el || !event || !listener) return null;
						this.events.push({
							el: el,
							event: event,
							listener: listener
						});
						el.addEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener
						};
					};

					EventHandler.prototype.unregister = function (_a) {
						var el = _a.el,
							event = _a.event,
							listener = _a.listener;
						if (!el || !event || !listener) return null;
						this.events = this.events.filter(function (e) {
							return el !== e.el || event !== e.event || listener !== e.listener;
						});
						el.removeEventListener(event, listener);
						return {
							el: el,
							event: event,
							listener: listener
						};
					};

					EventHandler.prototype.unregisterAll = function () {
						this.events.forEach(function (_a) {
							var el = _a.el,
								event = _a.event,
								listener = _a.listener;
							return el.removeEventListener(event, listener);
						});
						this.events = [];
					};

					return EventHandler;
				}();

			exports["default"] = EventHandler;
		});

		var index_es_Events = /*@__PURE__*/index_es_getDefaultExportFromCjs(shopify_cross_border_dist_index_es_EventHandler_1);

		var index_es_selectors = {
			disclosureList: '[data-disclosure-list]',
			disclosureToggle: '[data-disclosure-toggle]',
			disclosureInput: '[data-disclosure-input]',
			disclosureOptions: '[data-disclosure-option]'
		};
		var index_es_classes = {
			listVisible: 'disclosure-list--visible',
			alternateDrop: 'disclosure-list--alternate-drop'
		};

		var index_es_Disclosure = /*#__PURE__*/function () {
			function Disclosure(el) {
				shopify_cross_border_dist_index_es_classCallCheck(this, Disclosure);

				this.el = el;
				this.events = new index_es_Events();
				this.cache = {};

				this._cacheSelectors();

				this._connectOptions();

				this._connectToggle();

				this._onFocusOut();
			}

			shopify_cross_border_dist_index_es_createClass(Disclosure, [{
				key: "_cacheSelectors",
				value: function _cacheSelectors() {
					this.cache = {
						disclosureList: this.el.querySelector(index_es_selectors.disclosureList),
						disclosureToggle: this.el.querySelector(index_es_selectors.disclosureToggle),
						disclosureInput: this.el.querySelector(index_es_selectors.disclosureInput),
						disclosureOptions: this.el.querySelectorAll(index_es_selectors.disclosureOptions)
					};
				}
			}, {
				key: "_connectToggle",
				value: function _connectToggle() {
					var _this = this;

					this.events.register(this.cache.disclosureToggle, 'click', function (e) {
						var ariaExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
						e.currentTarget.setAttribute('aria-expanded', !ariaExpanded);

						_this.cache.disclosureList.classList.remove(index_es_classes.alternateDrop);

						_this.cache.disclosureList.classList.toggle(index_es_classes.listVisible);

						window.requestAnimationFrame(function () {
							var _this$cache$disclosur = _this.cache.disclosureList.getBoundingClientRect(),
								left = _this$cache$disclosur.left,
								width = _this$cache$disclosur.width;

							var _window = window,
								innerWidth = _window.innerWidth;
							var gutter = 30;

							if (left + width + gutter > innerWidth) {
								_this.cache.disclosureList.classList.add(index_es_classes.alternateDrop);
							}
						});
					});
				}
			}, {
				key: "_connectOptions",
				value: function _connectOptions() {
					var _this2 = this;

					var options = this.cache.disclosureOptions;

					for (var i = 0; i < options.length; i++) {
						var option = options[i];
						this.events.register(option, 'click', function (e) {
							return _this2._submitForm(e.currentTarget.dataset.value);
						});
					}
				}
			}, {
				key: "_onFocusOut",
				value: function _onFocusOut() {
					var _this3 = this;

					this.events.register(this.cache.disclosureToggle, 'focusout', function (e) {
						var disclosureLostFocus = !_this3.el.contains(e.relatedTarget);

						if (disclosureLostFocus) {
							_this3._hideList();
						}
					});
					this.events.register(this.cache.disclosureList, 'focusout', function (e) {
						var childInFocus = e.currentTarget.contains(e.relatedTarget);

						var isVisible = _this3.cache.disclosureList.classList.contains(index_es_classes.listVisible);

						if (isVisible && !childInFocus) {
							_this3._hideList();
						}
					});
					this.events.register(this.el, 'keyup', function (e) {
						if (e.defaultPrevented) {
							return; // Do nothing if the event was already processed
						}

						if (e.key !== 'Escape' || e.key !== 'Esc') return;

						_this3._hideList();

						_this3.cache.disclosureToggle.focus();
					});
					this.events.register(document.body, 'click', function (e) {
						var isOption = _this3.el.contains(e.target);

						var isVisible = _this3.cache.disclosureList.classList.contains(index_es_classes.listVisible);

						if (isVisible && !isOption) {
							_this3._hideList();
						}
					});
				}
			}, {
				key: "_submitForm",
				value: function _submitForm(value) {
					this.cache.disclosureInput.value = value;
					const currencyChanger = document.querySelector('#currency_code_in_local');

					if (this.cache.disclosureInput.value == "da") {
						currencyChanger.value = "DKK";
					} else if (this.cache.disclosureInput.value == "sv") {
						currencyChanger.value = "SEK";
					} else {
						currencyChanger.value = "EUR";
					}

					this.el.closest('form').submit();
				}
			}, {
				key: "_hideList",
				value: function _hideList() {
					this.cache.disclosureList.classList.remove(index_es_classes.listVisible);
					this.cache.disclosureToggle.setAttribute('aria-expanded', false);
				}
			}, {
				key: "unload",
				value: function unload() {
					this.events.unregisterAll();
				}
			}]);

			return Disclosure;
		}();

		if (!Element.prototype.matches) {
			Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest) {
			Element.prototype.closest = function closest(s) {
				var el = this;

				do {
					if (el.matches(s)) return el;
					el = el.parentElement || el.parentNode;
				} while (el !== null && el.nodeType === 1);

				return null;
			};
		}

/* harmony default export */ const shopify_cross_border_dist_index_es = (index_es_Disclosure);

		;// CONCATENATED MODULE: ./source/scripts/sections/StaticFooter.js

		class StaticFooter {
			constructor({
				el
			}) {
				this.el = el;
				this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
				this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
				this.disclosures = [];

				if (this.currencyDisclosureEl) {
					this.disclosures.push(new shopify_cross_border_dist_index_es(this.currencyDisclosureEl));
				}

				if (this.localeDisclosureEl) {
					this.disclosures.push(new shopify_cross_border_dist_index_es(this.localeDisclosureEl));
				}
			}

			onSectionUnload() {
				this.disclosures.forEach(disclosure => disclosure.unload());
			}

		}
		;// CONCATENATED MODULE: ./node_modules/shopify-asyncview/dist/index.es.js

		/*!
		 * shopify-asyncview v2.0.3
		 * (c) 2019 Pixel Union
		*/

		function shopify_asyncview_dist_index_es_classCallCheck(instance, Constructor) {
			if (!(instance instanceof Constructor)) {
				throw new TypeError("Cannot call a class as a function");
			}
		}

		function shopify_asyncview_dist_index_es_defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		function shopify_asyncview_dist_index_es_createClass(Constructor, protoProps, staticProps) {
			if (protoProps) shopify_asyncview_dist_index_es_defineProperties(Constructor.prototype, protoProps);
			if (staticProps) shopify_asyncview_dist_index_es_defineProperties(Constructor, staticProps);
			return Constructor;
		}

		function index_es_defineProperty(obj, key, value) {
			if (key in obj) {
				Object.defineProperty(obj, key, {
					value: value,
					enumerable: true,
					configurable: true,
					writable: true
				});
			} else {
				obj[key] = value;
			}

			return obj;
		}

		function index_es_ownKeys(object, enumerableOnly) {
			var keys = Object.keys(object);

			if (Object.getOwnPropertySymbols) {
				var symbols = Object.getOwnPropertySymbols(object);
				if (enumerableOnly) symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
				keys.push.apply(keys, symbols);
			}

			return keys;
		}

		function index_es_objectSpread2(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i] != null ? arguments[i] : {};

				if (i % 2) {
					index_es_ownKeys(source, true).forEach(function (key) {
						index_es_defineProperty(target, key, source[key]);
					});
				} else if (Object.getOwnPropertyDescriptors) {
					Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
				} else {
					index_es_ownKeys(source).forEach(function (key) {
						Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
					});
				}
			}

			return target;
		}

		function _slicedToArray(arr, i) {
			return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
		}

		function _arrayWithHoles(arr) {
			if (Array.isArray(arr)) return arr;
		}

		function _iterableToArrayLimit(arr, i) {
			var _arr = [];
			var _n = true;
			var _d = false;
			var _e = undefined;

			try {
				for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
					_arr.push(_s.value);

					if (i && _arr.length === i) break;
				}
			} catch (err) {
				_d = true;
				_e = err;
			} finally {
				try {
					if (!_n && _i["return"] != null) _i["return"]();
				} finally {
					if (_d) throw _e;
				}
			}

			return _arr;
		}

		function _nonIterableRest() {
			throw new TypeError("Invalid attempt to destructure non-iterable instance");
		}

		var deferred = {};

		var AsyncView =
			/*#__PURE__*/
			function () {
				function AsyncView() {
					shopify_asyncview_dist_index_es_classCallCheck(this, AsyncView);
				}

				shopify_asyncview_dist_index_es_createClass(AsyncView, null, [{
					key: "load",

					/**
					 * Load the template given by the provided URL into the provided
					 * view
					 *
					 * @param {string} url - The url to load
					 * @param {object} query - An object containing additional query parameters of the URL
					 * @param {string} query.view - A required query parameter indicating which view to load
					 * @param {object} [options] - Config options
					 * @param {string} [options.hash] - A hash of the current page content
					 */
					value: function load(url) {
						var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
						var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

						if (!('view' in query)) {
							return Promise.reject(new Error('\'view\' not found in \'query\' parameter'));
						}

						var querylessUrl = url.replace(/\?[^#]+/, '');
						var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
						var queryParams = query;

						if (queryParamsString && queryParamsString.length >= 2) {
							queryParamsString[1].split('&').forEach(function (param) {
								var _param$split = param.split('='),
									_param$split2 = _slicedToArray(_param$split, 2),
									key = _param$split2[0],
									value = _param$split2[1];

								queryParams[key] = value;
							});
						} // NOTE: We're adding an additional timestamp to the query.
						// This is to prevent certain browsers from returning cached
						// versions of the url we are requesting.
						// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


						var cachebustingParams = index_es_objectSpread2({}, queryParams, {
							_: new Date().getTime()
						});

						var hashUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
							return "".concat(address, "?").concat(Object.keys(queryParams).sort().map(function (key) {
								return "".concat(key, "=").concat(encodeURIComponent(queryParams[key]));
							}).join('&')).concat(hash);
						});
						var requestUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
							return "".concat(address, "?").concat(Object.keys(cachebustingParams).sort().map(function (key) {
								return "".concat(key, "=").concat(encodeURIComponent(cachebustingParams[key]));
							}).join('&')).concat(hash);
						});
						var promise = new Promise(function (resolve, reject) {
							var data;

							if (hashUrl in deferred) {
								resolve(deferred[hashUrl]);
								return;
							}

							deferred[hashUrl] = promise;

							if (options.hash) {
								data = sessionStorage.getItem(hashUrl);

								if (data) {
									var deserialized = JSON.parse(data);

									if (options.hash === deserialized.options.hash) {
										delete deferred[hashUrl];
										resolve(deserialized);
										return;
									}
								}
							}

							var xhr = new XMLHttpRequest();
							xhr.open('GET', requestUrl, true);

							xhr.onload = function () {
								var el = xhr.response;
								var newOptions = {};
								var optionsEl = el.querySelector('[data-options]');

								if (optionsEl && optionsEl.innerHTML) {
									newOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
								}

								var htmlEls = el.querySelectorAll('[data-html]');
								var newHtml = {};

								if (htmlEls.length === 1 && htmlEls[0].getAttribute('data-html') === '') {
									newHtml = htmlEls[0].innerHTML;
								} else {
									for (var i = 0; i < htmlEls.length; i++) {
										newHtml[htmlEls[i].getAttribute('data-html')] = htmlEls[i].innerHTML;
									}
								}

								var dataEls = el.querySelectorAll('[data-data]');
								var newData = {};

								if (dataEls.length === 1 && dataEls[0].getAttribute('data-data') === '') {
									newData = JSON.parse(dataEls[0].innerHTML);
								} else {
									for (var _i = 0; _i < dataEls.length; _i++) {
										newData[dataEls[_i].getAttribute('data-data')] = JSON.parse(dataEls[_i].innerHTML);
									}
								}

								if (options.hash) {
									try {
										sessionStorage.setItem(hashUrl, JSON.stringify({
											options: newOptions,
											data: newData,
											html: newHtml
										}));
									} catch (error) {
										console.error(error);
									}
								}

								delete deferred[hashUrl];
								resolve({
									data: newData,
									html: newHtml
								});
							};

							xhr.onerror = function () {
								delete deferred[hashUrl];
								reject();
							};

							xhr.responseType = 'document';
							xhr.send();
						});
						return promise;
					}
				}]);

				return AsyncView;
			}();

/* harmony default export */ const shopify_asyncview_dist_index_es = (AsyncView);

		;// CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
		function morphAttrs(fromNode, toNode) {
			var attrs = toNode.attributes;
			var i;
			var attr;
			var attrName;
			var attrNamespaceURI;
			var attrValue;
			var fromValue;

			// update attributes on original DOM element
			for (i = attrs.length - 1; i >= 0; --i) {
				attr = attrs[i];
				attrName = attr.name;
				attrNamespaceURI = attr.namespaceURI;
				attrValue = attr.value;

				if (attrNamespaceURI) {
					attrName = attr.localName || attrName;
					fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);

					if (fromValue !== attrValue) {
						fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
					}
				} else {
					fromValue = fromNode.getAttribute(attrName);

					if (fromValue !== attrValue) {
						fromNode.setAttribute(attrName, attrValue);
					}
				}
			}

			// Remove any extra attributes found on the original DOM element that
			// weren't found on the target element.
			attrs = fromNode.attributes;

			for (i = attrs.length - 1; i >= 0; --i) {
				attr = attrs[i];
				if (attr.specified !== false) {
					attrName = attr.name;
					attrNamespaceURI = attr.namespaceURI;

					if (attrNamespaceURI) {
						attrName = attr.localName || attrName;

						if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
							fromNode.removeAttributeNS(attrNamespaceURI, attrName);
						}
					} else {
						if (!toNode.hasAttribute(attrName)) {
							fromNode.removeAttribute(attrName);
						}
					}
				}
			}
		}

		var range; // Create a range object for efficently rendering strings to elements.
		var NS_XHTML = 'http://www.w3.org/1999/xhtml';

		var doc = typeof document === 'undefined' ? undefined : document;

		/**
		 * This is about the same
		 * var html = new DOMParser().parseFromString(str, 'text/html');
		 * return html.body.firstChild;
		 *
		 * @method toElement
		 * @param {String} str
		 */
		function toElement(str) {
			if (!range && doc.createRange) {
				range = doc.createRange();
				range.selectNode(doc.body);
			}

			var fragment;
			if (range && range.createContextualFragment) {
				fragment = range.createContextualFragment(str);
			} else {
				fragment = doc.createElement('body');
				fragment.innerHTML = str;
			}
			return fragment.childNodes[0];
		}

		/**
		 * Returns true if two node's names are the same.
		 *
		 * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
		 *       nodeName and different namespace URIs.
		 *
		 * @param {Element} a
		 * @param {Element} b The target element
		 * @return {boolean}
		 */
		function compareNodeNames(fromEl, toEl) {
			var fromNodeName = fromEl.nodeName;
			var toNodeName = toEl.nodeName;

			if (fromNodeName === toNodeName) {
				return true;
			}

			if (toEl.actualize &&
				fromNodeName.charCodeAt(0) < 91 && /* from tag name is upper case */
				toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */) {
				// If the target element is a virtual DOM node then we may need to normalize the tag name
				// before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
				// are converted to upper case
				return fromNodeName === toNodeName.toUpperCase();
			} else {
				return false;
			}
		}

		/**
		 * Create an element, optionally with a known namespace URI.
		 *
		 * @param {string} name the element name, e.g. 'div' or 'svg'
		 * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
		 * its `xmlns` attribute or its inferred namespace.
		 *
		 * @return {Element}
		 */
		function createElementNS(name, namespaceURI) {
			return !namespaceURI || namespaceURI === NS_XHTML ?
				doc.createElement(name) :
				doc.createElementNS(namespaceURI, name);
		}

		/**
		 * Copies the children of one DOM element to another DOM element
		 */
		function moveChildren(fromEl, toEl) {
			var curChild = fromEl.firstChild;
			while (curChild) {
				var nextChild = curChild.nextSibling;
				toEl.appendChild(curChild);
				curChild = nextChild;
			}
			return toEl;
		}

		function syncBooleanAttrProp(fromEl, toEl, name) {
			if (fromEl[name] !== toEl[name]) {
				fromEl[name] = toEl[name];
				if (fromEl[name]) {
					fromEl.setAttribute(name, '');
				} else {
					fromEl.removeAttribute(name);
				}
			}
		}

		var specialElHandlers = {
			OPTION: function (fromEl, toEl) {
				var parentNode = fromEl.parentNode;
				if (parentNode) {
					var parentName = parentNode.nodeName.toUpperCase();
					if (parentName === 'OPTGROUP') {
						parentNode = parentNode.parentNode;
						parentName = parentNode && parentNode.nodeName.toUpperCase();
					}
					if (parentName === 'SELECT' && !parentNode.hasAttribute('multiple')) {
						if (fromEl.hasAttribute('selected') && !toEl.selected) {
							// Workaround for MS Edge bug where the 'selected' attribute can only be
							// removed if set to a non-empty value:
							// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
							fromEl.setAttribute('selected', 'selected');
							fromEl.removeAttribute('selected');
						}
						// We have to reset select element's selectedIndex to -1, otherwise setting
						// fromEl.selected using the syncBooleanAttrProp below has no effect.
						// The correct selectedIndex will be set in the SELECT special handler below.
						parentNode.selectedIndex = -1;
					}
				}
				syncBooleanAttrProp(fromEl, toEl, 'selected');
			},
			/**
			 * The "value" attribute is special for the <input> element since it sets
			 * the initial value. Changing the "value" attribute without changing the
			 * "value" property will have no effect since it is only used to the set the
			 * initial value.  Similar for the "checked" attribute, and "disabled".
			 */
			INPUT: function (fromEl, toEl) {
				syncBooleanAttrProp(fromEl, toEl, 'checked');
				syncBooleanAttrProp(fromEl, toEl, 'disabled');

				if (fromEl.value !== toEl.value) {
					fromEl.value = toEl.value;
				}

				if (!toEl.hasAttribute('value')) {
					fromEl.removeAttribute('value');
				}
			},

			TEXTAREA: function (fromEl, toEl) {
				var newValue = toEl.value;
				if (fromEl.value !== newValue) {
					fromEl.value = newValue;
				}

				var firstChild = fromEl.firstChild;
				if (firstChild) {
					// Needed for IE. Apparently IE sets the placeholder as the
					// node value and vise versa. This ignores an empty update.
					var oldValue = firstChild.nodeValue;

					if (oldValue == newValue || (!newValue && oldValue == fromEl.placeholder)) {
						return;
					}

					firstChild.nodeValue = newValue;
				}
			},
			SELECT: function (fromEl, toEl) {
				if (!toEl.hasAttribute('multiple')) {
					var selectedIndex = -1;
					var i = 0;
					// We have to loop through children of fromEl, not toEl since nodes can be moved
					// from toEl to fromEl directly when morphing.
					// At the time this special handler is invoked, all children have already been morphed
					// and appended to / removed from fromEl, so using fromEl here is safe and correct.
					var curChild = fromEl.firstChild;
					var optgroup;
					var nodeName;
					while (curChild) {
						nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
						if (nodeName === 'OPTGROUP') {
							optgroup = curChild;
							curChild = optgroup.firstChild;
						} else {
							if (nodeName === 'OPTION') {
								if (curChild.hasAttribute('selected')) {
									selectedIndex = i;
									break;
								}
								i++;
							}
							curChild = curChild.nextSibling;
							if (!curChild && optgroup) {
								curChild = optgroup.nextSibling;
								optgroup = null;
							}
						}
					}

					fromEl.selectedIndex = selectedIndex;
				}
			}
		};

		var ELEMENT_NODE = 1;
		var DOCUMENT_FRAGMENT_NODE = 11;
		var TEXT_NODE = 3;
		var COMMENT_NODE = 8;

		function noop() { }

		function defaultGetNodeKey(node) {
			return node.id;
		}

		function morphdomFactory(morphAttrs) {

			return function morphdom(fromNode, toNode, options) {
				if (!options) {
					options = {};
				}

				if (typeof toNode === 'string') {
					if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML') {
						var toNodeHtml = toNode;
						toNode = doc.createElement('html');
						toNode.innerHTML = toNodeHtml;
					} else {
						toNode = toElement(toNode);
					}
				}

				var getNodeKey = options.getNodeKey || defaultGetNodeKey;
				var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
				var onNodeAdded = options.onNodeAdded || noop;
				var onBeforeElUpdated = options.onBeforeElUpdated || noop;
				var onElUpdated = options.onElUpdated || noop;
				var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
				var onNodeDiscarded = options.onNodeDiscarded || noop;
				var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
				var childrenOnly = options.childrenOnly === true;

				// This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
				var fromNodesLookup = {};
				var keyedRemovalList;

				function addKeyedRemoval(key) {
					if (keyedRemovalList) {
						keyedRemovalList.push(key);
					} else {
						keyedRemovalList = [key];
					}
				}

				function walkDiscardedChildNodes(node, skipKeyedNodes) {
					if (node.nodeType === ELEMENT_NODE) {
						var curChild = node.firstChild;
						while (curChild) {

							var key = undefined;

							if (skipKeyedNodes && (key = getNodeKey(curChild))) {
								// If we are skipping keyed nodes then we add the key
								// to a list so that it can be handled at the very end.
								addKeyedRemoval(key);
							} else {
								// Only report the node as discarded if it is not keyed. We do this because
								// at the end we loop through all keyed elements that were unmatched
								// and then discard them in one final pass.
								onNodeDiscarded(curChild);
								if (curChild.firstChild) {
									walkDiscardedChildNodes(curChild, skipKeyedNodes);
								}
							}

							curChild = curChild.nextSibling;
						}
					}
				}

				/**
				 * Removes a DOM node out of the original DOM
				 *
				 * @param  {Node} node The node to remove
				 * @param  {Node} parentNode The nodes parent
				 * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
				 * @return {undefined}
				 */
				function removeNode(node, parentNode, skipKeyedNodes) {
					if (onBeforeNodeDiscarded(node) === false) {
						return;
					}

					if (parentNode) {
						parentNode.removeChild(node);
					}

					onNodeDiscarded(node);
					walkDiscardedChildNodes(node, skipKeyedNodes);
				}

				// // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
				// function indexTree(root) {
				//     var treeWalker = document.createTreeWalker(
				//         root,
				//         NodeFilter.SHOW_ELEMENT);
				//
				//     var el;
				//     while((el = treeWalker.nextNode())) {
				//         var key = getNodeKey(el);
				//         if (key) {
				//             fromNodesLookup[key] = el;
				//         }
				//     }
				// }

				// // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
				//
				// function indexTree(node) {
				//     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
				//     var el;
				//     while((el = nodeIterator.nextNode())) {
				//         var key = getNodeKey(el);
				//         if (key) {
				//             fromNodesLookup[key] = el;
				//         }
				//     }
				// }

				function indexTree(node) {
					if (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE) {
						var curChild = node.firstChild;
						while (curChild) {
							var key = getNodeKey(curChild);
							if (key) {
								fromNodesLookup[key] = curChild;
							}

							// Walk recursively
							indexTree(curChild);

							curChild = curChild.nextSibling;
						}
					}
				}

				indexTree(fromNode);

				function handleNodeAdded(el) {
					onNodeAdded(el);

					var curChild = el.firstChild;
					while (curChild) {
						var nextSibling = curChild.nextSibling;

						var key = getNodeKey(curChild);
						if (key) {
							var unmatchedFromEl = fromNodesLookup[key];
							if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
								curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
								morphEl(unmatchedFromEl, curChild);
							}
						}

						handleNodeAdded(curChild);
						curChild = nextSibling;
					}
				}

				function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
					// We have processed all of the "to nodes". If curFromNodeChild is
					// non-null then we still have some from nodes left over that need
					// to be removed
					while (curFromNodeChild) {
						var fromNextSibling = curFromNodeChild.nextSibling;
						if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
							// Since the node is keyed it might be matched up later so we defer
							// the actual removal to later
							addKeyedRemoval(curFromNodeKey);
						} else {
							// NOTE: we skip nested keyed nodes from being removed since there is
							//       still a chance they will be matched up later
							removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
						}
						curFromNodeChild = fromNextSibling;
					}
				}

				function morphEl(fromEl, toEl, childrenOnly) {
					var toElKey = getNodeKey(toEl);

					if (toElKey) {
						// If an element with an ID is being morphed then it will be in the final
						// DOM so clear it out of the saved elements collection
						delete fromNodesLookup[toElKey];
					}

					if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
						return;
					}

					if (!childrenOnly) {
						// optional
						if (onBeforeElUpdated(fromEl, toEl) === false) {
							return;
						}

						// update attributes on original DOM element first
						morphAttrs(fromEl, toEl);
						// optional
						onElUpdated(fromEl);

						if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
							return;
						}
					}
					if (fromEl.nodeName !== 'TEXTAREA') {
						morphChildren(fromEl, toEl);
					} else {
						specialElHandlers.TEXTAREA(fromEl, toEl);
					}
				}

				function morphChildren(fromEl, toEl) {
					var curToNodeChild = toEl.firstChild;
					var curFromNodeChild = fromEl.firstChild;
					var curToNodeKey;
					var curFromNodeKey;

					var fromNextSibling;
					var toNextSibling;
					var matchingFromEl;

					// walk the children
					outer: while (curToNodeChild) {
						toNextSibling = curToNodeChild.nextSibling;
						curToNodeKey = getNodeKey(curToNodeChild);

						// walk the fromNode children all the way through
						while (curFromNodeChild) {
							fromNextSibling = curFromNodeChild.nextSibling;

							if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
								curToNodeChild = toNextSibling;
								curFromNodeChild = fromNextSibling;
								continue outer;
							}

							curFromNodeKey = getNodeKey(curFromNodeChild);

							var curFromNodeType = curFromNodeChild.nodeType;

							// this means if the curFromNodeChild doesnt have a match with the curToNodeChild
							var isCompatible = undefined;

							if (curFromNodeType === curToNodeChild.nodeType) {
								if (curFromNodeType === ELEMENT_NODE) {
									// Both nodes being compared are Element nodes

									if (curToNodeKey) {
										// The target node has a key so we want to match it up with the correct element
										// in the original DOM tree
										if (curToNodeKey !== curFromNodeKey) {
											// The current element in the original DOM tree does not have a matching key so
											// let's check our lookup to see if there is a matching element in the original
											// DOM tree
											if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
												if (fromNextSibling === matchingFromEl) {
													// Special case for single element removals. To avoid removing the original
													// DOM node out of the tree (since that can break CSS transitions, etc.),
													// we will instead discard the current node and wait until the next
													// iteration to properly match up the keyed target element with its matching
													// element in the original tree
													isCompatible = false;
												} else {
													// We found a matching keyed element somewhere in the original DOM tree.
													// Let's move the original DOM node into the current position and morph
													// it.

													// NOTE: We use insertBefore instead of replaceChild because we want to go through
													// the `removeNode()` function for the node that is being discarded so that
													// all lifecycle hooks are correctly invoked
													fromEl.insertBefore(matchingFromEl, curFromNodeChild);

													// fromNextSibling = curFromNodeChild.nextSibling;

													if (curFromNodeKey) {
														// Since the node is keyed it might be matched up later so we defer
														// the actual removal to later
														addKeyedRemoval(curFromNodeKey);
													} else {
														// NOTE: we skip nested keyed nodes from being removed since there is
														//       still a chance they will be matched up later
														removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
													}

													curFromNodeChild = matchingFromEl;
												}
											} else {
												// The nodes are not compatible since the "to" node has a key and there
												// is no matching keyed node in the source tree
												isCompatible = false;
											}
										}
									} else if (curFromNodeKey) {
										// The original has a key
										isCompatible = false;
									}

									isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
									if (isCompatible) {
										// We found compatible DOM elements so transform
										// the current "from" node to match the current
										// target DOM node.
										// MORPH
										morphEl(curFromNodeChild, curToNodeChild);
									}

								} else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
									// Both nodes being compared are Text or Comment nodes
									isCompatible = true;
									// Simply update nodeValue on the original node to
									// change the text value
									if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
										curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
									}

								}
							}

							if (isCompatible) {
								// Advance both the "to" child and the "from" child since we found a match
								// Nothing else to do as we already recursively called morphChildren above
								curToNodeChild = toNextSibling;
								curFromNodeChild = fromNextSibling;
								continue outer;
							}

							// No compatible match so remove the old node from the DOM and continue trying to find a
							// match in the original DOM. However, we only do this if the from node is not keyed
							// since it is possible that a keyed node might match up with a node somewhere else in the
							// target tree and we don't want to discard it just yet since it still might find a
							// home in the final DOM tree. After everything is done we will remove any keyed nodes
							// that didn't find a home
							if (curFromNodeKey) {
								// Since the node is keyed it might be matched up later so we defer
								// the actual removal to later
								addKeyedRemoval(curFromNodeKey);
							} else {
								// NOTE: we skip nested keyed nodes from being removed since there is
								//       still a chance they will be matched up later
								removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
							}

							curFromNodeChild = fromNextSibling;
						} // END: while(curFromNodeChild) {}

						// If we got this far then we did not find a candidate match for
						// our "to node" and we exhausted all of the children "from"
						// nodes. Therefore, we will just append the current "to" node
						// to the end
						if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
							fromEl.appendChild(matchingFromEl);
							// MORPH
							morphEl(matchingFromEl, curToNodeChild);
						} else {
							var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
							if (onBeforeNodeAddedResult !== false) {
								if (onBeforeNodeAddedResult) {
									curToNodeChild = onBeforeNodeAddedResult;
								}

								if (curToNodeChild.actualize) {
									curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
								}
								fromEl.appendChild(curToNodeChild);
								handleNodeAdded(curToNodeChild);
							}
						}

						curToNodeChild = toNextSibling;
						curFromNodeChild = fromNextSibling;
					}

					cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);

					var specialElHandler = specialElHandlers[fromEl.nodeName];
					if (specialElHandler) {
						specialElHandler(fromEl, toEl);
					}
				} // END: morphChildren(...)

				var morphedNode = fromNode;
				var morphedNodeType = morphedNode.nodeType;
				var toNodeType = toNode.nodeType;

				if (!childrenOnly) {
					// Handle the case where we are given two DOM nodes that are not
					// compatible (e.g. <div> --> <span> or <div> --> TEXT)
					if (morphedNodeType === ELEMENT_NODE) {
						if (toNodeType === ELEMENT_NODE) {
							if (!compareNodeNames(fromNode, toNode)) {
								onNodeDiscarded(fromNode);
								morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
							}
						} else {
							// Going from an element node to a text node
							morphedNode = toNode;
						}
					} else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
						if (toNodeType === morphedNodeType) {
							if (morphedNode.nodeValue !== toNode.nodeValue) {
								morphedNode.nodeValue = toNode.nodeValue;
							}

							return morphedNode;
						} else {
							// Text node to something else
							morphedNode = toNode;
						}
					}
				}

				if (morphedNode === toNode) {
					// The "to node" was not compatible with the "from node" so we had to
					// toss out the "from node" and use the "to node"
					onNodeDiscarded(fromNode);
				} else {
					morphEl(morphedNode, toNode, childrenOnly);

					// We now need to loop over any keyed nodes that might need to be
					// removed. We only do the removal if we know that the keyed node
					// never found a match. When a keyed node is matched up we remove
					// it out of fromNodesLookup and we use fromNodesLookup to determine
					// if a keyed node has been matched up or not
					if (keyedRemovalList) {
						for (var i = 0, len = keyedRemovalList.length; i < len; i++) {
							var elToRemove = fromNodesLookup[keyedRemovalList[i]];
							if (elToRemove) {
								removeNode(elToRemove, elToRemove.parentNode, false);
							}
						}
					}
				}

				if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
					if (morphedNode.actualize) {
						morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
					}
					// If we had to swap out the from node with a new node because the old
					// node was not compatible with the target node then we need to
					// replace the old DOM node in the original DOM tree. This is only
					// possible if the original DOM node was part of a DOM tree which
					// we know is the case if it has a parent node.
					fromNode.parentNode.replaceChild(morphedNode, fromNode);
				}

				return morphedNode;
			};
		}

		var morphdom = morphdomFactory(morphAttrs);

/* harmony default export */ const morphdom_esm = (morphdom);

		;// CONCATENATED MODULE: ./source/scripts/utils/CartRequests.js


		class CartRequests {
			constructor() {
				this.processRequestInterval = 500;
				this.processing = false;
				this.interval = setInterval(() => this._postRequests(), this.processRequestInterval);
				this.requests = [];
			}

			addItem(data) {
				const request = this._findAddItemRequest(data);

				const sanitizedData = data;
				this.requests = this.requests.filter(r => r !== request);
				sanitizedData.quantity = Math.max(0, sanitizedData.quantity);
				this.requests.push({
					type: 'add',
					data,
					timestamp: Math.floor(Date.now())
				}); // Immediately process adding an item

				this._postRequests(true);
			}

			changeItem(data) {
				const request = this._findChangeItemRequest(data);

				const sanitizedData = data;
				this.requests = this.requests.filter(r => r !== request);
				sanitizedData.quantity = Math.max(0, sanitizedData.quantity);
				this.requests.push({
					type: 'change',
					data,
					timestamp: Math.floor(Date.now())
				}); // Immediately process removing an item

				if (sanitizedData.quantity === 0) {
					this._postRequests(true);
				}
			}

			updateNote(note) {
				this.requests = this.requests.filter(r => r.type !== 'update');
				this.requests.push({
					type: 'update',
					data: {
						note
					},
					timestamp: Math.floor(Date.now())
				});
			}

			unload() {
				if (this.interval) {
					clearInterval(this.interval);
				}
			}

			_triggerStartLoadingEvents() {
				jquery_default()(window).trigger('cart-loading-start');
			}

			_triggerFinishLoadingEvent(newCart, oldCart, error) {
				const newItems = newCart.items.filter(newItem => {
					for (let i = 0; i < oldCart.items.length; i++) {
						const oldItem = oldCart.items[i];

						if (newItem.key === oldItem.key && newItem.quantity !== oldItem.quantity) {
							return true;
						}

						if (newItem.key === oldItem.key) {
							return false;
						}
					}

					return true;
				});
				jquery_default()(window).trigger('cart-loading-finish', {
					cart: newCart,
					newItems,
					error
				});
			}

			_handleError(error) {
				jquery_default()(window).trigger('cart-loading-error', {
					error
				});
			}

			_shouldPostRequests() {
				return !this.processing && this.requests.length && Math.floor(Date.now()) - this.requests[this.requests.length - 1].timestamp >= this.processRequestInterval;
			}

			_postRequests(force = false) {
				if (!force && !this._shouldPostRequests()) {
					return;
				}

				const requestsToProcess = this.requests;
				let originalCart = null;
				this.requests = [];
				this.processing = true;

				this._triggerStartLoadingEvents();

				let $deferred = jquery_default().Deferred().resolve();
				$deferred = $deferred.then(() => jquery_default().get({
					url: `${window.Theme.routes.cart_url}.js`,
					dataType: 'json'
				})).then(cart => {
					originalCart = cart;
				});
				requestsToProcess.forEach(request => {
					let deferredRequest = null;

					if (request.type === 'add') {
						deferredRequest = () => jquery_default().post({
							url: `${window.Theme.routes.cart_add_url}.js`,
							data: request.data,
							dataType: 'json'
						});
					}

					if (request.type === 'change') {
						deferredRequest = () => jquery_default().post({
							url: `${window.Theme.routes.cart_change_url}.js`,
							data: request.data,
							dataType: 'json'
						});
					}

					if (request.type === 'update') {
						deferredRequest = () => jquery_default().post({
							url: `${window.Theme.routes.cart_url}/update.js`,
							data: request.data,
							dataType: 'json'
						});
					}

					$deferred = $deferred.then(deferredRequest);
				});
				$deferred = $deferred.then(() => jquery_default().get({
					url: `${window.Theme.routes.cart_url}.js`,
					dataType: 'json'
				})).then(newCart => this._triggerFinishLoadingEvent(newCart, originalCart)).catch(error => {
					this._handleError(error.responseJSON.description);

					jquery_default().get({
						url: `${window.Theme.routes.cart_url}.js`,
						dataType: 'json'
					}).then(newCart => this._triggerFinishLoadingEvent(newCart, originalCart, error));
				}).always(() => {
					this.processing = false;
				});
			}

			_findAddItemRequest(data) {
				let request = null;
				this.requests.forEach(r => {
					if (r.type === 'add') {
						if (r.data.id === data.id) {
							request = r;
						}
					}
				});
				return request;
			}

			_findChangeItemRequest(data) {
				let request = null;
				this.requests.forEach(r => {
					if (r.type === 'change') {
						if (r.data.id === data.id) {
							request = r;
						}
					}
				});
				return request;
			}

		}

/* harmony default export */ const utils_CartRequests = (new CartRequests());
		;// CONCATENATED MODULE: ./source/scripts/components/LineItem.js


		class LineItem {
			constructor(el) {
				this.el = el;
				this.key = el.dataset.lineItem;
				this.removeButtonEl = el.querySelector('[data-line-item-remove]');
				this.quantityInputEl = el.querySelector('[data-line-item-quantity-input]');
				this.quantityDecrementEl = el.querySelector('[data-line-item-quantity-decrement]');
				this.quantityIncrementEl = el.querySelector('[data-line-item-quantity-increment]');

				this.remove = e => {
					e.preventDefault();

					this._changeQuantity(0);
				};

				this.decrementQuantity = e => {
					e.preventDefault();

					this._changeQuantity(parseInt(this.quantityInputEl.value, 10) - 1);
				};

				this.incrementQuantity = e => {
					e.preventDefault();

					this._changeQuantity(parseInt(this.quantityInputEl.value, 10) + 1);
				};

				this.onQuantityChange = this._onQuantityChange.bind(this);
				this.removeButtonEl.addEventListener('click', this.remove);
				this.quantityDecrementEl.addEventListener('click', this.decrementQuantity);
				this.quantityIncrementEl.addEventListener('click', this.incrementQuantity);
				this.quantityInputEl.addEventListener('change', this.onQuantityChange);
			}

			_onQuantityChange() {
				const quantity = Math.max(0, this.quantityInputEl.value);
				utils_CartRequests.changeItem({
					id: this.key,
					quantity
				});
			}

			_changeQuantity(quantity) {
				const event = document.createEvent('Event');
				event.initEvent('change', false, true);
				this.quantityInputEl.value = quantity;
				this.quantityInputEl.dispatchEvent(event);
			}

			unload() {
				this.removeButtonEl.removeEventListener('click', this.remove);
				this.quantityDecrementEl.removeEventListener('click', this.decrementQuantity);
				this.quantityIncrementEl.removeEventListener('click', this.incrementQuantity);
				this.quantityInputEl.removeEventListener('change', this.onQuantityChange);
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/components/ShippingCalculator.js

		class ShippingCalculator {
			constructor(el) {
				this.el = el;

				try {
					this.data = JSON.parse(jquery_default()('[data-shipping-calculator-data]', el).text());
				} catch (e) {
					console.log('No shipping localisations found, unable to continue.');
				}

				if (!this.data) {
					return;
				}

				this.shippingCalculator();

				if (this.data.settings.customer_country) {
					this.calculateShipping();
				}

				jquery_default()('[data-calculate-shipping-button]', this.el).on('click', () => this.calculateShipping());

				Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
			}

			shippingCalculator() {
				Shopify.Cart.ShippingCalculator.show({
					submitButton: this.data.language.submit_button,
					submitButtonDisabled: this.data.language.submit_button_processing,
					customerIsLoggedIn: this.data.settings.customer_country,
					moneyFormat: Theme.moneyFormat
				});
				const selectableOptions = jquery_default()('.cart-shipping-calculator select', this.el);
				setTimeout(() => {
					for (let i = 0; i < selectableOptions.length; i++) {
						this.updateShippingLabel(selectableOptions[i]);
					}
				}, 500);
				jquery_default()('.cart-shipping-calculator select', this.el).change(() => {
					for (let i = 0; i < selectableOptions.length; i++) {
						this.updateShippingLabel(selectableOptions[i]);
					}
				});
			}

			calculateShipping() {
				jquery_default()('[data-calculate-shipping-button]').val(this.data.language.submit_button_processing);
				const shippingAddress = {};
				shippingAddress.zip = jquery_default()('.address-zip').val() || '';
				shippingAddress.country = jquery_default()('.address-country').val() || '';
				shippingAddress.province = jquery_default()('.address-province').val() || '';
				const queryString = Object.keys(shippingAddress).map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`).join('&');
				jquery_default().ajax(`${window.Theme.routes.cart_url}/shipping_rates.json?${queryString}`, {
					dataType: 'json'
				}).fail(error => this.handleErrors(error.responseJSON || {})).done(response => {
					const rates = response.shipping_rates;
					let responseText;
					let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;

					if (!shippingAddress.province.length) {
						address = `${shippingAddress.zip}, ${shippingAddress.country}`;
					}

					if (!shippingAddress.zip.length) {
						address = `${shippingAddress.province}, ${shippingAddress.country}`;
					}

					if (!shippingAddress.province.length || !shippingAddress.zip.length) {
						address = shippingAddress.country;
					}

					const shippingCalculatorResponse = jquery_default()('.cart-shipping-calculator-response');
					shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
					const ratesFeedback = jquery_default()('.shipping-calculator-response');

					if (rates.length > 1) {
						const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
						responseText = this.data.language.multi_rates.replace('** address **', address).replace('** number_of_rates **', rates.length).replace('** rate **', `<span class='money'>${firstRate}</span>`);
						ratesFeedback.html(responseText);
					} else if (rates.length === 1) {
						responseText = this.data.language.one_rate.replace('** address **', address);
						ratesFeedback.html(responseText);
					} else {
						ratesFeedback.html(this.data.language.no_rates);
					}

					for (let i = 0; i < rates.length; i++) {
						const rate = rates[i];
						const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
						const rateValues = this.data.language.rate_values.replace('** rate_title **', rate.name).replace('** rate **', `<span class='money'>${price}</span>`);
						jquery_default()('.shipping-rates', this.el).append(`<li>${rateValues}</li>`);
					}

					jquery_default()('[data-calculate-shipping-button]').val(this.data.language.submit_button);
				});
			}

			updateShippingLabel(select) {
				if (select) {
					const $select = jquery_default()(select);
					let selectedOption = $select.find('option:selected').val();

					if (!selectedOption) {
						selectedOption = $select.prev('.selected-text').data('default');
					}

					$select.prev('.selected-text').text(selectedOption);
					setTimeout(() => {
						if ($select.attr('name') === 'address[country]') {
							this.updateShippingLabel(jquery_default()('#address_province', this.el));
						}
					}, 500);
				}
			}

			handleErrors(errorMessage) {
				if (errorMessage.zip) {
					errorMessage = this.data.language.error_message.replace('** error_message **', errorMessage.zip);
				} else if (errorMessage.error) {
					errorMessage = this.data.language.generic_error_message.replace('** error_message **', errorMessage.error.map(error => Object.keys(error).map(key => error[key]).join('\n')).join('\n'));
				} else {
					return;
				}

				jquery_default()('.cart-shipping-calculator-response').html(`<p>${errorMessage}</p>`);
			}

			onSectionUnload() {
				jquery_default()('[data-calculate-shipping-button]', this.el).off('click');
			}

			unload() {
				jquery_default()('[data-calculate-shipping-button]', this.el).off('click', () => this.calculateShipping());

				Shopify.onError = () => { };
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js






		class StaticCart {
			constructor(section) {
				this.section = section;
				this.updateNote = this._updateNote.bind(this);
				const itemEls = section.el.querySelectorAll('[data-line-item]');
				this.items = [];

				for (let i = 0; i < itemEls.length; i++) {
					this.items.push(new LineItem(itemEls[i]));
				}

				const shippingCalculatorEl = section.el.querySelector('[data-shipping-calculator]');

				if (shippingCalculatorEl) {
					this.shippingCalculator = new ShippingCalculator(shippingCalculatorEl);
				}

				this.cartNoteEl = section.el.querySelector('[data-cart-note]');

				if (this.cartNoteEl) {
					this.cartNoteEl.addEventListener('change', this.updateNote);
				}

				jquery_default()(window).on('cart-loading-start', this._onUpdateStart.bind(this));
				jquery_default()(window).on('cart-loading-finish', this._onUpdateFinish.bind(this));
			}

			_onUpdateStart() {
				this.section.el.classList.add('cart-updating');
			}

			_onUpdateFinish() {
				shopify_asyncview_dist_index_es.on('load',window.Theme.routes.cart_url, {
					view: 'ajax'
				}).then(({
					data,
					html
				}) => {
					if (data.item_count === 0) {
						this._unload();

						const form = this.section.el.querySelector('[data-cart]');
						const shipping = this.section.el.querySelector('[data-shipping-calculator]');

						if (form) {
							form.parentNode.removeChild(form);
						}

						if (shipping) {
							shipping.parentNode.removeChild(shipping);
						}
					}

					const itemsEl = this.section.el.querySelector('[data-cart-items]');
					const noteEl = this.section.el.querySelector('[data-cart-note]');
					const totalsEl = this.section.el.querySelector('[data-cart-totals]');
					const newItemsEl = document.createElement('div');
					const newNoteEl = document.createElement('div');
					const newTotalsEl = document.createElement('div'); // This should be removed and the update should occur locally to the element

					jquery_default()('.cart-link .cart-count').text(data.item_count);
					document.dispatchEvent(new CustomEvent('cart:count', {
						detail: {
							count: data.item_count
						}
					}));

					if (itemsEl && html.cart_items) {
						newItemsEl.innerHTML = html.cart_items;
						morphdom_esm(itemsEl, newItemsEl, {
							childrenOnly: true,
							onBeforeElUpdated: (fromEl, toEl) => {
								// Skip images if src matches
								// - we don't want to reload lazy loaded images
								if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
									return false;
								}

								return true;
							}
						});
					}

					if (noteEl && html.cart_note) {
						newNoteEl.innerHTML = html.cart_note;
						morphdom_esm(noteEl, newNoteEl);
					}

					if (totalsEl && html.cart_totals) {
						newTotalsEl.innerHTML = html.cart_totals;
						morphdom_esm(totalsEl, newTotalsEl, {
							childrenOnly: true
						});
					}

					this.items.forEach(item => item.unload());
					this.items = [];
					const itemEls = this.section.el.querySelectorAll('[data-line-item]');

					for (let i = 0; i < itemEls.length; i++) {
						this.items.push(new LineItem(itemEls[i]));
					}

					this.section.el.classList.remove('cart-updating');
					this.cartNoteEl = this.section.el.querySelector('[data-cart-note]');

					if (this.cartNoteEl) {
						this.cartNoteEl.addEventListener('change', this.updateNote);
					}
				});
			}

			_updateNote() {
				utils_CartRequests.updateNote(this.cartNoteEl.value);
			}

			_unload() {
				this.items.forEach(item => item.unload());

				if (this.shippingCalculator) {
					this.shippingCalculator.unload();
				}

				if (this.cartNoteEl) {
					this.cartNoteEl.removeEventListener('change', this.updateNote);
				}
			}

			onSectionUnload() {
				this._unload();
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticArticleList.js

		class StaticArticleList {
			constructor({
				el
			}) {
				this.$el = jquery_default()(el);
				this.setFeaturedImage(true);
				this.artDirection();
				this.wrapAllNodes();
				jquery_default()(window).resize(() => {
					this.setFeaturedImage();
				});
			}

			wrapAllNodes() {
				const childNodes = jquery_default()('.rte', this.$el);

				for (let i = 0; i < childNodes.length; i++) {
					const node = childNodes[i];

					if (node.nodeType === 3 && node.textContent.replace(/^\s+|\s+$/g, '')) {
						jquery_default()(node).replaceWith(`<p>${node.textContent}</p>`);
					}
				}
			}

			setFeaturedImage(load) {
				const featuredImage = jquery_default()('.featured-image', this.$el);

				if (featuredImage.length) {
					if (featuredImage.hasClass('full-bleed-featured-image')) {
						const windowWidth = jquery_default()(window).width();
						const contentWidth = this.$el.outerWidth(true);
						featuredImage.css({
							width: windowWidth,
							marginLeft: -1 * (windowWidth - contentWidth) / 2
						});
					}

					if (load) {
						featuredImage.addClass('processed');
					}
				}
			}

			artDirection() {
				const images = jquery_default()('.post-content img', this.$el);
				images.one('rimg:load', () => {
					for (let i = 0; i < images.length; i++) {
						const image = jquery_default()(images[i]);

						if (!image.hasClass('post-image')) {
							if (image.parent().hasClass('post-content')) {
								image.wrap('<div />');
							}

							const imageParent = image.parent();

							if (image.css('float') !== 'none') {
								const direction = image.css('float');
								imageParent.addClass(`highlight highlight-${direction}`);
							}

							const imageWidth = image.width();
							const imageAlt = image.attr('alt');

							if (imageAlt && imageAlt.length && imageParent.not('img')) {
								const marginLeft = image.css('margin-left');
								const marginRight = image.css('margin-right');
								imageParent.append(`
              <div
                style="
                  max-width: ${imageWidth}px;
                  margin-left: ${marginLeft};
                  margin-right: ${marginRight};
                "
                class="photo-caption meta"
              >
                ${imageAlt}
              </div>
            `);
							}
						}
					}
				});
			}

			unload() {
				jquery_default()('.post-content img', this.$el).off('rimg:load');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js


		class StaticBlog {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.listViews = [];
				this.render();
			}

			render() {
				const $articleListItem = jquery_default()('[data-blog-list-item]', this.$el);

				if ($articleListItem.length === 0) {
					return;
				}

				$articleListItem.map((i, listItem) => this.listViews.push(new StaticArticleList({
					el: listItem
				})));
			}

			onSectionLoad() {
				this.render();
			}

			onSectionUnload() {
				this.listViews.map(listView => listView.unload());
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/helpers/ProductReviews.js
		const initShopifyProductReviews = () => {
			if (!window.SPR) {
				return;
			}

			window.SPR.registerCallbacks();
			window.SPR.initRatingHandler();
			window.SPR.initDomEls();
			window.SPR.loadProducts();
			window.SPR.loadBadges();
		};
/* harmony default export */ const ProductReviews = ({
			initShopifyProductReviews
		});
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
		// eslint-disable-line



		class StaticProductRecommendations {
			constructor(section) {
				this.section = section;
				this.productId = section.data.productId;
				this.limit = section.data.settings.limit;
				this.recommendationContainer = document.querySelector('[data-product-recommendations]');
				this.recommendUrl = window.Theme.routes.product_recommendations_url;
				this.queryParams = {
					section_id: this.section.id,
					limit: this.limit,
					product_id: this.productId,
					view: ''
				};

				this._loadRecommendations();
			}

			_loadRecommendations() {
				shopify_asyncview_dist_index_es.on('load',this.recommendUrl, this.queryParams).then(({
					data,
					html
				}) => {
					this.recommendationContainer.innerHTML = html;
					dist_index_es.watch(this.recommendationContainer);
					initShopifyProductReviews();
				});
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticSearch.js

		class StaticSearch {
			constructor(section) {
				this.facetedFilters = new FacetedFiltering(section);
			}

			onSectionUnload() {
				this.facetedFilters.unload();
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/sections/StaticAddresses.js

		class StaticAddresses {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.prepareAddresses();

				this._bindEvents();
			}

			_bindEvents() {
				jquery_default()('.delete-address', this.$el).on('click', e => this.deleteAddress(e));
				jquery_default()('.edit-address', this.$el).on('click', e => this.editAddress(e));
				jquery_default()('.cancel-edit', this.$el).on('click', e => this.cancelEditing(e));
				jquery_default()('.toggle-new-address', this.$el).on('click', () => this.toggleNewAddress());
				jquery_default()('.select-wrapper select', this.$el).on('change', e => this.updateSelectedText(e, false));
				jquery_default()('.customer-address-wrap .customer-address-edit-form form').on('submit', e => this.submitToCustomAppEndpoint(e));
				jquery_default()('.add-new-address-wrapper .customer-new-address form').on('submit', e => this.submitToCustomAppEndpoint(e));
			}

			submitToCustomAppEndpoint(e) {
				const form = jquery_default()(e.currentTarget);
	
				$.ajax({
					type: 'PUT',
					url: '/apps/nexaro/update_address',
					data: form.serialize()
				});
			}

			prepareAddresses() {
				new Shopify.CountryProvinceSelector('address-country', 'address-province', {
					hideElement: 'address-province-container'
				});
				const addresses = jquery_default()('.customer-address', this.$el);

				if (addresses.length) {
					for (let i = 0; i < addresses.length; i++) {
						const address = addresses[i];
						const addressID = jquery_default()(address).data('address-id');
						new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
							hideElement: `address-province-container-${addressID}`
						});
					}
				}

				const selectableOptions = jquery_default()('.select-wrapper select', this.$el);

				for (let i = 0; i < selectableOptions.length; i++) {
					this.updateSelectedText(null, selectableOptions[i]);
				}
			}

			updateSelectedText(e, select) {
				const text = e ? jquery_default()(e.target) : jquery_default()(select);
				const selectedValue = text.find('option:selected').text();

				if (selectedValue !== '') {
					text.prev('.selected-text').text(selectedValue);
				}

				if (text.attr('name') === 'address[country]') {
					let addressID = jquery_default()(text).attr('id').split('address-country-')[1];
					addressID = addressID ? `#address-province-${addressID}` : '.new-address-province';
					this.updateSelectedText(null, jquery_default()(addressID));
				}
			}

			deleteAddress(e) {
				const addressID = jquery_default()(e.target).parents('[data-address-id]').data('address-id');			
				this.editMetafieldsDefault(e, addressID);

				Shopify.CustomerAddress.destroy(addressID);
			}

			editMetafieldsDefault(e, addressID) {
				const addressFormID = 'address_form_' + addressID;
				const default_address = jquery_default()(e.target).parents('[data-address-id]').find('.is-default');	

				if(default_address.length) {
					window.onbeforeunload = ()=>{	// When the dialog is confirmed.
							const allForms = jquery_default()('.customer-address-wrap .customer-address-edit-form form');
							const filteredForms = jquery_default().grep(allForms, function(e){ 
								return e.id != addressFormID;
							});
							const lastForm = jquery_default()(filteredForms[filteredForms.length - 1]);
							const defaultCheckbox = lastForm.find("input[name='address[default]']")[0];
							jquery_default()(defaultCheckbox).prop('checked', true);

							$.ajax({
								type: 'PUT',
								url: '/apps/nexaro/update_address',
								data: lastForm.serialize()
							});
					};
				}
			}

			editAddress(e) {
				const addressID = jquery_default()(e.target).parents('[data-address-id]').data('address-id');
				jquery_default()(`.customer-address[data-address-id='${addressID}']`).addClass('editing');
				jquery_default()(`.customer-address-edit-form[data-address-id='${addressID}']`).addClass('show');
				this.prepareAddresses();
			}

			cancelEditing(e) {
				const addressID = jquery_default()(e.target).parents('[data-address-id]').data('address-id');
				jquery_default()(`.customer-address[data-address-id='${addressID}']`).removeClass('editing');
				jquery_default()(`.customer-address-edit-form[data-address-id='${addressID}']`).removeClass('show');
			}

			toggleNewAddress() {
				jquery_default()('.add-new-address', this.$el).toggle();
				jquery_default()('.customer-new-address', this.$el).toggleClass('show');
			}

			onSectionUnload() {
				jquery_default()('.delete-address', this.$el).off('click');
				jquery_default()('.edit-address', this.$el).off('click');
				jquery_default()('.cancel-edit', this.$el).off('click');
				jquery_default()('.toggle-new-address', this.$el).off('click');
				jquery_default()('.select-wrapper select', this.$el).off('change');
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/templates/Account.js


		class Account {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				jquery_default()('.toggle-forgetfulness span', this.$el).on('click', () => this.recoverPassword());

				if (jquery_default()(document.body).hasClass('template-customers-addresses')) {
					this.StaticAddresses = new StaticAddresses({
						el: jquery_default()('.main-content')
					});
				}

				if (jquery_default()(document.body).hasClass('template-customers-login')) {
					this.checkForReset();
				}

				if (window.location.hash === '#recover') {
					this.recoverPassword();
				}
			}

			recoverPassword() {
				jquery_default()('.recover-password', this.$el).toggle();
				jquery_default()('.customer-login', this.$el).toggle();
			}

			checkForReset() {
				if (jquery_default()('.reset-check').data('successful-reset') === true) {
					jquery_default()('.successful-reset').show();
				}
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/templates/Contact.js

		class Contact {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				jquery_default()('.contact-form', this.$el).on('submit', () => this.spamCheck());
			}

			spamCheck(event) {
				if (jquery_default()(event.target).find('.spam-check').val().length > 0) {
					event.preventDefault();
				}
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/templates/GiftCard.js
		class GiftCard {
			constructor(section) {
				this.el = section.el;
				this.qrCodeAttr = 'data-qr-code';
				this.qrCode = '[data-qr-code]';
				this.addQrCode();
			}

			addQrCode() {
				const qrWrapper = this.el.querySelector(this.qrCode);
				new QRCode(qrWrapper, {
					text: qrWrapper.getAttribute(this.qrCodeAttr),
					width: 120,
					height: 120
				});
			}

		}
		;// CONCATENATED MODULE: ./source/scripts/helpers/FlickityTouchFix.js
		// This is a helper class to fix a touch issue that came up in flickity
		// on iOS devices as of version 13. It should smooth out some of the scroll
		// and swipe issues that flickity is having on that version of iOS.
		const flickityTouchFix = () => {
			let touchingSlider = false;
			let touchStartCoordsX = 0;

			const onTouchStart = e => {
				if (e.target.closest && e.target.closest('.flickity-slider')) {
					touchingSlider = true;
					touchStartCoordsX = e.touches[0].pageX;
				} else {
					touchingSlider = false;
				}
			};

			const onTouchMove = e => {
				if (!(touchingSlider && e.cancelable)) {
					return;
				}

				if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
					e.preventDefault();
				}
			};

			document.body.addEventListener('touchstart', onTouchStart);
			document.body.addEventListener('touchmove', onTouchMove, {
				passive: false
			});
		};

/* harmony default export */ const FlickityTouchFix = (flickityTouchFix);
		;// CONCATENATED MODULE: ./source/scripts/components/ImagesWithText.js


		class ImagesWithText {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.$window = jquery_default()(window);
				this.centerText(this.$el);
				this.$window.on('resize.images-with-text', ThemeUtils.debounce(() => this.centerText(this.$el), 10));
			}

			prepareRemove() {
				this.$window.off('resize.images-with-text');
			}

			centerText($container) {
				$container.css({
					minHeight: ''
				});

				if ($container.attr('data-image-with-text-layout') !== 'background') {
					return;
				}

				const $content = $container.find('[data-feature-content]');
				const containerHeight = $container.outerHeight(true);
				const contentHeight = $content.outerHeight(true);

				if (containerHeight > contentHeight) {
					$content.css({
						top: (containerHeight - contentHeight) / 2
					});
				} else {
					$content.css({
						top: ''
					});
					$container.css({
						minHeight: contentHeight
					});
				}
			}

		}
		// EXTERNAL MODULE: ./node_modules/fitvids/index.js
		var fitvids = __webpack_require__(729);
		var fitvids_default = /*#__PURE__*/__webpack_require__.n(fitvids);
		;// CONCATENATED MODULE: ./source/scripts/components/RTE.js


		class RTE {
			constructor(section) {
				this.$el = jquery_default()(section.el);
				this.setupTabs();
				const selects = this.$el.find('select');

				for (let i = 0; i < selects.length; i++) {
					const select = selects[i];

					if (!jquery_default()(select).parent('.select-wrapper').length) {
						jquery_default()(select).wrap('<div class="select-wrapper" />').parent().prepend('<span class="selected-text"></span>');
					}

					this.updateOption(null, select);
				}

				fitvids_default()('.rte');

				this._bindEvents();
			}

			_bindEvents() {
				jquery_default()('.tabs li', this.$el).on('click', event => this.switchTabs(event));
				jquery_default()('.select-wrapper select', this.$el).on('change', event => this.updateOption(event));
			}

			switchTabs(event) {
				event.preventDefault();
				const tab = jquery_default()(event.currentTarget);
				const position = tab.index();
				this.tabs.removeClass('active');
				this.tabsContent.removeClass('active');
				tab.addClass('active');
				this.tabsContent.eq(position).addClass('active');
			}

			setupTabs() {
				this.tabs = jquery_default()('.tabs > li', this.$el);
				this.tabsContent = jquery_default()('.tabs-content > li', this.$el);
				this.tabs.first().addClass('active');
				this.tabsContent.first().addClass('active');
			}

			updateOption(event, selector) {
				const select = event ? jquery_default()(event.target) : jquery_default()(selector);
				const newOption = select.find('option:selected').text();
				select.siblings('.selected-text').text(newOption);
			}
		};


		var Drawer = /*#__PURE__*/function () {
			function Drawer(element) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				_classCallCheck(this, Drawer);

				this.element = element;

				if (this.element.hasAttribute("reverse-breakpoint")) {
					this.originalDirection = this.element.classList.contains("Drawer--fromLeft") ? "left" : "right";
					const matchMedia2 = window.matchMedia(this.element.getAttribute("reverse-breakpoint"));
					matchMedia2.addListener(this._checkReverseOpeningDirection.bind(this));
					this._checkReverseOpeningDirection(matchMedia2);
				}

				this.onOpen = options['onOpen'] || function () {};

				this.onClose = options['onClose'] || function () {};

				this.isOpen = false;
				this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
				this.pageOverlayElement = document.querySelector('.PageOverlay');

				this._attachListeners();
			}
	
			_createClass(Drawer, [{
				key: "destroy",
				value: function destroy() {
					document.body.removeEventListener('click', this._openListener);
					document.body.removeEventListener('click', this._closeListener);
					window.removeEventListener('resize', this._calculateMaxHeightListener);
				}
			}, {
				key: "toggle",
				value: function toggle() {
					this.isOpen ? this.close() : this.open();
				}
			}, {
				key: "_checkReverseOpeningDirection",
				value: function _checkReverseOpeningDirection(match) {
					const left = (this.originalDirection === "left" && !match.matches) || (this.originalDirection !== "left" && match.matches);
					this.element.classList.toggle("Drawer--fromLeft", left);
					this.element.classList.toggle("Drawer--fromRight", !left);
				}
			}, {
				key: "open",
				value: function open(event) {
					if (this.isOpen) {
						return;
					}

          const topBar = document.getElementById('top-bar');
          if (topBar) {
              topBar.style.zIndex = '1000';
          }

					if (event) {
						event.preventDefault();
					}

					this.element.setAttribute('aria-hidden', 'false');

					this._calculateMaxHeight();

					document.documentElement.classList.add('no-scroll');
					this.pageOverlayElement.classList.add('is-visible');
					this.pageOverlayElement.addEventListener('click', this._closeListener);
					this.isOpen = true;

					const initialFocus = this.element.querySelector(this.element.getAttribute('initial-focus-selector'));
					if (initialFocus) {
						setTimeout(function() {
							initialFocus.focus();
						}, 500);
					}

					this.onOpen();

					return false;
				}
			}, {
				key: "close",
				value: function close(event) {
					if (!this.isOpen) {
						return;
					}

          const topBar = document.getElementById('top-bar');
          if (topBar) {
              topBar.style.zIndex = '1002';
          }

					if (event) {
						event.preventDefault();
					}


					this.element.setAttribute('aria-hidden', 'true');
					document.documentElement.classList.remove('no-scroll');
					this.pageOverlayElement.classList.remove('is-visible');
					this.pageOverlayElement.removeEventListener('click', this._closeListener);
					this.isOpen = false;
					this.onClose();
				}
			}, {
				key: "_attachListeners",
				value: function _attachListeners() {
					var _this = this;

					this._openListener = function (event) {
						if (event.target.closest("[data-action=\"open-drawer\"][data-drawer-id=\"".concat(_this.element.id, "\"]"))) {
							_this.open(event);
						}
					};

					this._closeListener = function (event) {
						if (event.target.closest("[data-action=\"close-drawer\"]:not([data-drawer-id]),[data-action=\"close-drawer\"][data-drawer-id=\"".concat(_this.element.id, "\"]"))) {
							_this.close(event);
						}
					};

					this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
					document.body.addEventListener('click', this._openListener);
					document.body.addEventListener('click', this._closeListener);
					this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
					window.addEventListener('resize', this._calculateMaxHeightListener);
				}
			}, {
				key: "_calculateMaxHeight",
				value: function _calculateMaxHeight() {
					this.element.style.maxHeight = window.innerHeight + 'px';
				}
			}, {
				key: "_handleKeyboard",
				value: function _handleKeyboard(event) {
					if (this.isOpen && event.keyCode === 27) {
						this.close();
					}
				}
			}]);

			return Drawer;
		}();
	
		// js/custom-element/section/search/predictive-search-drawer.js
		var PredictiveSearchDrawer = class extends HTMLElement {
			connectedCallback() {
				this.drawer = new Drawer(this);
				this.inputElement = this.querySelector('[name="q"]');
				this.drawerContentElement = this.querySelector(".Drawer__Content");
				this.drawerFooterElement = this.querySelector(".Drawer__Footer");
				this.loadingStateElement = this.querySelector(".predictive-search__loading-state");
				this.resultsElement = this.querySelector(".predictive-search__results");
				this.menuListElement = this.querySelector(".predictive-search__menu-list");

				this.inputElement?.addEventListener("input", this._debounce(this._onSearch.bind(this), 200));
			}
			async _onSearch(event) {
				const target = event.target;
				if (event.key === "Enter") {
					return;
				}
				if (this.abortController) {
					this.abortController.abort();
				}
				this.drawerContentElement.classList.remove("drawer__content--center");
				this.drawerFooterElement.hidden = true;
				if (target.value === "") {
					this.loadingStateElement.hidden = true;
					this.resultsElement.hidden = true;
					this.menuListElement ? this.menuListElement.hidden = false : "";
				} else {
					this.drawerContentElement.classList.add("drawer__content--center");
					this.loadingStateElement.hidden = false;
					this.resultsElement.hidden = true;
					this.menuListElement ? this.menuListElement.hidden = true : "";
					let searchResults = {};
					try {
						this.abortController = new AbortController();
						if (this.getAttribute("data-predictive-search") == "true" && this._supportPredictiveApi()) {
							searchResults = await this._doPredictiveSearch(target.value);
						} else {
							searchResults = await this._doLiquidSearch(target.value);
						}
					} catch (e) {
						if (e.name === "AbortError") {
							return;
						}
					}
					this.loadingStateElement.hidden = true;
					this.resultsElement.hidden = false;
					this.menuListElement ? this.menuListElement.hidden = true : "";
					if (searchResults.hasResults) {
						this.drawerFooterElement.hidden = false;
						this.drawerContentElement.classList.remove("drawer__content--center");
					}
					this.resultsElement.innerHTML = searchResults.html;
					
					const resetSearchButton = this.querySelector('[data-action="reset-search"]');
					resetSearchButton?.addEventListener("click", this._startNewSearch.bind(this));
				}
			}
			async _doPredictiveSearch(term) {
				const response = await fetch(`${window.Theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=10&resources[prefix]=last&resources[limit_scope]=each&section_id=predictive-search`, {
					signal: this.abortController.signal
				});
				const div = document.createElement("div");
				div.innerHTML = await response.text();
				return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
			}
			async _doLiquidSearch(term) {
				const response = await fetch(`${window.Theme.routes.search_url}?q=${encodeURIComponent(term)}&resources[limit]=50&section_id=predictive-search-compatibility`, {
					signal: this.abortController.signal
				});
				const div = document.createElement("div");
				div.innerHTML = await response.text();
				return { hasResults: div.querySelector(".predictive-search__results-categories") !== null, html: div.firstElementChild.innerHTML };
			}
			_startNewSearch() {
				this.inputElement.value = "";
				this.inputElement.focus();
				const event = new Event("input", {
					bubbles: true,
					cancelable: true
				});
				this.inputElement.dispatchEvent(event);
			}
			_supportPredictiveApi() {
				const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
				return shopifyFeatureRequests["predictiveSearch"];
			}
			_debounce(fn, delay3) {
				let timer = null;
				return (...args) => {
					clearTimeout(timer);
					timer = setTimeout(() => {
						fn.apply(this, args);
					}, delay3);
				};
			}
		};
		window.customElements.define("predictive-search-drawer", PredictiveSearchDrawer);

		
		// js/custom-element/ui/tabs-nav.js
		var TabsNav = class extends HTMLElement {
			connectedCallback() {
				this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
				this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));
				this.positionElement = document.createElement("span");
				this.positionElement.classList.add("tabs-nav__position");
				this.insertAdjacentElement("beforeend", this.positionElement);
				this._adjustNavigationPosition();
			}
			get selectedTabIndex() {
				return this.buttons.findIndex((button) => button.getAttribute("aria-expanded") === "true");
			}
			get selectedButton() {
				return this.buttons.find((button) => button.getAttribute("aria-expanded") === "true");
			}
			selectButton(button, animate = true) {
				if (!this.buttons.includes(button) || this.selectedButton === button) {
					return;
				}
				const from = document.getElementById(this.selectedButton.getAttribute("aria-controls")), to = document.getElementById(button.getAttribute("aria-controls"));
				if (animate) {
					this._transitionContent(from, to);
				} else {
					from.hidden = true;
					to.hidden = false;
				}
				this.selectedButton.setAttribute("aria-expanded", "false");
				button.setAttribute("aria-expanded", "true");
				this._adjustNavigationPosition();
			}
			_transitionContent(from, to) {
				from.animate({
					opacity: [1, 0]
				}, {
					duration: 250,
					easing: "ease"
				}).onfinish = () => {
					from.hidden = true;
					to.hidden = false;
					to.animate({
						opacity: [0, 1]
					}, {
						duration: 250,
						easing: "ease"
					});
				};
			}
			_adjustNavigationPosition(shouldAnimate = true) {
				const scale = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth, translate = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / scale;
				if (!shouldAnimate) {
					this.positionElement.style.transition = "none";
				}
				this.positionElement.style.setProperty("--scale", scale);
				this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
				this.positionElement.clientWidth;
				requestAnimationFrame(() => {
					this.positionElement.classList.add("is-initialized");
					this.positionElement.style.transition = null;
				});
			}
		};
		window.customElements.define("tabs-nav", TabsNav);

		class CartSection {
			constructor(section) {
				this.section = section;
				this.element = section.el.querySelector("[data-section-id]");
				this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
				this.itemCount = this.options['itemCount'];
				this.isCartNoteOpen = false;

				if (this.options['drawer']) {
					this.sidebarDrawer = new Drawer(this.element, {
						onClose: this._onDrawerClosed.bind(this)
					});
				}

				section.el.querySelectorAll('[data-line-item]').forEach((item) => {
					new LineItem(item);
				})
				this._attachListeners();
			}
	
			_attachListeners() {
				this.element.querySelector('#cart-note')?.addEventListener('change', this._updateCartNote.bind(this));

				this.element.querySelectorAll('[data-action="toggle-cart-note"]').forEach((btn) => {
					btn.addEventListener('click', this._toggleCartNote.bind(this));
				})

				document.addEventListener('product:added', this._onProductAdded.bind(this));
				document.addEventListener('cart:refresh', this._rerenderCart.bind(this, false));
				jquery_default()(window).on('cart-loading-finish', this._rerenderCart.bind(this));

				document.addEventListener('click', function(ev) {
					if (ev.target.closest(".Drawer__Footer") || !this.element.classList.contains('has-note-open')) {
						return;
					}
					this._toggleCartNote();
				}.bind(this))
			}
			
			_updateCartNote(event) {
				fetch("".concat(window.Theme.routes.cart_url, "/update.js"), {
					body: JSON.stringify({
						note: event.target.value
					}),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

					}
				});
			}
		
			_toggleCartNote() {
				var _this = this;

				var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
						cartNote = this.element.querySelector('#cart-note');
				this.element.classList.toggle('has-note-open');
				this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
				noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
				this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

				if (this.element.classList.contains('has-note-open')) {
					setTimeout(() => {
						_this.element.querySelector('#cart-note').focus();
					}, 200)
				}
			}
		
			_updateItemQuantity(event) {
				var _this2 = this;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));
				var quantity = null,
						elementToAnimate = null;

				if (event.target.tagName === 'INPUT') {
					quantity = parseInt(Math.max(parseInt(event.target.value) || 1, 1));
				} else {
					quantity = parseInt(event.target.getAttribute('data-quantity'));
				} // If the quantity is 0, then we will animate the product with a removal effect


				if (quantity === 0) {
					elementToAnimate = event.target.closest('.CartItemWrapper');
				}

				fetch("".concat(window.Theme.routes.cart_change_url, ".js"), {
					body: JSON.stringify({
						line: event.target.getAttribute('data-line'),
						quantity: quantity
					}),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

					}
				}).then(function (cart) {
					cart.json().then(function (content) {
						_this2.itemCount = content['item_count'];

						updateCartCount(content.item_count);

						_this2._rerenderCart(elementToAnimate);

						document.dispatchEvent(new CustomEvent('theme:loading:end'));
					});
				});
				event.preventDefault();
			}
		
			_onProductAdded(event) {
				var _this3 = this;

				this.itemCount += event.detail.quantity;
				
				const options = {
					isUpsell: Boolean((event.target && event.target.closest ? event.target.closest('cart-drawer-recommendations') : null) || event.detail.isUpsell || false)
				}

				this._rerenderCart(null, options).then(function () {
					_this3.sidebarDrawer.open();
				});
			}
		
			_onDrawerClosed() {
				if (this.isCartNoteOpen) {
					this._toggleCartNote();
				}
			}
			/**
			 * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
			 * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
			 * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
			 * all the time and hence having easier logic.
			 */

		
			_rerenderCart(elementToAnimate, options) {
				var _this4 = this;

				// Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
				return fetch("".concat(window.Theme.routes.cart_url, "?section_id=").concat(this.section.id, "&timestamp=").concat(Date.now()), {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (content) {
					content.text().then(function (html) {
						_this4._replaceContent(html);
						const drawerUpsellHint = _this4.element.querySelector('cart-upsell-add-hint');
						if (drawerUpsellHint && options?.isUpsell) {
							const hintElement = drawerUpsellHint.querySelector("cart-upsell-add-hint-content");
							if (hintElement) {
								hintElement.classList.add("show");
		
								setTimeout(() => {
									hintElement.classList.remove("show");
								}, window.cartUpsellHintDuration || 2000)
							}
						}
					});
				});
			}
		
			_replaceContent(html) {
				var _this5 = this;

				var tempElement = document.createElement('div');
				tempElement.innerHTML = html;

				if (!this.element.querySelector('.Cart')) {
					return;
				}

				var cartNodeParent = this.element.querySelector('.Cart').parentNode;

				var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
				cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
				this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;

				var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
				var cartCount = document.querySelectorAll('[data-cart-count]');
				this.itemCount = cartResult['itemCount'];
				cartCount.forEach(function (item) {
					item.innerHTML = cartResult['itemCount'];
				});

				const cartArticleText = document.querySelector('#drawer_cart_item_text');
				if (cartArticleText) {
					if (cartResult['itemCount'] < 2) {
						cartArticleText.innerHTML = window.languages.cartOptimizeOneArticle;
					} else {
						cartArticleText.innerHTML = window.languages.cartOptimizeMoreArticle;
					}
				}

				const ShippingProgressBar = document.querySelector('.Drawer__ShippingProgressBarIndicator');
				if (ShippingProgressBar) {
					ShippingProgressBar.style.width = ShippingProgressBar.dataset.width; 
				}

				this.element.querySelectorAll('[data-line-item]').forEach((item) => {
					new LineItem(item);
				})
				this.element.querySelector('#cart-note')?.addEventListener('change', this._updateCartNote.bind(this));
				this.element.querySelectorAll('[data-action="toggle-cart-note"]').forEach((btn) => {
					btn.addEventListener('click', this._toggleCartNote.bind(this));
				})
			}
		};
	
		// js/custom-element/section/cart/cart-drawer-recommendations.js
		var CartDrawerRecommendations = class extends HTMLElement {
			async connectedCallback() {
				const recommendationType = this.getAttribute("recommendation-type") || "complementary";
				const response = await fetch(`${window.Theme.routes.product_recommendations_url}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}&recommendation_type=${recommendationType}&intent=complementary`);
				const div = document.createElement("div");
				div.innerHTML = await response.clone().text();
				const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
				if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
					this.innerHTML = productRecommendationsElement.innerHTML;

					const slider = this.querySelector(".mini-cart__recommendations-list");
					if (slider) {
						const mq = window.matchMedia('(max-width: 999px)');
						const onMqMatches = function(mq) {
							if(mq.matches) {
								this.flickity = new flickityFade(slider, {
									accessibility: false, // Flickity's inherent "accessibility" actually makes it worse
									adaptiveHeight: false,
									autoPlay: Number.parseInt(this.getAttribute("data-autoplay")),
									cellAlign: 'left',
									cellSelector: '.product-list-item',
									contain: true,
									imagesLoaded: true,
									pageDots: false,
									prevNextButtons: this.getAttribute("data-arrows") == "true",
									pauseAutoPlayOnHover: true,
									percentPosition: false,
									arrowShape: {
										x0: 10,
										x1: 60,
										y1: 50,
										x2: 65,
										y2: 45,
										x3: 20
									}
								});
							} else if(this.flickity) {
								this.flickity.destroy();
							}
						}.bind(this);
						mq.onchange = onMqMatches;
						onMqMatches(mq);
					}

					const forms = this.querySelectorAll(".ProductForm__QuickBuy");
					forms.forEach((form) => {
						form.addEventListener("submit", this._addToCart.bind(this));
					});
					this.querySelectorAll("img[data-rimg]").forEach((img) => {
						var item = parseItem(img, {});
						loadImage(item);
					});
				} else {
					this.hidden = true;
				}
			}
			get productId() {
				return this.getAttribute("product-id");
			}
			get sectionId() {
				return this.getAttribute("section-id");
			} 
			_addToCart(event) {
				event.preventDefault();

				const form = event.target.closest(".ProductForm__QuickBuy");
				if(!form) { return; }
				const addToCartButton = form.querySelector('.link'); // First, we switch the status of the button
				const loader = addToCartButton.nextElementSibling;
	
				addToCartButton?.setAttribute('disabled', 'disabled');
				addToCartButton?.classList.add('hidden');
				loader?.classList.remove('hidden');
				document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
	
				var formElement = event.target;
				fetch("".concat(window.Theme.routes.cart_add_url, ".js"), {
					body: JSON.stringify(this.serializeForm(formElement)),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
	
					}
				}).then(function (response) {
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
					if (response.ok) {
						// We simply trigger an event so the mini-cart can re-render
	
						document.dispatchEvent(new CustomEvent('product:added', {
							bubbles: true,
							detail: {
								//variant: this.currentVariant,
								quantity: 1,
								isUpsell: true
							}
						}));
					} else {
						response.json().then(function (content) {
							var errorMessageElement = document.createElement('span');
							errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
							errorMessageElement.innerHTML = content['description'];
							addToCartButton.removeAttribute('disabled');
							addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
							setTimeout(function () {
								errorMessageElement.remove();
							}, 2500);
						});
					}
				});
			}
			serializeForm(form) {
				const serialized = {};
				const formElements = form.elements;
			
				for (let i = 0; i < formElements.length; i++) {
					const field = formElements[i];
					if (!field.name || field.disabled || field.type === 'file') continue;
			
					if (field.type === 'select-multiple') {
						serialized[field.name] = [];
						for (let j = 0; j < field.options.length; j++) {
							if (field.options[j].selected) {
								serialized[field.name].push(field.options[j].value);
							}
						}
					} else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
						serialized[field.name] = field.value;
					}
				}
			
				return serialized;
			}
		};
		window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);

		// CONCATENATED MODULE: ./source/scripts/Startup.js

		// Shared Sections




		// Sections










		// Templates



		// Helpers


		// Components


		// Utilities


		class Startup {
			constructor() {
				const body = jquery_default()(document.body); // Set up conditionals

				this.isHome = body.hasClass('template-index');
				this.isAccount = body.attr('class').indexOf('-customers-') > 0;
				this.isCollection = jquery_default()('[data-section-type="static-collection"]').length;
				this.isProduct = jquery_default()('[data-section-type="static-product"]').length;
				this.isProductSlideshow = jquery_default()('[data-section-type="static-product-slideshow"]').length;
				this.isCart = jquery_default()('[data-section-type="static-cart"]').length;
				this.isContactPage = jquery_default()('[data-section-type="static-contact"]').length;
				this.isGiftCardPage = jquery_default()('[data-section-type="static-giftcard"]').length;
				this.isBlog = jquery_default()('[data-section-type="static-blog"]').length;
				this.isBlogPost = jquery_default()('[data-section-type="static-article"]').length;
				this.is404 = jquery_default()('[data-section-type="static-404"]').length;
				this.isSearch = jquery_default()('[data-section-type="static-search"]').length;
				FlickityTouchFix(); // Common views

				this.sections = new shopify_sections_manager_es();
				this.sections.register('pxs-header-standard', section => new StaticHeader(section));
				this.sections.register('static-footer', section => new StaticFooter(section));
				this.sections.register('cart', section => new CartSection(section));
				this.sections.register('pxs-map', section => new PxsMap(section));
				this.sections.register('pxs-video', section => new pxs_video_dist_index_es(section));
				this.sections.register('pxs-faq', section => new DynamicFAQ(section));
				dist_index_es.init(); // Conditional views

				this.sections.register('dynamic-featured-product', section => new Product(section));
				this.sections.register('dynamic-twitter', section => new DynamicTwitter(section));
				this.sections.register('dynamic-image-with-text', section => new ImagesWithText(section));
				this.sections.register('dynamic-image-with-text-overlay', section => new ImagesWithText(section));
				this.sections.register('pxs-slideshow', section => new pxs_slideshow_dist_index_es(section));
				this.sections.register('pxs-testimonials', section => new pxs_testimonials_dist_index_es(section));

				if (this.isCollection) {
					this.sections.register('static-collection', section => new StaticCollection(section));
				}

				if (this.isGiftCardPage) {
					this.sections.register('static-giftcard', section => new GiftCard(section));
				}

				if (this.isContactPage) {
					this.sections.register('static-contact', section => new Contact(section));
				}

				if (this.isProduct) {
					this.sections.register('static-product', section => new Product(section));
					this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
				}

				if (this.isCart) {
					this.sections.register('static-cart', section => new StaticCart(section));
				}

				if (this.isBlog) {
					this.sections.register('static-blog', section => new StaticBlog(section));
				}

				if (this.isBlogPost) {
					this.sections.register('static-article', section => new StaticBlog(section));
				}

				if (this.isSearch) {
					this.sections.register('static-search', section => new StaticSearch(section));
				}

				if (this.isAccount) {
					this.Account = new Account({
						el: '.main-content'
					});
				}

				this.rtes = [];
				this.richTextInit();
				ThemeUtils.externalLinks(jquery_default()(document));
				jquery_default()(document).on('shopify:section:load', event => {
					ThemeUtils.externalLinks(jquery_default()(event.target));
					this.richTextInit();
					initShopifyProductReviews();
				});
				this.classHoist();
				jquery_default()(document).on('shopify:section:select.home-page', () => this.classHoist()).on('shopify:section:load.home-page', () => this.classHoist()).on('shopify:section:deselect.home-page', () => this.classHoist());
			}

			getStyle($el) {
				const styleSetting = $el.attr('class').match(/(default|contrast|accent)-style/);

				if (styleSetting != null) {
					return styleSetting[0];
				}

				return false;
			}

			getSectionWidth($el) {
				const sectionWidthSetting = $el.attr('class').match(/content-width|full-width/);

				if (sectionWidthSetting !== null) {
					return sectionWidthSetting[0];
				}

				return false;
			}

			classHoist() {
				jquery_default()('.module-container').each((index, section) => {
					const $section = jquery_default()(section);
					const $parent = $section.parent();
					const sectionStyle = this.getStyle($section);
					const parentStyle = this.getStyle($parent);
					const sectionWidthStyle = this.getSectionWidth($section);

					if (sectionWidthStyle) {
						$parent.addClass(sectionWidthStyle);
					}

					if (!sectionStyle) {
						return;
					}

					if (parentStyle) {
						$parent.removeClass(parentStyle);
					}

					$parent.addClass(sectionStyle);
				});
			}

			richTextInit() {
				for (let i = 0; i < jquery_default()('.rte').length; i++) {
					this.rtes.push(new RTE({
						el: jquery_default()('.rte')[i]
					}));
				}
			}

		}
		jquery_default()(() => {
			window.theme = new Startup();
		});
	})();

	/******/
})()
	;
//# sourceMappingURL=startup.js.map?1634149905897